import "./plugins/jquery.minicolors.js";
import JsBarcode from "./jsbarcode/JsBarcode.js";
import QRCode from "./plugins/qrcode.js";
import watermark from "./plugins/watermark.js";
import lImg from "./css/image/l_img.svg";
import vImg from "./css/image/v_img.svg";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import Nzh from "nzh/dist/nzh.min.js";
import { Canvg } from "canvg";
import defaultTypeProvider from "./etypes/default-etyps-provider";
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
window.autoConnect = false;
var hiprint = function(t2) {
  var e2 = {};
  function n2(i2) {
    if (e2[i2]) return e2[i2].exports;
    var o2 = e2[i2] = {
      i: i2,
      l: false,
      exports: {}
    };
    return t2[i2].call(o2.exports, o2, o2.exports, n2), o2.l = true, o2.exports;
  }
  return n2.m = t2, n2.c = e2, n2.d = function(t3, e3, i2) {
    n2.o(t3, e3) || Object.defineProperty(t3, e3, {
      enumerable: true,
      get: i2
    });
  }, n2.r = function(t3) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t3, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t3, "__esModule", {
      value: true
    });
  }, n2.t = function(t3, e3) {
    if (1 & e3 && (t3 = n2(t3)), 8 & e3) return t3;
    if (4 & e3 && "object" == _typeof(t3) && t3 && t3.__esModule) return t3;
    var i2 = /* @__PURE__ */ Object.create(null);
    if (n2.r(i2), Object.defineProperty(i2, "default", {
      enumerable: true,
      value: t3
    }), 2 & e3 && "string" != typeof t3)
      for (var o2 in t3) {
        n2.d(
          i2,
          o2,
          function(e4) {
            return t3[e4];
          }.bind(null, o2)
        );
      }
    return i2;
  }, n2.n = function(t3) {
    var e3 = t3 && t3.__esModule ? function() {
      return t3.default;
    } : function() {
      return t3;
    };
    return n2.d(e3, "a", e3), e3;
  }, n2.o = function(t3, e3) {
    return Object.prototype.hasOwnProperty.call(t3, e3);
  }, n2.p = "/", n2(n2.s = 21);
}([
  function(t2, e2, n2) {
    "use strict";
    var i2;
    n2.d(e2, "a", function() {
      return hinnn;
    }), window.hinnn = {}, hinnn.event = (i2 = {}, {
      on: function on(t3, e3) {
        i2[t3] || (i2[t3] = []), i2[t3].push(e3);
      },
      id: 0,
      off: function off(t3, e3) {
        var n3 = i2[t3];
        if (n3) {
          for (var o2 = -1, r2 = 0; r2 < n3.length; r2++) {
            if (n3[r2] === e3) {
              o2 = r2;
              break;
            }
          }
          o2 < 0 || i2[t3].splice(o2, 1);
        }
      },
      trigger: function trigger(t3) {
        var e3 = i2[t3];
        if (e3 && e3.length)
          for (var n3 = Array.prototype.slice.call(arguments, 1), o2 = 0; o2 < e3.length; o2++) {
            e3[o2].apply(this, n3);
          }
      },
      clear: function clear(t3) {
        i2[t3] = [];
      },
      getId: function getId() {
        return this.id += 1, this.id;
      },
      getNameWithId: function getNameWithId(t3) {
        return t3 + "-" + this.getId();
      }
    }), hinnn.form = {
      serialize: function serialize(t3) {
        var e3 = hiprintJQuery(t3).serializeArray(), n3 = {};
        return hiprintJQuery.each(e3, function() {
          n3[this.name] ? "[object Array]" == Object.prototype.toString.call(n3[this.name]) ? n3[this.name].push(this.value) : n3[this.name] = [n3[this.name], this.value] : n3[this.name] = this.value;
        }), n3;
      }
    }, hinnn.pt = {
      toPx: function toPx(t3) {
        return t3 * (this.getDpi() / 72);
      },
      toMm: function toMm(t3) {
        return hinnn.px.toMm(hinnn.pt.toPx(t3));
      },
      dpi: 0,
      getDpi: function getDpi() {
        if (!this.dpi) {
          var _t2 = document.createElement("DIV");
          _t2.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden", document.body.appendChild(_t2), this.dpi = _t2.offsetHeight;
        }
        return this.dpi;
      }
    }, hinnn.px = {
      toPt: function toPt(t3) {
        return t3 * (72 / this.getDpi());
      },
      toMm: function toMm(t3) {
        return Math.round(t3 / this.getDpi() * 25.4 * 100) / 100;
      },
      dpi: 0,
      getDpi: function getDpi() {
        if (!this.dpi) {
          var _t3 = document.createElement("DIV");
          _t3.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden", document.body.appendChild(_t3), this.dpi = _t3.offsetHeight;
        }
        return this.dpi;
      }
    }, hinnn.mm = {
      toPt: function toPt(t3) {
        return 72 / 25.4 * t3;
      },
      toPx: function toPx(t3) {
        return hinnn.pt.toPx(hinnn.mm.toPt(t3));
      }
    }, hinnn.throttle = function(t3, e3, n3) {
      var i3, o2, r2, a2 = null, p2 = 0;
      n3 || (n3 = {});
      var s2 = function s3() {
        p2 = false === n3.leading ? 0 : _.now(), a2 = null, r2 = t3.apply(i3, o2), a2 || (i3 = o2 = null);
      };
      return function() {
        var l2 = _.now();
        p2 || false !== n3.leading || (p2 = l2);
        var u2 = e3 - (l2 - p2);
        return i3 = this, o2 = arguments, u2 <= 0 || u2 > e3 ? (a2 && (clearTimeout(a2), a2 = null), p2 = l2, r2 = t3.apply(i3, o2), a2 || (i3 = o2 = null)) : a2 || false === n3.trailing || (a2 = setTimeout(s2, u2)), r2;
      };
    }, hinnn.debounce = function(t3, e3, n3) {
      var i3, o2, r2, a2, p2, s2 = function s3() {
        var l2 = _.now() - a2;
        l2 < e3 && l2 >= 0 ? i3 = setTimeout(s3, e3 - l2) : (i3 = null, n3 || (p2 = t3.apply(r2, o2), i3 || (r2 = o2 = null)));
      };
      return function() {
        r2 = this, o2 = arguments, a2 = _.now();
        var l2 = n3 && !i3;
        return i3 || (i3 = setTimeout(s2, e3)), l2 && (p2 = t3.apply(r2, o2), r2 = o2 = null), p2;
      };
    }, hinnn.toUtf8 = function(t3) {
      var e3, n3, i3, o2;
      for (e3 = "", i3 = t3.length, n3 = 0; n3 < i3; n3++) {
        (o2 = t3.charCodeAt(n3)) >= 1 && o2 <= 127 ? e3 += t3.charAt(n3) : o2 > 2047 ? (e3 += String.fromCharCode(224 | o2 >> 12 & 15), e3 += String.fromCharCode(128 | o2 >> 6 & 63), e3 += String.fromCharCode(128 | o2 >> 0 & 63)) : (e3 += String.fromCharCode(192 | o2 >> 6 & 31), e3 += String.fromCharCode(128 | o2 >> 0 & 63));
      }
      return e3;
    }, hinnn.groupBy = function(t3, e3, n3) {
      var i3 = {};
      return t3.forEach(function(t4) {
        var o2 = JSON.stringify(n3(t4));
        i3[o2] || (i3[o2] = {
          rows: []
        }, e3.forEach(function(e4) {
          i3[o2][e4] = t4[e4];
        })), i3[o2].rows.push(t4);
      }), Object.keys(i3).map(function(t4) {
        return i3[t4];
      });
    }, hinnn.orderBy = function(t3, e3) {
      if (t3.length <= 1) return t3;
      var n3 = Math.floor(t3.length / 2), i3 = t3.splice(n3, 1)[0], o2 = [], r2 = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = void 0;
      try {
        for (var _iterator = t3[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _n = _step.value;
          e3(_n) < e3(i3) ? o2.push(_n) : r2.push(_n);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      return this.orderBy(o2, e3).concat([i3], this.orderBy(r2, e3));
    }, hinnn.dateFormat = function(t3, e3) {
      if (t3)
        try {
          var o2 = /* @__PURE__ */ new Date(`${t3}`);
          var n3 = {
            "y+": o2.getFullYear(),
            "M+": o2.getMonth() + 1,
            "d+": o2.getDate(),
            "H+": o2.getHours(),
            "m+": o2.getMinutes(),
            "s+": o2.getSeconds(),
            "q+": Math.floor((o2.getMonth() + 3) / 3),
            S: o2.getMilliseconds()
          };
          for (var i3 in /(y+)/.test(e3) && (e3 = e3.replace(RegExp.$1, (o2.getFullYear() + "").substr(4 - RegExp.$1.length))), n3) {
            new RegExp("(" + i3 + ")").test(e3) && (e3 = e3.replace(RegExp.$1, 1 == RegExp.$1.length ? n3[i3] : ("00" + n3[i3]).substr(("" + n3[i3]).length)));
          }
          return e3;
        } catch (t4) {
          return /* @__PURE__ */ console.log(t4), "";
        }
      return "";
    }, hinnn.numFormat = function(t3, e3) {
      if (t3 != void 0)
        try {
          var o2 = "string" == typeof t3 ? parseFloat(t3) : t3;
          var l2 = parseInt(e3);
          if (l2 > 0) {
            return o2.toFixed(l2);
          }
          return parseInt(o2.toString());
        } catch (t4) {
          return /* @__PURE__ */ console.log(t4), "";
        }
      return "";
    }, hinnn.toUpperCase = function(type, val) {
      if (!Nzh) return val;
      var backStr = val;
      switch (type) {
        case "0":
          backStr = Nzh.cn.encodeS(val);
          break;
        case "1":
          backStr = Nzh.cn.encodeS(val, { tenMin: false });
          break;
        case "2":
          backStr = Nzh.cn.encodeB(val, { tenMin: true });
          break;
        case "3":
          backStr = Nzh.cn.encodeB(val);
          break;
        case "4":
          backStr = Nzh.cn.toMoney(val, { tenMin: true });
          break;
        case "5":
          backStr = Nzh.cn.toMoney(val);
          break;
        case "6":
          backStr = Nzh.cn.toMoney(val, { complete: true });
          break;
        case "7":
          backStr = Nzh.cn.toMoney(val, { complete: true, outSymbol: false });
          break;
      }
      return backStr;
    };
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return o2;
    });
    var i2 = n2(9), o2 = function() {
      function t3() {
      }
      return t3.prototype.init = function(t4) {
        t4 && hiprintJQuery.extend(this, t4);
      }, t3.prototype.on = function(t4, c2) {
        hinnn.event.on(t4, c2);
      }, t3.prototype.clear = function(t4) {
        hinnn.event.clear(t4);
      }, t3.prototype.registerItems = function(items) {
        items.forEach(function(t4) {
          i2.a.registerItem(new t4());
        });
      }, Object.defineProperty(t3, "instance", {
        get: function get() {
          return t3._instance || (t3._instance = new t3(), window.HIPRINT_CONFIG && hiprintJQuery.extend(t3._instance, HIPRINT_CONFIG), t3._instance.optionItems && t3._instance.optionItems.forEach(function(t4) {
            i2.a.registerItem(new t4());
          })), t3._instance;
        },
        enumerable: true,
        configurable: true
      }), t3;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    var i2 = function() {
      function t3(t4) {
        this.printElement = t4;
      }
      return t3.prototype.updatePosition = function(t4, e3) {
        this.left = t4, this.top = e3;
      }, t3;
    }();
    n2.d(e2, "a", function() {
      return o2;
    });
    var o2 = function() {
      function t3() {
        this.printTemplateContainer = {}, this.A1 = {
          width: 841,
          height: 594
        }, this.A2 = {
          width: 420,
          height: 594
        }, this.A3 = {
          width: 420,
          height: 297
        }, this.A4 = {
          width: 210,
          height: 297
        }, this.A5 = {
          width: 210,
          height: 148
        }, this.A6 = {
          width: 105,
          height: 148
        }, this.A7 = {
          width: 105,
          height: 74
        }, this.A8 = {
          width: 52,
          height: 74
        }, this.B1 = {
          width: 1e3,
          height: 707
        }, this.B2 = {
          width: 500,
          height: 707
        }, this.B3 = {
          width: 500,
          height: 353
        }, this.B4 = {
          width: 250,
          height: 353
        }, this.B5 = {
          width: 250,
          height: 176
        }, this.B6 = {
          width: 125,
          height: 176
        }, this.B7 = {
          width: 125,
          height: 88
        }, this.B8 = {
          width: 62,
          height: 88
        }, this.dragLengthCNum = function(t4, e3) {
          var n3 = 0.75 * t4;
          return e3 && (e3 = e3), Math.round(n3 / e3) * e3;
        };
      }
      return Object.defineProperty(t3, "instance", {
        get: function get() {
          return this._instance || (this._instance = new t3()), this._instance;
        },
        enumerable: true,
        configurable: true
      }), t3.prototype.getDragingPrintElement = function() {
        return t3.instance.dragingPrintElement;
      }, t3.prototype.setDragingPrintElement = function(e3) {
        t3.instance.dragingPrintElement = new i2(e3);
      }, t3.prototype.guid = function() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t4) {
          var e3 = 16 * Math.random() | 0;
          return ("x" == t4 ? e3 : 3 & e3 | 8).toString(16);
        });
      }, t3.prototype.imageToBase64 = function(t4) {
        if (-1 == hiprintJQuery(t4).attr("src").indexOf("base64"))
          try {
            var e3 = document.createElement("canvas"), n3 = new Image();
            n3.src = t4.attr("src"), e3.width = n3.width, e3.height = n3.height, e3.getContext("2d").drawImage(n3, 0, 0), t4.attr("src", e3.toDataURL("image/png"));
          } catch (e4) {
            try {
              this.xhrLoadImage(t4);
            } catch (t5) {
              /* @__PURE__ */ console.log(t5);
            }
          }
      }, t3.prototype.xhrLoadImage = function(t4) {
      }, t3.prototype.transformImg = function(t4) {
        var e3 = this;
        t4.map(function(t5, n3) {
          e3.imageToBase64(hiprintJQuery(n3));
        });
      }, t3.prototype.getPrintTemplateById = function(e3) {
        return t3.instance.printTemplateContainer[e3];
      }, t3.prototype.setPrintTemplateById = function(e3, n3) {
        return t3.instance.printTemplateContainer[e3] = n3;
      }, t3;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    var i2 = /* @__PURE__ */ function() {
      return function() {
      };
    }();
    n2.d(e2, "a", function() {
      return o2;
    });
    var o2 = function() {
      function t3(t4) {
        t4 = t4 || {}, this.left = t4.left, this.top = t4.top, this.topInDesign = this.top, this.height = t4.height, this.width = t4.width, this.transform = t4.transform, this.init(t4);
      }
      return t3.prototype.setDefault = function(t4) {
        this.defaultOptions = t4, this.initSize();
        Object.keys(this.defaultOptions).forEach((key) => {
          this[key] = this[key] || this.defaultOptions[key];
        });
      }, t3.prototype.initSize = function() {
        this.width || this.setWidth(this.defaultOptions.width), this.height || this.setHeight(this.defaultOptions.height);
      }, t3.prototype.initSizeByHtml = function(t4, e3) {
        this.width || this.setWidth(t4), this.height || this.setHeight(e3);
      }, t3.prototype.getRectInfo = function() {
        var d2 = { w: 0, h: 0, diffW: 0, diffH: 0 };
        if (this.transform) {
          var rad = this.transform * Math.PI / 180, width2 = this.width, height = this.height, sin = Math.sin(rad), cos = Math.cos(rad), w2 = Math.abs(width2 * cos) + Math.abs(height * sin), h2 = Math.abs(width2 * sin) + Math.abs(height * cos), diffW = (width2 - w2) / 2, diffH = (height - h2) / 2;
          d2.w = w2, d2.h = h2, d2.diffW = diffW, d2.diffH = diffH;
        }
        return d2;
      }, t3.prototype.getLeft = function() {
        return this.left - 0;
      }, t3.prototype.posLeft = function() {
        var left = this.left;
        if (this.transform) left += this.getRectInfo().diffW;
        return Math.floor(left * 10) / 10;
      }, t3.prototype.setRotate = function(t4) {
        null != t4 && (this.transform = t4);
      }, t3.prototype.displayLeft = function(t4) {
        if (this.transform && t4) {
          return this.left + this.getRectInfo().diffW + "pt";
        }
        return this.left + "pt";
      }, t3.prototype.setLeft = function(t4) {
        null != t4 && (this.left = t4);
      }, t3.prototype.getTop = function() {
        return this.top - 0;
      }, t3.prototype.posTop = function() {
        var top = this.top;
        if (this.transform) top += this.getRectInfo().diffH;
        return Math.floor(top * 10) / 10;
      }, t3.prototype.getTopInDesign = function() {
        return this.topInDesign;
      }, t3.prototype.displayTop = function(t4) {
        if (this.transform && t4) {
          return this.top + this.getRectInfo().diffH + "pt";
        }
        return this.top + "pt";
      }, t3.prototype.setTop = function(t4) {
        null != t4 && (this.top = t4);
      }, t3.prototype.copyDesignTopFromTop = function() {
        this.topInDesign = this.top;
      }, t3.prototype.getHeight = function() {
        if (this.transform) {
          var i3 = this.getRectInfo();
          return i3.h + i3.diffH;
        }
        return this.height - 0;
      }, t3.prototype.displayHeight = function() {
        return this.height + "pt";
      }, t3.prototype.setHeight = function(t4) {
        null != t4 && (this.height = t4);
      }, t3.prototype.getWidth = function() {
        if (this.transform) {
          var i3 = this.getRectInfo();
          return i3.w + i3.diffW;
        }
        return this.width - 0;
      }, t3.prototype.displayWidth = function() {
        return this.width + "pt";
      }, t3.prototype.setWidth = function(t4) {
        null != t4 && (this.width = t4);
      }, t3.prototype.getValueFromOptionsOrDefault = function(t4) {
        return null == this[t4] ? this.defaultOptions[t4] : this[t4];
      }, t3.prototype.getPrintElementOptionEntity = function() {
        var t4 = new i2(), e3 = this;
        return Object.keys(this).filter(function(t5) {
          return "topInDesign" != t5;
        }).forEach(function(n3) {
          if ("number" != typeof e3[n3] && "string" != typeof e3[n3] && !["fields"].includes(n3) && _typeof(e3[n3]) != _typeof(true) || (t4[n3] = e3[n3]), "style" == n3) {
            t4.style = {};
            var i3 = e3[n3];
            if (i3)
              Object.keys(i3).forEach(function(e4) {
                "number" != typeof i3[e4] && "string" != typeof i3[e4] || (t4.style[e4] = i3[e4]);
              });
          }
        }), t4;
      }, t3.prototype.init = function(t4) {
        var e3 = this;
        t4 && Object.keys(t4).forEach(function(n3) {
          e3[n3] = t4[n3];
        });
      }, t3;
    }();
  },
  function(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    __webpack_require__.d(__webpack_exports__, "a", function() {
      return BasePrintElement;
    });
    var _entity_PrintElementEntity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17), _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1), _print_element_option_PrintElementOptionItemManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9), _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6), _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0), _PrintReferenceElement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8), _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2), BasePrintElement = function() {
      function BasePrintElement(t2) {
        this.printElementType = t2, this.id = _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.guid();
      }
      return BasePrintElement.prototype.getConfigOptionsByName = function(t2) {
        return _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance[t2];
      }, BasePrintElement.prototype.getProxyTarget = function(t2) {
        t2 && this.SetProxyTargetOption(t2);
        var e2 = this.getData(), n2 = this.createTarget(this.getTitle(), e2);
        return this.updateTargetSize(n2), this.css(n2, e2), n2;
      }, BasePrintElement.prototype.SetProxyTargetOption = function(t2) {
        this.options.getPrintElementOptionEntity();
        hiprintJQuery.extend(this.options, t2);
        this.copyFromType();
      }, BasePrintElement.prototype.showInPage = function(t2, e2) {
        var n2 = this.options.showInPage, i2 = this.options.unShowInPage;
        if (n2) {
          if ("first" == n2) return 0 == t2;
          if (t2 == e2 - 1 && "last" == i2) return false;
          if ("odd" == n2) return (0 != t2 || "first" != i2) && t2 % 2 == 0;
          if ("even" == n2) return t2 % 2 == 1;
          if ("last" == n2) return t2 == e2 - 1;
        }
        return (0 != t2 || "first" != i2) && (t2 != e2 - 1 || "last" != i2);
      }, BasePrintElement.prototype.setTemplateId = function(t2) {
        this.templateId = t2;
      }, BasePrintElement.prototype.setPanel = function(t2) {
        this.panel = t2;
      }, BasePrintElement.prototype.getField = function() {
        return this.options.field || this.printElementType.field;
      }, BasePrintElement.prototype.getTitle = function() {
        return this.printElementType.title;
      }, BasePrintElement.prototype.updateSizeAndPositionOptions = function(t2, e2, n2, i2) {
        const template = _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.getPrintTemplateById(this.templateId);
        if (this.panel !== void 0 && !template.willOutOfBounds) {
          const panelWidthPt = hinnn.mm.toPt(this.panel.width);
          const panelHeightPt = hinnn.mm.toPt(this.panel.height);
          if (t2 < 0) {
            return;
          }
          if (e2 < 0) {
            return;
          }
          if (t2 + this.options.width > panelWidthPt) {
            return;
          }
          if (e2 + this.options.height > panelHeightPt) {
            return;
          }
        }
        this.options.setLeft(t2), this.options.setTop(e2), this.options.copyDesignTopFromTop(), this.options.setWidth(n2), this.options.setHeight(i2);
      }, BasePrintElement.prototype.initSizeByHtml = function(t2) {
        if (t2 && t2.length) {
          this.createTempContainer();
          var e2 = t2.clone();
          this.getTempContainer().append(e2), this.options.initSizeByHtml(parseInt(hinnn.px.toPt(e2.width()).toString()), parseInt(hinnn.px.toPt(e2.height()).toString())), this.removeTempContainer();
        }
      }, BasePrintElement.prototype.updateTargetSize = function(t2) {
        t2.css("width", this.options.displayWidth()), t2.css("height", this.options.displayHeight());
      }, BasePrintElement.prototype.updateTargetWidth = function(t2) {
        t2.css("width", this.options.displayWidth());
      }, BasePrintElement.prototype.getDesignTarget = function(t2) {
        var e2 = this, lastTimeStamp = 0;
        return this.designTarget = this.getHtml(t2)[0].target, this.designPaper = t2, this.designTarget.click(function(ev) {
          if (ev.timeStamp - lastTimeStamp > 500) {
            hinnn.event.trigger(e2.getPrintElementSelectEventKey(), {
              printElement: e2
            });
          }
          lastTimeStamp = ev.timeStamp;
        }), this.designTarget.dblclick(function(ev) {
          var c2 = e2.designTarget.find(".hiprint-printElement-content");
          if (c2) {
            var p2 = e2.designTarget.find(".resize-panel");
            if (e2.printElementType.type == "text" && !(e2.options.textType && "text" != e2.options.textType)) {
              e2._editing = true;
              e2.designTarget.hidraggable("update", { draggable: false });
              c2.css("cursor", "text"), c2.addClass("editing");
              e2.designTarget.addClass("editing");
              c2.click(function(ev2) {
                if (e2._editing) {
                  ev2.stopPropagation();
                }
              });
              c2.attr("contenteditable", true), p2 && p2.css("display", "none");
              e2.selectEnd(c2);
            }
          }
        }), this.designTarget;
      }, BasePrintElement.prototype.selectEnd = function(el) {
        el.focus();
        if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
          var r2 = document.createRange();
          r2.selectNodeContents(el[0]);
          r2.collapse(false);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(r2);
        } else if (typeof document.body.createTextRange != "undefined") {
          var r2 = document.body.createTextRange();
          r2.moveToElementText(el[0]), r2.collapse(false), r2.select();
        }
      }, BasePrintElement.prototype.updateByContent = function(clear) {
        var e2 = this, c2 = e2.designTarget.find(".hiprint-printElement-content");
        if (e2._editing) {
          c2 && c2.css("cursor", "") && c2.removeClass("editing") && c2.removeAttr("contenteditable");
          e2.designTarget.removeClass("editing");
          var t2 = c2.text(), title = e2.options.title + "\uFF1A";
          if (t2.startsWith(title) && e2.options.field) {
            if (t2.length > title.length) {
              e2.options.testData = t2.split("\uFF1A")[1];
            } else {
              e2.options.title = t2;
              e2.options.testData = "";
            }
          } else {
            e2.options.title = t2;
          }
          e2.options.title = e2.options.title.split("\uFF1A")[0];
          if (!clear) {
            hinnn.event.trigger(e2.getPrintElementSelectEventKey(), {
              printElement: e2
            });
          }
          e2.updateDesignViewFromOptions(), hinnn.event.trigger("hiprintTemplateDataChanged_" + e2.templateId, "\u7F16\u8F91\u4FEE\u6539");
          e2._editing = false;
          var draggable = e2.options.draggable == void 0 || true == e2.options.draggable;
          e2.designTarget.hidraggable("update", { draggable });
        }
      }, BasePrintElement.prototype.getPrintElementSelectEventKey = function() {
        return "PrintElementSelectEventKey_" + this.templateId;
      }, BasePrintElement.prototype.design = function(t2, e2) {
        var n2 = this;
        this.designTarget.hidraggable({
          // 添加 draggable 属性
          draggable: n2.options.draggable,
          axis: n2.options.axis ? n2.options.axis : void 0,
          designTarget: n2,
          onDrag: function onDrag(t3, i2, o2) {
            var els = n2.panel.printElements.filter(function(t4) {
              return "block" == t4.designTarget.children().last().css("display") && t4.designTarget.children().last().hasClass("selected") && !t4.printElementType.type.includes("table");
            });
            var isMultiple = els.length > 1;
            var notSelected = !n2.designTarget.children().last().hasClass("selected");
            if (isMultiple) {
              var left = i2 - n2.options.left, top = o2 - n2.options.top;
              els.forEach(function(t4) {
                t4.updateSizeAndPositionOptions(left + t4.options.getLeft(), top + t4.options.getTop()), t4.designTarget.css("left", t4.options.displayLeft()), t4.designTarget.css("top", t4.options.displayTop());
                t4.createLineOfPosition(e2);
              });
              if (notSelected) {
                n2.updateSizeAndPositionOptions(i2, o2), n2.createLineOfPosition(e2);
              }
            } else {
              n2.updateSizeAndPositionOptions(i2, o2), n2.createLineOfPosition(e2);
            }
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.changed = true;
          },
          moveUnit: "pt",
          minMove: _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance.movingDistance,
          onBeforeDrag: function onBeforeDrag(t3) {
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.draging = true, n2.designTarget.focus(), n2.createLineOfPosition(e2);
          },
          onBeforeSelectAllDrag: function onBeforeSelectAllDrag() {
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.draging = true, n2.designTarget.focus();
          },
          getScale: function getScale() {
            return n2.designPaper.scale || 1;
          },
          onStopDrag: function onStopDrag(t3) {
            if (_HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.changed) hinnn.event.trigger("hiprintTemplateDataChanged_" + n2.templateId, "\u79FB\u52A8");
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.draging = false, _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.changed = false;
            var els = n2.panel.printElements.filter(function(t4) {
              return "block" == t4.designTarget.children().last().css("display") && !t4.printElementType.type.includes("table");
            });
            if (els.length > 1) {
              els.forEach(function(t4) {
                t4.removeLineOfPosition();
              });
            } else n2.removeLineOfPosition();
          }
        }), this.setResizePanel(), this.bingCopyEvent(this.designTarget), this.bingKeyboardMoveEvent(this.designTarget, e2);
      }, BasePrintElement.prototype.getPrintElementEntity = function(t2) {
        return t2 ? new _entity_PrintElementEntity__WEBPACK_IMPORTED_MODULE_0__.a(void 0, this.options.getPrintElementOptionEntity(), this.printElementType.getPrintElementTypeEntity()) : new _entity_PrintElementEntity__WEBPACK_IMPORTED_MODULE_0__.a(this.printElementType.tid, this.options.getPrintElementOptionEntity());
      }, BasePrintElement.prototype.submitOption = function() {
        var els = this.panel.printElements.filter(function(t3) {
          return "block" == t3.designTarget.children().last().css("display") && t3.designTarget.children().last().hasClass("selected") && !t3.printElementType.type.includes("table");
        });
        els = els.filter((ele) => ele.printElementType.type == this.printElementType.type);
        var t2 = this, o2 = this.getConfigOptions();
        if (o2 && o2.tabs && o2.tabs.length) {
          this.getPrintElementOptionTabs().forEach(function(tab) {
            if (tab.name === "\u6837\u5F0F" && els.length) {
              tab.list.forEach(function(e2) {
                els.forEach((ele) => {
                  var n2 = e2.getValue(), r2 = "textType" == e2.name && ele.options[e2.name] !== n2, a2 = "axis" == e2.name && ele.options[e2.name] !== n2;
                  n2 && "object" == _typeof(n2) ? Object.keys(n2).forEach(function(e3) {
                    ele.options[e3] = n2[e3];
                  }) : ele.options[e2.name] = n2;
                  if (r2) {
                    ele.setResizePanel();
                  }
                  if (a2) {
                    ele.designTarget.hidraggable("update", { axis: n2 });
                  }
                });
              });
            } else {
              tab.list.forEach(function(e2) {
                if (!e2) return;
                var n2 = e2.getValue(), r2 = "textType" == e2.name && t2.options[e2.name] !== n2, a2 = "axis" == e2.name && t2.options[e2.name] !== n2;
                n2 && "object" == _typeof(n2) ? Object.keys(n2).forEach(function(e3) {
                  t2.options[e3] = n2[e3];
                }) : t2.options[e2.name] = n2;
                if (r2) {
                  t2.setResizePanel();
                }
                if (a2) {
                  t2.designTarget.hidraggable("update", { axis: n2 });
                }
              });
            }
          });
        } else {
          this.getPrintElementOptionItems().forEach(function(e2) {
            var n2 = e2.getValue(), r2 = "textType" == e2.name && t2.options[e2.name] !== n2, a2 = "axis" == e2.name && t2.options[e2.name] !== n2;
            n2 && "object" == _typeof(n2) ? Object.keys(n2).forEach(function(e3) {
              t2.options[e3] = n2[e3];
            }) : t2.options[e2.name] = n2;
            if (r2) {
              t2.setResizePanel();
            }
            if (a2) {
              t2.designTarget.hidraggable("update", { axis: n2 });
            }
          });
        }
        this.updateDesignViewFromOptions(), hinnn.event.trigger("hiprintTemplateDataChanged_" + this.templateId, "\u5143\u7D20\u4FEE\u6539");
      }, BasePrintElement.prototype.updateOption = function(o2, v2, b2) {
        try {
          var e2 = this.getConfigOptions();
          var optionKeys = [];
          if (e2 && e2.tabs && e2.tabs.length) {
            e2.tabs.forEach(function(n2) {
              n2.options.forEach(function(e3) {
                optionKeys.push(e3.name);
              });
            });
          } else {
            optionKeys = e2.supportOptions.map(function(e3) {
              return e3.name;
            });
          }
          if (optionKeys && optionKeys.includes(o2)) {
            this.options[o2] = v2;
            this.updateDesignViewFromOptions();
            if (!b2) {
              hinnn.event.trigger("hiprintTemplateDataChanged_" + this.templateId, "\u53C2\u6570\u4FEE\u6539");
            }
          }
          this._printElementOptionTabs.forEach((tab) => {
            tab.list.forEach((item) => {
              var _a, _b;
              if (item.name === o2) {
                (_a = item.target.find("select")) == null ? void 0 : _a.val(v2.toString());
                (_b = item.target.find("input")) == null ? void 0 : _b.val(v2.toString());
              }
            });
          });
        } catch (e3) {
          /* @__PURE__ */ console.log("updateOption error", e3);
        }
      }, BasePrintElement.prototype.getReizeableShowPoints = function() {
        return ["barcode", "qrcode"].includes(this.options.textType) ? ["se", "s", "e", "r"] : ["s", "e", "r"];
      }, BasePrintElement.prototype.setResizePanel = function() {
        var n2 = this, e2 = this.designPaper;
        this.designTarget.hireizeable({
          showPoints: n2.getReizeableShowPoints(),
          draggable: n2.options.draggable,
          // 元素是否可拖拽、删除
          // 是否显示宽高box
          showSizeBox: _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance.showSizeBox,
          getScale: function getScale() {
            return n2.designPaper.scale || 1;
          },
          onBeforeResize: function onBeforeResize() {
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.draging = true;
          },
          onResize: function onResize(t2, i2, o2, r2, a2, rt2) {
            if (void 0 != rt2) {
              n2.onRotate(t2, rt2);
            } else {
              n2.onResize(t2, i2, o2, r2, a2);
            }
            n2.createLineOfPosition(e2);
          },
          onStopResize: function onStopResize(r2) {
            hinnn.event.trigger("hiprintTemplateDataChanged_" + n2.templateId, r2 ? "\u65CB\u8F6C" : "\u5927\u5C0F");
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.draging = false, n2.removeLineOfPosition();
          }
        });
      }, BasePrintElement.prototype.onRotate = function(t2, r2) {
        this.options.setRotate(r2);
      }, BasePrintElement.prototype.onResize = function(t2, e2, n2, i2, o2) {
        this.updateSizeAndPositionOptions(o2, i2, n2, e2);
      }, BasePrintElement.prototype.getOrderIndex = function() {
        return this.options.getTop();
      }, BasePrintElement.prototype.getHtml = function(t2, e2, n2) {
        var i2 = 0;
        this.setCurrenttemplateData(e2);
        var o2 = [], r2 = this.getBeginPrintTopInPaperByReferenceElement(t2), a2 = t2.getPaperFooter(i2);
        this.isHeaderOrFooter() || this.isFixed() || r2 > a2 && "none" != t2.panelPageRule && (o2.push(
          new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_3__.a({
            target: void 0,
            printLine: void 0
          })
        ), r2 = r2 - a2 + t2.paperHeader, i2++, a2 = t2.getPaperFooter(i2));
        var p2 = this.getData(e2), s2 = this.createTarget(this.getTitle(), p2, n2);
        this.updateTargetSize(s2), this.css(s2, p2), s2.css("position", "absolute"), s2.css("left", this.options.displayLeft()), s2.css("top", r2 + "pt"), o2.push(
          new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_3__.a({
            target: s2,
            printLine: r2 + this.options.getHeight(),
            referenceElement: new _PrintReferenceElement__WEBPACK_IMPORTED_MODULE_5__.a({
              top: this.options.getTop(),
              left: this.options.getLeft(),
              height: this.options.getHeight(),
              width: this.options.getWidth(),
              beginPrintPaperIndex: t2.index,
              bottomInLastPaper: r2 + this.options.getHeight(),
              printTopInPaper: r2
            })
          })
        );
        if (e2 && this.options.pageBreak) {
          o2[0].target.css("top", t2.paperHeader + "pt");
          o2[0].referenceElement.top = this.options.getTop() - this.options.getHeight() - t2.paperHeader;
          o2[0].printLine = t2.paperHeader;
          o2[0].referenceElement.bottomInLastPaper = 0;
          o2[0].referenceElement.printTopInPaper = t2.paperHeader;
          o2.unshift(
            new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_3__.a({
              target: s2,
              printLine: t2.height,
              referenceElement: new _PrintReferenceElement__WEBPACK_IMPORTED_MODULE_5__.a({
                top: 0,
                left: 0,
                height: 0,
                width: 0,
                beginPrintPaperIndex: t2.index,
                bottomInLastPaper: t2.height,
                printTopInPaper: t2.paperHeader
              })
            })
          );
        }
        return o2;
      }, BasePrintElement.prototype.getHtml2 = function(t2, e2, n2) {
        var i2 = 0;
        this.setCurrenttemplateData(e2);
        var o2 = [], r2 = this.getBeginPrintTopInPaperByReferenceElement(t2), a2 = t2.getPaperFooter(i2);
        this.isHeaderOrFooter() || this.isFixed() || ("none" != t2.panelPageRule && r2 > a2 && (o2.push(
          new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_3__.a({
            target: void 0,
            printLine: void 0
            // (e && r + this.options.getHeight() > a) --> 设计时拖拽元素高度超过页脚线时,导致报错问题
          })
        ), r2 = r2 - a2 + t2.paperHeader, i2++, a2 = t2.getPaperFooter(i2)), r2 <= a2 && e2 && r2 + this.options.getHeight() > a2 && "none" != t2.panelPageRule && (o2.push(
          new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_3__.a({
            target: void 0,
            printLine: void 0
          })
        ), r2 = t2.paperHeader, i2++, a2 = t2.getPaperFooter(i2)));
        var p2 = this.getData(e2), s2 = this.createTarget(this.getTitle(), p2);
        if ("none" == t2.panelPageRule && r2 + this.options.getHeight() > a2) this.updatePanelHeight(r2 + this.options.getHeight(), t2);
        this.updateTargetSize(s2), this.css(s2, p2), s2.css("position", "absolute"), s2.css("left", this.options.displayLeft()), s2.css("top", r2 + "pt"), o2.push(
          new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_3__.a({
            target: s2,
            printLine: r2 + this.options.getHeight(),
            referenceElement: new _PrintReferenceElement__WEBPACK_IMPORTED_MODULE_5__.a({
              top: this.options.getTop(),
              left: this.options.getLeft(),
              height: this.options.getHeight(),
              width: this.options.getWidth(),
              beginPrintPaperIndex: t2.index,
              bottomInLastPaper: r2 + this.options.getHeight(),
              printTopInPaper: r2
            })
          })
        );
        if (e2 && this.options.pageBreak) {
          o2[0].target.css("top", t2.paperHeader + "pt");
          o2[0].referenceElement.top = this.options.getTop() - this.options.getHeight() - t2.paperHeader;
          o2[0].printLine = t2.paperHeader;
          o2[0].referenceElement.bottomInLastPaper = 0;
          o2[0].referenceElement.printTopInPaper = t2.paperHeader;
          o2.unshift(
            new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_3__.a({
              target: s2,
              printLine: t2.height,
              referenceElement: new _PrintReferenceElement__WEBPACK_IMPORTED_MODULE_5__.a({
                top: 0,
                left: 0,
                height: 0,
                width: 0,
                beginPrintPaperIndex: t2.index,
                bottomInLastPaper: t2.height,
                printTopInPaper: t2.paperHeader
              })
            })
          );
        }
        return o2;
      }, BasePrintElement.prototype.updatePanelHeight = function(h2, p2) {
        if ("none" == this.panel.panelPageRule) {
          var nmh = hinnn.pt.toMm(h2);
          p2.paperFooter = h2;
          p2.target.css("height", nmh + "mm"), p2.target.attr("original-height", nmh);
        }
      }, BasePrintElement.prototype.getBeginPrintTopInPaperByReferenceElement = function(t2) {
        var e2 = this.options.getTop();
        return this.isHeaderOrFooter() || this.isFixed() ? e2 : t2.referenceElement.isPositionLeftOrRight(e2) ? t2.referenceElement.printTopInPaper + (e2 - t2.referenceElement.top) : t2.referenceElement.bottomInLastPaper + (e2 - (t2.referenceElement.top + t2.referenceElement.height));
      }, BasePrintElement.prototype.css = function(t2, e2) {
        var n2 = this, i2 = [], o2 = this.getConfigOptions();
        if (o2) {
          var r2;
          if (o2.tabs && o2.tabs.length) {
            r2 = [];
            o2.tabs.forEach(function(n3) {
              r2 = r2.concat(n3.options);
            });
          } else {
            r2 = o2.supportOptions;
          }
          r2 && r2.forEach(function(e3) {
            var o3 = _print_element_option_PrintElementOptionItemManager__WEBPACK_IMPORTED_MODULE_2__.a.getItem(e3.name);
            if (o3 && o3.css) {
              var r3 = o3.css(t2, n2.options.getValueFromOptionsOrDefault(e3.name));
              r3 && i2.push(r3);
            }
          });
        }
        this.stylerCss(t2, e2);
      }, BasePrintElement.prototype.stylerCss = function(t2, e2) {
        var n2 = this.getStyler();
        if (n2) {
          var i2 = n2(e2, this.options, t2, this._currenttemplateData);
          if (i2)
            Object.keys(i2).forEach(function(e3) {
              t2.css(e3, i2[e3]);
            });
        }
      }, BasePrintElement.prototype.getData = function(t2) {
        var f2 = this.getField();
        return t2 ? f2 ? f2.split(".").reduce((a2, c2) => a2 ? a2[c2] : t2 ? t2[c2] : "", false) || "" : "" : this.printElementType.getData();
      }, BasePrintElement.prototype.copyFromType = function() {
        var options2 = this.options, type = this.printElementType;
        var o2 = this.getConfigOptions();
        var names = [];
        if (o2 && o2.tabs && o2.tabs.length) {
          o2.tabs.forEach(function(n2) {
            n2.options.forEach(function(e2) {
              names.push(e2.name);
            });
          });
        } else {
          names = o2.supportOptions.map(function(e2) {
            return e2.name;
          });
        }
        Object.keys(type).forEach(function(e2) {
          if (type[e2] && "columns" != e2 && names.indexOf(e2) > -1) {
            options2[e2] = "function" == _typeof(type[e2]) ? type[e2].toString() : type[e2];
          }
        });
        return options2;
      }, BasePrintElement.prototype.getPrintElementOptionTabs = function() {
        if (this._printElementOptionTabs) return this._printElementOptionTabs;
        var tabs = [], e2 = this.getConfigOptions();
        if (e2) {
          var t2 = e2.tabs;
          t2 && t2.forEach(function(n2, i2) {
            tabs.push({ name: n2.name, list: [] });
            n2.options.filter(function(t3) {
              return !t3.hidden;
            }).forEach(function(e3) {
              var n3 = _print_element_option_PrintElementOptionItemManager__WEBPACK_IMPORTED_MODULE_2__.a.getItem(e3.name);
              tabs[i2].list.push(n3);
            });
          });
        }
        return this._printElementOptionTabs = tabs, this._printElementOptionItems = void 0, this._printElementOptionTabs;
      }, BasePrintElement.prototype.getPrintElementOptionItems = function() {
        if (this._printElementOptionItems) return this._printElementOptionItems;
        var t2 = [], e2 = this.getConfigOptions();
        if (e2) {
          var n2;
          if (e2.tabs && e2.tabs.length) {
            n2 = [];
            e2.tabs.forEach(function(n3) {
              n3 = n3.concat(n3.options);
            });
          } else {
            n2 = e2.supportOptions;
          }
          n2 && n2.filter(function(t3) {
            return !t3.hidden;
          }).forEach(function(e3) {
            var n3 = _print_element_option_PrintElementOptionItemManager__WEBPACK_IMPORTED_MODULE_2__.a.getItem(e3.name);
            t2.push(n3);
          });
        }
        return this._printElementOptionItems = this.filterOptionItems(t2.concat()), this._printElementOptionTabs = void 0, this._printElementOptionItems;
      }, BasePrintElement.prototype.getPrintElementOptionItemsByName = function(t2) {
        var e2 = [], n2 = this.getConfigOptionsByName(t2);
        if (n2) {
          var i2;
          if (n2.tabs && n2.tabs.length) {
            i2 = [];
            n2.tabs.forEach(function(n3) {
              i2 = i2.concat(n3.options);
            });
          } else {
            i2 = n2.supportOptions;
          }
          i2 && i2.filter(function(t3) {
            return !t3.hidden;
          }).forEach(function(t3) {
            var n3 = _print_element_option_PrintElementOptionItemManager__WEBPACK_IMPORTED_MODULE_2__.a.getItem(t3.name);
            e2.push(n3);
          });
        }
        return e2.concat();
      }, BasePrintElement.prototype.filterOptionItems = function(t2) {
        return this.printElementType.field ? t2.filter(function(t3) {
          return "field" != t3.name;
        }) : t2;
      }, BasePrintElement.prototype.createTempContainer = function() {
        this.removeTempContainer(), hiprintJQuery("body").append(hiprintJQuery('<div class="hiprint_temp_Container hiprint-printPaper" style="overflow:hidden;height: 0px;box-sizing: border-box;"></div>'));
      }, BasePrintElement.prototype.removeTempContainer = function() {
        hiprintJQuery(".hiprint_temp_Container").remove();
      }, BasePrintElement.prototype.getTempContainer = function() {
        return hiprintJQuery(".hiprint_temp_Container");
      }, BasePrintElement.prototype.isHeaderOrFooter = function() {
        return this.options.getTopInDesign() < this.panel.paperHeader || this.options.getTopInDesign() >= this.panel.paperFooter;
      }, BasePrintElement.prototype.delete = function() {
        this.designTarget && this.designTarget.remove();
      }, BasePrintElement.prototype.setCurrenttemplateData = function(t2) {
        this._currenttemplateData = t2;
      }, BasePrintElement.prototype.isFixed = function() {
        return this.options.fixed;
      }, BasePrintElement.prototype.onRendered = function(t2, e2) {
        this.printElementType && this.printElementType.onRendered && this.printElementType.onRendered(e2, this.options, t2.getTarget());
      }, BasePrintElement.prototype.createLineOfPosition = function(t2) {
        var e2 = hiprintJQuery(".toplineOfPosition.id" + this.id), topPos = hiprintJQuery(".topPosition.id" + this.id), n2 = hiprintJQuery(".leftlineOfPosition.id" + this.id), leftPos = hiprintJQuery(".leftPosition.id" + this.id), i2 = hiprintJQuery(".rightlineOfPosition.id" + this.id), o2 = hiprintJQuery(".bottomlineOfPosition.id" + this.id);
        var config = _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance;
        if (e2.length) e2.css("top", this.options.displayTop(true));
        else {
          var e2 = hiprintJQuery('<div class="toplineOfPosition id' + this.id + '" style="position: absolute; width: 100%;"></div>');
          e2.css("top", this.options.displayTop(true)), e2.css("width", t2.displayWidth()), this.designTarget.parents(".hiprint-printPaper-content").append(e2);
        }
        if (config.showPosition) {
          if (topPos.length) {
            topPos.toggleClass("topPosition-lineMode", config.positionLineMode);
            topPos.text(this.options.posTop() + (config.positionUnit ? "pt" : ""));
            topPos.css("top", this.options.posTop() - topPos.height() + "pt");
            if (config.positionLineMode) {
              topPos.css("left", this.options.posLeft() - topPos.width() / 2 + "pt");
            } else {
              topPos.css("left", this.options.posLeft() + 2 + "pt");
            }
            this.designTarget.find(".size-box") && this.designTarget.find(".size-box").toggleClass("hide", true);
          } else {
            var topPos = hiprintJQuery('<div class="topPosition id' + this.id + '" style="position: absolute;"></div>');
            topPos.toggleClass("topPosition-lineMode", config.positionLineMode);
            topPos.text(this.options.posTop() + (config.positionUnit ? "pt" : ""));
            if (config.positionLineMode) {
              topPos.css("left", this.options.posLeft() - topPos.width() / 2 + "pt");
            } else {
              topPos.css("left", this.options.posLeft() + 2 + "pt");
            }
            this.designTarget.find(".size-box") && this.designTarget.find(".size-box").toggleClass("hide", true);
            this.designTarget.parents(".hiprint-printPaper-content").append(topPos);
            topPos.css("top", this.options.posTop() - topPos.height() + "pt");
          }
        }
        if (n2.length) n2.css("left", this.options.displayLeft(true));
        else {
          var r2 = hiprintJQuery('<div class="leftlineOfPosition id' + this.id + '" style="position: absolute;height: 100%;"></div>');
          r2.css("left", this.options.displayLeft(true)), r2.css("height", t2.displayHeight()), this.designTarget.parents(".hiprint-printPaper-content").append(r2);
        }
        if (config.showPosition) {
          if (leftPos.length) {
            leftPos.text(this.options.posLeft() + (config.positionUnit ? "pt" : ""));
            leftPos.toggleClass("leftPosition-lineMode", config.positionLineMode);
            leftPos.css("left", this.options.posLeft() - leftPos.width() + "pt");
            if (config.positionLineMode) {
              leftPos.css("top", this.options.posTop() - leftPos.height() / 3 + "pt");
            } else {
              leftPos.css("top", this.options.posTop() + 2 + "pt");
            }
          } else {
            var leftPos = hiprintJQuery('<div class="leftPosition id' + this.id + '" style="position: absolute;"></div>');
            leftPos.text(this.options.posLeft() + (config.positionUnit ? "pt" : ""));
            leftPos.toggleClass("leftPosition-lineMode", config.positionLineMode);
            if (config.positionLineMode) {
              leftPos.css("top", this.options.posTop() - leftPos.height() / 3 + "pt");
            } else {
              leftPos.css("top", this.options.posTop() + 2 + "pt");
            }
            this.designTarget.parents(".hiprint-printPaper-content").append(leftPos);
            leftPos.css("left", this.options.posLeft() - leftPos.width() + "pt");
          }
        }
        if (i2.length) i2.css("left", this.options.getLeft() + this.options.getWidth() + "pt");
        else {
          var a2 = hiprintJQuery('<div class="rightlineOfPosition id' + this.id + '" style="position: absolute;height: 100%;"></div>');
          a2.css("left", this.options.getLeft() + this.options.getWidth() + "pt"), a2.css("height", t2.displayHeight()), this.designTarget.parents(".hiprint-printPaper-content").append(a2);
        }
        if (o2.length) o2.css("top", this.options.getTop() + this.options.getHeight() + "pt");
        else {
          var p2 = hiprintJQuery('<div class="bottomlineOfPosition id' + this.id + '" style="position: absolute;width: 100%;"></div>');
          p2.css("top", this.options.getTop() + this.options.getHeight() + "pt"), p2.css("width", t2.displayWidth()), this.designTarget.parents(".hiprint-printPaper-content").append(p2);
        }
      }, BasePrintElement.prototype.removeLineOfPosition = function() {
        hiprintJQuery(".toplineOfPosition.id" + this.id).remove(), hiprintJQuery(".topPosition.id" + this.id).remove(), this.designTarget.find(".size-box") && this.designTarget.find(".size-box").toggleClass("hide", false), hiprintJQuery(".leftlineOfPosition.id" + this.id).remove(), hiprintJQuery(".leftPosition.id" + this.id).remove(), hiprintJQuery(".rightlineOfPosition.id" + this.id).remove(), hiprintJQuery(".bottomlineOfPosition.id" + this.id).remove();
      }, BasePrintElement.prototype.getFontList = function() {
        var t2 = this.options.fontList;
        return t2 || (t2 = _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.getPrintTemplateById(this.templateId).getFontList());
      }, BasePrintElement.prototype.getFields = function() {
        if ("table" == this.printElementType.type) {
          var t2 = this.options.tableFields;
          return t2;
        }
        var t2 = this.options.fields;
        return t2 || (t2 = _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.getPrintTemplateById(this.templateId).getFields());
      }, BasePrintElement.prototype.getOnImageChooseClick = function() {
        var t2 = this.options.onImageChooseClick;
        return t2 || (t2 = _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.getPrintTemplateById(this.templateId).getOnImageChooseClick());
      }, BasePrintElement.prototype.bingCopyEvent = function(t2) {
        var n2 = this;
        t2.keydown(function(r2) {
          if (n2._editing) {
            if (!r2.altKey && 13 == r2.keyCode) {
              n2.updateByContent();
              return;
            }
          }
          if ((r2.ctrlKey || r2.metaKey) && 67 == r2.keyCode) {
            n2.copyJson();
            r2.preventDefault();
          }
        });
      }, BasePrintElement.prototype.copyJson = function() {
        try {
          var n2 = this;
          var copyArea = hiprintJQuery("#copyArea");
          if (!copyArea.length) copyArea = hiprintJQuery('<textarea id="copyArea" style="position: absolute; left: 0px; top: 0px;opacity: 0"></textarea>');
          hiprintJQuery("body").append(copyArea);
          let copyElements = this.panel.printElements.filter((ele) => {
            return "block" == ele.designTarget.children().last().css("display") && !ele.printElementType.type.includes("table");
          });
          copyElements = copyElements.map((ele) => {
            return {
              options: ele.options,
              printElementType: ele.printElementType,
              id: ele.id,
              templateId: ele.templateId
            };
          });
          var json = JSON.stringify(copyElements);
          copyArea.text(json);
          copyArea.css("visibility", "visible");
          if (copyArea.setSelectionRange) copyArea.setSelectionRange(0, copyArea.value.length);
          else copyArea.select();
          var flag = false;
          flag = document.execCommand("copy");
          copyArea.css("visibility", "hidden");
          n2.designTarget.focus();
          /* @__PURE__ */ console.log("copyJson success");
        } catch (e2) {
          flag = false;
          /* @__PURE__ */ console.log("copyJson error", e2);
        }
        return flag;
      }, BasePrintElement.prototype.clone = function(t2) {
        var n2 = this;
        let newObj = n2.printElementType.createPrintElement();
        Object.keys(n2.options).forEach(function(key) {
          newObj.options[key] = n2.options[key];
        });
        return newObj;
      }, BasePrintElement.prototype.getFormatter = function() {
        var formatter = void 0;
        if (this.printElementType.formatter && (formatter = this.printElementType.formatter), this.options.formatter)
          try {
            var s = "formatter=" + this.options.formatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return formatter;
      }, BasePrintElement.prototype.getStyler = function() {
        var fnstyler = void 0;
        if (this.printElementType.styler && (fnstyler = this.printElementType.styler), this.options.styler)
          try {
            var s = "fnstyler=" + this.options.styler;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return fnstyler;
      }, BasePrintElement.prototype.bingKeyboardMoveEvent = function(t2, e2) {
        var n2 = this, i2 = void 0, o2 = void 0;
        t2.attr("tabindex", "1"), t2.keydown(function(r2) {
          if ("INPUT" == r2.target.tagName) {
            return;
          }
          if (n2._editing && !r2.altKey) {
            return;
          }
          if (false === n2.options.draggable) {
            return;
          }
          var els = n2.panel.printElements.filter(function(t3) {
            return "block" == t3.designTarget.children().last().css("display") && !t3.printElementType.type.includes("table");
          });
          var isMultiple = els.length > 1;
          var movingDistance = _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance.movingDistance;
          switch (r2.keyCode) {
            case 8:
            case 46:
              var templete = _HiPrintlib__WEBPACK_IMPORTED_MODULE_6__.a.instance.getPrintTemplateById(n2.templateId);
              templete.deletePrintElement(n2);
              hinnn.event.trigger("hiprintTemplateDataChanged_" + n2.templateId, "\u5220\u9664");
              hinnn.event.trigger("clearSettingContainer");
              els.forEach((ele) => {
                templete.deletePrintElement(ele);
                hinnn.event.trigger("hiprintTemplateDataChanged_" + ele.templateId, "\u5220\u9664");
              });
              hinnn.event.trigger("clearSettingContainer");
              break;
            case 37:
              i2 = n2.options.getLeft();
              if (isMultiple) {
                els.forEach(function(t3) {
                  t3.updatePositionByMultipleSelect(0 - movingDistance, 0);
                });
              } else {
                n2.updateSizeAndPositionOptions(i2 - movingDistance), t2.css("left", n2.options.displayLeft());
              }
              r2.preventDefault();
              break;
            case 38:
              o2 = n2.options.getTop();
              if (isMultiple) {
                els.forEach(function(t3) {
                  t3.updatePositionByMultipleSelect(0, 0 - movingDistance);
                });
              } else {
                n2.updateSizeAndPositionOptions(void 0, o2 - movingDistance), t2.css("top", n2.options.displayTop());
              }
              r2.preventDefault();
              break;
            case 39:
              i2 = n2.options.getLeft();
              if (isMultiple) {
                els.forEach(function(t3) {
                  t3.updatePositionByMultipleSelect(movingDistance, 0);
                });
              } else {
                n2.updateSizeAndPositionOptions(i2 + movingDistance), t2.css("left", n2.options.displayLeft());
              }
              r2.preventDefault();
              break;
            case 40:
              o2 = n2.options.getTop();
              if (isMultiple) {
                els.forEach(function(t3) {
                  t3.updatePositionByMultipleSelect(0, movingDistance);
                });
              } else {
                n2.updateSizeAndPositionOptions(void 0, o2 + movingDistance), t2.css("top", n2.options.displayTop());
              }
              r2.preventDefault();
          }
          if ([37, 38, 39, 40].includes(r2.keyCode)) {
            hinnn.event.trigger("hiprintTemplateDataChanged_" + n2.templateId, "\u952E\u76D8\u79FB\u52A8");
          }
        });
      }, BasePrintElement.prototype.inRect = function(t2) {
        var ptr = this.designPaper.scale || 1;
        var x1 = this.designTarget[0].offsetLeft, y1 = this.designTarget[0].offsetTop, h2 = this.designTarget[0].offsetHeight, w2 = this.designTarget[0].offsetWidth, x2 = x1 + w2, y2 = y1 + h2, ex1 = hiprintJQuery(t2.target[0]).position().left / ptr, ey1 = hiprintJQuery(t2.target[0]).position().top / ptr, eh = t2.target[0].offsetHeight, ew = t2.target[0].offsetWidth, ex2 = ex1 + ew, ey2 = ey1 + eh;
        return ex1 < x2 && ex2 > x1 && y1 < ey2 && y2 > ey1;
      }, BasePrintElement.prototype.multipleSelect = function(t2) {
        t2 ? this.designTarget.addClass("multipleSelect") : this.designTarget.removeClass("multipleSelect");
      }, BasePrintElement.prototype.updatePositionByMultipleSelect = function(t2, e2) {
        if (false === this.options.draggable) return;
        this.updateSizeAndPositionOptions(t2 + this.options.getLeft(), e2 + this.options.getTop()), this.designTarget.css("left", this.options.displayLeft()), this.designTarget.css("top", this.options.displayTop());
      }, BasePrintElement;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    var i2 = function() {
      function t3() {
      }
      return t3.prototype.init = function(t4) {
        this.target = hiprintJQuery('<input type="text" class="hitable-editor-text" value="" />'), t4.getTarget().append(this.target), this.target.focus();
      }, t3.prototype.getValue = function() {
        return this.target.val();
      }, t3.prototype.setValue = function(t4) {
        this.target.val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), o2 = function() {
      function t3() {
        this.text = new i2();
      }
      return Object.defineProperty(t3, "Instance", {
        get: function get() {
          return t3._instance || (t3._instance = new t3()), t3._instance;
        },
        enumerable: true,
        configurable: true
      }), t3;
    }(), i22 = function() {
      function t3() {
      }
      return t3.prototype.init = function(e3, i3) {
        var n3 = `<select class="auto-submit" style="width:100%">
                <option value="" disabled>\u8BF7\u9009\u62E9\u5B57\u6BB5</option>`;
        e3.forEach(function(t4, e4) {
          if (t4.field == i3.field) {
            n3 += ' <option value="' + (t4.field || "") + '" selected >' + (t4.text || "") + "</option>";
          } else {
            n3 += ' <option value="' + (t4.field || "") + '" >' + (t4.text || "") + "</option>";
          }
        }), n3 += " </select>";
        this.target = hiprintJQuery(n3), i3.getTarget().append(this.target), this.target.focus();
      }, t3.prototype.getValue = function() {
        var val = this.target.val();
        var text = this.target.find('option[value="' + val + '"]').text();
        return text + "#" + val;
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), o22 = function() {
      function t3() {
        this.select = new i22();
      }
      return Object.defineProperty(t3, "Instance", {
        get: function get() {
          return t3._instance || (t3._instance = new t3()), t3._instance;
        },
        enumerable: true,
        configurable: true
      }), t3;
    }(), r2 = function() {
      function t3() {
      }
      return Object.defineProperty(t3, "Instance", {
        get: function get() {
          return o2._instance || (t3._instance = new t3()), t3._instance;
        },
        enumerable: true,
        configurable: true
      }), t3.prototype.createEditor = function(t4) {
        return hiprintJQuery.extend({}, o2.Instance[t4]);
      }, t3.prototype.createSelect = function(t4) {
        return hiprintJQuery.extend({}, o22.Instance[t4]);
      }, t3;
    }(), a2 = n2(10), p2 = n2(14), s2 = n2(11), l2 = function() {
      function t3() {
      }
      return t3.prototype.init = function(t4, e3) {
        var n3 = this;
        this.tableOptions = e3, this.title = t4.title, this.field = t4.field, t4.getTarget().unbind("dblclick.hitable").bind("dblclick.hitable", function() {
          t4.isEditing = true, n3.beginEdit(t4);
        });
      }, t3.prototype.getDisplayHtml = function() {
        return this.title;
      }, t3.prototype.beginEdit = function(t4) {
        var e3 = this;
        if (e3.tableOptions.options.fields && e3.tableOptions.options.fields.length) {
          this.editor = r2.Instance.createSelect("select"), t4.getTarget().html(""), this.editor.init(e3.tableOptions.options.fields, t4), this.editor.setValue(this.field || ""), hiprintJQuery(this.editor.target).keydown(function(n3) {
            13 == n3.keyCode && e3.endEdit(t4);
          }), hiprintJQuery(this.editor.target).change(function(n3) {
            e3.endEdit(t4);
          }), hiprintJQuery(this.editor.target).blur(function(n3) {
            e3.endEdit(t4);
          });
        } else {
          this.editor = r2.Instance.createEditor("text"), t4.getTarget().html(""), this.editor.init(t4), (this.title || this.field) && (this.tableOptions.options.isEnableEditField ? this.editor.setValue((this.title || "") + "#" + (this.field || "")) : this.editor.setValue(this.title || "")), hiprintJQuery(this.editor.target).keydown(function(n3) {
            13 == n3.keyCode && e3.endEdit(t4);
          }), hiprintJQuery(this.editor.target).blur(function(n3) {
            e3.endEdit(t4);
          }), this.tableOptions.editingCell && this.tableOptions.editingCell.id != t4.id && this.tableOptions.editingCell.innerElement.endEdit(this.tableOptions.editingCell), this.tableOptions.editingCell = t4;
        }
      }, t3.prototype.endEdit = function(t4) {
        t4.isEditing = 0;
        var e3 = this.editor.getValue();
        if (e3) {
          if (this.tableOptions.options.isEnableEditField || this.tableOptions.options.fields) {
            var n3 = e3.split("#");
            t4.title = this.title = n3[0], n3.length > 0 && (t4.columnId = t4.field = this.field = n3[1]);
            t4.id && t4.target.attr("id", t4.id), t4.columnId && t4.target.attr("column-id", t4.columnId);
            hinnn.event.trigger("hiprintTemplateDataChanged_" + this.tableOptions.options.templateId, "\u8C03\u6574\u8868\u683C\u5217\u5B57\u6BB5");
          } else t4.title = this.title = e3;
        } else this.tableOptions.options.isEnableEditField ? (t4.title = this.title = "", t4.field = this.field = "") : t4.title = this.title = "";
        this.editor.destroy(), t4.getTarget().html(this.title);
      }, t3;
    }(), u2 = /* @__PURE__ */ function() {
      return function(t3) {
        this.title = t3.title, this.field = t3.field, this.width = t3.width, this.align = t3.align, this.halign = t3.halign, this.vAlign = t3.vAlign, this.colspan = t3.colspan, this.rowspan = t3.rowspan, this.checked = t3.checked, this.columnId = t3.columnId, this.tableSummaryTitle = t3.tableSummaryTitle, this.tableSummaryText = t3.tableSummaryText, this.tableSummaryColspan = t3.tableSummaryColspan, this.tableSummary = t3.tableSummary, this.tableSummaryAlign = t3.tableSummaryAlign, this.tableSummaryNumFormat = t3.tableSummaryNumFormat, this.tableSummaryFormatter = t3.tableSummaryFormatter, this.showCodeTitle = t3.showCodeTitle, this.upperCase = t3.upperCase, this.renderFormatter = t3.renderFormatter && t3.renderFormatter.toString(), this.formatter2 = t3.formatter2 && t3.formatter2.toString(), this.styler2 = t3.styler2 && t3.styler2.toString(), this.stylerHeader = t3.stylerHeader && t3.stylerHeader.toString(), this.tableColumnHeight = t3.tableColumnHeight, this.tableTextType = t3.tableTextType, this.tableBarcodeMode = t3.tableBarcodeMode, this.tableQRCodeLevel = t3.tableQRCodeLevel;
      };
    }(), d2 = function() {
      function t3() {
        this.id = s2.a.createId();
      }
      return t3.prototype.init = function(t4, e3, n3, i3) {
        this.isHead = i3, this.rowId = n3, this.isEditing = false;
        var o3 = /^[0-9]*$/;
        this.target = t4, this.tableOptions = e3;
        var r3 = this.target.attr("colspan");
        this.colspan = o3.test(r3) ? parseInt(r3) : 1;
        var a3 = this.target.attr("rowspan");
        this.rowspan = o3.test(a3) ? parseInt(a3) : 1, this.initEvent(), this.isHead && this.initInnerEelement();
      }, t3.prototype.beginEdit = function() {
        if (!this.isEditing && this.tableOptions.isEnableEdit && this.tableOptions.onBeforEdit(this)) {
          var t4 = this.getValue();
          this.editor = r2.Instance.createEditor("text"), this.isEditing = true, this.tableOptions.editingCell = this, this.target.html(""), this.editor.init(this), this.editor.setValue(t4);
        }
      }, t3.prototype.endEdit = function() {
        this.isEditing = false;
        var t4 = this.editor.getValue();
        this.editor.destroy(), this.target.html(t4);
      }, t3.prototype.getTarget = function() {
        return this.target;
      }, t3.prototype.getValue = function() {
        return this.target.html();
      }, t3.prototype.setValue = function(t4) {
      }, t3.prototype.initInnerEelement = function() {
        this.innerElement = new l2(), this.innerElement.init(this, this.tableOptions);
      }, t3.prototype.initEvent = function() {
      }, t3.prototype.isXYinCell = function(t4, e3) {
        var n3 = new a2.b({
          x: t4,
          y: e3,
          height: 0,
          width: 0
        });
        return this.isOverlap(n3);
      }, t3.prototype.getTableRect = function() {
        return new a2.b({
          x: this.target.offset().left,
          y: this.target.offset().top,
          height: this.target[0].offsetHeight,
          width: this.target[0].offsetWidth
        });
      }, t3.prototype.isOverlap = function(t4) {
        var e3 = this.getTableRect();
        return t4.x + t4.width > e3.x && e3.x + e3.width > t4.x && t4.y + t4.height > e3.y && e3.y + e3.height > t4.y;
      }, t3.prototype.isInRect = function(t4) {
        var e3 = t4.rect, n3 = this.getTableRect();
        if (n3.x >= e3.x && n3.x + n3.width <= e3.x + e3.width && n3.y >= e3.y && n3.y + n3.height <= e3.y + e3.height) {
          var i3 = p2.a.mergeRect(e3, n3);
          return JSON.stringify(e3) == JSON.stringify(i3) || (t4.changed = true, t4.rect = i3, true);
        }
        return false;
      }, t3.prototype.isSelected = function() {
        return this.target.hasClass("selected");
      }, t3.prototype.select = function() {
        this.target.addClass("selected");
      }, t3.prototype.isHeader = function() {
        return false;
      }, t3.prototype.setAlign = function(t4) {
        this.align = t4, t4 ? this.target.css("text-align", t4) : this.target[0].style.textAlign = "";
      }, t3.prototype.setVAlign = function(t4) {
        this.vAlign = t4, t4 ? this.target.css("vertical-align", t4) : this.target[0].style.verticalAlign = "";
      }, t3.prototype.getEntity = function() {
        return new u2(this);
      }, t3;
    }();
    n2.d(e2, "a", function() {
      return f2;
    });
    var _c, h2 = (_c = function c2(t3, e3) {
      return (_c = Object.setPrototypeOf || _instanceof(
        {
          __proto__: []
        },
        Array
      ) && function(t4, e4) {
        t4.__proto__ = e4;
      } || function(t4, e4) {
        for (var n3 in e4) {
          e4.hasOwnProperty(n3) && (t4[n3] = e4[n3]);
        }
      })(t3, e3);
    }, function(t3, e3) {
      function n3() {
        this.constructor = t3;
      }
      _c(t3, e3), t3.prototype = null === e3 ? Object.create(e3) : (n3.prototype = e3.prototype, new n3());
    }), f2 = function(t3) {
      function e3(e4) {
        var n3 = this;
        return e4 = e4 || {}, (n3 = t3.call(this) || this).width = e4.width ? parseFloat(e4.width.toString()) : 100, n3.title = e4.title, n3.descTitle = e4.descTitle, n3.field = e4.field, n3.fixed = e4.fixed, n3.rowspan = e4.rowspan ? parseInt(e4.rowspan) : 1, n3.colspan = e4.colspan ? parseInt(e4.colspan) : 1, n3.align = e4.align, n3.halign = e4.halign, n3.vAlign = e4.vAlign, n3.formatter = e4.formatter, n3.styler = e4.styler, n3.renderFormatter = e4.renderFormatter, n3.formatter2 = e4.formatter2, n3.styler2 = e4.styler2, n3.stylerHeader = e4.stylerHeader, n3.checkbox = e4.checkbox, n3.checked = 0 != e4.checked, n3.columnId = e4.columnId || e4.field, n3.tableColumnHeight = e4.tableColumnHeight, n3.tableTextType = e4.tableTextType, n3.tableBarcodeMode = e4.tableBarcodeMode, n3.tableQRCodeLevel = e4.tableQRCodeLevel, n3.tableSummaryTitle = e4.tableSummaryTitle, n3.tableSummaryText = e4.tableSummaryText, n3.tableSummaryColspan = e4.tableSummaryColspan, n3.tableSummary = e4.tableSummary, n3.tableSummaryAlign = e4.tableSummaryAlign, n3.tableSummaryNumFormat = e4.tableSummaryNumFormat, n3.tableSummaryFormatter = e4.tableSummaryFormatter, n3.showCodeTitle = e4.showCodeTitle, n3.upperCase = e4.upperCase, n3;
      }
      return h2(e3, t3), e3.prototype.css = function(t4) {
      }, e3;
    }(d2);
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return i2;
    });
    var i2 = /* @__PURE__ */ function() {
      return function(t3) {
        this.printLine = t3.printLine, this.target = t3.target, this.referenceElement = t3.referenceElement;
      };
    }();
  },
  function(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    __webpack_require__.d(__webpack_exports__, "a", function() {
      return TableExcelHelper;
    });
    var _ReconsitutionTableColumns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19), _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0), TableExcelHelper = function() {
      function TableExcelHelper() {
      }
      return TableExcelHelper.createTableHead = function(t2, e2) {
        for (var n2 = TableExcelHelper.reconsitutionTableColumnTree(t2), i2 = hiprintJQuery("<thead></thead>"), colgroup = hiprintJQuery("<colgroup></colgroup>"), o2 = TableExcelHelper.getColumnsWidth(n2, e2), r2 = function r3(t3) {
          var e3 = hiprintJQuery("<tr></tr>");
          colgroup = hiprintJQuery("<colgroup></colgroup>");
          n2[t3].filter(function(t4) {
            return t4.checked;
          }).forEach(function(t4) {
            var n3 = hiprintJQuery("<td></td>");
            t4.id && n3.attr("id", t4.id), t4.columnId && n3.attr("column-id", t4.columnId), (t4.align || t4.halign) && n3.css("text-align", t4.halign || t4.align), t4.vAlign && n3.css("vertical-align", t4.vAlign), t4.colspan > 1 && n3.attr("colspan", t4.colspan), t4.rowspan > 1 && n3.attr("rowspan", t4.rowspan), n3.html(t4.title), o2[t4.id] ? (t4.hasWidth = true, t4.targetWidth = o2[t4.id], n3.attr("haswidth", "haswidth"), n3.css("width", o2[t4.id] + "pt")) : t4.hasWidth = false;
            var s2 = TableExcelHelper.getHeaderStyler(t4);
            if (s2) {
              var l2 = s2(t4);
              if (l2)
                Object.keys(l2).forEach(function(t5) {
                  n3.css(t5, l2[t5]);
                });
            }
            e3.append(n3);
            colgroup.append(`<col column-id="${t4.columnId}" width="${t4.width}pt"></col>`);
          }), i2.append(e3);
        }, a2 = 0; a2 < n2.totalLayer; a2++) {
          r2(a2);
        }
        return TableExcelHelper.syncTargetWidthToOption(t2), [i2, colgroup];
      }, TableExcelHelper.createTableFooter = function(t2, e2, n2, i2, o2, r2, pageIndex) {
        var a2 = hiprintJQuery("<tfoot></tfoot>"), p2 = this.getFooterFormatter(n2, i2);
        var tst = this.tableSummaryTitle;
        let tSumData = n2.tableFooterScope == "all" ? e2 : r2;
        let idx = n2.columns.length - 1;
        var rowColumns = this.rowColumns || n2.columns[idx].columns;
        if (n2.tableFooterRepeat != "no" && rowColumns.some(function(column2) {
          return column2.tableSummary;
        })) {
          var tableFooter = hiprintJQuery("<tr></tr>");
          rowColumns.filter(function(t3) {
            return t3.checked;
          }).forEach(function(column2) {
            var fieldData = tSumData.filter(function(row) {
              return row && row[column2.field];
            }).map(function(row) {
              return new RegExp("^-?(0|[1-9]\\d*)(\\.\\d+)?").test(row[column2.field]) ? Number(row[column2.field]) : 0;
            });
            var text = column2.tableSummaryText;
            var numF = column2.tableSummaryNumFormat || 2;
            var style = `text-align: ${column2.tableSummaryAlign || "center"}`;
            var colspan = column2.tableSummaryColspan == void 0 ? 1 : column2.tableSummaryColspan;
            var upperCaseType = column2.upperCase;
            let { toUpperCase, numFormat } = _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_1__.a;
            var tableSummaryFormatter2 = TableExcelHelper.getColumnTableSummaryFormatter(column2);
            var formatterResult = tableSummaryFormatter2 ? tableSummaryFormatter2(column2, fieldData, e2, n2) : "";
            if (formatterResult) {
              tableFooter.append(formatterResult);
              return;
            }
            switch (column2.tableSummary) {
              case "count":
                var title = tst(column2, text || `\u8BA1\u6570:`, o2);
                var count = toUpperCase(upperCaseType, tSumData.filter((i3) => i3).length || 0);
                tableFooter.append(`<td style="${style}" colspan="${colspan}">${title}${count}</td>`);
                break;
              case "sum":
                var sum = parseFloat(
                  Number(
                    fieldData.reduce(function(prev, cur) {
                      return prev + cur;
                    }, 0)
                  )
                );
                sum = toUpperCase(upperCaseType, numFormat(sum, numF));
                var title = tst(column2, text || `\u5408\u8BA1:`, o2);
                tableFooter.append(`<td style="${style}" colspan="${colspan}">${title}${sum}</td>`);
                break;
              case "avg":
                var sum = parseFloat(
                  Number(
                    fieldData.reduce(function(prev, cur) {
                      return prev + cur;
                    }, 0)
                  )
                );
                var avg = parseFloat(Number(sum / (fieldData.length || 1)));
                avg = toUpperCase(upperCaseType, numFormat(avg, numF));
                var title = tst(column2, text || `\u5E73\u5747\u503C:`, o2);
                tableFooter.append(`<td style="${style}" colspan="${colspan}">${title}${avg}</td>`);
                break;
              case "min":
                var min = Math.min(...fieldData) || 0;
                min == Infinity && (min = 0);
                min = toUpperCase(upperCaseType, numFormat(min, numF));
                var title = tst(column2, text || `\u6700\u5C0F\u503C:`, o2);
                tableFooter.append(`<td style="${style}" colspan="${colspan}">${title}${min || 0}</td>`);
                break;
              case "max":
                var max = Math.max(...fieldData);
                max == -Infinity && (max = 0);
                max = toUpperCase(upperCaseType, numFormat(max, numF));
                var title = tst(column2, text || `\u6700\u5927\u503C:`, o2);
                tableFooter.append(`<td style="${style}" colspan="${colspan}">${title}${max || 0}</td>`);
                break;
              case "text":
                tableFooter.append(`<td style="${style}" colspan="${colspan}">${text || ""}</td>`);
                break;
              default:
                if (colspan >= 1) {
                  tableFooter.append(`<td style="${style}" colspan="${colspan}">${text || ""}</td>`);
                }
                break;
            }
          });
          a2.append(tableFooter);
        }
        if (p2) {
          a2.append(p2(n2, e2, o2, r2, pageIndex));
        }
        return a2;
      }, TableExcelHelper.tableSummaryTitle = function(column2, title, data) {
        var s2 = column2.tableSummaryTitle == void 0 || column2.tableSummaryTitle == true;
        return s2 ? `${title}` : data ? `` : `<span style="color:firebrick">${title}</span>`;
      }, TableExcelHelper.createTableRow = function(t2, e2, printData2, n2, i2) {
        var h2 = this;
        var o2 = TableExcelHelper.reconsitutionTableColumnTree(t2), r2 = hiprintJQuery("<tbody></tbody>");
        var gff = h2.getGroupFieldsFormatter(n2, i2);
        var groupRowIndex = 0;
        var groupFields = gff ? n2.groupFields = gff(i2, n2, e2) : i2.groupFields ? i2.groupFields : [];
        e2 = Array.isArray(e2) ? e2 : [];
        groupFields.length ? _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_1__.a.groupBy(e2, groupFields, function(t3) {
          var e3 = {};
          return groupFields.forEach(function(n3) {
            return e3[n3] = t3[n3];
          }), e3;
        }).forEach(function(t3) {
          var groupFormatter2 = h2.getGroupFormatter(n2, i2);
          if (groupFormatter2) {
            let result = groupFormatter2(o2.colspan, e2, printData2, t3, n2);
            if (hiprintJQuery(result).is("tr")) {
              r2.append(result);
            } else if (hiprintJQuery(result).is("td")) {
              r2.append(`<tr>${result}</tr>`);
            } else {
              r2.append(`<tr><td>${result}</td></tr>`);
            }
          }
          var groupFooterFormatter2 = h2.getGroupFooterFormatter(n2, i2);
          var groupData = t3;
          if (groupData.rows.forEach(function(t4, rowIndex2) {
            let sequenceIndex = n2.groupSequenceContinue ? groupRowIndex : rowIndex2;
            var e3 = TableExcelHelper.createRowTarget(o2, t4, n2, i2, sequenceIndex, groupData.rows, printData2);
            r2.append(e3);
            groupRowIndex += 1;
          }), groupFooterFormatter2) {
            let result = groupFooterFormatter2(o2.colspan, e2, printData2, t3, n2);
            if (hiprintJQuery(result).is("tr")) {
              r2.append(result);
            } else if (hiprintJQuery(result).is("td")) {
              r2.append(`<tr>${result}</tr>`);
            } else {
              r2.append(`<tr><td>${result}</td></tr>`);
            }
          }
        }) : e2.forEach(function(t3, rowIndex2) {
          var row = TableExcelHelper.createRowTarget(o2, t3, n2, i2, rowIndex2, e2, printData2);
          r2.append(row);
        });
        return r2;
      }, TableExcelHelper.createRowTarget = function(t, e, n, i, rowIndex, tableData, printData) {
        var o = hiprintJQuery("<tr></tr>");
        var columns = t.rowColumns.filter(function(t2) {
          return t2.checked;
        });
        o.data("rowData", e), t.rowColumns.filter(function(t2) {
          return t2.checked;
        }).forEach(function(t, i) {
          if (!t.checked) return;
          var rowsColumnsMerge = "";
          if (n.rowsColumnsMerge) {
            eval("rowsColumnsMerge=" + n.rowsColumnsMerge);
            var rowsColumnsArr = rowsColumnsMerge(e, t, i, rowIndex, tableData, printData) || [1, 1];
            var r = hiprintJQuery(`<td style = 'display:${!(rowsColumnsArr[0] && rowsColumnsArr[1]) ? "none" : ""}' rowspan = '${rowsColumnsArr[0]}' colspan = '${rowsColumnsArr[1]}'></td>`);
          } else {
            var r = hiprintJQuery("<td></td>");
          }
          if (e && Object.keys(e).length > 0 && ("first" == n.tableHeaderRepeat || "none" == n.tableHeaderRepeat)) {
            t.field && r.attr("field", t.field), t.align && r.css("text-align", t.align), t.vAlign && r.css("vertical-align", t.vAlign);
            if (n.rowsColumnsMerge) {
              if (rowsColumnsArr[1] > 1) {
                var width = 0;
                columns.forEach((item, index) => {
                  if (index >= i && index < i + rowsColumnsArr[1]) {
                    width += item.width;
                  }
                });
              }
            }
            r.css("width", (width || t.width) + "pt");
          } else {
            t.field && r.attr("field", t.field), t.align && r.css("text-align", t.align), t.vAlign && r.css("vertical-align", t.vAlign);
          }
          var a = TableExcelHelper.getColumnFormatter(t), p = a ? a(e[t.field], e, i, n) : e[t.field];
          var rf = TableExcelHelper.getColumnRenderFormatter(t);
          if (rf) {
            r.html(rf(e[t.field], e, i, n, rowIndex));
          } else if ("text" == t.tableTextType || t.tableTextType == void 0) r.html(p);
          else {
            if ("barcode" == t.tableTextType) {
              r.html('<svg width="100%" display="block" height="100%" class="hibarcode_imgcode" preserveAspectRatio="none slice"></svg ><div class="hibarcode_displayValue"></div>');
              try {
                p ? (JsBarcode(r.find(".hibarcode_imgcode")[0], p, {
                  format: t.tableBarcodeMode || "CODE128A",
                  width: 1,
                  textMargin: -1,
                  lineColor: "#000000",
                  margin: 0,
                  height: parseInt(10),
                  displayValue: false
                }), r.find(".hibarcode_imgcode").attr("height", t.tableColumnHeight || "30pt"), r.find(".hibarcode_imgcode").css("margin", "5pt 10pt"), r.find(".hibarcode_imgcode").attr("width", "calc(100% - 20pt)")) : r.html("");
                if (t.showCodeTitle) {
                  r.find(".hibarcode_displayValue").html(p);
                }
              } catch (t2) {
                /* @__PURE__ */ console.log(t2), r.html(`\u6B64\u683C\u5F0F\u4E0D\u652F\u6301\u8BE5\u6587\u672C`);
              }
            }
            if ("image" == t.tableTextType) {
              r.html("");
              if (p) {
                var imagebox = hiprintJQuery('<div><img style = "max-width:100%;max-height:100%"/></div>');
                imagebox.find("img").attr("src", p);
                imagebox.find("img").attr("height", t.tableColumnHeight || "50pt");
                /* @__PURE__ */ console.log(imagebox.find("img").css("width"));
                r.html(imagebox);
              }
            }
            if ("qrcode" == t.tableTextType) {
              r.html("");
              try {
                var qrcodebox = hiprintJQuery('<div style="margin:2pt 0pt" class="hiqrcode_imgcode"></div>');
                if (p) {
                  var l = parseInt(t.width || t.targetWidth || 20), u = parseInt(t.tableColumnHeight || 20);
                  qrcodebox.css("height", (l > u ? u : l) + "pt");
                  new QRCode(qrcodebox[0], {
                    width: l > u ? u : l,
                    height: l > u ? u : l,
                    colorDark: "#000000",
                    useSVG: true,
                    correctLevel: t.tableQRCodeLevel || 0,
                    mode: 4
                  }).makeCode(p);
                  r.html(qrcodebox);
                  if (t.showCodeTitle) {
                    r.append('<div class="hiqrcode_displayValue"></div>');
                    r.find(".hiqrcode_displayValue").html(p);
                  }
                }
              } catch (t2) {
                /* @__PURE__ */ console.log(t2), r.html(`\u4E8C\u7EF4\u7801\u751F\u6210\u5931\u8D25`);
              }
            }
            if ("sequence" === t.tableTextType) {
              r.html(rowIndex + 1);
            }
          }
          var s = TableExcelHelper.getColumnStyler(t);
          if (s) {
            var l = s(e[t.field], e, i, n);
            if (l)
              Object.keys(l).forEach(function(t2) {
                r.css(t2, l[t2]);
              });
          }
          o.append(r);
        });
        var r = TableExcelHelper.getRowStyler(n, i);
        if (r) {
          var a = r(e, n);
          if (a)
            Object.keys(a).forEach(function(t2) {
              o.css(t2, a[t2]);
            });
        }
        return o;
      }, TableExcelHelper.createEmptyRowTarget = function(t2, tableElement) {
        var e2 = TableExcelHelper.reconsitutionTableColumnTree(t2), n2 = hiprintJQuery("<tr></tr>");
        e2.rowColumns.filter(function(t3) {
          return t3.checked;
        }).forEach(function(t3, e3) {
          var i2 = hiprintJQuery("<td></td>");
          t3.field && i2.attr("field", t3.field), t3.align && i2.css("text-align", t3.align), t3.vAlign && i2.css("vertical-align", t3.vAlign), n2.append(i2);
        });
        if (tableElement && tableElement.options.tableBodyRowHeight) {
          n2.find("td:not([rowspan])").css("height", tableElement.options.tableBodyRowHeight + "pt");
        }
        return n2;
      }, TableExcelHelper.getColumnsWidth = function(t2, e2) {
        var n2 = {}, i2 = TableExcelHelper.allAutoWidth(t2), o2 = TableExcelHelper.allFixedWidth(t2);
        return t2.rowColumns.filter(function(t3) {
          return t3.checked;
        }).forEach(function(t3) {
          if (t3.fixed) n2[t3.id] = t3.width;
          else {
            var r2 = e2 - o2, a2 = t3.width / i2 * (r2 > 0 ? r2 : 0);
            n2[t3.id] = a2;
          }
        }), n2;
      }, TableExcelHelper.resizeTableCellWidth = function(t2, e2, n2) {
        var i2 = TableExcelHelper.reconsitutionTableColumnTree(e2), o2 = TableExcelHelper.getColumnsWidth(i2, n2);
        t2.find("thead tr td[haswidth]").map(function(t3, e3) {
          var n3 = hiprintJQuery(e3).attr("id"), i3 = o2[n3];
          hiprintJQuery(e3).css("width", i3 + "pt");
        });
      }, TableExcelHelper.allAutoWidth = function(t2) {
        var e2 = 0, n2 = {};
        return t2.rowColumns.filter(function(t3) {
          return t3.checked;
        }).forEach(function(t3) {
          n2[t3.id] ? n2[t3.id] = 0 : n2[t3.id] = t3.width;
          e2 += t3.fixed ? 0 : n2[t3.id];
        }), e2;
      }, TableExcelHelper.allFixedWidth = function(t2) {
        var e2 = 0, n2 = {};
        return t2.rowColumns.filter(function(t3) {
          return t3.checked;
        }).forEach(function(t3) {
          n2[t3.id] ? n2[t3.id] = 0 : n2[t3.id] = t3.width;
          e2 += t3.fixed ? n2[t3.id] : 0;
        }), e2;
      }, TableExcelHelper.reconsitutionTableColumnTree = function(t2, e2, n2) {
        var i2 = e2 || new _ReconsitutionTableColumns__WEBPACK_IMPORTED_MODULE_0__.a();
        i2.colspan = 0;
        for (var o2 = function o3(e3) {
          i2.totalLayer = e3 + 1, i2[e3] = t2[e3].columns, 0 == e3 && t2[e3].columns.forEach(function(t3) {
            0 == e3 && (i2.colspan += t3.colspan);
          });
        }, r2 = 0; r2 < t2.length; r2++) {
          o2(r2);
        }
        return i2.rowColumns = TableExcelHelper.getOrderdColumns(i2), i2;
      }, TableExcelHelper.syncTargetWidthToOption = function(t2) {
        t2.forEach(function(t3) {
          t3.columns.forEach(function(t4) {
            t4.hasWidth && (t4.width = t4.targetWidth);
          });
        });
      }, TableExcelHelper.getGroupFieldsFormatter = function(options, tablePrintElementType) {
        var groupFieldsFormatter = void 0;
        if (tablePrintElementType.groupFields && tablePrintElementType.groupFields.length) {
          var arr = typeof tablePrintElementType.groupFields == "string" ? tablePrintElementType.groupFields : JSON.stringify(tablePrintElementType.groupFields);
          options.groupFieldsFormatter = "function(type,options,data){ return " + arr + " }";
        }
        if (tablePrintElementType.groupFieldsFormatter && (groupFieldsFormatter = tablePrintElementType.groupFieldsFormatter), options.groupFieldsFormatter)
          try {
            var s = "groupFieldsFormatter=" + options.groupFieldsFormatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return groupFieldsFormatter;
      }, TableExcelHelper.getGroupFormatter = function(options, tablePrintElementType) {
        var groupFormatter = void 0;
        if (tablePrintElementType.groupFormatter && (groupFormatter = tablePrintElementType.groupFormatter), options.groupFormatter)
          try {
            var s = "groupFormatter=" + options.groupFormatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return groupFormatter;
      }, TableExcelHelper.getGroupFooterFormatter = function(options, tablePrintElementType) {
        var groupFooterFormatter = void 0;
        if (tablePrintElementType.groupFooterFormatter && (groupFooterFormatter = tablePrintElementType.groupFooterFormatter), options.groupFooterFormatter)
          try {
            var s = "groupFooterFormatter=" + options.groupFooterFormatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return groupFooterFormatter;
      }, TableExcelHelper.getFooterFormatter = function(options, tablePrintElementType) {
        var footerFormatter = void 0;
        if (tablePrintElementType.footerFormatter && (footerFormatter = tablePrintElementType.footerFormatter), options.footerFormatter)
          try {
            var s = "footerFormatter=" + options.footerFormatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return footerFormatter;
      }, TableExcelHelper.getRowStyler = function(options, tablePrintElementType) {
        var rowStyler = void 0;
        if (tablePrintElementType.rowStyler && (rowStyler = tablePrintElementType.rowStyler), options.rowStyler)
          try {
            var s = "rowStyler=" + options.rowStyler;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return rowStyler;
      }, TableExcelHelper.getColumnTableSummaryFormatter = function(column) {
        var tableSummaryFormatter = void 0;
        if (column.tableSummaryFormatter && (tableSummaryFormatter = column.tableSummaryFormatter), column.tableSummaryFormatter)
          try {
            var s = "tableSummaryFormatter=" + column.tableSummaryFormatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return tableSummaryFormatter;
      }, TableExcelHelper.getColumnStyler = function(column) {
        var styler = void 0;
        if (column.styler && (styler = column.styler), column.styler2)
          try {
            var s = "styler=" + column.styler2;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return styler;
      }, TableExcelHelper.getHeaderStyler = function(column) {
        var stylerHeader = void 0;
        if (column.stylerHeader && (stylerHeader = column.stylerHeader), column.stylerHeader)
          try {
            var s = "stylerHeader=" + column.stylerHeader;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return stylerHeader;
      }, TableExcelHelper.getColumnRenderFormatter = function(column) {
        var renderFormatter = void 0;
        if (column.renderFormatter && (renderFormatter = column.renderFormatter), column.renderFormatter)
          try {
            var s = "renderFormatter=" + column.renderFormatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return renderFormatter;
      }, TableExcelHelper.getColumnFormatter = function(column) {
        var formatter = void 0;
        if (column.formatter && (formatter = column.formatter), column.formatter2)
          try {
            var s = "formatter=" + column.formatter2;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return formatter;
      }, TableExcelHelper.getOrderdColumns = function(t2) {
        let newColumns = {};
        for (let i2 = 0; i2 < t2.totalLayer; i2++) {
          newColumns[i2] = [];
          t2[i2].forEach((column2, columnIdx) => {
            newColumns[i2].push(...new Array(column2.colspan).fill({ ...column2, colspan: 1 }));
          });
        }
        for (let i2 = 0; i2 < t2.totalLayer; i2++) {
          newColumns[i2].forEach((column2, columnIdx) => {
            for (let n2 = 1; n2 < column2.rowspan; n2++) {
              newColumns[i2 + n2].splice(columnIdx, 0, { ...column2, rowspan: 1 });
            }
          });
        }
        let lastColumns = [];
        for (let i2 = 0; i2 < t2.totalLayer; i2++) {
          if (i2 >= t2.totalLayer - 1) {
            newColumns[i2].forEach((column2, columnIdx) => {
              if (!column2.field) {
                column2.field = lastColumns[columnIdx];
              }
            });
          } else {
            newColumns[i2].forEach((column2, columnIdx) => {
              if (i2 == 0) {
                lastColumns.push(column2.field || "");
              } else {
                column2.field && (lastColumns[columnIdx] = column2.field);
              }
            });
          }
        }
        this.rowColumns = newColumns[t2.totalLayer - 1];
        return newColumns[t2.totalLayer - 1];
      }, TableExcelHelper;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return i2;
    });
    var i2 = function() {
      function t3(t4) {
        this.top = t4.top, this.left = t4.left, this.height = t4.height, this.width = t4.width, this.bottomInLastPaper = t4.bottomInLastPaper, this.beginPrintPaperIndex = t4.beginPrintPaperIndex, this.printTopInPaper = t4.printTopInPaper, this.endPrintPaperIndex = t4.endPrintPaperIndex;
      }
      return t3.prototype.isPositionLeftOrRight = function(t4) {
        return this.top <= t4 && this.top + this.height > t4;
      }, t3;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    var i2 = function() {
      function t3() {
        this.name = "lineHeight";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("line-height", e3 + "pt"), "line-height:" + e3 + "pt";
          t4[0].style.lineHeight = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5B57\u4F53\u884C\u9AD8
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        <option value="22.5" >22.5pt</option>
        <option value="23.25" >23.25pt</option>
        <option value="24" >24pt</option>
        <option value="24.75" >24.75pt</option>
        <option value="25.5" >25.5pt</option>
        <option value="26.25" >26.25pt</option>
        <option value="27" >27pt</option>
        <option value="27.75" >27.75pt</option>
        <option value="28.5" >28.5pt</option>
        <option value="29.25" >29.25pt</option>
        <option value="30" >30pt</option>
        <option value="30.75" >30.75pt</option>
        <option value="31.5" >31.5pt</option>
        <option value="32.25" >32.25pt</option>
        <option value="33" >33pt</option>
        <option value="33.75" >33.75pt</option>
        <option value="34.5" >34.5pt</option>
        <option value="35.25" >35.25pt</option>
        <option value="36" >36pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), fontFamily = function() {
      function t3() {
        this.name = "fontFamily";
      }
      return t3.prototype.createTarget = function(t4) {
        var e3 = void 0;
        if (t4 && (e3 = t4.getFontList()), e3) {
          var n3 = `<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5B57\u4F53
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>`;
          e3.forEach(function(t5, e4) {
            n3 += ' <option value="' + (t5.value || "") + '" >' + (t5.title || "") + "</option>";
          }), n3 += " </select>\n            </div>\n        </div>", this.target = hiprintJQuery(n3);
        } else {
          this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5B57\u4F53
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="SimSun" >\u5B8B\u4F53</option>
            <option value="Microsoft YaHei" >\u5FAE\u8F6F\u96C5\u9ED1</option>
        </select>
        </div>
    </div>`);
        }
        return this.target;
      }, t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("font-family", e3), "font-family:" + e3;
          t4[0].style.fontFamily = "inherit";
        }
        return null;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), r2 = function() {
      function t3() {
        this.name = "fontSize";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("font-size", e3 + "pt"), "font-size:" + e3 + "pt";
          t4[0].style.fontSize = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5B57\u4F53\u5927\u5C0F
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), a2 = function() {
      function t3() {
        this.name = "fontWeight";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("font-weight", e3), "font-weight:" + e3;
          t4[0].style.fontWeight = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5B57\u4F53\u7C97\u7EC6
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="lighter" >\u66F4\u7EC6</option>
        <option value="bold" >\u7C97\u4F53</option>
        <option value="bolder" >\u7C97\u4F53+</option>
            <option value="100" >100</option>
            <option value="200" >200</option>
            <option value="300" >300</option>
            <option value="400" >400</option>
            <option value="500" >500</option>
            <option value="600" >600</option>
            <option value="700" >700</option>
            <option value="800" >800</option>
            <option value="900" >900</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), p2 = function() {
      function t3() {
        this.name = "letterSpacing";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("letter-spacing", e3 + "pt"), "letter-spacing:" + e3 + "pt";
          t4[0].style.letterSpacing = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5B57\u95F4\u8DDD
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="0.75" >0.75pt</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), s2 = function() {
      function t3() {
        this.name = "textAlign";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("text-align", e3), "justify" == e3 ? (t4.css("text-align-last", "justify"), t4.css("text-justify", "distribute-all-lines")) : (t4[0].style.textAlignLast = "", t4[0].style.textJustify = ""), "text-align:" + e3;
          t4[0].style.textAlign = "", t4[0].style.textAlignLast = "", t4[0].style.textJustify = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5DE6\u53F3\u5BF9\u9F50
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="left" >\u5C45\u5DE6</option>
        <option value="center" >\u5C45\u4E2D</option>
        <option value="right" >\u5C45\u53F3</option>
        <option value="justify" >\u4E24\u7AEF\u5BF9\u9F50</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), l2 = function() {
      function t3() {
        this.name = "hideTitle";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6807\u9898\u663E\u793A\u9690\u85CF
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="false" >\u663E\u793A</option>
            <option value="true" >\u9690\u85CF</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        if ("true" == this.target.find("select").val()) return true;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), u2 = function() {
      function t3() {
        this.name = "tableBorder";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("table").length) {
          if ("border" == e3 || void 0 == e3) return t4.find("table").css("border", "1px solid"), "border:1px solid";
          "noBorder" == e3 ? t4.find("table").css("border", "0px solid") : t4.find("table")[0].style.border = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u683C\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
            <select class="auto-submit">
            <option value="" >\u9ED8\u8BA4</option>
            <option value="border" >\u6709\u8FB9\u6846</option>
            <option value="noBorder" >\u65E0\u8FB9\u6846</option>
            </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), d2 = function() {
      function t3() {
        this.name = "tableHeaderBorder";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("thead tr").length) {
          if ("border" == e3 || void 0 == e3) return t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-all");
          "noBorder" == e3 ? t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-none") : "leftBorder" == e3 ? t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-left") : "rightBorder" == e3 ? t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-right") : "leftRightBorder" == e3 ? t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-lr") : "topBorder" == e3 ? t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-top") : "bottomBorder" == e3 ? t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-bottom") : "topBottomBorder" == e3 ? t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-tb") : t4.find("thead tr").removeClass();
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u5934\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>    
        <option value="border" >\u6709\u8FB9\u6846</option>
        <option value="noBorder" >\u65E0\u8FB9\u6846</option>
        <option value="leftBorder" >\u5DE6\u8FB9\u6846</option>
        <option value="rightBorder" >\u53F3\u8FB9\u6846</option>
        <option value="leftRightBorder" >\u5DE6\u53F3\u8FB9\u6846</option>
        <option value="topBorder" >\u4E0A\u8FB9\u6846</option>
        <option value="bottomBorder" >\u4E0B\u8FB9\u6846</option>
        <option value="topBottomBorder" >\u4E0A\u4E0B\u8FB9\u6846</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), c2 = function() {
      function t3() {
        this.name = "tableHeaderCellBorder";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("thead tr").length) {
          if ("border" == e3 || void 0 == e3) return t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-td-all");
          "noBorder" == e3 ? t4.find("thead tr").addClass("hiprint-printElement-tableTarget-border-td-none") : t4.find("thead tr").removeClass();
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u5934\u5355\u5143\u683C\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>    
        <option value="border" >\u6709\u8FB9\u6846</option>
        <option value="noBorder" >\u65E0\u8FB9\u6846</option>
      
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), d22 = function() {
      function t3() {
        this.name = "tableFooterBorder";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("tfoot tr").length) {
          if ("border" == e3 || void 0 == e3) return t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-all");
          "noBorder" == e3 ? t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-none") : "leftBorder" == e3 ? t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-left") : "rightBorder" == e3 ? t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-right") : "leftRightBorder" == e3 ? t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-lr") : "topBorder" == e3 ? t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-top") : "bottomBorder" == e3 ? t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-bottom") : "topBottomBorder" == e3 ? t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-tb") : t4.find("tfoot tr").removeClass();
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u5C3E\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>    
        <option value="border" >\u6709\u8FB9\u6846</option>
        <option value="noBorder" >\u65E0\u8FB9\u6846</option>
        <option value="leftBorder" >\u5DE6\u8FB9\u6846</option>
        <option value="rightBorder" >\u53F3\u8FB9\u6846</option>
        <option value="leftRightBorder" >\u5DE6\u53F3\u8FB9\u6846</option>
        <option value="topBorder" >\u4E0A\u8FB9\u6846</option>
        <option value="bottomBorder" >\u4E0B\u8FB9\u6846</option>
        <option value="topBottomBorder" >\u4E0A\u4E0B\u8FB9\u6846</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), c22 = function() {
      function t3() {
        this.name = "tableFooterCellBorder";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("tfoot tr").length) {
          if ("border" == e3 || void 0 == e3) return t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-td-all");
          "noBorder" == e3 ? t4.find("tfoot tr").addClass("hiprint-printElement-tableTarget-border-td-none") : t4.find("tfoot tr").removeClass();
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u5C3E\u5355\u5143\u683C\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>    
        <option value="border" >\u6709\u8FB9\u6846</option>
        <option value="noBorder" >\u65E0\u8FB9\u6846</option>
      
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), h2 = function() {
      function t3() {
        this.name = "tableHeaderRowHeight";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("thead tr td").length) {
          if (e3) return t4.find("thead tr td:not([rowspan])").css("height", e3 + "pt"), "height:" + e3 + "pt";
          t4.find("thead tr td").map(function(t5, e4) {
            e4.style.height = "";
          });
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u5934\u884C\u9AD8
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
       
        <option value="" >\u9ED8\u8BA4</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        <option value="22.5" >22.5pt</option>
        <option value="23.25" >23.25pt</option>
        <option value="24" >24pt</option>
        <option value="24.75" >24.75pt</option>
        <option value="25.5" >25.5pt</option>
        <option value="26.25" >26.25pt</option>
        <option value="27" >27pt</option>
        <option value="27.75" >27.75pt</option>
        <option value="28.5" >28.5pt</option>
        <option value="29.25" >29.25pt</option>
        <option value="30" >30pt</option>
        <option value="30.75" >30.75pt</option>
        <option value="31.5" >31.5pt</option>
        <option value="32.25" >32.25pt</option>
        <option value="33" >33pt</option>
        <option value="33.75" >33.75pt</option>
        <option value="34.5" >34.5pt</option>
        <option value="35.25" >35.25pt</option>
        <option value="36" >36pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), f2 = function() {
      function t3() {
        this.name = "tableHeaderFontSize";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("thead").length) {
          if (e3) return t4.find("thead").css("font-size", e3 + "pt"), "font-size:" + e3 + "pt";
          t4.find("thead").map(function(t5, e4) {
            e4.style.fontSize = "";
          });
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u5934\u5B57\u4F53\u5927\u5C0F
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), g2 = function() {
      function t3() {
        this.name = "tableHeaderFontWeight";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("thead").length) {
          if (e3) return t4.find("thead tr td").css("font-weight", e3), "font-weight:" + e3;
          t4.find("thead tr td").map(function(t5, e4) {
            e4.style.fontWeight = "";
          });
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u5934\u5B57\u4F53\u7C97\u7EC6
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit"> 
        <option value="" >\u9ED8\u8BA4</option>
        <option value="lighter" >\u66F4\u7EC6</option>
        <option value="bold" >\u7C97\u4F53</option>
        <option value="bolder" >\u7C97\u4F53+</option>
        <option value="100" >100</option>
        <option value="200" >200</option>
        <option value="300" >300</option>
        <option value="400" >400</option>
        <option value="500" >500</option>
        <option value="600" >600</option>
        <option value="700" >700</option>
        <option value="800" >800</option>
        <option value="900" >900</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), m2 = function() {
      function t3() {
        this.name = "tableBodyCellBorder";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("tbody tr").length) {
          if ("border" == e3 || void 0 == e3) return t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-td-all");
          "noBorder" == e3 ? t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-td-none") : t4.find("tbody tr").removeClass();
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
            \u8868\u4F53\u5355\u5143\u683C\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
            <select class="auto-submit">
            <option value="" >\u9ED8\u8BA4</option>
            <option value="border" >\u6709\u8FB9\u6846</option>
            <option value="noBorder" >\u65E0\u8FB9\u6846</option>
            </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), v2 = function() {
      function t3() {
        this.name = "tableBodyRowHeight";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("tbody tr td").length) {
          if (e3) return t4.find("tbody tr td").css("height", e3 + "pt"), "height:" + e3 + "pt";
          t4.find("tbody tr td").map(function(t5, e4) {
            e4.style.height = "";
          });
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
            \u8868\u4F53\u884C\u9AD8
        </div>
        <div class="hiprint-option-item-field">
            <select class="auto-submit">
            <option value="" >\u9ED8\u8BA4</option>
            <option value="6" >6pt</option>
            <option value="6.75" >6.75pt</option>
            <option value="7.5" >7.5pt</option>
            <option value="8.25" >8.25pt</option>
            <option value="9" >9pt</option>
            <option value="9.75" >9.75pt</option>
            <option value="10.5" >10.5pt</option>
            <option value="11.25" >11.25pt</option>
            <option value="12" >12pt</option>
            <option value="12.75" >12.75pt</option>
            <option value="13.5" >13.5pt</option>
            <option value="14.25" >14.25pt</option>
            <option value="15" >15pt</option>
            <option value="15.75" >15.75pt</option>
            <option value="16.5" >16.5pt</option>
            <option value="17.25" >17.25pt</option>
            <option value="18" >18pt</option>
            <option value="18.75" >18.75pt</option>
            <option value="19.5" >19.5pt</option>
            <option value="20.25" >20.25pt</option>
            <option value="21" >21pt</option>
            <option value="21.75" >21.75pt</option>
            <option value="22.5" >22.5pt</option>
            <option value="23.25" >23.25pt</option>
            <option value="24" >24pt</option>
            <option value="24.75" >24.75pt</option>
            <option value="25.5" >25.5pt</option>
            <option value="26.25" >26.25pt</option>
            <option value="27" >27pt</option>
            <option value="27.75" >27.75pt</option>
            <option value="28.5" >28.5pt</option>
            <option value="29.25" >29.25pt</option>
            <option value="30" >30pt</option>
            <option value="30.75" >30.75pt</option>
            <option value="31.5" >31.5pt</option>
            <option value="32.25" >32.25pt</option>
            <option value="33" >33pt</option>
            <option value="33.75" >33.75pt</option>
            <option value="34.5" >34.5pt</option>
            <option value="35.25" >35.25pt</option>
            <option value="36" >36pt</option>
            </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), y2 = function() {
      function t3() {
        this.name = "tableHeaderBackground";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("thead").length) {
          if (e3) return t4.find("thead").css("background", e3), "background:" + e3;
          t4.find("thead").map(function(t5, e4) {
            e4.style.background = "";
          });
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u5934\u80CC\u666F
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" class="auto-submit" />
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").minicolors({
          defaultValue: t4 || "",
          theme: "bootstrap"
        }), this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), b2 = function() {
      function t3() {
        this.name = "borderWidth";
      }
      return t3.prototype.createTarget = function(t4) {
        var name = ["hline", "vline", "rect", "oval"].includes(t4.printElementType.type) ? `\u7EBF\u5BBD` : `\u8FB9\u6846\u5927\u5C0F`;
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        ${name}
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="0.75" >0.75pt</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("border-width", e3 + "pt"), "border-width:" + e3 + "pt";
          t4[0].style.borderWidth = "";
        }
        return null;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), E2 = function() {
      function t3() {
        this.name = "barcodeMode";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6761\u5F62\u7801\u683C\u5F0F
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="CODE128A" >CODE128A</option>
        <option value="CODE128B" >CODE128B</option>
        <option value="CODE128C" >CODE128C</option>
        <option value="CODE39" >CODE39</option>
        <option value="EAN13" >EAN-13</option>
        <option value="EAN8" >EAN-8</option>
        <option value="EAN5" >EAN-5</option>
        <option value="EAN2" >EAN-2</option>
        <option value="UPC" >UPC\uFF08A\uFF09</option>
        <option value="ITF" >ITF</option>
        <option value="ITF14" >ITF-14</option>
        <option value="MSI" >MSI</option>
            <option value="MSI10" >MSI10</option>
            <option value="MSI11" >MSI11</option>
            <option value="MSI1010" >MSI1010</option>
            <option value="MSI1110" >MSI1110</option>
            <option value="Pharmacode" >Pharmacode</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return t4 || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), barTextMode = function() {
      function t3() {
        this.name = "barTextMode";
      }
      return t3.prototype.createTarget = function() {
        this.target = hiprintJQuery(`<div class="hiprint-option-item"><div class="hiprint-option-item-label">\u6761\u7801\u6587\u672C\u6A21\u5F0F</div><div class="hiprint-option-item-field"><select class="auto-submit"><option value="">\u9ED8\u8BA4</option><option value="text">\u5355\u72EC\u6587\u672C</option><option value="svg">svg\u6587\u672C</option></select></div></div>`);
        return this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return t4 || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), barWidth = function() {
      function t3() {
        this.name = "barWidth";
      }
      return t3.prototype.createTarget = function() {
        this.target = hiprintJQuery(`<div class="hiprint-option-item"><div class="hiprint-option-item-label">\u6761\u7801\u5BBD\u5EA6</div><div class="hiprint-option-item-field"><select class="auto-submit"><option value="">\u9ED8\u8BA4</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></div>`);
        return this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return t4 || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), barAutoWidth = function() {
      function t3() {
        this.name = "barAutoWidth";
      }
      return t3.prototype.createTarget = function() {
        this.target = hiprintJQuery(`<div class="hiprint-option-item"><div class="hiprint-option-item-label">\u6761\u7801\u81EA\u52A8\u589E\u5BBD</div><div class="hiprint-option-item-field"><select class="auto-submit"><option value="">\u9ED8\u8BA4</option><option value="true">\u81EA\u52A8</option><option value="false">\u4E0D\u81EA\u52A8</option></select></div></div>`);
        return this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return t4 || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), barcodeType = function() {
      function t3() {
        this.name = "barcodeType";
      }
      return t3.prototype.createTarget = function() {
        var options2 = [
          {
            label: `\u9ED8\u8BA4(Code 128)`,
            value: ""
          },
          {
            label: `\u5546\u54C1\u6761\u7801`,
            children: [
              {
                label: "EAN-13",
                value: "ean13"
              },
              {
                label: "EAN-8",
                value: "ean8"
              },
              {
                label: "UPC-A",
                value: "upca"
              },
              {
                label: "UPC-E",
                value: "upce"
              },
              {
                label: "ISBN",
                value: "isbn"
              },
              {
                label: "ISMN",
                value: "ismn"
              },
              {
                label: "ISSN",
                value: "issn"
              }
            ]
          },
          {
            label: `\u6761\u5F62\u7801`,
            children: [
              {
                label: "Code 39",
                value: "code39"
              },
              {
                label: "Code 39 Extended",
                value: "code39ext"
              },
              {
                label: "Code 93",
                value: "code93"
              },
              {
                label: "Code 93 Extended",
                value: "code93ext"
              },
              {
                label: "Code 128",
                value: "code128"
              },
              {
                label: "Interleaved 2 of 5 (ITF)",
                value: "interleaved2of5"
              }
            ]
          },
          {
            label: `\u7269\u6D41`,
            children: [
              {
                label: "EAN-14",
                value: "ean14"
              },
              {
                label: "GS1-128",
                value: "gs1-128"
              },
              {
                label: "ITF-14",
                value: "itf14"
              },
              {
                label: "SSCC-18",
                value: "sscc18"
              }
            ]
          },
          {
            label: "GS1 DataBar",
            children: [
              {
                label: "\u6269\u5C55\u5F0F GS1 DataBar",
                value: "databarexpanded"
              },
              {
                label: "\u5C42\u6392\u6269\u5C55\u5F0F GS1 DataBar",
                value: "databarexpandedstacked"
              },
              {
                label: "\u9650\u5B9A\u5F0F GS1 DataBar",
                value: "databarlimited"
              },
              {
                label: "\u5168\u5411\u5F0F GS1 DataBar",
                value: "databaromni"
              },
              {
                label: "\u5C42\u6392\u5F0F GS1 DataBar",
                value: "databarstacked"
              },
              {
                label: "\u5168\u5411\u5C42\u6392\u5F0F GS1 DataBar",
                value: "databarstackedomni"
              },
              {
                label: "\u622A\u77ED\u5F0F GS1 DataBar",
                value: "databartruncated"
              },
              {
                label: "GS1 \u5317\u7F8E\u4F18\u60E0\u5238\u7801",
                value: "gs1northamericancoupon"
              }
            ]
          },
          {
            label: `\u90AE\u653F\u548C\u5FEB\u9012\u7F16\u7801`,
            children: [
              {
                label: "AusPost 4 State Customer Code",
                value: "auspost"
              },
              {
                label: "Deutsche Post Identcode",
                value: "identcode"
              },
              {
                label: "Deutsche Post Leitcode",
                value: "leitcode"
              },
              {
                label: "Japan Post 4 State Customer Code",
                value: "japanpost"
              },
              {
                label: "Royal TNT Post",
                value: "kix"
              },
              {
                label: "Royal Mail 4 State Customer Code",
                value: "royalmail"
              },
              {
                label: "Royal Mail Mailmark",
                value: "mailmark"
              },
              {
                label: "MaxiCode",
                value: "maxicode"
              },
              {
                label: "USPS FIM symbols",
                value: "symbol"
              },
              {
                label: "USPS Intelligent Mail",
                value: "onecode"
              },
              {
                label: "USPS PLANET",
                value: "planet"
              },
              {
                label: "USPS POSTNET",
                value: "postnet"
              }
            ]
          },
          {
            label: `\u533B\u7597\u4EA7\u54C1\u7F16\u7801`,
            children: [
              {
                label: "Italian Pharmacode",
                value: "code32"
              },
              {
                label: "Pharmaceutical Binary Code",
                value: "pharmacode"
              },
              {
                label: "Pharmazentralnummer (PZN)",
                value: "pzn"
              },
              {
                label: "Two-track Pharmacode",
                value: "pharmacode2"
              },
              {
                label: "HIBC Aztec Code",
                value: "hibcazteccode"
              },
              {
                label: "HIBC Codablock F",
                value: "hibccodablockf"
              },
              {
                label: "HIBC Code 128",
                value: "hibccode128"
              },
              {
                label: "HIBC Code 39",
                value: "hibccode39"
              }
            ]
          },
          {
            label: `\u4E0D\u5E38\u7528\u7F16\u7801`,
            children: [
              {
                label: "Code 11",
                value: "code11"
              },
              {
                label: "Code 16K",
                value: "code16k"
              },
              {
                label: "Code 2 of 5",
                value: "code2of5"
              },
              {
                label: "Code 49",
                value: "code49"
              },
              {
                label: "Code One",
                value: "codeone"
              },
              {
                label: "Codabar",
                value: "rationalizedCodabar"
              },
              {
                label: "Codablock F",
                value: "codablockf"
              },
              {
                label: "BC412",
                value: "bc412"
              },
              {
                label: "COOP 2 of 5",
                value: "coop2of5"
              },
              {
                label: "Channel Code",
                value: "channelcode"
              },
              {
                label: "Datalogic 2 of 5",
                value: "datalogic2of5"
              },
              {
                label: "DotCode",
                value: "dotcode"
              },
              {
                label: "IATA 2 of 5",
                value: "iata2of5"
              },
              {
                label: "MSI Plessey",
                value: "msi"
              },
              {
                label: "Matrix 2 of 5",
                value: "matrix2of5"
              },
              {
                label: "Plessey UK",
                value: "plessey"
              },
              {
                label: "PosiCode",
                value: "posicode"
              },
              {
                label: "Telepen",
                value: "telepen"
              },
              {
                label: "Telepen Numeric",
                value: "telepennumeric"
              }
            ]
          },
          {
            label: "GS1 \u590D\u5408\u7F16\u7801",
            children: [
              {
                label: "\u590D\u5408 EAN-13",
                value: "ean13composite"
              },
              {
                label: "\u590D\u5408 EAN-8",
                value: "ean8composite"
              },
              {
                label: "\u590D\u5408 UPC-A",
                value: "upcacomposite"
              },
              {
                label: "\u590D\u5408 UPC-E",
                value: "upcecomposite"
              },
              {
                label: "\u5C42\u6392\u6269\u5C55\u5F0F\u590D\u5408 GS1 DataBar",
                value: "databarexpandedstackedcomposite"
              },
              {
                label: "\u6269\u5C55\u5F0F\u590D\u5408 GS1 DataBar",
                value: "databarexpandedcomposite"
              },
              {
                label: "\u9650\u5B9A\u5F0F\u590D\u5408 GS1 DataBar",
                value: "databarlimitedcomposite"
              },
              {
                label: "\u5168\u5411\u5F0F\u590D\u5408 GS1 DataBar",
                value: "databaromnicomposite"
              },
              {
                label: "\u5C42\u6392\u5F0F\u590D\u5408 GS1 DataBar",
                value: "databarstackedcomposite"
              },
              {
                label: "\u5168\u5411\u5C42\u6392\u5F0F\u590D\u5408 GS1 DataBar",
                value: "databarstackedomnicomposite"
              },
              {
                label: "\u622A\u77ED\u5F0F\u590D\u5408 GS1 DataBar",
                value: "databartruncatedcomposite"
              },
              {
                label: "\u590D\u5408 GS1-128",
                value: "gs1-128composite"
              }
            ]
          },
          {
            label: `\u9644\u52A0\u7EC4\u4EF6`,
            children: [
              {
                label: "EAN-2 (2 \u4F4D\u9644\u52A0\u7801)",
                value: "ean2"
              },
              {
                label: "EAN-5 (5 \u4F4D\u9644\u52A0\u7801)",
                value: "ean5"
              },
              {
                label: "GS1 \u590D\u5408 2D \u7EC4\u4EF6",
                value: "gs1-cc"
              }
            ]
          },
          {
            label: `\u5B9E\u9A8C\u7F16\u7801`,
            children: [
              {
                label: "Raw",
                value: "raw"
              },
              {
                label: "Custom 4 state symbology",
                value: "daft"
              },
              {
                label: "Flattermarken",
                value: "flattermarken"
              }
            ]
          }
        ];
        this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row"><div class="hiprint-option-item-label">\u6761\u7801\u7C7B\u578B</div><div class="hiprint-option-item-field"><select class="auto-submit"></select></div></div>`);
        var select = this.target.find("select.auto-submit");
        options2.forEach((item) => {
          if (item.children) {
            var optgroup = hiprintJQuery(`<optgroup label="${item.label}"></optgroup`);
            item.children.forEach((chil) => {
              optgroup.append(hiprintJQuery(`<option value="${chil.value}">${chil.label}</option>`));
            });
            select.append(optgroup);
          } else {
            select.append(`<option value="${item.value}">${item.label}</option>`);
          }
        });
        return this.target;
      }, t3.prototype.getValue = function() {
        return this.target.find("select").val() || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), qrcodeType = function() {
      function t3() {
        this.name = "qrcodeType";
      }
      return t3.prototype.createTarget = function() {
        var options2 = [
          {
            label: `\u9ED8\u8BA4(qrcode)`,
            value: ""
          },
          {
            label: "QR Code",
            value: "qrcode"
          },
          {
            label: "Micro QR Code",
            value: "microqrcode"
          },
          {
            label: "Swiss QR Code",
            value: "swissqrcode"
          },
          {
            label: "Rectangular Micro QR Code",
            value: "rectangularmicroqrcode"
          },
          {
            label: "Aztec Code",
            value: "azteccode"
          },
          {
            label: "Aztec Runes",
            value: "aztecrune"
          },
          {
            label: "Compact Aztec Code",
            value: "azteccodecompact"
          },
          {
            label: "Data Matrix",
            value: "datamatrix"
          },
          {
            label: "Data Matrix Rectangular",
            value: "datamatrixrectangular"
          },
          {
            label: "\u6C49\u4FE1\u7801",
            value: "hanxin"
          },
          {
            label: "GS1 Data Matrix",
            value: "gs1datamatrix"
          },
          {
            label: "GS1 Data Matrix Rectangular",
            value: "gs1datamatrixrectangular"
          },
          {
            label: "GS1 QR Code",
            value: "gs1qrcode"
          },
          {
            label: "HIBC Data Matrix",
            value: "hibcdatamatrix"
          },
          {
            label: "HIBC Data Matrix Rectangular",
            value: "hibcdatamatrixrectangular"
          },
          {
            label: "HIBC MicroPDF417",
            value: "hibcmicropdf417"
          },
          {
            label: "HIBC PDF417",
            value: "hibcpdf417"
          },
          {
            label: "HIBC QR Code",
            value: "hibcqrcode"
          }
        ];
        this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row"><div class="hiprint-option-item-label">\u4E8C\u7EF4\u7801\u7C7B\u578B</div><div class="hiprint-option-item-field"><select class="auto-submit"></select></div></div>`);
        var select = this.target.find("select.auto-submit");
        options2.forEach((item) => {
          select.append(`<option value="${item.value}">${item.label}</option>`);
        });
        return this.target;
      }, t3.prototype.getValue = function() {
        return this.target.find("select").val() || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), qrCodeLevel = function() {
      function t3() {
        this.name = "qrCodeLevel";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E8C\u7EF4\u7801\u5BB9\u9519\u7387
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="1" >7% L</option>
        <option value="0" >15% M</option>
        <option value="3" >25% Q</option>
        <option value="2" >30% H</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return parseInt(t4 || 0);
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), T2 = function() {
      function t3() {
        this.name = "color";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("color", e3), "color:" + e3;
          t4[0].style.color = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5B57\u4F53\u989C\u8272
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" class="auto-submit"/>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").minicolors({
          defaultValue: t4 || "",
          theme: "bootstrap"
        }), this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), P2 = function() {
      function t3() {
        this.name = "textDecoration";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6587\u672C\u4FEE\u9970
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="underline" >\u4E0B\u5212\u7EBF</option>
            <option value="overline" >\u4E0A\u5212\u7EBF</option>
            <option value="line-through" >\u7A7F\u68AD\u7EBF</option>
           
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("text-decoration", e3), "text-decoration:" + e3;
          t4[0].style.textDecoration = "";
        }
        return null;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), _2 = function() {
      function t3() {
        this.name = "field";
      }
      return t3.prototype.createTarget = function(t4) {
        var e3 = void 0;
        if (t4 && (e3 = t4.getFields()), e3) {
          this.isSelect = true;
          var n3 = `<div class="hiprint-option-item hiprint-option-item-row">
            <div class="hiprint-option-item-label">
            \u5B57\u6BB5\u540D
            </div>
            <div class="hiprint-option-item-field">
            <select class="auto-submit">
                <option value="" >\u8BF7\u9009\u62E9\u5B57\u6BB5</option>`;
          e3.forEach(function(t5, e4) {
            n3 += ' <option value="' + (t5.field || "") + '" >' + (t5.text || "") + "</option>";
          }), n3 += " </select>\n            </div>\n        </div>", this.target = hiprintJQuery(n3);
        } else {
          this.isSelect = false;
          this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
            <div class="hiprint-option-item-label">
            \u5B57\u6BB5\u540D
            </div>
            <div class="hiprint-option-item-field">
            <input type="text" placeholder="\u8BF7\u8F93\u5165\u5B57\u6BB5\u540D" class="auto-submit">
            </div>
        </div>`);
        }
        return this.target;
      }, t3.prototype.getValue = function() {
        return (this.isSelect ? this.target.find("select").val() : this.target.find("input").val()) || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.isSelect ? t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"), this.target.find("select").val(t4)) : this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), w2 = function() {
      function t3() {
        this.name = "title";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u6807\u9898
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:50px;" placeholder="\u8BF7\u8F93\u5165\u6807\u9898" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), x2 = function() {
      function t3() {
        this.name = "testData";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u6D4B\u8BD5\u6570\u636E
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u4EC5\u5B57\u6BB5\u540D\u79F0\u5B58\u5728\u65F6\u6709\u6548" class="auto-submit" >
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), coordinate = function() {
      function t3() {
        this.name = "coordinate";
      }
      return t3.prototype.createTarget = function(t4, o2) {
        var n3 = this;
        n3.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
          <div class="hiprint-option-item-label">
        \u4F4D\u7F6E\u5750\u6807
        </div>
          <div class="hiprint-option-item-field" style="display: flex;align-items: baseline;">

          <input type="number" style="width:48%" placeholder="X\u4F4D\u7F6E(\u5DE6)" class="auto-submit" />

          <input type="number" style="width:48%" placeholder="Y\u4F4D\u7F6E(\u4E0A)" class="auto-submit" />

          </div>

          </div>`);
        n3.syncLock = o2.coordinateSync || false;
        n3.createSyncLock(n3.syncLock);
        return n3.target;
      }, t3.prototype.createSyncLock = function(t4) {
        var n3 = this;
        n3.lockTarget = n3.syncLock ? hiprintJQuery(`<label style="margin: 0 4px;text-align:center;width: 8%" title="\u540C\u6B65">\u{1F517}</label>`) : hiprintJQuery(`<label style="margin: 0 4px;text-align:center;width: 8%" title="\u4E0D\u540C\u6B65">\u{1F513}</label>`);
        n3.lockTarget.click(function() {
          if (n3.syncLock) {
            n3.lockTarget.text("\u{1F513}").attr("title", `\u4E0D\u540C\u6B65`);
          } else {
            n3.lockTarget.text("\u{1F517}").attr("title", `\u540C\u6B65`);
          }
          n3.syncLock = !n3.syncLock;
        });
        n3.target.find("input:first").after(n3.lockTarget);
        n3.target.find("input:first").change(function() {
          if (n3.syncLock) {
            n3.target.find("input:last").val(hiprintJQuery(this).val());
          }
        });
        n3.target.find("input:last").change(function() {
          if (n3.syncLock) {
            n3.target.find("input:first").val(hiprintJQuery(this).val());
          }
        });
        return n3.lockTarget;
      }, t3.prototype.css = function(t4) {
        if (t4 && t4.length && this.target) {
          if (("block" == t4.find(".resize-panel").css("display") || t4[0].className.includes("table")) && this.el == t4) {
            var v3 = this.getValue();
            return t4.css("left", v3.left + "pt").css("top", v3.top + "pt");
          }
        }
        return null;
      }, t3.prototype.getValue = function() {
        var v3 = {
          coordinateSync: this.syncLock,
          left: 0,
          top: 0
        };
        v3.left = parseFloat(this.target.find("input:first").val() || 0);
        v3.top = parseFloat(this.target.find("input:last").val() || 0);
        return v3;
      }, t3.prototype.setValue = function(t4, el) {
        this.el = el.designTarget || el;
        this.target.find("input:first").val(t4.left);
        this.target.find("input:last").val(t4.top);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), widthHeight = function() {
      function t3() {
        this.name = "widthHeight";
      }
      return t3.prototype.createTarget = function(t4, o2) {
        var n3 = this;
        n3.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
          <div class="hiprint-option-item-label">
        \u5BBD\u9AD8\u5927\u5C0F
        </div>
          <div class="hiprint-option-item-field" style="display: flex;align-items: baseline;">

          <input type="number" style="width:48%" placeholder="\u5BBD" class="auto-submit" min="0" max="2000" setp="1"/>

          <input type="number" style="width:48%" placeholder="\u9AD8" class="auto-submit" min="0" max="2000" setp="1"/>

          </div>

          </div>`);
        n3.syncLock = o2.widthHeightSync || false;
        n3.createSyncLock(n3.syncLock);
        return n3.target;
      }, t3.prototype.createSyncLock = function(t4) {
        var n3 = this;
        n3.lockTarget = n3.syncLock ? hiprintJQuery(`<label style="margin: 0 4px;text-align:center;width: 8%" title="\u540C\u6B65">\u{1F517}</label>`) : hiprintJQuery(`<label style="margin: 0 4px;text-align:center;width: 8%" title="\u4E0D\u540C\u6B65">\u{1F513}</label>`);
        n3.lockTarget.click(function() {
          if (n3.syncLock) {
            n3.lockTarget.text("\u{1F513}").attr("title", `\u4E0D\u540C\u6B65`);
          } else {
            n3.lockTarget.text("\u{1F517}").attr("title", `\u540C\u6B65`);
          }
          n3.syncLock = !n3.syncLock;
        });
        n3.target.find("input:first").after(n3.lockTarget);
        n3.target.find("input:first").change(function() {
          if (n3.syncLock) {
            n3.target.find("input:last").val(hiprintJQuery(this).val());
          }
        });
        n3.target.find("input:last").change(function() {
          if (n3.syncLock) {
            n3.target.find("input:first").val(hiprintJQuery(this).val());
          }
        });
        return n3.lockTarget;
      }, t3.prototype.css = function(t4) {
        if (t4 && t4.length && this.target) {
          if (("block" == t4.find(".resize-panel").css("display") || t4[0].className.includes("table")) && this.el == t4) {
            var v3 = this.getValue();
            return t4.css("width", v3.width + "pt").css("height", v3.height + "pt");
          }
        }
        return null;
      }, t3.prototype.getValue = function() {
        var v3 = {
          widthHeightSync: this.syncLock,
          width: 0,
          height: 0
        };
        v3.width = parseFloat(this.target.find("input:first").val() || 0);
        v3.height = parseFloat(this.target.find("input:last").val() || 0);
        return v3;
      }, t3.prototype.setValue = function(t4, el) {
        this.el = el.designTarget || el;
        this.target.find("input:first").val(t4.width);
        this.target.find("input:last").val(t4.height);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), C2 = function() {
      function t3() {
        this.name = "src";
      }
      return t3.prototype.createTarget = function(t4) {
        this.el = t4;
        var e3 = void 0, i3 = this;
        this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u56FE\u7247\u5730\u5740
        </div>
        <div class="hiprint-option-item-field" style="display: flex;align-items: baseline;">
        <input type="text" placeholder="\u8BF7\u8F93\u5165\u56FE\u7247\u5730\u5740" class="auto-submit" style="width:70%">
    <button class="hiprint-option-item-settingBtn" style="padding:0 10px;margin:0 0 0 5px" type="button">\u9009\u62E9</button>        </div>
    </div>`);
        if (t4 && (e3 = t4.getOnImageChooseClick()), e3) {
          this.target.find("button").click(function() {
            e3 && e3(i3);
          });
        }
        return this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.refresh = function(t4, opt, cb) {
        var that = this;
        this.setValue(t4), this.target.find("input").change();
        if (this.el && opt) {
          var img = new Image();
          img.src = t4;
          if (img.complete) {
            that.updateEl(img.width, img.height, opt, cb);
          } else {
            img.onload = function() {
              that.updateEl(img.width, img.height, opt, cb);
            };
          }
        }
      }, t3.prototype.updateEl = function(width2, height, opt, cb) {
        if (opt) {
          var ratio, w3, h3;
          if (opt && opt.auto) {
            if (width2 >= height) {
              opt.width = true;
            } else {
              opt.height = true;
            }
          }
          if (opt.width) {
            ratio = height / width2;
            w3 = this.el.options.width;
            h3 = Math.floor(w3 * ratio * 10) / 10;
            this.el.options.height = h3;
            this.el.designTarget.css("height", h3 + "pt");
          } else if (opt.height) {
            ratio = width2 / height;
            h3 = this.el.options.height;
            w3 = Math.floor(h3 * ratio * 10) / 10;
            this.el.options.width = w3;
            this.el.designTarget.css("width", w3 + "pt");
          } else if (opt.real) {
            w3 = hinnn.px.toPt(width2);
            h3 = hinnn.px.toPt(height);
            this.el.options.width = w3;
            this.el.options.height = h3;
            this.el.designTarget.css("width", w3 + "pt");
            this.el.designTarget.css("height", h3 + "pt");
          }
          this.el.designTarget.children(".resize-panel").trigger(hiprintJQuery.Event("click"));
        }
        cb && cb(this.el, width2, height);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), imageFit = function() {
      function t3() {
        this.name = "fit";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.find("img").css("object-fit", e3), "object-fit:" + e3;
          t4.find("img")[0].style["object-fit"] = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u56FE\u7247\u7F29\u653E
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="contain" >\u7B49\u6BD4</option>
        <option value="cover" >\u526A\u88C1</option>
        <option value="fill" >\u586B\u5145</option>
        <option value="none" >\u539F\u59CB\u5C3A\u5BF8</option>
                </select>
        </div>
    </div>`), this.target;
        return this.target;
      }, t3.prototype.getValue = function() {
        return this.target.find("select").val();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), O2 = function() {
      function t3() {
        this.name = "borderColor";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("border-color", e3), "border-color:" + e3;
          t4[0].style.borderColor = "";
        }
        return null;
      }, t3.prototype.createTarget = function(t4) {
        var name = ["hline", "vline", "rect", "oval"].includes(t4.printElementType.type) ? `\u989C\u8272` : `\u8FB9\u6846\u989C\u8272`;
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        ${name}
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" class="auto-submit" />
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").minicolors({
          defaultValue: t4 || "",
          theme: "bootstrap"
        }), this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), watermarkOptions = function() {
      function t3() {
        this.name = "watermarkOptions";
      }
      return t3.prototype.createTarget = function() {
        this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row"><div class="hiprint-option-item-label">\u6C34\u5370\u529F\u80FD</div></div>`);
        this.content = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: baseline;"><div style="width:25%">\u6C34\u5370\u5185\u5BB9:</div><input style="width:75%" type="text" placeholder="\u6C34\u5370\u5185\u5BB9" class="auto-submit"></div>`);
        this.fillStyle = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: center;margin-top: 4px"><div style="width:25%">\u5B57\u4F53\u989C\u8272:</div><input style="width:110%" data-format="rgb" data-opacity="0.3" type="text" placeholder="\u5B57\u4F53\u989C\u8272" class="auto-submit"></div>`);
        this.fontSize = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: center;"><div style="width:25%">\u5B57\u4F53\u5927\u5C0F:</div><input style="width:75%" type="range" min="10" max="80" placeholder="\u5B57\u4F53\u5927\u5C0F" class="auto-submit"></div>`);
        this.rotate = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: center;"><div style="width:25%">\u65CB\u8F6C\u89D2\u5EA6:</div><input style="width:75%" type="range" min="0" max="180" placeholder="\u65CB\u8F6C\u89D2\u5EA6" class="auto-submit"></div>`);
        this.width = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: center;"><div style="width:25%">\u6C34\u5E73\u5BC6\u5EA6:</div><input style="width:75%" type="range" min="100" max="800" placeholder="\u6C34\u5E73\u5BC6\u5EA6" class="auto-submit"></div>`);
        this.height = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: center;"><div style="width:25%">\u5782\u76F4\u5BC6\u5EA6:</div><input style="width:75%" type="range" min="100" max="800" placeholder="\u5782\u76F4\u5BC6\u5EA6" class="auto-submit"></div>`);
        this.timestamp = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: center;"><div style="width:25%">\u6C34\u5370\u65F6\u95F4:</div><input style="width:18px;height:18px;margin:0 0 4px 0;" type="checkbox" placeholder="\u6C34\u5370\u65F6\u95F4" class="auto-submit"></div>`);
        let formatlist = ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm", "YYYY-MM-DD HH", "YYYY-MM-DD", "YYYY-MMMM", "YYYY-MM", "YYYY"];
        let timeFormatList = `
            <option value="" >\u9ED8\u8BA4(YYYY-MM-DD HH:mm)</option>`;
        formatlist.forEach(function(e3) {
          timeFormatList += '\n            <option value="' + e3 + '">' + e3 + "</option>";
        });
        this.format = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: baseline;"><div style="width:25%">\u65F6\u95F4\u683C\u5F0F:</div><select style="width:75%" class="auto-submit"></select></div>`);
        this.format.find(".auto-submit").append(hiprintJQuery(timeFormatList));
        this.target.append(this.content);
        this.target.append(this.fillStyle);
        this.target.append(this.fontSize);
        this.target.append(this.rotate);
        this.target.append(this.width);
        this.target.append(this.height);
        this.target.append(this.timestamp);
        this.target.append(this.format);
        return this.target;
      }, t3.prototype.getValue = function() {
        let opt = {
          content: this.content.find("input").val(),
          fillStyle: this.fillStyle.find("input").val() || "rgba(184, 184, 184, 0.3)",
          fontSize: parseInt(this.fontSize.find("input").val() || "14") + "px",
          rotate: parseInt(this.rotate.find("input").val() || "25"),
          width: parseInt(this.width.find("input").val() || "200"),
          height: parseInt(this.height.find("input").val() || "200"),
          timestamp: this.timestamp.find("input").is(":checked"),
          format: this.format.find("select").val() == "" ? "YYYY-MM-DD HH:mm" : this.format.find("select").val()
        };
        let options2 = Object.assign({}, this.options, opt);
        return options2;
      }, t3.prototype.setValue = function(t4) {
        this.options = t4;
        this.content.find("input").val(t4.content || "");
        this.fillStyle.find("input").val(t4.fillStyle || "rgba(184, 184, 184, 0.3)");
        this.fillStyle.find("input").minicolors({
          format: "rgb",
          opacity: true,
          theme: "bootstrap"
        });
        const fontSize = parseInt(t4.fontSize || "14");
        this.fontSize.find("input").val(fontSize);
        this.rotate.find("input").val(t4.rotate || 25);
        this.width.find("input").val(t4.width || 200);
        this.height.find("input").val(t4.height || 200);
        this.timestamp.find("input").attr("checked", t4.timestamp == void 0 ? false : t4.timestamp);
        this.format.find("select").val(t4.format || "YYYY-MM-DD HH:mm");
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), H2 = function() {
      function t3() {
        this.name = "paperNumberFormat";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u9875\u7801\u683C\u5F0F
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\${paperNo}-\${paperCount}" class="auto-submit">
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), D2 = function() {
      function t3() {
        this.name = "paperNumberDisabled";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u663E\u793A\u9875\u7801
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u663E\u793A</option>
        <option value="true" >\u9690\u85CF</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        if ("true" == this.target.find("select").val()) return true;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), paperNumberContinue = function() {
      function t3() {
        this.name = "paperNumberContinue";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u9875\u7801\u7EED\u6392
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="true" >\u7EED\u6392</option>
        <option value="reset" >\u91CD\u6392</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        return "true" == this.target.find("select").val();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((t4 == void 0 || t4 ? "true" : "reset").toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), I2 = function() {
      function t3() {
        this.name = "longTextIndent";
      }
      return t3.prototype.css = function(t4, e3) {
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6BCF\u884C\u7F29\u8FDB
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        <option value="22.5" >22.5pt</option>
        <option value="23.25" >23.25pt</option>
        <option value="24" >24pt</option>
        <option value="24.75" >24.75pt</option>
        <option value="25.5" >25.5pt</option>
        <option value="26.25" >26.25pt</option>
        <option value="27" >27pt</option>
        <option value="27.75" >27.75pt</option>
        <option value="28.5" >28.5pt</option>
        <option value="29.25" >29.25pt</option>
        <option value="30" >30pt</option>
        <option value="30.75" >30.75pt</option>
        <option value="31.5" >31.5pt</option>
        <option value="32.25" >32.25pt</option>
        <option value="33" >33pt</option>
        <option value="33.75" >33.75pt</option>
        <option value="34.5" >34.5pt</option>
        <option value="35.25" >35.25pt</option>
        <option value="36" >36pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), R2 = function() {
      function t3() {
        this.name = "showInPage";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3 && "none" == e3) return t4.addClass("alwaysHide");
          t4.removeClass("alwaysHide");
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u663E\u793A\u89C4\u5219
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="none" >\u59CB\u7EC8\u9690\u85CF</option>
            <option value="first" >\u9996\u9875</option>
            <option value="odd" >\u5947\u6570\u9875</option>
            <option value="even" >\u5076\u6570\u9875</option>
            <option value="last" >\u5C3E\u9875</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), pageBreak = function() {
      function t3() {
        this.name = "pageBreak";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3 && "none" == e3) return t4.addClass("alwaysHide");
          t4.removeClass("alwaysHide");
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5F3A\u5236\u5206\u9875
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="true" >\u662F</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        if ("true" == this.target.find("select").val()) return true;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), M2 = function() {
      function t3() {
        this.name = "panelPaperRule";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6253\u5370\u89C4\u5219
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="odd" >\u4FDD\u6301\u5947\u6570</option>
            <option value="even" >\u4FDD\u6301\u5076\u6570</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), M22 = function() {
      function t3() {
        this.name = "panelPageRule";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5206\u9875\u89C4\u5219
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="none" >\u4E0D\u5206\u9875</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), S2 = function() {
      function t3() {
        this.name = "leftSpaceRemoved";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u79FB\u9664\u6BB5\u843D\u5DE6\u4FA7\u7A7A\u767D
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="true" >\u79FB\u9664</option>
            <option value="false" >\u4E0D\u79FB\u9664</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        if ("false" == this.target.find("select").val()) return false;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), B2 = function() {
      function t3() {
        this.name = "firstPaperFooter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u9996\u9875\u9875\u5C3E
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u9996\u9875\u9875\u5C3E" class="auto-submit">
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), F2 = function() {
      function t3() {
        this.name = "lastPaperFooter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5C3E\u9875\u9875\u5C3E
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u5C3E\u9875\u9875\u5C3E" class="auto-submit">
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), L2 = function() {
      function t3() {
        this.name = "evenPaperFooter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5076\u6570\u9875\u9875\u5C3E
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u5076\u6570\u9875\u9875\u5C3E" class="auto-submit">
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), A2 = function() {
      function t3() {
        this.name = "oddPaperFooter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5947\u6570\u9875\u9875\u5C3E
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u5947\u6570\u9875\u9875\u5C3E" class="auto-submit" >
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), z2 = function() {
      function t3() {
        this.name = "fixed";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4F4D\u7F6E\u56FA\u5B9A
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="false" >\u5426</option>
            <option value="true" >\u662F</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if ("true" === t4) return true;
        if ("false" === t4) return false;
        return void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), k2 = function() {
      function t3() {
        this.name = "axis";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u62D6\u52A8\u65B9\u5411
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="h" >\u6A2A\u5411</option>
        <option value="v" >\u7AD6\u5411</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return t4 || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), N2 = function() {
      function t3() {
        this.name = "leftOffset";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5DE6\u504F\u79FB
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u504F\u79FB\u91CFpt" class="auto-submit" >
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), V2 = function() {
      function t3() {
        this.name = "lHeight";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u6700\u4F4E\u9AD8\u5EA6
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u6587\u672C\u8FC7\u77ED\u6216\u4E3A\u7A7A\u65F6\u7684\u9AD8\u5EA6" class="auto-submit">
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), W2 = function() {
      function t3() {
        this.name = "unShowInPage";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u9690\u85CF\u89C4\u5219
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="first" >\u9996\u9875</option>
            <option value="last" >\u5C3E\u9875</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), j2 = function() {
      function t3() {
        this.name = "tableBodyRowBorder";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4.find("tbody tr").length) {
          if ("border" == e3 || void 0 == e3) return t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-all");
          "noBorder" == e3 ? t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-none") : "leftBorder" == e3 ? t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-left") : "rightBorder" == e3 ? t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-right") : "leftRightBorder" == e3 ? t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-lr") : "topBorder" == e3 ? t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-top") : "bottomBorder" == e3 ? t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-bottom") : "topBottomBorder" == e3 ? t4.find("tbody tr").addClass("hiprint-printElement-tableTarget-border-tb") : t4.find("tbody tr").removeClass();
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u4F53\u884C\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>    
        <option value="border" >\u6709\u8FB9\u6846</option>
        <option value="noBorder" >\u65E0\u8FB9\u6846</option>
        <option value="leftBorder" >\u5DE6\u8FB9\u6846</option>
        <option value="rightBorder" >\u53F3\u8FB9\u6846</option>
        <option value="leftRightBorder" >\u5DE6\u53F3\u8FB9\u6846</option>
        <option value="topBorder" >\u4E0A\u8FB9\u6846</option>
        <option value="bottomBorder" >\u4E0B\u8FB9\u6846</option>
        <option value="topBottomBorder" >\u4E0A\u4E0B\u8FB9\u6846</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), U2 = function() {
      function t3() {
        this.name = "transform";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          var n3 = t4.find(".hiprint-printElement-content").parent(".hiprint-printElement");
          if (!n3.length) {
            n3 = t4;
          }
          if (e3) return n3.css("transform", "rotate(" + e3 + "deg)"), n3.css("-ms-transform", "rotate(" + e3 + "deg)"), n3.css("-moz-transform", "rotate(" + e3 + "deg)"), n3.css("-webkit-transform", "rotate(" + e3 + "deg)"), n3.css("-o-transform", "rotate(" + e3 + "deg)"), "transform:rotate(" + e3 + "deg)";
          n3.length && (n3[0].style.transform = "");
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u65CB\u8F6C\u89D2\u5EA6
        </div>
        <div class="hiprint-option-item-field">
        <input type="number" class="auto-submit"/>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), zIndex = function() {
      function t3() {
        this.name = "zIndex";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("z-index", e3);
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5143\u7D20\u5C42\u7EA7
        </div>
        <div class="hiprint-option-item-field">
        <input type="number" class="auto-submit"/>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseInt(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), borderRadius = function() {
      function t3() {
        this.name = "borderRadius";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("border-raduis", e3);
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8FB9\u6846\u5706\u89D2
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" class="auto-submit"/>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), K2 = function() {
      function t3() {
        this.name = "optionsGroup";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u8FB9\u6846\u8BBE\u7F6E
        </div>
       
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
      }, t3.prototype.setValue = function(t4) {
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), G2 = function() {
      function t3() {
        this.name = "borderTop";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("border-top-style", e3), "border-top:1px";
          t4[0].style.borderTopStyle = "", t4[0].style.borderTopWidth = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E0A\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
            <option value="" >\u5426</option>
            <option value="solid" >\u5B9E\u7EBF</option>
            <option value="dotted" >\u865A\u7EBF</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), q2 = function() {
      function t3() {
        this.name = "borderLeft";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("border-left-style", e3), "border-left:1px";
          t4[0].style.borderLeftStyle = "", t4[0].style.borderLeftWidth = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5DE6\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u5426</option>
        <option value="solid" >\u5B9E\u7EBF</option>
        <option value="dotted" >\u865A\u7EBF</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), X = function() {
      function t3() {
        this.name = "borderRight";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("border-right-style", e3), "border-right:1px";
          t4[0].style.borderRightStyle = "", t4[0].style.borderRightWidth = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u53F3\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u5426</option>
        <option value="solid" >\u5B9E\u7EBF</option>
        <option value="dotted" >\u865A\u7EBF</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), Y = function() {
      function t3() {
        this.name = "borderBottom";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("border-bottom-style", e3), "border-bottom-style:1px solid";
          t4[0].style.borderBottomStyle = "", t4[0].style.borderBottomWidth = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E0B\u8FB9\u6846
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u5426</option>
        <option value="solid" >\u5B9E\u7EBF</option>
        <option value="dotted" >\u865A\u7EBF</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), J = function() {
      function t3() {
        this.name = "contentPaddingLeft";
      }
      return t3.prototype.css = function(t4, e3) {
        var n3 = t4.find(".hiprint-printElement-content");
        if (n3 && n3.length) {
          if (e3) return n3.css("padding-left", e3 + "pt"), "padding-left";
          n3[0].style.paddingLeft = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5DE6\u5185\u8FB9\u8DDD
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="0.75" >0.75pt</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), Q2 = function() {
      function t3() {
        this.name = "contentPaddingTop";
      }
      return t3.prototype.css = function(t4, e3) {
        var n3 = t4.find(".hiprint-printElement-content");
        if (n3 && n3.length) {
          if (e3) return n3.css("padding-top", e3 + "pt"), "padding-top";
          n3[0].style.paddingTop = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E0A\u5185\u8FB9\u8DDD
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="0.75" >0.75pt</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), Z = function() {
      function t3() {
        this.name = "contentPaddingRight";
      }
      return t3.prototype.css = function(t4, e3) {
        var n3 = t4.find(".hiprint-printElement-content");
        if (n3 && n3.length) {
          if (e3) return n3.css("padding-right", e3 + "pt"), "padding-right";
          n3[0].style.paddingRight = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u53F3\u5185\u8FB9\u8DDD
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="0.75" >0.75pt</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tt2 = function() {
      function t3() {
        this.name = "contentPaddingBottom";
      }
      return t3.prototype.css = function(t4, e3) {
        var n3 = t4.find(".hiprint-printElement-content");
        if (n3 && n3.length) {
          if (e3) return n3.css("padding-bottom", e3 + "pt"), "padding-bottom";
          n3[0].style.paddingBottom = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E0B\u5185\u8FB9\u8DDD
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="0.75" >0.75pt</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), et2 = function() {
      function t3() {
        this.name = "borderStyle";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("border-style", e3), "border-style:1px";
          t4[0].style.borderStyle = "";
        }
        return null;
      }, t3.prototype.createTarget = function(t4) {
        var name = ["hline", "vline", "rect", "oval"].includes(t4.printElementType.type) ? `\u6837\u5F0F` : `\u8FB9\u6846\u6837\u5F0F`;
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
       ${name}
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
            <option value="" >\u9ED8\u8BA4</option>
            <option value="solid" >\u5B9E\u7EBF</option>
            <option value="dashed" >\u957F\u865A\u7EBF</option>
            <option value="dotted" >\u77ED\u865A\u7EBF</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), nt2 = function() {
      function t3() {
        this.name = "backgroundColor";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3) return t4.css("background-color", e3), "background-color:" + e3;
          t4[0].style.backgroundColor = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u80CC\u666F\u989C\u8272
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" class="auto-submit"/>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").minicolors({
          defaultValue: t4 || "",
          theme: "bootstrap"
        }), this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), barColor = function() {
      function t3() {
        this.name = "barColor";
      }
      return t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6761\u7801\u989C\u8272
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" class="auto-submit"/>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").minicolors({
          defaultValue: t4 || "",
          theme: "bootstrap"
        }), this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), it2 = function() {
      function t3() {
        this.name = "orient";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u7EB8\u5F20\u65B9\u5411(\u4EC5\u81EA\u5B9A\u4E49\u7EB8\u8D28\u6709\u6548)
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="1" >\u7EB5\u5411</option>
        <option value="2" >\u6A2A\u5411</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), ot2 = function() {
      function t3() {
        this.name = "textContentVerticalAlign";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E0A\u4E0B\u5BF9\u9F50
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="middle" >\u5782\u76F4\u5C45\u4E2D</option>
        <option value="bottom" >\u5E95\u90E8</option>
       
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          t4.removeClass("hiprint-text-content-middle"), t4.removeClass("hiprint-text-content-bottom");
          if (e3) return "middle" === e3 && t4.addClass("hiprint-text-content-middle"), "bottom" === e3 && t4.addClass("hiprint-text-content-bottom"), "";
        }
        return null;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), textWrap = function() {
      function t3() {
        this.name = "textContentWrap";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6587\u672C\u6362\u884C
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="nowrap" >\u4E0D\u6362\u884C</option>
        <option value="clip" >\u4E0D\u6362\u884C&\u9690\u85CF</option>
        <option value="ellipsis" >\u4E0D\u6362\u884C&\u7701\u7565</option>
       </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          t4.removeClass("hiprint-text-content-wrap");
          t4.find(".hiprint-printElement-text-content").removeClass("hiprint-text-content-wrap-nowrap");
          t4.find(".hiprint-printElement-text-content").removeClass("hiprint-text-content-wrap-clip");
          t4.find(".hiprint-printElement-text-content").removeClass("hiprint-text-content-wrap-ellipsis");
          if (e3) return t4.addClass("hiprint-text-content-wrap"), t4.find(".hiprint-printElement-text-content").addClass("hiprint-text-content-wrap-" + e3), "";
        }
        return null;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), rt2 = n2(5), at2 = function() {
      function t3() {
        this.name = "columns";
      }
      return t3.prototype.createTarget = function() {
        hiprintJQuery('<div class="indicator"></div>').appendTo("body");
        return " </ul>\n       </div>\n    </div>", this.target = hiprintJQuery(' <div class="hiprint-option-item hiprint-option-item-row">\n       <div>\n            <ul class="hiprint-option-table-selected-columns"> </ul>\n       </div>\n    </div>'), this.target;
      }, t3.prototype.getValue = function() {
        return this.buildData();
      }, t3.prototype.setValue = function(t4, e3, n3) {
        var i3 = this, o2 = this;
        this.value = t4, this.options = e3, this.printElementType = n3;
        var r3 = n3.columns[0].filter(function(e4) {
          return 0 == t4[0].columns.filter(function(t5) {
            return e4.columnId == t5.columnId;
          }).length;
        }).map(function(t5) {
          var e4 = new rt2.a(t5);
          return e4.checked = false, e4;
        });
        this.allColumns = t4[0].columns.concat(r3), t4 && 1 == t4.length && (this.target.find("ul").html(
          this.allColumns.map(function(t5, e4) {
            return '<li  class="hiprint-option-table-selected-item"> <div class="hi-pretty p-default">\n                ' + (t5.checked ? '<input type="checkbox"   checked column-id="' + (t5.id || t5.columnId) + '" />' : '<input type="checkbox"  column-id="' + (t5.id || t5.columnId) + '" />') + '\n                <div class="state">\n                    <label></label>\n                </div>\n            </div><span class="column-title">' + (t5.title || t5.descTitle || "") + "</span></li>";
          }).join("")
        ), this.target.find("input").change(function(e4) {
          var checked = e4.target.checked, id = e4.target.attributes["column-id"].nodeValue || "";
          var idx = i3.allColumns.findIndex(function(e5) {
            return e5.field == id || e5.id == id;
          });
          if (idx >= 0) {
            i3.allColumns[idx]["checked"] = checked;
          }
          i3.submit();
        }), this.printElementType.columnDisplayIndexEditable && this.target.find("li").hidraggable({
          revert: true,
          handle: ".column-title",
          moveUnit: "pt",
          deltaX: 0,
          deltaY: 0
        }).hidroppable({
          onDragOver: function onDragOver(t5, e4) {
            hiprintJQuery(this).css("border-top-color", "red");
          },
          onDragLeave: function onDragLeave(t5, e4) {
            hiprintJQuery(this).css("border-top-color", "");
          },
          onDrop: function onDrop(t5, e4) {
            hiprintJQuery(e4).insertBefore(this), hiprintJQuery(this).css("border-top-color", ""), o2.submit();
          }
        }));
      }, t3.prototype.buildData = function() {
        var t4 = this, e3 = [];
        if (t4.options.columns.length > 1) {
          return this.value;
        }
        t4.printElementType.makeColumnObj(t4.allColumns);
        this.target.find("input").map(function(n3, i3) {
          var o2 = hiprintJQuery(i3).attr("column-id");
          var a3 = t4.printElementType.getColumnByColumnId(o2);
          if (a3) {
            var p3 = new rt2.a(a3);
            p3.checked = a3.checked, e3.push(p3);
          }
        });
        return this.value[0].columns = e3, this.value;
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), pt2 = function() {
      function t3() {
        this.name = "textType";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6253\u5370\u7C7B\u578B
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="" >\u6587\u672C</option>
        <option value="barcode" >\u6761\u5F62\u7801</option>
        <option value="qrcode" >\u4E8C\u7EF4\u7801</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tablept = function() {
      function t3() {
        this.name = "tableTextType";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5B57\u6BB5\u7C7B\u578B
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4(\u6587\u672C)</option>
        <option value="text" >\u6587\u672C</option>
 <option value="sequence" >\u5E8F\u53F7</option>
       <option value="barcode" >\u6761\u5F62\u7801</option>
        <option value="qrcode" >\u4E8C\u7EF4\u7801</option>
    <option value="image" >\u56FE\u7247</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableE = function() {
      function t3() {
        this.name = "tableBarcodeMode";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6761\u5F62\u7801\u683C\u5F0F
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
         <option value="" >\u9ED8\u8BA4(CODE128A)</option>
         <option value="CODE128A" >CODE128A</option>
        <option value="CODE128B" >CODE128B</option>
        <option value="CODE128C" >CODE128C</option>
        <option value="CODE39" >CODE39</option>
        <option value="EAN-13" >EAN-13</option>
        <option value="EAN-8" >EAN-8</option>
        <option value="EAN-5" >EAN-5</option>
        <option value="EAN-2" >EAN-2</option>
        <option value="UPC\uFF08A\uFF09" >UPC\uFF08A\uFF09</option>
        <option value="ITF" >ITF</option>
        <option value="ITF-14" >ITF-14</option>
        <option value="MSI" >MSI</option>
            <option value="MSI10" >MSI10</option>
            <option value="MSI11" >MSI11</option>
            <option value="MSI1010" >MSI1010</option>
            <option value="MSI1110" >MSI1110</option>
            <option value="Pharmacode" >Pharmacode</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return t4 || void 0;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableQRCodeLevel = function() {
      function t3() {
        this.name = "tableQRCodeLevel";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E8C\u7EF4\u7801\u5BB9\u9519\u7387
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="1" >7% L</option>
        <option value="0" >15% M</option>
        <option value="3" >25% Q</option>
        <option value="2" >30% H</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return parseInt(t4 || 0);
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableColumnH = function() {
      function t3() {
        this.name = "tableColumnHeight";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item ">
        <div class="hiprint-option-item-label">
        \u5355\u5143\u683C\u9AD8\u5EA6
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u6761\u5F62\u7801\u3001\u4E8C\u7EF4\u7801\u4EE5\u53CA\u56FE\u7247\u6709\u6548" class="auto-submit" >
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableSummaryTitle = function() {
      function t3() {
        this.name = "tableSummaryTitle";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item"><div class="hiprint-option-item-label">\u5E95\u90E8\u805A\u5408\u6807\u9898</div><div class="hiprint-option-item-field"><select class="auto-submit"><option value="">\u9ED8\u8BA4</option><option value="true">\u663E\u793A</option><option value="false">\u9690\u85CF</option></select></div></div>`), this.target;
      }, t3.prototype.getValue = function() {
        return !("false" == this.target.find("select").val());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableSummaryText = function() {
      function t3() {
        this.name = "tableSummaryText";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5E95\u90E8\u805A\u5408\u6587\u672C
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u805A\u5408\u7C7B\u578B:" class="auto-submit" >
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableSummaryColspan = function() {
      function t3() {
        this.name = "tableSummaryColspan";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5E95\u90E8\u805A\u5408\u5408\u5E76\u5217\u6570
        </div>
        <div class="hiprint-option-item-field">
        <input type="number" min="0" step="1" placeholder="\u5408\u5E76\u5217\u6570" class="auto-submit" >
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableSummaryAlign = function() {
      function t3() {
        this.name = "tableSummaryAlign";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5E95\u90E8\u805A\u5408\u7C7B\u578B\u5DE6\u53F3\u5BF9\u9F50
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="left" >\u5C45\u5DE6</option>
        <option value="center" >\u5C45\u4E2D</option>
        <option value="right" >\u5C45\u53F3</option>
        <option value="justify" >\u4E24\u7AEF\u5BF9\u9F50</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableSummaryNumFormat = function() {
      function t3() {
        this.name = "tableSummaryNumFormat";
      }
      return t3.prototype.createTarget = function() {
        var list = [{ t: `\u6574\u6570`, v: "0" }], num = [1, 2, 3, 4, 5, 6];
        num.forEach(function(n4) {
          list.push({ t: "\u4FDD\u7559" + n4 + "\u4F4D", v: "" + n4 });
        });
        var n3 = `
            <option value="" >\u9ED8\u8BA4</option>`;
        list.forEach(function(e3) {
          n3 += '\n            <option value="' + (e3.v || "") + '">' + (e3.t || "") + "</option>";
        });
        this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5E95\u90E8\u805A\u5408\u5C0F\u6570
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit"></select>
        </div>
    </div>`);
        this.target.find(".auto-submit").append(hiprintJQuery(n3));
        return this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), showCodeTitle = function() {
      function t3() {
        this.name = "showCodeTitle";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(` <div class="hiprint-option-item" title="\u6761\u5F62\u7801\u5E95\u90E8\u662F\u5426\u663E\u793A\u5185\u5BB9">
        <div class="hiprint-option-item-label">
          \u663E\u793A\u7801\u503C
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
            <option value="true" >\u663E\u793A</option>
            <option value="false" >\u9690\u85CF</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        if ("true" == this.target.find("select").val()) return true;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableSummaryFormatter2 = function() {
      function t3() {
        this.name = "tableSummaryFormatter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5E95\u90E8\u805A\u5408\u683C\u5F0F\u5316\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(column,fieldPageData,tableData,options){ return '<td></td>'; }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), upperCase = function() {
      function t3() {
        this.name = "upperCase";
      }
      return t3.prototype.createTarget = function() {
        var list = [
          { t: "\u300C\u5C0F\u5199\u300D\u5341\u70B9\u516B", v: "0" },
          { t: "\u300C\u5C0F\u5199\u300D\u4E00\u5341\u70B9\u516B", v: "1" },
          { t: "\u300C\u5927\u5199\u300D\u62FE\u70B9\u634C", v: "2" },
          { t: "\u300C\u5927\u5199\u300D\u58F9\u62FE\u70B9\u634C", v: "3" },
          { t: "\u300C\u91D1\u989D\u300D\u4EBA\u6C11\u5E01\u62FE\u5143\u634C\u89D2", v: "4" },
          { t: "\u300C\u91D1\u989D\u300D\u4EBA\u6C11\u5E01\u58F9\u62FE\u5143\u634C\u89D2", v: "5" },
          { t: "\u300C\u91D1\u989D\u300D\u4EBA\u6C11\u5E01\u58F9\u62FE\u5143\u634C\u89D2\u96F6\u5206", v: "6" },
          { t: "\u300C\u91D1\u989D\u300D\u58F9\u62FE\u5143\u634C\u89D2\u96F6\u5206", v: "7" }
        ];
        var n3 = `
<option value="">\u9ED8\u8BA4</option>`;
        list.forEach((e3) => {
          n3 += `
<option value='${e3.v}'>${e3.t}</option>`;
        });
        this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
<div class="hiprint-option-item-label">
\u8F6C\u5927\u5C0F\u5199
</div>
<div class="hiprint-option-item-field">
<select class="auto-submit"></select>
</div>
</div>`);
        this.target.find(".auto-submit").append(hiprintJQuery(n3));
        return this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableSummary = function() {
      function t3() {
        this.name = "tableSummary";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item"><div class="hiprint-option-item-label">\u5E95\u90E8\u805A\u5408\u7C7B\u578B</div><div class="hiprint-option-item-field"><select class="auto-submit"><option value="">\u4E0D\u805A\u5408</option><option value="count">\u8BA1\u6570</option><option value="sum">\u5408\u8BA1</option><option value="avg">\u5E73\u5747\u503C</option><option value="min">\u6700\u5C0F\u503C</option><option value="max">\u6700\u5927\u503C</option><option value="text">\u4EC5\u6587\u672C</option></select></div></div>`), this.target;
      }, t3.prototype.getValue = function() {
        return this.target.find("select").val();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), st2 = function() {
      function t3() {
        this.name = "topOffset";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u9876\u90E8\u504F\u79FB
        </div>
        <div class="hiprint-option-item-field">
        <input type="text" placeholder="\u504F\u79FB\u91CFpt" class="auto-submit">
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), panelLayoutOptions = function() {
      function t3() {
        this.name = "panelLayoutOptions";
      }
      return t3.prototype.createTarget = function() {
        this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row"><div class="hiprint-option-item-label">\u9762\u677F\u6392\u5217</div></div>`);
        this.layoutType = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: baseline;"><div style="width:25%">\u6392\u5217\u65B9\u5F0F:</div><select style="width:75%" class="auto-submit"><option value="column" >\u7EB5\u5411</option><option value="row" >\u6A2A\u5411</option></select></div></div>`);
        this.layoutRowGap = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: baseline;margin-top: 4px"><div style="width:25%">\u5782\u76F4\u95F4\u8DDD:</div><input style="width:75%" type="text" placeholder="\u5782\u76F4\u95F4\u8DDDmm" class="auto-submit"></div>`);
        this.layoutColumnGap = hiprintJQuery(`<div class="hiprint-option-item-field" style="display: flex;align-items: baseline;margin-top: 4px"><div style="width:25%">\u6C34\u5E73\u95F4\u8DDD:</div><input style="width:75%" type="text" placeholder="\u6C34\u5E73\u95F4\u8DDDmm" class="auto-submit"></div>`);
        this.target.append(this.layoutType);
        this.target.append(this.layoutRowGap);
        this.target.append(this.layoutColumnGap);
        return this.target;
      }, t3.prototype.getValue = function() {
        let opt = {
          layoutType: this.layoutType.find("select").val() || "column",
          layoutRowGap: parseInt(this.layoutRowGap.find("input").val() || 0),
          layoutColumnGap: parseInt(this.layoutColumnGap.find("input").val() || 0)
        };
        let options2 = Object.assign({}, this.options, opt);
        return options2;
      }, t3.prototype.setValue = function(t4) {
        this.options = t4;
        this.layoutType.find("select").val(t4.layoutType || "column");
        this.layoutRowGap.find("input").val(t4.layoutRowGap);
        this.layoutColumnGap.find("input").val(t4.layoutColumnGap);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), lt2 = function() {
      function t3() {
        this.name = "gridColumns";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E00\u884C\u591A\u7EC4
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="2" >\u4E00\u884C\u4E8C\u5217</option>
        <option value="3" >\u4E00\u884C\u4E09\u5217</option>
        <option value="4" >\u4E00\u884C\u56DB\u5217</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), ut2 = function() {
      function t3() {
        this.name = "gridColumnsGutter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u4E00\u884C\u591A\u7EC4\u95F4\u9694
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.25" >7.25pt</option>
        <option value="8.5" >8.5pt</option>
        <option value="9" >9pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.css = function(t4, e3) {
        if (t4 && t4.length) {
          if (e3)
            return t4.find(".table-grid-row").css("margin-left", "-" + e3 + "pt").css("margin-right", "-" + e3 + "pt"), t4.find(".tableGridColumnsGutterRow").css("padding-left", e3 + "pt").css("padding-right", e3 + "pt"), null;
          t4.find(".table-grid-row").map(function(t5, e4) {
            e4.style.marginLeft = "", e4.style.marginRight = "";
          }), t4.find(".tableGridColumnsGutterRow").map(function(t5, e4) {
            e4.style.paddingLeft = "", e4.style.paddingRight = "";
          });
        }
        return null;
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), ith = function() {
      function t3() {
        this.name = "tableHeaderRepeat";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u683C\u5934\u663E\u793A
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="page" >\u6BCF\u9875\u663E\u793A</option>
        <option value="first" >\u9996\u9875\u663E\u793A</option>
        <option value="none" >\u4E0D\u663E\u793A</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), dt2 = function() {
      function t3() {
        this.name = "paddingLeft";
      }
      return t3.prototype.css = function(t4, e3) {
        var n3 = t4;
        if (n3 && n3.length) {
          if (e3) return n3.css("padding-left", e3 + "pt"), "padding-left";
          n3[0].style.paddingLeft = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5DE6\u5185\u8FB9\u8DDD
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="0.75" >0.75pt</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), ct2 = function() {
      function t3() {
        this.name = "paddingRight";
      }
      return t3.prototype.css = function(t4, e3) {
        var n3 = t4;
        if (n3 && n3.length) {
          if (e3) return n3.css("padding-right", e3 + "pt"), "padding-right";
          n3[0].style.paddingRight = "";
        }
        return null;
      }, t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u53F3\u5185\u8FB9\u8DDD
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="0.75" >0.75pt</option>
        <option value="1.5" >1.5pt</option>
        <option value="2.25" >2.25pt</option>
        <option value="3" >3pt</option>
        <option value="3.75" >3.75pt</option>
        <option value="4.5" >4.5pt</option>
        <option value="5.25" >5.25pt</option>
        <option value="6" >6pt</option>
        <option value="6.75" >6.75pt</option>
        <option value="7.5" >7.5pt</option>
        <option value="8.25" >8.25pt</option>
        <option value="9" >9pt</option>
        <option value="9.75" >9.75pt</option>
        <option value="10.5" >10.5pt</option>
        <option value="11.25" >11.25pt</option>
        <option value="12" >12pt</option>
        <option value="12.75" >12.75pt</option>
        <option value="13.5" >13.5pt</option>
        <option value="14.25" >14.25pt</option>
        <option value="15" >15pt</option>
        <option value="15.75" >15.75pt</option>
        <option value="16.5" >16.5pt</option>
        <option value="17.25" >17.25pt</option>
        <option value="18" >18pt</option>
        <option value="18.75" >18.75pt</option>
        <option value="19.5" >19.5pt</option>
        <option value="20.25" >20.25pt</option>
        <option value="21" >21pt</option>
        <option value="21.75" >21.75pt</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return parseFloat(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        t4 && (this.target.find('option[value="' + t4 + '"]').length || this.target.find("select").prepend('<option value="' + t4 + '" >' + t4 + "</option>"));
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), ht2 = function() {
      function t3() {
        this.name = "dataType";
      }
      return t3.prototype.createTarget = function() {
        var t4 = this;
        return this.target = hiprintJQuery(`
        <div class="hiprint-option-item-row">
        <div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6570\u636E\u7C7B\u578B
        </div>
        <div class="hiprint-option-item-field">
        <select class="hiprint-option-item-datatype">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="datetime" >\u65E5\u671F\u65F6\u95F4</option>
        <option value="boolean" >\u5E03\u5C14</option>
        </select>
        </div>
    </div>
    <div class="hiprint-option-item ">
        <div class="hiprint-option-item-label ">
        \u683C\u5F0F
        </div>
        <div class="hiprint-option-item-field">
        <select  class="auto-submit hiprint-option-item-datatype-select-format">
        <option value="" >\u9ED8\u8BA4</option>
        
        </select>
        <input class="auto-submit  hiprint-option-item-datatype-input-format" type="text" data-type="boolean" placeholder="true:false">
        </div>
    </div>
        </div>
`), hiprintJQuery(this.target.find(".hiprint-option-item-datatype")).change(function() {
          var e3 = hiprintJQuery(t4.target.find(".hiprint-option-item-datatype")).val();
          t4.loadFormatSelectByDataType(e3), t4.submit(t4.getValue());
        }), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find(".hiprint-option-item-datatype").val();
        if (t4) {
          var e3 = this.target.find(".hiprint-option-item-datatype-format").val();
          return {
            dataType: t4,
            format: e3 || void 0
          };
        }
        return {
          dataType: void 0,
          format: void 0
        };
      }, t3.prototype.setValue = function(t4, e3) {
        this.target.find(".hiprint-option-item-datatype").val(e3.dataType || ""), this.loadFormatSelectByDataType(e3.dataType), this.target.find(".hiprint-option-item-datatype-format").val(e3.format || "");
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3.prototype.loadFormatSelectByDataType = function(t4) {
        "boolean" === t4 ? (this.target.find(".hiprint-option-item-datatype-select-format").removeClass("hiprint-option-item-datatype-format").hide().val(""), this.target.find(".hiprint-option-item-datatype-input-format").addClass("hiprint-option-item-datatype-format").show()) : "datetime" === t4 ? (this.target.find(".hiprint-option-item-datatype-select-format").addClass("hiprint-option-item-datatype-format").show(), this.target.find(".hiprint-option-item-datatype-input-format").removeClass("hiprint-option-item-datatype-format").hide().val(""), this.target.find(".hiprint-option-item-datatype-select-format").html(`
            <option value="" >\u9ED8\u8BA4</option>
            <option value="M/d" >M/d</option>
            <option value="MM/dd" >MM/dd</option>
            <option value="yy/M/d" >yy/M/d</option>
            <option value="yy/MM/dd" >yy/MM/dd</option>
            <option value="yyyy/M/d" >yyyy/M/d</option>
            <option value="yyyy/MM/dd" >yyyy/MM/dd</option>
            <option value="yy/M/d H:m" >yy/M/d H:m</option>
            <option value="yy/M/d H:m:s" >yy/M/d H:m:s</option>
            <option value="yy/M/d HH:mm" >yy/M/d HH:mm</option>
            <option value="yy/M/d HH:mm:ss" >yy/M/d HH:mm:ss</option>
            <option value="yy/MM/dd H:m" >yy/MM/dd H:m</option>
            <option value="yy/MM/dd H:m:s" >yy/MM/dd H:m:s</option>
            <option value="yy/MM/dd HH:mm" >yy/MM/dd HH:mm</option>
            <option value="yy/MM/dd HH:mm:ss" >yy/MM/dd HH:mm:ss</option>
            <option value="yyyy/M/d H:m" >yyyy/M/dd H:m</option>
            <option value="yyyy/M/d H:m:s" >yyyy/M/d H:m:s</option>
            <option value="yyyy/M/d HH:mm" >yyyy/M/d HH:mm</option>
            <option value="yyyy/M/d HH:mm:ss" >yyyy/M/d HH:mm:ss</option>
            <option value="yyyy/MM/dd H:m" >yyyy/MM/dd H:m</option>
            <option value="yyyy/MM/dd H:m:s" >yyyy/MM/dd H:m:s</option>
            <option value="yyyy/MM/dd HH:mm" >yyyy/MM/dd HH:mm</option>
            <option value="yyyy/MM/dd HH:mm:ss" >yyyy/MM/dd HH:mm:ss</option>

            <option value="M-d" >M-d</option>
            <option value="MM-dd" >MM-dd</option>
            <option value="yy-M-d" >yy-M-d</option>
            <option value="yy-MM-dd" >yy-MM-dd</option>
            <option value="yyyy-M-d" >yyyy-M-d</option>
            <option value="yyyy-MM-dd" >yyyy-MM-dd</option>
            <option value="yy-M-d H:m" >yy-M-d H:m</option>
            <option value="yy-M-d H:m:s" >yy-M-d H:m:s</option>
            <option value="yy-M-d HH:mm" >yy-M-d HH:mm</option>
            <option value="yy-M-d HH:mm:ss" >yy-M-d HH:mm:ss</option>
            <option value="yy-MM-dd H:m" >yy-MM-dd H:m</option>
            <option value="yy-MM-dd H:m:s" >yy-MM-dd H:m:s</option>
            <option value="yy-MM-dd HH:mm" >yy-MM-dd HH:mm</option>
            <option value="yy-MM-dd HH:mm:ss" >yy-MM-dd HH:mm:ss</option>
            <option value="yyyy-M-d H:m" >yyyy-M-d H:m</option>
            <option value="yyyy-M-d H:m:s" >yyyy-M-d H:m:s</option>
            <option value="yyyy-M-d HH:mm" >yyyy-M-d HH:mm</option>
            <option value="yyyy-M-d HH:mm:ss" >yyyy-M-d HH:mm:ss</option>
            <option value="yyyy-MM-dd H:m" >yyyy-MM-dd H:m</option>
            <option value="yyyy-MM-dd H:m:s" >yyyy-MM-dd H:m:s</option>
            <option value="yyyy-MM-dd HH:mm" >yyyy-MM-dd HH:mm</option>
            <option value="yyyy-MM-dd HH:mm:ss" >yyyy-MM-dd HH:mm:ss</option>
`)) : (this.target.find(".hiprint-option-item-datatype-select-format").show(), this.target.find(".hiprint-option-item-datatype-input-format").hide().val(""), this.target.find(".hiprint-option-item-datatype-format").html(`
            <option value="" >\u9ED8\u8BA4</option>
`));
      }, t3;
    }(), ft2 = function() {
      function t3() {
        this.name = "formatter";
      }
      return t3.prototype.createTarget = function() {
        var t4 = `<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u683C\u5F0F\u5316\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(title,value,options,templateData,target){}" class="auto-submit"></textarea>
        </div>
    </div>`;
        return this.target = hiprintJQuery(t4), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), gt2 = function() {
      function t3() {
        this.name = "styler";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u6837\u5F0F\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(value, options, target,templateData){}" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), rowcolumns = function() {
      function t3() {
        this.name = "rowsColumnsMerge";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u884C/\u5217\u5408\u5E76\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(data, col, colIndex, rowIndex, tableData, printData){ return [1,1] }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), rowsColumnsMergeClean = function() {
      function t3() {
        this.name = "rowsColumnsMergeClean";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u8DE8\u9875\u5408\u5E76\u662F\u5426\u6E05\u9664
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="true" >\u662F</option>
        <option value="false" >\u5426</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        if ("true" == this.target.find("select").val()) return true;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), mt2 = function() {
      function t3() {
        this.name = "footerFormatter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u8868\u683C\u811A\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(options,rows,data,pageData,pageIndex){ return '<tr></tr>' }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), groupSequenceContinue = function() {
      function t3() {
        this.name = "groupSequenceContinue";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5206\u7EC4\u5E8F\u53F7\u7EED\u7F16
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="true" >\u662F</option>
        <option value="false" >\u5426</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        if ("true" == this.target.find("select").val()) return true;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), groupFieldsFormatter2 = function() {
      function t3() {
        this.name = "groupFieldsFormatter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5206\u7EC4\u5B57\u6BB5\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(type,options,data){ return [] }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), groupFormatter2 = function() {
      function t3() {
        this.name = "groupFormatter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5206\u7EC4\u5934\u683C\u5F0F\u5316\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(colTotal,tableData,printData,groupData,options){ return '\u5206\u7EC4\u5934\u4FE1\u606F(html)' }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), groupFooterFormatter2 = function() {
      function t3() {
        this.name = "groupFooterFormatter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5206\u7EC4\u811A\u683C\u5F0F\u5316\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(colTotal,tableData,printData,groupData,options){ return '\u5206\u7EC4\u811A\u4FE1\u606F(html)' }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), vt = function() {
      function t3() {
        this.name = "gridColumnsFooterFormatter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u591A\u7EC4\u8868\u683C\u811A\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(options,rows,data,pageData){ return '' }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), yt = function() {
      function t3() {
        this.name = "rowStyler";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u884C\u6837\u5F0F\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(value,options){ return '' }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), bt = function() {
      function t3() {
        this.name = "align";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5355\u5143\u683C\u5DE6\u53F3\u5BF9\u9F50
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="left" >\u5C45\u5DE6</option>
        <option value="center" >\u5C45\u4E2D</option>
        <option value="right" >\u5C45\u53F3</option>
        <option value="justify" >\u4E24\u7AEF\u5BF9\u9F50</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), Et = function() {
      function t3() {
        this.name = "vAlign";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u5355\u5143\u683C\u4E0A\u4E0B\u5BF9\u9F50
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="top" >\u4E0A</option>
        <option value="middle" >\u4E2D</option>
        <option value="bottom" >\u4E0B</option>
        
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), Tt = function() {
      function t3() {
        this.name = "halign";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u683C\u5934\u5355\u5143\u683C\u5DE6\u53F3\u5BF9\u9F50
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="left" >\u5C45\u5DE6</option>
        <option value="center" >\u5C45\u4E2D</option>
        <option value="right" >\u5C45\u53F3</option>
        <option value="justify" >\u4E24\u7AEF\u5BF9\u9F50</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), Pt = function() {
      function t3() {
        this.name = "styler2";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5355\u5143\u683C\u6837\u5F0F\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(value,row,index,options){ return {color:'red' }; }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), stylerHeader2 = function() {
      function t3() {
        this.name = "stylerHeader";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u8868\u683C\u5934\u6837\u5F0F\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(options){ return {color:'red' }; }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), _t = function() {
      function t3() {
        this.name = "formatter2";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5355\u5143\u683C\u683C\u5F0F\u5316\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(value,row,index,options){ return ''; }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), renderFormatter2 = function() {
      function t3() {
        this.name = "renderFormatter";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item hiprint-option-item-row">
        <div class="hiprint-option-item-label">
        \u5355\u5143\u683C\u6E32\u67D3\u51FD\u6570
        </div>
        <div class="hiprint-option-item-field">
        <textarea style="height:80px;" placeholder="function(value,row,colIndex,options,rowIndex){ return '<td></td>'; }" class="auto-submit"></textarea>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("textarea").val();
        if (t4) return t4;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("textarea").val(t4 ? t4.toString() : null);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), wt = function() {
      function t3() {
        this.name = "autoCompletion";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u81EA\u52A8\u8865\u5168
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="true" >\u662F</option>
        <option value="false" >\u5426</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        if ("true" == this.target.find("select").val()) return true;
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val((null == t4 ? "" : t4).toString());
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), maxRows = function() {
      function t3() {
        this.name = "maxRows";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u6BCF\u9875\u6700\u5927\u884C\u6570
        </div>
        <div class="hiprint-option-item-field">
        <input type="number" value="1" step="1" min="1" class="auto-submit"/>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("input").val();
        if (t4) return parseInt(t4.toString());
      }, t3.prototype.setValue = function(t4) {
        this.target.find("input").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), xt = function() {
      function t3() {
        this.name = "tableFooterRepeat";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(`<div class="hiprint-option-item">
        <div class="hiprint-option-item-label">
        \u8868\u683C\u811A\u663E\u793A
        </div>
        <div class="hiprint-option-item-field">
        <select class="auto-submit">
        <option value="" >\u9ED8\u8BA4</option>
        <option value="no" >\u4E0D\u663E\u793A</option>
        <option value="page" >\u6BCF\u9875\u663E\u793A</option>
        <option value="last" >\u6700\u540E\u663E\u793A</option>
        </select>
        </div>
    </div>`), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        if (t4) return t4.toString();
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }(), tableFooterScope = function() {
      function t3() {
        this.name = "tableFooterScope";
      }
      return t3.prototype.createTarget = function() {
        return this.target = hiprintJQuery(' <div class="hiprint-option-item">\n        <div class="hiprint-option-item-label">\n        \u805A\u5408\u6570\u636E\u8303\u56F4\n        </div>\n        <div class="hiprint-option-item-field">\n        <select class="auto-submit">\n        <option value="page" >\u5F53\u524D\u9875</option>\n        <option value="all" >\u5168\u90E8\u6570\u636E</option>\n        </select>\n        </div>\n    </div>'), this.target;
      }, t3.prototype.getValue = function() {
        var t4 = this.target.find("select").val();
        return t4 ? t4.toString() : "page";
      }, t3.prototype.setValue = function(t4) {
        this.target.find("select").val(t4);
      }, t3.prototype.destroy = function() {
        this.target.remove();
      }, t3;
    }();
    n2.d(e2, "a", function() {
      return Ct;
    });
    var Ct = function() {
      function t3() {
      }
      return t3.init = function() {
        t3.printElementOptionItems || (t3.printElementOptionItems = {}, t3._printElementOptionItems.forEach(function(e3) {
          t3.printElementOptionItems[e3.name] = e3;
        }));
      }, t3.registerItem = function(e3) {
        if (!e3.name) throw new Error("styleItem must have name");
        t3.init(), t3.printElementOptionItems[e3.name] = e3;
      }, t3.getItem = function(e3) {
        return t3.init(), t3.printElementOptionItems[e3];
      }, t3._printElementOptionItems = [new fontFamily(), new r2(), new a2(), new p2(), new i2(), new s2(), new l2(), new pt2(), new u2(), new d2(), new c2(), new h2(), new f2(), new g2(), new m2(), new d22(), new c22(), new v2(), new y2(), new b2(), new E2(), new qrCodeLevel(), new T2(), new P2(), new _2(), new w2(), new x2(), new coordinate(), new widthHeight(), new C2(), new imageFit(), new O2(), new H2(), new D2(), new paperNumberContinue(), new watermarkOptions(), new I2(), new R2(), new pageBreak(), new M2(), new M22(), new S2(), new B2(), new F2(), new L2(), new A2(), new z2(), new k2(), new st2(), new N2(), new V2(), new W2(), new j2(), new U2(), new borderRadius(), new zIndex(), new K2(), new G2(), new q2(), new X(), new Y(), new Q2(), new J(), new Z(), new tt2(), new et2(), new nt2(), new it2(), new ot2(), new textWrap(), new at2(), new lt2(), new panelLayoutOptions(), new ut2(), new ith(), new dt2(), new ct2(), new ht2(), new ft2(), new gt2(), new mt2(), new rowcolumns(), new rowsColumnsMergeClean(), new groupSequenceContinue(), new groupFieldsFormatter2(), new groupFormatter2(), new groupFooterFormatter2(), new vt(), new yt(), new bt(), new Tt(), new Et(), new Pt(), new stylerHeader2(), new renderFormatter2(), new _t(), new wt(), new maxRows(), new xt(), new tableColumnH(), new tableE(), new tableQRCodeLevel(), new tablept(), new tableSummaryTitle(), new tableSummaryText(), new tableSummaryColspan(), new tableSummary(), new tableSummaryAlign(), new tableSummaryNumFormat(), new tableSummaryFormatter2(), new showCodeTitle(), new upperCase(), new barcodeType(), new qrcodeType(), new barColor(), new barTextMode(), new barWidth(), new barAutoWidth(), new tableFooterScope()], t3;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return o2;
    }), n2.d(e2, "b", function() {
      return r2;
    });
    var i2 = n2(14), o2 = function() {
      function t3(t4, e3) {
        this.selectedCells = [], this.rows = t4, this.tableTatget = e3;
      }
      return t3.prototype.clear = function() {
        this.tableTatget.find("td").removeClass("selected");
      }, t3.prototype.setSingleSelect = function(t4) {
        this.startCell = t4, this.selectedCells = [];
      }, t3.prototype.getSingleSelect = function() {
        if (this.selectedCells.length) {
          if (1 == this.selectedCells.length) return 1 == this.selectedCells[0].length ? this.selectedCells[0][0] : void 0;
          if (this.selectedCells.length > 1) return;
        }
        return this.startCell;
      }, t3.prototype.singleSelectByXY = function(t4, e3) {
        var n3 = this.getCellByXY(t4, e3);
        n3 && (this.clear(), n3 && (n3.cell.select(), this.startCell = n3, this.selectedCells = []));
      }, t3.prototype.multipleSelectByXY = function(t4, e3) {
        this.clear();
        var n3 = [];
        if (this.startCell) {
          var o3 = this.getCellByXY(t4, e3);
          if (o3) {
            var r3 = i2.a.mergeRect(this.startCell.cell.getTableRect(), o3.cell.getTableRect());
            this.selectByRect(new a2(r3), n3);
          }
        }
        this.selectedCells = n3;
      }, t3.prototype.selectByRect = function(t4, e3) {
        this.rows.forEach(function(n3, i3) {
          var o3 = [];
          n3.columns.forEach(function(e4) {
            e4.isInRect(t4) && (o3.push(new p2(i3, e4)), e4.select());
          }), o3.length && e3.push(o3);
        }), t4.changed && (t4.changed = false, e3.splice(0, e3.length), this.selectByRect(t4, e3));
      }, t3.prototype.getSelectedCells = function() {
        return this.selectedCells;
      }, t3.prototype.getCellByXY = function(t4, e3) {
        var n3;
        return this.rows.forEach(function(i3, o3) {
          var r3 = (i3.columns || []).filter(function(column2) {
            return column2.checked;
          }).filter(function(n4) {
            return n4.isXYinCell(t4, e3);
          });
          r3.length && (n3 = new p2(o3, r3[0]));
        }), n3;
      }, t3;
    }(), r2 = /* @__PURE__ */ function() {
      return function(t3) {
        this.x = t3.x, this.y = t3.y, this.height = t3.height, this.width = t3.width;
      };
    }(), a2 = /* @__PURE__ */ function() {
      return function(t3) {
        this.rect = t3;
      };
    }(), p2 = /* @__PURE__ */ function() {
      return function(t3, e3) {
        this.rowIndex = t3, this.cell = e3;
      };
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return i2;
    });
    var i2 = function() {
      function t3() {
      }
      return t3.createId = function() {
        return this.id += 1, this.id;
      }, t3.id = 1, t3;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return p2;
    });
    var _i, o2 = n2(5), r2 = n2(13), a2 = (_i = function i2(t3, e3) {
      return (_i = Object.setPrototypeOf || _instanceof(
        {
          __proto__: []
        },
        Array
      ) && function(t4, e4) {
        t4.__proto__ = e4;
      } || function(t4, e4) {
        for (var n3 in e4) {
          e4.hasOwnProperty(n3) && (t4[n3] = e4[n3]);
        }
      })(t3, e3);
    }, function(t3, e3) {
      function n3() {
        this.constructor = t3;
      }
      _i(t3, e3), t3.prototype = null === e3 ? Object.create(e3) : (n3.prototype = e3.prototype, new n3());
    }), p2 = function(t3) {
      function e3(e4) {
        var n3 = t3.call(this) || this;
        (n3.columns = [], e4 && e4.constructor === Array) ? (e4 || []).forEach(function(t4) {
          n3.columns.push(new o2.a(t4));
        }) : e4.columns && (e4.columns || []).forEach(function(t4) {
          n3.columns.push(new o2.a(t4));
        });
        return n3;
      }
      return a2(e3, t3), e3.prototype.getPrintElementOptionEntity = function() {
        var t4 = [];
        var all = this.allColumns ? this.allColumns.filter(function(c2) {
          return !c2.checked;
        }) : [];
        return [...this.columns, ...all].forEach(function(e4) {
          t4.push(e4.getEntity());
        }), t4;
      }, e3;
    }(r2.a);
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return r2;
    });
    var i2 = n2(11), o2 = n2(5), r2 = function() {
      function t3() {
        this.id = i2.a.createId();
      }
      return t3.prototype.init = function(t4, e3, n3) {
        this.isHead = n3, this.target = e3 || hiprintJQuery("<tr></tr>"), this.tableOptions = t4, this.allColumns = this.columns || [], this.initCells(
          (this.columns || []).filter(function(column2) {
            return column2.checked;
          })
        );
      }, t3.prototype.getTarget = function() {
        return this.target;
      }, t3.prototype.initCells = function(t4) {
        var e3 = this;
        t4 ? (this.columns = t4, t4.forEach(function(t5, n3) {
          t5.init(e3.target.find("td:eq(" + n3 + ")"), e3.tableOptions, e3.id, e3.isHead);
        })) : (this.columns = [], this.target.find("td").map(function(t5, n3) {
          var i3 = new o2.a();
          i3.init(hiprintJQuery(n3), e3.tableOptions, e3.id, e3.isHead), e3.columns.push(i3);
        }));
      }, t3.prototype.removeCell = function(t4) {
        var e3 = this.columns.indexOf(t4);
        this.columns[e3].getTarget().remove(), this.columns.splice(e3, 1);
      }, t3.prototype.createTableCell = function(t4, e3) {
        var n3 = new o2.a();
        return n3.init(hiprintJQuery("<td></td>"), this.tableOptions, this.id, this.isHead), t4 > 1 && (n3.getTarget().attr("rowspan", t4), n3.rowspan = t4), e3 > 1 && (n3.getTarget().attr("colspan", e3), n3.colspan = e3), n3;
      }, t3.prototype.insertToTargetCellLeft = function(t4, e3) {
        var n3 = this.columns.indexOf(t4);
        t4.getTarget().before(e3.getTarget()), this.columns.splice(n3, 0, e3);
      }, t3.prototype.insertToTargetCellRight = function(t4, e3) {
        var n3 = this.columns.indexOf(t4);
        this.columns[n3].getTarget().after(e3.getTarget()), this.columns.splice(n3 + 1, 0, e3);
      }, t3.prototype.insertCellToFirst = function(t4) {
        this.target.prepend(t4.getTarget()), this.columns.splice(0, 0, t4);
      }, t3.prototype.insertCellToLast = function(t4) {
        this.columns.push(t4), this.target.append(t4.getTarget());
      }, t3.prototype.getPrintElementOptionEntity = function() {
        var t4 = [];
        return [
          ...this.columns,
          ...this.allColumns.filter(function(c2) {
            return !c2.checked;
          })
        ].forEach(function(e3) {
          t4.push(e3.getEntity());
        }), t4;
      }, t3;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return o2;
    });
    var i2 = n2(10), o2 = function() {
      function t3() {
      }
      return t3.mergeRect = function(t4, e3) {
        var n3 = Math.min(t4.x, e3.x), o3 = Math.min(t4.y, e3.y);
        return new i2.b({
          x: n3,
          y: o3,
          height: Math.max(t4.y + t4.height, e3.y + e3.height) - o3,
          width: Math.max(t4.x + t4.width, e3.x + e3.width) - n3
        });
      }, t3.Rect = function(t4, e3, n3, i3) {
        return {
          minX: t4 < n3 ? t4 : n3,
          minY: e3 < i3 ? e3 : i3,
          maxX: t4 < n3 ? n3 : t4,
          maxY: e3 < i3 ? i3 : e3
        };
      }, t3;
    }();
  },
  function(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    __webpack_require__.d(__webpack_exports__, "a", function() {
      return TablePrintElement;
    });
    var _BasePrintElement__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4), _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1), _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6), _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0), _PrintReferenceElement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8), _option_TablePrintElementOption__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18), _table_TableExcelHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7), _hitable_HiTale__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16), _table_GridColumnsStructure__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20), _HiPrintlib__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2), __extends = (_extendStatics = function extendStatics(t2, e2) {
      return (_extendStatics = Object.setPrototypeOf || _instanceof(
        {
          __proto__: []
        },
        Array
      ) && function(t3, e3) {
        t3.__proto__ = e3;
      } || function(t3, e3) {
        for (var n2 in e3) {
          e3.hasOwnProperty(n2) && (t3[n2] = e3[n2]);
        }
      })(t2, e2);
    }, function(t2, e2) {
      function n2() {
        this.constructor = t2;
      }
      _extendStatics(t2, e2), t2.prototype = null === e2 ? Object.create(e2) : (n2.prototype = e2.prototype, new n2());
    }), _extendStatics, TablePrintElement = function(_super) {
      function TablePrintElement(t2, e2) {
        var n2 = _super.call(this, t2) || this;
        return n2.gridColumnsFooterCss = "hiprint-gridColumnsFooter", n2.tableGridRowCss = "table-grid-row", n2.options = new _option_TablePrintElementOption__WEBPACK_IMPORTED_MODULE_5__.a(e2, n2.printElementType), n2.options.setDefault(new _option_TablePrintElementOption__WEBPACK_IMPORTED_MODULE_5__.a(_HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance.table.default).getPrintElementOptionEntity()), n2;
      }
      return __extends(TablePrintElement, _super), TablePrintElement.prototype.getColumns = function() {
        return this.options.columns;
      }, TablePrintElement.prototype.getColumnByColumnId = function(t2) {
        return this.options.getColumnByColumnId(t2);
      }, TablePrintElement.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t2 = this.designTarget.find(".hiprint-printElement-table-content"), e2 = this.getHtml(this.designPaper);
          t2.html(""), t2.append(e2[0].target.find(".table-grid-row")), this.printElementType.editable && this.setHitable(), this.setColumnsOptions();
          this.css(this.designTarget, this.getData());
        }
      }, TablePrintElement.prototype.css = function(t2, e2) {
        if ((this.getField() || !this.options.content) && !this.printElementType.formatter) return _super.prototype.css.call(this, t2, e2);
      }, TablePrintElement.prototype.getDesignTarget = function(t2) {
        return this.designTarget = (this.getHtml(t2)[0] || {}).target || hiprintJQuery('<div style="color:#fff;background:#f56c6c;padding:4px 6px;font-size:12px;">\u8868\u683C\u5185\u5BB9\u8D85\u51FA\u9875\u9762\u53EF\u6253\u5370\u9AD8\u5EA6\uFF0C\u8BF7\u51CF\u5C11\u884C\u6570/\u5217\u6570\u6216\u8C03\u5C0F\u5C3A\u5BF8</div>'), this.css(this.designTarget, this.getData()), this.designPaper = t2, this.designTarget.find("td").hidroppable({
          accept: ".rn-draggable-item",
          onDrop: function onDrop(t3, e2) {
          },
          onDragEnter: function onDragEnter(t3, e2) {
            hiprintJQuery(e2).removeClass("rn-draggable-item");
          },
          onDragLeave: function onDragLeave(t3, e2) {
            hiprintJQuery(e2).addClass("rn-draggable-item");
          }
        }), this.designTarget;
      }, TablePrintElement.prototype.getConfigOptions = function() {
        return _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance.table;
      }, TablePrintElement.prototype.createTarget = function(t2, e2, n2) {
        for (var i2 = hiprintJQuery('<div class="hiprint-printElement hiprint-printElement-table" style="position: absolute;"><div class="hiprint-printElement-table-handle"></div><div class="hiprint-printElement-table-content" style="height:100%;width:100%"></span></div>'), o2 = this.createGridColumnsStructure(n2), r2 = 0; r2 < o2.gridColumns; r2++) {
          o2.getByIndex(r2).append(this.getTableHtml(e2, n2));
        }
        return i2.find(".hiprint-printElement-table-content").append(o2.target), i2;
      }, TablePrintElement.prototype.createGridColumnsStructure = function(t2) {
        for (var e2 = hiprintJQuery('<div class="hi-grid-row table-grid-row"></div>'), n2 = 0; n2 < this.options.getGridColumns(); n2++) {
          var i2 = hiprintJQuery('<div class="tableGridColumnsGutterRow hi-grid-col" style="width:' + 100 / this.options.getGridColumns() + '%;"></div>');
          e2.append(i2);
        }
        var o2 = this.getGridColumnsFooterFormatter();
        if (o2) {
          var r2 = hiprintJQuery('<div class="hiprint-gridColumnsFooter"></div>');
          r2.append(o2(this.options, this.getData(t2), t2, [])), e2.append(r2);
        }
        return new _table_GridColumnsStructure__WEBPACK_IMPORTED_MODULE_8__.a(this.options.getGridColumns(), e2);
      }, TablePrintElement.prototype.createtempEmptyRowsTargetStructure = function(t2) {
        if (this.getField()) return this.createTarget(this.printElementType.title, []);
        var e2 = this.createTarget(this.printElementType.title, []).clone();
        return e2.find(".hiprint-printElement-tableTarget tbody tr").remove(), e2;
      }, TablePrintElement.prototype.getTableHtml = function(t2, e2) {
        var n2, i2;
        if (!this.getField() && this.options.content) return (n2 = hiprintJQuery("<div></div>")).append(this.options.content), (i2 = n2.find("table")).addClass("hiprint-printElement-tableTarget"), i2;
        if (this.printElementType.formatter) return (n2 = hiprintJQuery("<div></div>")).append(this.printElementType.formatter(t2)), (i2 = n2.find("table")).addClass("hiprint-printElement-tableTarget"), i2;
        var o2 = hiprintJQuery('<table class="hiprint-printElement-tableTarget" style="border-collapse: collapse;"></table>');
        let headerList = _table_TableExcelHelper__WEBPACK_IMPORTED_MODULE_6__.a.createTableHead(this.getColumns(), this.options.getWidth() / this.options.getGridColumns());
        return this.isNotDesign && ["first", "none"].includes(this.options.tableHeaderRepeat) ? o2.append(headerList) : o2.append(headerList[0]), o2.append(_table_TableExcelHelper__WEBPACK_IMPORTED_MODULE_6__.a.createTableRow(this.getColumns(), t2, e2, this.options, this.printElementType)), "no" == this.options.tableFooterRepeat || _table_TableExcelHelper__WEBPACK_IMPORTED_MODULE_6__.a.createTableFooter(this.printElementType.columns, t2, this.options, this.printElementType, e2, t2).insertBefore(o2.find("tbody")), o2;
      }, TablePrintElement.prototype.getEmptyRowTarget = function() {
        return _table_TableExcelHelper__WEBPACK_IMPORTED_MODULE_6__.a.createEmptyRowTarget(this.getColumns(), this);
      }, TablePrintElement.prototype.getHtml = function(t2, e2) {
        this.createTempContainer();
        this.isNotDesign = e2 != void 0;
        var n2 = this.getPaperHtmlResult(t2, e2);
        return this.removeTempContainer(), n2;
      }, TablePrintElement.prototype.getPaperHtmlResult = function(t2, e2) {
        var n2 = [], i2 = this.getData(e2), o2 = this.getTableHtml(i2, e2), r2 = this.createtempEmptyRowsTargetStructure(e2);
        e2 ? this.updateTargetWidth(r2) : this.updateTargetSize(r2), this.css(r2, i2), this.css(o2, i2), this.getTempContainer().html(""), this.getTempContainer().append(r2);
        var tfh = r2.find("tfoot").outerHeight() || 0;
        r2.find("tfoot").remove();
        for (var a2, p2 = this.getBeginPrintTopInPaperByReferenceElement(t2), s2 = 0, l2 = false; !l2; ) {
          var u2 = 0, d2 = t2.getPaperFooter(s2);
          0 == s2 && p2 > d2 && "none" != t2.panelPageRule && (p2 = p2 - d2 + t2.paperHeader, n2.push(
            new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_2__.a({
              target: void 0,
              printLine: void 0
            })
          ), u2 = t2.getContentHeight(s2) - (p2 - t2.paperHeader), s2++, d2 = t2.getPaperFooter(s2));
          var c2 = n2.length > 0 ? n2[n2.length - 1].target : void 0, h2 = this.getRowsInSpecificHeight(e2, u2 > 0 ? u2 : 0 == s2 ? d2 - p2 : t2.getContentHeight(s2), r2, o2, s2, c2, tfh);
          l2 = h2.isEnd;
          if (u2 < 0) {
            n2[0].target = hiprintJQuery(`<div style="position:absolute;background: red;color: white;padding: 0px 4px;">\u6CA1\u6709\u8DB3\u591F\u7A7A\u95F4\u8FDB\u884C\u8868\u683C\u5206\u9875\uFF0C\u8BF7\u8C03\u6574\u9875\u7709/\u9875\u811A\u7EBF</div>`);
            n2[0].printLine = p2;
            n2[0].referenceElement = new _PrintReferenceElement__WEBPACK_IMPORTED_MODULE_4__.a({
              top: this.options.getTop(),
              left: this.options.getLeft(),
              height: this.options.getHeight(),
              width: this.options.getWidth(),
              beginPrintPaperIndex: t2.index,
              bottomInLastPaper: p2 + this.options.lHeight,
              printTopInPaper: p2
            });
            n2[0].target.css("top", p2 + "pt");
            n2[0].target.css("left", this.options.displayLeft());
            break;
          }
          var f2 = void 0;
          h2.target && (h2.target.css("left", this.options.displayLeft()), h2.target[0].height = "");
          if (0 == s2 || u2 > 0) {
            h2.target && (a2 = p2, h2.target.css("top", p2 + "pt")), f2 = l2 && null != this.options.lHeight ? p2 + (h2.height > this.options.lHeight ? h2.height : this.options.lHeight) : p2 + h2.height;
          } else {
            h2.target && (a2 = t2.paperHeader, h2.target.css("top", t2.paperHeader + "pt")), f2 = t2.paperHeader + h2.height;
          }
          n2.push(
            new _dto_PaperHtmlResult__WEBPACK_IMPORTED_MODULE_2__.a({
              target: h2.target,
              printLine: f2,
              referenceElement: new _PrintReferenceElement__WEBPACK_IMPORTED_MODULE_4__.a({
                top: this.options.getTop(),
                left: this.options.getLeft(),
                height: this.options.getHeight(),
                width: this.options.getWidth(),
                beginPrintPaperIndex: t2.index,
                bottomInLastPaper: f2,
                printTopInPaper: a2
              })
            })
          ), s2++;
          e2 && this.updatePanelHeight(f2 + this.options.getHeight(), t2);
        }
        return n2;
      }, TablePrintElement.prototype.getRowsInSpecificHeight = function(t2, e2, n2, i2, o2, r2, tfh) {
        var that = this;
        var a2 = i2.find("tbody"), p2 = _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.pt.toPx(e2);
        n2.find(".hiprint-printElement-tableTarget tbody").html("");
        if ("last" != this.options.tableFooterRepeat) {
          n2.find(".hiprint-printElement-tableTarget tfoot").remove();
        }
        if ("first" == this.options.tableHeaderRepeat && o2 > 0) {
          n2.find(".hiprint-printElement-tableTarget thead").remove();
        } else if ("none" == this.options.tableHeaderRepeat) {
          if (t2) {
            n2.find(".hiprint-printElement-tableTarget thead").remove();
          } else {
            n2.find(".hiprint-printElement-tableTarget thead").css("background", "firebrick");
            n2.find(".hiprint-printElement-tableTarget thead tr").css("background", "firebrick");
          }
        }
        var noPaging = "none" == this.panel.panelPageRule;
        var headTr;
        if (t2 && noPaging) {
          var headStyle = n2.find(".hiprint-printElement-tableTarget thead").attr("style");
          headTr = n2.find(".hiprint-printElement-tableTarget thead tr").clone();
          if (headStyle) {
            headTr.attr("style", headStyle);
          } else {
            headTr.css({ background: "#e8e8e8" });
          }
          n2.find(".hiprint-printElement-tableTarget thead").remove();
        }
        var s2 = n2.outerHeight();
        if (!noPaging && s2 > p2)
          return {
            target: void 0,
            length: 0,
            height: 0,
            isEnd: false
          };
        var getGridColumns = this.options.getGridColumns();
        for (var l2 = [], u2 = 0; u2 < getGridColumns; u2++) {
          for (var d2 = n2.find(".hiprint-printElement-tableTarget:eq(" + u2 + ")"), c2 = void 0, h2 = []; ; ) {
            if (noPaging) {
              var trLen = a2.find("tr").length;
              if (0 == trLen)
                c2 = {
                  height: _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.px.toPt(s2),
                  isEnd: true
                }, t2 && this.options.autoCompletion && (this.autoCompletion(p2, d2, tfh), s2 = n2.outerHeight());
              else {
                var f2 = a2.find("tr:lt(1)");
                if (h2.length == 0 && headTr) {
                  d2.find("tbody").append(headTr);
                }
                d2.find("tbody").append(f2);
                var g2 = f2.data("rowData");
                l2.push(g2), h2.push(g2), s2 = n2.outerHeight();
                0 == trLen && (a2.prepend(f2), l2.pop(), h2.pop(), c2 = {
                  height: _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.px.toPt(s2),
                  isEnd: false
                });
              }
            } else {
              if (s2 <= p2)
                if (0 == a2.find("tr").length)
                  c2 = {
                    height: _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.px.toPt(s2),
                    isEnd: true
                  }, t2 && this.options.autoCompletion && (this.autoCompletion(p2, d2, tfh), s2 = d2.outerHeight());
                else {
                  var f2 = a2.find("tr:lt(1)");
                  if (that.options.rowsColumnsMerge && (o2 > 0 || u2 > 0) && h2.length == 0) {
                    f2 = that.fixMergeSpan(f2, a2);
                  }
                  d2.find("tbody").append(f2);
                  var g2 = f2.data("rowData");
                  l2.push(g2), h2.push(g2), ((s2 = d2.outerHeight(), "last" == this.options.tableFooterRepeat ? s2 : s2 += tfh) > p2 || this.options.maxRows && h2.length > +this.options.maxRows) && (a2.prepend(f2), l2.pop(), h2.pop(), s2 = d2.outerHeight(), c2 = {
                    height: _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.px.toPt(s2),
                    isEnd: false
                  });
                }
            }
            if (c2) {
              if ("last" == this.options.tableFooterRepeat && !c2.isEnd) break;
              if ("no" !== this.options.tableFooterRepeat) {
                if (noPaging) {
                  d2.find("tbody").append(_table_TableExcelHelper__WEBPACK_IMPORTED_MODULE_6__.a.createTableFooter(this.printElementType.columns, this.getData(t2), this.options, this.printElementType, t2, h2, o2).children());
                } else {
                  _table_TableExcelHelper__WEBPACK_IMPORTED_MODULE_6__.a.createTableFooter(this.printElementType.columns, this.getData(t2), this.options, this.printElementType, t2, h2, o2).insertBefore(d2.find("tbody"));
                }
                that.css(d2, t2);
              }
              break;
            }
          }
        }
        var m2 = n2.find(".hiprint-printElement-tableTarget tbody tr").length, v2 = this.getGridColumnsFooterFormatter();
        v2 && n2.find(this.gridColumnsFooterCss).html(v2(this.options, this.getData(t2), t2, l2));
        s2 = n2.outerHeight();
        let curRow = a2.find("tr:lt(1)");
        if (m2 == 0 && curRow.length && g2 == curRow.data("rowData")) {
          d2.find("tbody").append(curRow);
          let height = d2.find("tbody tr").outerHeight();
          a2.prepend(curRow);
          return {
            target: hiprintJQuery(`<div style="position:absolute;background: red;color: white;padding: 0px 4px;">\u6CA1\u6709\u8DB3\u591F\u7A7A\u95F4,\u663E\u793A\u4E0B\u65B9\u5185\u5BB9, \u53EF\u5206\u9875\u9AD8\u5EA6: ` + p2 + `px < \u5F53\u524D\u9700\u8981\u9AD8\u5EA6: ` + height + "px</div>").append(curRow.css("background", "blue")),
            length: m2,
            height: _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.px.toPt(s2),
            isEnd: false
          };
        }
        var zz = 0 == a2.find("tr").length ? 0 == m2 && r2 ? {
          target: void 0,
          length: 0,
          height: 0,
          isEnd: true
        } : {
          target: n2.clone(),
          length: m2,
          height: _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.px.toPt(s2),
          isEnd: true
        } : {
          target: n2.clone(),
          length: m2,
          height: _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.px.toPt(s2),
          isEnd: false
        };
        return zz;
      }, TablePrintElement.prototype.fixMergeSpan = function(tr, tbody) {
        const nextRowMap = /* @__PURE__ */ new Map();
        tr.children().each((_2, td) => {
          var field = hiprintJQuery(td).attr("field");
          nextRowMap.set(field, {
            rowSpan: 1,
            rowEnd: false
          });
          tr.nextAll().each((_3, nextTr) => {
            if (hiprintJQuery(nextTr).has(`td[field=${field}][rowspan=0]`).length && !nextRowMap.get(field).rowEnd) {
              nextRowMap.set(field, { rowSpan: ++nextRowMap.get(field).rowSpan, rowEnd: false });
            } else {
              nextRowMap.set(field, { ...nextRowMap.get(field), rowEnd: true });
            }
          });
          if (hiprintJQuery(td).attr("rowspan") < 1) {
            hiprintJQuery(td).attr("rowspan", nextRowMap.get(field).rowSpan);
            hiprintJQuery(td).css("display", "");
            if (this.options.rowsColumnsMergeClean) {
              hiprintJQuery(td).text("");
            }
          }
        });
        return tr;
      }, TablePrintElement.prototype.autoCompletion = function(t2, e2, tfh) {
        var that = this;
        for (var n2, i2 = this.getEmptyRowTarget(), o2 = e2.outerHeight() + tfh; t2 > o2; ) {
          n2 = i2.clone(), e2.find("tbody").append(n2), o2 = e2.outerHeight() + tfh;
          if (that.options.maxRows && e2.find("tbody").children().length > that.options.maxRows) {
            break;
          }
        }
        n2 && n2.remove();
      }, TablePrintElement.prototype.getData = function(t2) {
        if (!t2) {
          try {
            let testData = this.options.testData || "[{}]";
            return JSON.parse(testData);
          } catch (e3) {
            /* @__PURE__ */ console.log("table testData parse error", e3);
            return [{}];
          }
        }
        var f2 = this.getField();
        var e2 = f2 ? f2.split(".").reduce((a2, c2) => a2 ? a2[c2] : t2 ? t2[c2] : "", false) || "" : "";
        return e2 ? JSON.parse(JSON.stringify(e2)) : [];
      }, TablePrintElement.prototype.onResize = function(t2, e2, n2, i2, o2) {
        _super.prototype.updateSizeAndPositionOptions.call(this, o2, i2, n2, e2), _table_TableExcelHelper__WEBPACK_IMPORTED_MODULE_6__.a.resizeTableCellWidth(this.designTarget, this.getColumns(), this.options.getWidth());
      }, TablePrintElement.prototype.getReizeableShowPoints = function() {
        return ["s", "e"];
      }, TablePrintElement.prototype.design = function(t2, e2) {
        var n2 = this;
        this.designTarget.hidraggable({
          handle: this.designTarget.find(".hiprint-printElement-table-handle"),
          axis: n2.options.axis ? n2.options.axis : void 0,
          designTarget: n2,
          onDrag: function onDrag(t3, i2, o2) {
            n2.updateSizeAndPositionOptions(i2, o2), n2.createLineOfPosition(e2);
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_9__.a.instance.changed = true;
          },
          moveUnit: "pt",
          minMove: _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance.movingDistance,
          onBeforeDrag: function onBeforeDrag(t3) {
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_9__.a.instance.draging = true, n2.createLineOfPosition(e2);
          },
          getScale: function getScale() {
            return n2.designPaper.scale || 1;
          },
          onStopDrag: function onStopDrag(t3) {
            if (_HiPrintlib__WEBPACK_IMPORTED_MODULE_9__.a.instance.changed) _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.event.trigger("hiprintTemplateDataChanged_" + n2.templateId, "\u79FB\u52A8");
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_9__.a.instance.draging = false, _HiPrintlib__WEBPACK_IMPORTED_MODULE_9__.a.instance.changed = false, n2.removeLineOfPosition();
          }
        }), this.printElementType.editable && this.setHitable(), this.setColumnsOptions(), this.designTarget.hireizeable({
          showPoints: n2.getReizeableShowPoints(),
          // 是否显示宽高box
          showSizeBox: _HiPrintConfig__WEBPACK_IMPORTED_MODULE_1__.a.instance.showSizeBox,
          noContainer: true,
          onBeforeResize: function onBeforeResize() {
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_9__.a.instance.draging = true;
          },
          getScale: function getScale() {
            return n2.designPaper.scale || 1;
          },
          onResize: function onResize(t3, i2, o2, r2, a2) {
            n2.onResize(t3, i2, o2, r2, a2), n2.hitable && n2.hitable.updateColumnGrips(), n2.createLineOfPosition(e2);
          },
          onStopResize: function onStopResize(r2) {
            _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.event.trigger("hiprintTemplateDataChanged_" + n2.templateId, r2 ? "\u65CB\u8F6C" : "\u5927\u5C0F");
            _HiPrintlib__WEBPACK_IMPORTED_MODULE_9__.a.instance.draging = false, n2.removeLineOfPosition();
          }
        }), this.bingKeyboardMoveEvent(this.designTarget, e2);
      }, TablePrintElement.prototype.setHitable = function() {
        var t2 = this;
        this.hitable = new _hitable_HiTale__WEBPACK_IMPORTED_MODULE_7__.a({
          templateId: t2.templateId,
          table: this.designTarget.find(".hiprint-printElement-tableTarget:eq(0)"),
          rows: this.getColumns(),
          resizeRow: false,
          resizeColumn: true,
          fields: this.options.fields,
          trs: this.designTarget.find(".hiprint-printElement-tableTarget:eq(0)").find("tbody tr"),
          handle: this.designTarget.find(".hiprint-printElement-tableTarget:eq(0)").find("thead"),
          isEnableEdit: this.printElementType.editable ? this.printElementType.editable : true,
          columnDisplayEditable: this.printElementType.columnDisplayEditable != void 0 ? this.printElementType.columnDisplayEditable : true,
          columnDisplayIndexEditable: this.printElementType.columnDisplayIndexEditable != void 0 ? this.printElementType.columnDisplayIndexEditable : true,
          columnResizable: this.printElementType.columnResizable != void 0 ? this.printElementType.columnResizable : true,
          columnAlignEditable: this.printElementType.columnAlignEditable != void 0 ? this.printElementType.columnAlignEditable : true,
          isEnableEditText: this.printElementType.columnTitleEditable != void 0 ? this.printElementType.columnTitleEditable : true,
          isEnableEditField: this.printElementType.isEnableEditField != void 0 ? this.printElementType.isEnableEditField : true,
          isEnableContextMenu: this.printElementType.isEnableContextMenu != void 0 ? this.printElementType.isEnableContextMenu : true,
          isEnableInsertRow: this.printElementType.isEnableInsertRow != void 0 ? this.printElementType.isEnableInsertRow : true,
          isEnableDeleteRow: this.printElementType.isEnableDeleteRow != void 0 ? this.printElementType.isEnableDeleteRow : true,
          isEnableInsertColumn: this.printElementType.isEnableInsertColumn != void 0 ? this.printElementType.isEnableInsertColumn : true,
          isEnableDeleteColumn: this.printElementType.isEnableDeleteColumn != void 0 ? this.printElementType.isEnableDeleteColumn : true,
          isEnableMergeCell: this.printElementType.isEnableMergeCell != void 0 ? this.printElementType.isEnableMergeCell : true
        }), _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.event.on("updateTable" + this.hitable.id, function() {
          t2.updateDesignViewFromOptions();
          _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.event.trigger("hiprintTemplateDataChanged_" + t2.templateId, "\u8C03\u6574\u8868\u5934");
        });
      }, TablePrintElement.prototype.setColumnsOptions = function() {
        var t2 = this;
        this.designTarget.find(".hiprint-printElement-tableTarget:eq(0)").find("thead td").bind("click.hiprint", function(e2) {
          var n2 = hiprintJQuery(e2.target).attr("id") || hiprintJQuery(e2.target).attr("column-id"), i2 = t2.getColumnByColumnId(n2);
          if (i2) {
            var o2 = t2.getPrintElementOptionItemsByName("tableColumn");
            _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.event.trigger(t2.getPrintElementSelectEventKey(), {
              printElement: t2,
              customOptionsInput: [
                {
                  title: (i2.title || `${i2.id}(id)`) + `-\u5217\u5C5E\u6027`,
                  optionItems: o2,
                  options: i2,
                  callback: function callback(t3) {
                    o2.forEach(function(t4) {
                      var e3 = t4.getValue();
                      if ("title" == t4.name && e3 && !e3.trim().endsWith("#") && !e3.trim().startsWith("#")) {
                        var n3 = e3 ? e3.split("#") : "";
                        i2.title = n3[0], n3.length > 1 && (i2.columnId = i2.field = n3[1]);
                        i2.columnId && i2.target.attr("column-id", i2.columnId);
                        t4.target.find("textarea").val(n3[0]);
                        return;
                      }
                      i2[t4.name] = e3;
                    });
                  }
                }
              ]
            });
          } else
            _assets_plugins_hinnn__WEBPACK_IMPORTED_MODULE_3__.a.event.trigger(t2.getPrintElementSelectEventKey(), {
              printElement: t2
            });
        });
      }, TablePrintElement.prototype.filterOptionItems = function(t2) {
        var e2 = _super.prototype.filterOptionItems.call(this, t2);
        return this.printElementType.editable && 1 == this.options.columns.length ? e2 : t2.filter(function(t3) {
          return "columns" != t3.name;
        });
      }, TablePrintElement.prototype.getFooterFormatter = function() {
        var footerFormatter = void 0;
        if (this.printElementType.footerFormatter && (footerFormatter = this.printElementType.footerFormatter), this.options.footerFormatter)
          try {
            var s = "footerFormatter=" + this.options.footerFormatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return footerFormatter;
      }, TablePrintElement.prototype.getGridColumnsFooterFormatter = function() {
        var gridColumnsFooterFormatter = void 0;
        if (this.printElementType.gridColumnsFooterFormatter && (gridColumnsFooterFormatter = this.printElementType.gridColumnsFooterFormatter), this.options.gridColumnsFooterFormatter)
          try {
            var s = "gridColumnsFooterFormatter=" + this.options.gridColumnsFooterFormatter;
            eval(s);
          } catch (t2) {
            /* @__PURE__ */ console.log(t2);
          }
        return gridColumnsFooterFormatter;
      }, TablePrintElement;
    }(_BasePrintElement__WEBPACK_IMPORTED_MODULE_0__.a);
  },
  function(t2, e2, n2) {
    "use strict";
    var i2 = /* @__PURE__ */ function() {
      return function(t3) {
        this.table = t3.table, this.templateId = t3.templateId, this.fields = t3.fields, this.isEnableEdit = t3.isEnableEdit, this.trs = t3.trs, this.resizeRow = t3.resizeRow, this.resizeColumn = t3.resizeColumn, this.isEnableEditField = t3.isEnableEditField, this.isEnableContextMenu = t3.isEnableContextMenu, this.isEnableEditField = t3.isEnableEditField, this.isEnableInsertRow = t3.isEnableInsertRow, this.isEnableDeleteRow = t3.isEnableDeleteRow, this.isEnableInsertColumn = t3.isEnableInsertColumn, this.isEnableDeleteColumn = t3.isEnableDeleteColumn, this.isEnableMergeCell = t3.isEnableMergeCell, this.columnResizable = t3.columnResizable, this.columnAlignEditable = t3.columnAlignEditable;
      };
    }(), o2 = function() {
      function t3(t4) {
        this.options = new i2(t4);
      }
      return t3.prototype.enableEidt = function() {
        this.options.isEnableEdit;
      }, t3.prototype.disableEdit = function() {
        this.options.isEnableEdit;
      }, t3.prototype.isEnableEdit = function() {
        return this.options.isEnableEdit;
      }, t3;
    }(), r2 = n2(0), a2 = /* @__PURE__ */ function() {
      return function(t3) {
        this.cell = t3.cell, this.link = t3.link, this.linkType = t3.linkType, this.bottom = t3.bottom, this.rightMost = t3.rightMost, this.rowLevel = t3.rowLevel, this.columnLevel = t3.columnLevel, this.indexInTableGridRow = t3.indexInTableGridRow, this.indexInTableGridColumn = t3.indexInTableGridColumn;
      };
    }(), p2 = n2(10), s2 = function() {
      function t3() {
      }
      return t3.getLeftTableCell = function(t4, e3) {
        var n3;
        return t4.forEach(function(t5, i3) {
          t5.cell && i3 < e3 && (n3 = t5.cell);
        }), n3;
      }, t3.getIndex = function(t4, e3) {
        var n3;
        return t4.forEach(function(t5, i3) {
          t5.cell && t5.cell.id == e3 && (n3 = i3);
        }), n3;
      }, t3;
    }(), l2 = n2(13), u2 = n2(11), d2 = /* @__PURE__ */ function() {
      return function(t3, e3) {
        this.target = t3, this.grips = e3;
      };
    }(), c2 = /* @__PURE__ */ function() {
      return function(t3) {
        this.target = t3;
      };
    }(), h2 = /* @__PURE__ */ function() {
      return function() {
        this.rowColumns = [];
      };
    }(), f2 = function() {
      function t3() {
      }
      return t3.getColumnsWidth = function(e3, n3) {
        var i3 = {}, o3 = t3.allAutoWidth(e3);
        return e3.rowColumns.forEach(function(t4) {
          var e4 = n3 - 0, r3 = t4.width / o3 * (e4 > 0 ? e4 : 0);
          i3[t4.id] = r3;
        }), i3;
      }, t3.resizeTableCellWeight = function(t4) {
        t4.forEach(function(t5) {
          t5.columns.forEach(function(t6) {
            t6.hasWidth && hiprintJQuery(t6.getTarget()).css("width", t6.width + "pt");
          });
        });
      }, t3.allAutoWidth = function(t4) {
        var e3 = 0;
        return t4.rowColumns.forEach(function(t5) {
          e3 += t5.width;
        }), e3;
      }, t3.reconsitutionTableColumnTree = function(t4, e3, n3) {
        for (var i3 = e3 || new h2(), o3 = function o4(e4) {
          i3.totalLayer = e4 + 1, i3[e4] = t4[e4].columns, i3.rowColumns = i3.rowColumns.concat(
            i3[e4].filter(function(n4) {
              return n4.rowspan == t4.length - e4;
            })
          );
        }, r3 = 0; r3 < t4.length; r3++) {
          o3(r3);
        }
        return i3;
      }, t3;
    }(), g2 = n2(2), m2 = function() {
      function t3(t4) {
        this.signature = "HiTresizer", this.hitable = t4, this.rows = t4.rows, this.target = t4.target;
      }
      return t3.prototype.init = function() {
        this.addResizeRowAndColumn(), this.hitable.optionsCoat.options.resizeColumn && this.createColumnGrips(), this.hitable.optionsCoat.options.resizeRow && this.createRowGrips();
      }, t3.prototype.resizeTableCellWidth = function() {
        f2.resizeTableCellWeight(this.rows);
      }, t3.prototype.addResizeRowAndColumn = function() {
      }, t3.prototype.createColumnGrips = function() {
        var t4 = this, e3 = this, n3 = [], i3 = hiprintJQuery('<div class="columngrips"/>');
        i3.width(this.target.width()), this.rows.forEach(function(o3) {
          (o3.columns || []).filter(function(column2) {
            return column2.checked;
          }).forEach(function(o4, a3) {
            if (o4.getTarget().attr("haswidth")) {
              var p3 = hiprintJQuery('<div class="columngrip"><div class="gripResizer"></div></div>');
              i3.append(p3);
              var s3 = new c2(p3);
              n3.length > 0 && (n3[n3.length - 1].nextGrip = s3), n3.push(s3), t4.syncGrips(o4, s3), hiprintJQuery(p3).hidraggable({
                axis: "h",
                onDrag: function onDrag(t5, e4, n4) {
                },
                moveUnit: "pt",
                minMove: 1,
                getScale: function getScale() {
                  return hiprintJQuery(".hiprint-printPaper")[0].style.transform && parseFloat(hiprintJQuery(".hiprint-printPaper")[0].style.transform.slice(6, -1)) || 1;
                },
                onBeforeDrag: function onBeforeDrag(t5) {
                  if (g2.a.instance.draging = true, !s3.nextGrip) return false;
                  e3.dragingGrip = s3, e3.dragingGrip.left = parseFloat(e3.dragingGrip.target.css("left").replace("px", "")), s3.target.addClass("columngripDraging");
                },
                onStopDrag: function onStopDrag(n4) {
                  g2.a.instance.draging = false;
                  var i4 = parseFloat(e3.dragingGrip.target.css("left").replace("px", "")), o5 = r2.a.px.toPt(i4 - e3.dragingGrip.left);
                  if (s3.cell.width + o5 < 10) {
                    o5 = 10 - s3.cell.width;
                  } else if (s3.nextGrip.cell.width - o5 < 10) {
                    o5 = s3.nextGrip.cell.width - 10;
                  }
                  s3.cell.width = s3.cell.width + o5, s3.nextGrip.cell.width = s3.nextGrip.cell.width - o5, t4.resizeTableCellWidth(), s3.target.removeClass("columngripDraging"), e3.updateColumnGrips();
                }
              });
            }
          });
        }), this.target.before(i3), this.cgripContariner = new d2(i3, n3);
      }, t3.prototype.updateColumnGrips = function() {
        this.cgripContariner && (this.cgripContariner.target.remove(), this.createColumnGrips());
      }, t3.prototype.updateRowGrips = function() {
        this.rgripContariner && (this.rgripContariner.target.remove(), this.createRowGrips());
      }, t3.prototype.createRowGrips = function() {
        var t4 = this, e3 = this, n3 = [], i3 = hiprintJQuery('<div class="rowgrips"/>');
        this.rows.forEach(function(o3, a3) {
          var p3 = hiprintJQuery('<div class="rowgrip"><div class="gripResizer"></div></div>');
          i3.append(p3);
          var s3 = new c2(p3);
          n3.push(s3), a3 > 0 && a3 < t4.rows.length && hiprintJQuery(p3).hidraggable({
            axis: "v",
            onDrag: function onDrag(t5, e4, n4) {
            },
            moveUnit: "pt",
            minMove: 1,
            onBeforeDrag: function onBeforeDrag(t5) {
              e3.dragingGrip = s3, e3.dragingGrip.top = parseFloat(e3.dragingGrip.target.css("top").replace("px", "")), s3.target.addClass("rowgripDraging");
            },
            onStopDrag: function onStopDrag(t5) {
              var n4 = parseFloat(e3.dragingGrip.target.css("top").replace("px", "")), i4 = r2.a.px.toPt(n4 - e3.dragingGrip.top + e3.rows[a3].columns[0].getTarget().height());
              e3.rows[a3].columns[0].getTarget().css("height", i4 + "pt"), e3.syncRowGrips(), s3.target.removeClass("rowgripDraging");
            }
          });
        }), this.target.before(i3), this.rgripContariner = new d2(i3, n3), this.syncRowGrips();
      }, t3.prototype.syncGrips = function(t4, e3) {
        var n3 = t4.getTarget();
        var scale = hiprintJQuery(".hiprint-printPaper")[0].style.transform && parseFloat(hiprintJQuery(".hiprint-printPaper")[0].style.transform.slice(6, -1)) || 1;
        e3.cell = t4, e3.target.css({
          left: n3.offset().left / scale - this.target.offset().left / scale + n3.outerWidth(false),
          height: 30
        });
      }, t3.prototype.syncRowGrips = function() {
        var t4 = this;
        this.rgripContariner.target.height(this.target.height()), this.rows.forEach(function(e3, n3) {
          var i3 = e3.columns[0].getTarget();
          t4.rgripContariner.grips[n3].target.css({
            top: i3.offset().top - t4.target.offset().top + i3.outerHeight(false),
            width: 30
          });
        });
      }, t3.prototype.addResizerHeadRow = function() {
        this.target.find("thead").prepend();
      }, t3;
    }(), v2 = function() {
      function t3() {
      }
      return t3.prototype.init = function() {
      }, t3.prototype.updateRowGrips = function() {
      }, t3.prototype.updateColumnGrips = function() {
      }, t3;
    }();
    n2.d(e2, "a", function() {
      return y2;
    });
    var y2 = function() {
      function t3(t4) {
        this.id = u2.a.createId(), this.optionsCoat = new o2(t4), this.handle = t4.handle, this.target = t4.table, this.initRows(t4.rows), this.init(t4), this.tableCellSelector = new p2.a(this.rows, this.target), this.resizer = this.optionsCoat.options.columnResizable ? new m2(this) : new v2(), this.resizer.init();
      }
      return t3.prototype.insertRow = function(t4, e3, n3) {
        var i3 = e3 || this.tableCellSelector.getSingleSelect(), o3 = i3.cell, a3 = this.rows[i3.rowIndex], p3 = i3.rowIndex, s3 = this.getCellGrid(), u3 = new l2.a();
        if (u3.init(this.optionsCoat, void 0, a3.isHead), n3 && u3.getTarget().addClass(n3), "above" == t4)
          s3[p3].forEach(function(t5) {
            var e4 = t5.link ? t5.link : t5.cell, n4 = e4.width / e4.colspan;
            if (0 == t5.columnLevel) {
              var i4 = u3.createTableCell();
              i4.width = n4, u3.insertCellToLast(i4);
            } else {
              if ("column" == t5.linkType) {
                var o4 = t5.link.getTarget();
                t5.link.rowspan += 1, o4.attr("rowspan", t5.link.rowspan);
              }
              t5.linkType;
            }
          }), this.rows.splice(p3, 0, u3), a3.getTarget().before(u3.getTarget()), r2.a.event.trigger("newRow" + this.id, u3);
        else {
          var d3 = p3 + o3.rowspan - 1;
          s3[d3].forEach(function(t5) {
            var e4 = t5.link ? t5.link : t5.cell, n4 = e4.width / e4.colspan;
            if (t5.bottom) {
              var i4 = u3.createTableCell();
              i4.width = n4, u3.insertCellToLast(i4);
            } else {
              if (t5.cell) {
                var o4 = t5.cell.getTarget();
                t5.cell.rowspan += 1, o4.attr("rowspan", t5.cell.rowspan);
              }
              if ("column" == t5.linkType) {
                o4 = t5.link.getTarget();
                t5.link.rowspan += 1, o4.attr("rowspan", t5.link.rowspan);
              }
            }
          }), this.rows.splice(d3 + 1, 0, u3), this.rows[d3].getTarget().after(u3.getTarget()), r2.a.event.trigger("newRow" + this.id, u3);
        }
      }, t3.prototype.insertColumn = function(t4, e3, n3, i3) {
        var o3 = this, a3 = this.rows.concat(this.trRows), p3 = e3 || this.tableCellSelector.getSingleSelect(), s3 = p3.cell, l3 = p3.rowIndex, u3 = this.getCellGrid(a3), d3 = u3[l3].filter(function(t5) {
          return t5.cell && t5.cell.id == s3.id || t5.link && t5.link.id == s3.id;
        });
        if ("left" == t4) {
          var c3 = d3[0].indexInTableGridRow;
          u3.forEach(function(t5, e4) {
            var p4 = t5[c3], s4 = t5.filter(function(t6, e5) {
              return e5 >= c3 && t6.cell;
            });
            if (0 == p4.rowLevel) {
              var l4 = a3[e4], u4 = a3[e4].createTableCell();
              n3 && u4.getTarget().addClass(n3), null != i3 && (u4.width = i3), s4.length ? l4.insertToTargetCellLeft(s4[0].cell, u4) : l4.insertCellToLast(u4), r2.a.event.trigger("newCell" + o3.id, u4);
            } else if ("row" == p4.linkType) {
              var d4 = p4.link.getTarget();
              p4.link.colspan += 1, d4.attr("colspan", p4.link.colspan);
            }
          });
        } else {
          var h3 = d3[d3.length - 1].indexInTableGridRow;
          u3.forEach(function(t5, e4) {
            var p4 = t5[h3], s4 = t5.filter(function(t6, e5) {
              return e5 <= h3 && t6.cell;
            });
            if (p4.rightMost) {
              var l4 = a3[e4], u4 = l4.createTableCell();
              n3 && u4.getTarget().addClass(n3), null != i3 && (u4.width = i3), s4.length ? l4.insertToTargetCellRight(s4[s4.length - 1].cell, u4) : l4.insertCellToFirst(u4), r2.a.event.trigger("newCell" + o3.id, u4);
            } else {
              var d4 = p4.link || p4.cell;
              if ("row" == p4.linkType) {
                var c4 = d4.getTarget();
                d4.colspan += 1, c4.attr("colspan", d4.colspan);
              }
              if (p4.cell) {
                c4 = d4.getTarget();
                d4.colspan += 1, c4.attr("colspan", d4.colspan);
              }
            }
          });
        }
      }, t3.prototype.deleteRow = function() {
        var t4 = this, e3 = this.tableCellSelector.getSingleSelect(), n3 = (e3.cell, this.rows[e3.rowIndex], e3.rowIndex), i3 = this.getCellGrid(), o3 = this.rows[n3];
        i3[n3].forEach(function(e4, r3) {
          if (e4.cell) {
            if (1 == e4.cell.rowspan) o3.removeCell(e4.cell);
            else {
              o3.removeCell(e4.cell);
              var a3 = i3[n3 + 1].filter(function(t5, e5) {
                return t5.cell && e5 > r3;
              }), p3 = t4.rows[n3 + 1], s3 = p3.createTableCell(e4.cell.rowspan - 1, e4.cell.colspan);
              a3.length ? p3.insertToTargetCellLeft(a3[0].cell, s3) : p3.insertCellToLast(s3);
            }
          } else if ("column" == e4.linkType) {
            var l3 = e4.link;
            l3.rowspan -= 1, l3.getTarget().attr("rowspan", l3.rowspan);
          }
        }), o3.getTarget().remove(), this.rows.splice(n3, 1);
      }, t3.prototype.deleteColums = function() {
        var t4 = this.rows.concat(this.trRows), e3 = this.tableCellSelector.getSingleSelect(), n3 = e3.cell, i3 = e3.rowIndex, o3 = this.getCellGrid(t4), r3 = o3[i3].filter(function(t5) {
          return t5.cell && t5.cell.id == n3.id || t5.link && t5.link.id == n3.id;
        })[0].indexInTableGridRow;
        o3.forEach(function(e4, n4) {
          var i4 = e4[r3];
          i4.cell ? 1 == i4.cell.colspan ? t4[n4].removeCell(i4.cell) : (i4.cell.colspan -= 1, i4.cell.getTarget().attr("colspan", i4.cell.colspan)) : "row" == i4.linkType && (i4.link.colspan -= 1, i4.link.getTarget().attr("colspan", i4.link.colspan));
        });
      }, t3.prototype.mergeCell = function() {
        var t4 = this, e3 = this.tableCellSelector.getSelectedCells();
        if (0 != e3.length) {
          var n3 = e3[0][0].cell;
          e3.forEach(function(i3, o3) {
            i3.forEach(function(i4, r3) {
              0 == o3 ? 0 != r3 && (n3.colspan += i4.cell.colspan, t4.rows[i4.rowIndex].removeCell(i4.cell)) : t4.rows[i4.rowIndex].removeCell(i4.cell), 0 == r3 && e3[0][0].rowIndex + n3.rowspan - 1 < i4.rowIndex && (n3.rowspan += i4.cell.rowspan);
            });
          }), n3.getTarget().attr("colspan", n3.colspan), n3.getTarget().attr("rowspan", n3.rowspan), this.tableCellSelector.setSingleSelect(e3[0][0]);
        }
      }, t3.prototype.splitCell = function() {
        var t4 = this.tableCellSelector.getSingleSelect(), e3 = this.getCellGrid(), n3 = s2.getIndex(e3[t4.rowIndex], t4.cell.id);
        if (t4) {
          for (var i3 = t4.rowIndex; i3 < t4.rowIndex + t4.cell.rowspan; i3++) {
            for (var o3 = this.rows[i3], r3 = i3 == t4.rowIndex ? t4.cell : s2.getLeftTableCell(e3[i3], n3), a3 = 0; a3 < t4.cell.colspan; a3++) {
              i3 == t4.rowIndex && 0 == a3 || (r3 ? o3.insertToTargetCellRight(r3, o3.createTableCell()) : o3.insertCellToFirst(o3.createTableCell()));
            }
          }
          t4.cell.rowspan = 1, t4.cell.colspan = 1, t4.cell.getTarget().attr("colspan", t4.cell.colspan), t4.cell.getTarget().attr("rowspan", t4.cell.rowspan);
        }
      }, t3.prototype.init = function(t4) {
        var e3 = this;
        hiprintJQuery(this.target).addClass("hitable"), this.optionsCoat.onBeforEdit = function(n3) {
          if (e3.optionsCoat.options.onBeforEdit && false === t4.onBeforEdit(n3)) return false;
          return e3.optionsCoat.editingCell && e3.optionsCoat.editingCell.endEdit(), true;
        }, hiprintJQuery(this.target).mousedown(function(t5) {
          e3.optionsCoat.isLeftMouseButtonDown = true;
        }), hiprintJQuery(this.target).mouseup(function(t5) {
          e3.optionsCoat.isLeftMouseButtonDown = false;
        }), this.initContext(), this.target.on("mousemove", function(t5) {
          1 === t5.buttons && e3.tableCellSelector.multipleSelectByXY(t5.pageX, t5.pageY);
        }).on("mousedown", function(t5) {
          1 === t5.buttons && e3.tableCellSelector.singleSelectByXY(t5.pageX, t5.pageY);
        });
      }, t3.prototype.initRows = function(t4) {
        var e3 = this;
        if (this.trRows = [], t4) {
          this.rows = t4, t4.forEach(function(t5, n4) {
            t5.init(e3.optionsCoat, e3.target.find("tr:eq(" + n4 + ")"), true);
          });
          var n3 = this.optionsCoat.options.trs;
          n3 && this.initRowsByTrs(n3).forEach(function(t5) {
            e3.trRows.push(t5);
          });
        } else this.rows = this.initRowsByTrs(this.target.find("tr"));
      }, t3.prototype.initRowsByTrs = function(t4) {
        var e3 = this;
        return t4.map(function(t5, n3) {
          var i3 = new l2.a();
          return i3.init(e3.optionsCoat, hiprintJQuery(n3)), i3;
        }).get();
      }, t3.prototype.enableEidt = function() {
        this.optionsCoat.enableEidt();
      }, t3.prototype.disableEdit = function() {
        this.optionsCoat.disableEdit();
      }, t3.prototype.getCellGrid = function(t4) {
        var e3 = t4 || this.rows, n3 = this.getColumnStep(), i3 = new Array();
        return e3.forEach(function(t5, e4) {
          t5.columns.forEach(function(t6, o3) {
            for (var r3 = 0; r3 < t6.colspan; r3++) {
              for (var p3 = 0, s3 = false; p3 < n3 && !s3; ) {
                if (i3[e4] = i3[e4] || [], i3[e4][p3]) ;
                else {
                  i3[e4][p3] = new a2({
                    cell: 0 == r3 ? t6 : void 0,
                    link: 0 != r3 ? t6 : void 0,
                    linkType: r3 > 0 ? "row" : void 0,
                    rightMost: r3 == t6.colspan - 1 || void 0,
                    bottom: 0 == t6.rowspan - 1,
                    rowLevel: r3,
                    columnLevel: 0,
                    indexInTableGridRow: p3,
                    indexInTableGridColumn: e4
                  });
                  for (var l3 = e4 + 1, u3 = 1; u3 < t6.rowspan; u3++) {
                    i3[l3] = i3[l3] || [], i3[l3][p3] = new a2({
                      cell: void 0,
                      link: t6,
                      linkType: r3 > 0 ? "rowColumn" : "column",
                      rightMost: r3 == t6.colspan - 1 || void 0,
                      bottom: u3 == t6.rowspan - 1,
                      rowLevel: r3,
                      columnLevel: u3,
                      indexInTableGridRow: p3,
                      indexInTableGridColumn: l3
                    }), l3 += 1;
                  }
                  s3 = true;
                }
                p3++;
              }
            }
          });
        }), i3;
      }, t3.prototype.setAlign = function(t4) {
        var e3 = this.tableCellSelector.getSingleSelect();
        e3 && e3.cell.setAlign(t4);
      }, t3.prototype.setVAlign = function(t4) {
        var e3 = this.tableCellSelector.getSingleSelect();
        e3 && e3.cell.setVAlign(t4);
      }, t3.prototype.getColumnStep = function(t4) {
        var e3 = 0;
        return this.rows.length && this.rows[t4 || 0].columns.forEach(function(t5) {
          e3 += t5.colspan;
        }), e3;
      }, t3.prototype.initContext = function() {
        var t4 = this;
        if (!this.optionsCoat.options.isEnableContextMenu) return false;
        hiprintJQuery(this.handle).hicontextMenu({
          menus: [
            {
              text: `\u5728\u4E0A\u65B9\u63D2\u5165\u884C`,
              enabled: this.optionsCoat.options.isEnableInsertRow,
              disable: function disable() {
                return !t4.tableCellSelector.getSingleSelect();
              },
              callback: function callback() {
                t4.insertRow("above"), t4.resizer.updateRowGrips(), r2.a.event.trigger("updateTable" + t4.id);
              }
            },
            {
              text: `\u5728\u4E0B\u65B9\u63D2\u5165\u884C`,
              borderBottom: true,
              enabled: this.optionsCoat.options.isEnableInsertRow,
              disable: function disable() {
                return !t4.tableCellSelector.getSingleSelect();
              },
              callback: function callback() {
                t4.insertRow("below"), t4.resizer.updateRowGrips(), r2.a.event.trigger("updateTable" + t4.id);
              }
            },
            {
              text: `\u5411\u5DE6\u65B9\u63D2\u5165\u5217`,
              enabled: this.optionsCoat.options.isEnableInsertColumn,
              disable: function disable() {
                return !t4.tableCellSelector.getSingleSelect();
              },
              callback: function callback() {
                t4.insertColumn("left"), t4.resizer.updateColumnGrips(), r2.a.event.trigger("updateTable" + t4.id);
              }
            },
            {
              text: `\u5411\u53F3\u65B9\u63D2\u5165\u5217`,
              enabled: this.optionsCoat.options.isEnableInsertColumn,
              disable: function disable() {
                return !t4.tableCellSelector.getSingleSelect();
              },
              borderBottom: true,
              callback: function callback() {
                t4.insertColumn("right"), t4.resizer.updateColumnGrips(), r2.a.event.trigger("updateTable" + t4.id);
              }
            },
            {
              text: `\u5220\u9664\u884C`,
              enabled: this.optionsCoat.options.isEnableDeleteRow,
              disable: function disable() {
                return !t4.tableCellSelector.getSingleSelect() || t4.rows.length <= 1;
              },
              callback: function callback() {
                t4.deleteRow(), t4.resizer.updateRowGrips(), r2.a.event.trigger("updateTable" + t4.id);
              }
            },
            {
              text: `\u5220\u9664\u5217`,
              borderBottom: true,
              enabled: this.optionsCoat.options.isEnableDeleteColumn,
              disable: function disable() {
                return !t4.tableCellSelector.getSingleSelect() || t4.rows.length > 0 && t4.rows[0].columns.length <= 1;
              },
              callback: function callback() {
                t4.deleteColums(), t4.resizer.updateColumnGrips(), r2.a.event.trigger("updateTable" + t4.id);
              }
            },
            {
              text: `\u5BF9\u9F50`,
              borderBottom: true,
              enabled: this.optionsCoat.options.columnAlignEditable,
              menus: [
                {
                  text: `\u5DE6`,
                  callback: function callback() {
                    t4.setAlign("left");
                  }
                },
                {
                  text: `\u5DE6\u53F3\u5C45\u4E2D`,
                  callback: function callback() {
                    t4.setAlign("center");
                  }
                },
                {
                  text: `\u53F3`,
                  callback: function callback() {
                    t4.setAlign("right");
                  }
                },
                {
                  text: `\u9ED8\u8BA4`,
                  borderBottom: true,
                  callback: function callback() {
                    t4.setAlign("");
                  }
                },
                {
                  text: `\u4E0A`,
                  callback: function callback() {
                    t4.setVAlign("top");
                  }
                },
                {
                  text: `\u5782\u76F4\u5C45\u4E2D`,
                  callback: function callback() {
                    t4.setVAlign("middle");
                  }
                },
                {
                  text: `\u4E0B`,
                  callback: function callback() {
                    t4.setVAlign("bottom");
                  }
                },
                {
                  text: `\u9ED8\u8BA4`,
                  callback: function callback() {
                    t4.setVAlign("");
                  }
                }
              ]
            },
            {
              text: `\u5408\u5E76\u5355\u5143\u683C`,
              enabled: this.optionsCoat.options.isEnableMergeCell,
              disable: function disable() {
                return t4.tableCellSelector.getSingleSelect();
              },
              callback: function callback() {
                t4.mergeCell(), r2.a.event.trigger("updateTable" + t4.id);
              }
            },
            {
              text: `\u89E3\u5F00\u5355\u5143\u683C`,
              enabled: this.optionsCoat.options.isEnableMergeCell,
              disable: function disable() {
                var e3 = t4.tableCellSelector.getSingleSelect();
                return !e3 || 1 == e3.cell.rowspan && 1 == e3.cell.colspan;
              },
              callback: function callback() {
                t4.splitCell(), r2.a.event.trigger("updateTable" + t4.id);
              }
            }
          ].filter(function(t5) {
            return t5.enabled;
          })
        });
      }, t3.prototype.getTableWidth = function() {
        return r2.a.px.toPt(this.target.outerWidth(false));
      }, t3.prototype.updateColumnGrips = function() {
        this.resizer.updateColumnGrips();
      }, t3.prototype.updateRowGrips = function() {
        this.resizer.updateRowGrips();
      }, t3;
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return i2;
    });
    var i2 = /* @__PURE__ */ function() {
      return function(t3, e3, n3) {
        this.tid = t3, this.options = e3, this.printElementType = n3;
      };
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    var i2 = n2(3), o2 = n2(12), r2 = (/* @__PURE__ */ function() {
    }(), /* @__PURE__ */ function() {
      return function(t3) {
        this.width = t3.width, this.title = t3.title, this.field = t3.field, this.checked = t3.checked, this.columnId = t3.columnId, this.fixed = false, this.rowspan = t3.rowspan || 1, this.colspan = t3.colspan || 1, this.align = t3.align, this.halign = t3.halign, this.vAlign = t3.vAlign, this.renderFormatter = t3.renderFormatter, this.formatter2 = t3.formatter2, this.styler2 = t3.styler2, this.stylerHeader = t3.stylerHeader, this.tableColumnHeight = t3.tableColumnHeight, this.tableTextType = t3.tableTextType, this.tableBarcodeMode = t3.tableBarcodeMode, this.tableQRCodeLevel = t3.tableQRCodeLevel, this.tableSummaryTitle = t3.tableSummaryTitle, this.tableSummaryText = t3.tableSummaryText, this.tableSummaryColspan = t3.tableSummaryColspan, this.tableSummary = t3.tableSummary, this.tableSummaryAlign = t3.tableSummaryAlign, this.tableSummaryNumFormat = t3.tableSummaryNumFormat, this.tableSummaryFormatter = t3.tableSummaryFormatter, this.showCodeTitle = t3.showCodeTitle, this.upperCase = t3.upperCase;
      };
    }()), a2 = n2(5);
    n2.d(e2, "a", function() {
      return l2;
    });
    var _p, s2 = (_p = function p2(t3, e3) {
      return (_p = Object.setPrototypeOf || _instanceof(
        {
          __proto__: []
        },
        Array
      ) && function(t4, e4) {
        t4.__proto__ = e4;
      } || function(t4, e4) {
        for (var n3 in e4) {
          e4.hasOwnProperty(n3) && (t4[n3] = e4[n3]);
        }
      })(t3, e3);
    }, function(t3, e3) {
      function n3() {
        this.constructor = t3;
      }
      _p(t3, e3), t3.prototype = null === e3 ? Object.create(e3) : (n3.prototype = e3.prototype, new n3());
    }), l2 = function(t3) {
      function e3(e4, n3) {
        var i3 = this;
        (e4 = e4 || {}, (i3 = t3.call(this, e4) || this).lHeight = e4.lHeight, i3.autoCompletion = e4.autoCompletion, i3.tableFooterRepeat = e4.tableFooterRepeat, n3) && (i3.columns = [], n3.editable && e4.columns && e4.columns.length ? e4.columns.forEach(function(t4) {
          var e5 = [];
          t4.forEach(function(t5) {
            var i4 = new r2(t5), o3 = n3.getColumnByColumnId(i4.columnId), p2 = o3 ? hiprintJQuery.extend(o3, i4) : new a2.a(i4);
            e5.push(p2);
          }), i3.columns.push(new o2.a(e5));
        }) : n3.columns.forEach(function(t4) {
          i3.columns.push(new o2.a(t4));
        }));
        return i3;
      }
      return s2(e3, t3), e3.prototype.getColumnByColumnId = function(t4) {
        return this.makeColumnObj()[t4];
      }, e3.prototype.makeColumnObj = function() {
        var t4 = {};
        return this.columns && this.columns.forEach(function(e4) {
          e4.columns.forEach(function(e5) {
            (e5.id || e5.columnId) && (t4[e5.id || e5.columnId] = e5);
          });
        }), t4;
      }, e3.prototype.getGridColumns = function() {
        return this.gridColumns || 1;
      }, e3.prototype.getPrintElementOptionEntity = function() {
        var e4 = t3.prototype.getPrintElementOptionEntity.call(this);
        e4.fields = this.fields;
        return this.columns && (e4.columns = [], this.columns.forEach(function(t4) {
          var n3 = t4.getPrintElementOptionEntity().map(function(t5) {
            return new r2(t5);
          });
          e4.columns.push(n3);
        })), e4;
      }, e3;
    }(i2.a);
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return i2;
    });
    var i2 = /* @__PURE__ */ function() {
      return function() {
        this.rowColumns = [];
      };
    }();
  },
  function(t2, e2, n2) {
    "use strict";
    n2.d(e2, "a", function() {
      return i2;
    });
    var i2 = function() {
      function t3(t4, e3) {
        this.gridColumns = t4, this.target = e3;
      }
      return t3.prototype.getByIndex = function(t4) {
        return this.target.find(".hi-grid-col:eq(" + t4 + ")");
      }, t3;
    }();
  },
  function(t2, e2, n2) {
    t2.exports = n2(33);
  },
  function(t2, e2) {
    !function(t3) {
      function e3(e4) {
        var n3 = t3.data(e4.data.target, "hidraggable"), i3 = n3.options, o3 = n3.proxy, r3 = e4.data, a2 = r3.startLeft + (e4.pageX - r3.startX) / (n3.options.getScale() || 1), p2 = r3.startTop + (e4.pageY - r3.startY) / (n3.options.getScale() || 1);
        o3 && (o3.parent()[0] == document.body ? (a2 = null != i3.deltaX && null != i3.deltaX ? e4.pageX + i3.deltaX : e4.pageX - e4.data.offsetWidth, p2 = null != i3.deltaY && null != i3.deltaY ? e4.pageY + i3.deltaY : e4.pageY - e4.data.offsetHeight) : (null != i3.deltaX && null != i3.deltaX && (a2 += e4.data.offsetWidth + i3.deltaX), null != i3.deltaY && null != i3.deltaY && (p2 += e4.data.offsetHeight + i3.deltaY))), e4.data.parent != document.body && (a2 += t3(e4.data.parent).scrollLeft(), p2 += t3(e4.data.parent).scrollTop()), "h" == i3.axis ? r3.left = a2 : "v" == i3.axis ? r3.top = p2 : e4.shiftKey && e4.altKey ? r3.top = p2 : e4.shiftKey ? r3.left = a2 : (r3.left = a2, r3.top = p2);
      }
      function n2(e4) {
        var n3 = t3.data(e4.data.target, "hidraggable"), i3 = n3.options, o3 = n3.proxy;
        o3 || (o3 = t3(e4.data.target)), o3.css({
          left: t3.fn.dragLengthC(e4.data.left, i3),
          top: t3.fn.dragLengthC(e4.data.top, i3)
        }), t3("body").css("cursor", i3.cursor);
      }
      function i2(i3) {
        t3.fn.hidraggable.isDragging = true;
        var o3 = t3.data(i3.data.target, "hidraggable"), r3 = o3.options, a2 = t3(".hidroppable").filter(function() {
          return i3.data.target != this;
        }).filter(function() {
          var e4 = t3.data(this, "hidroppable").options.accept;
          return !e4 || t3(e4).filter(function() {
            return this == i3.data.target;
          }).length > 0;
        });
        o3.hidroppables = a2;
        var p2 = o3.proxy;
        return p2 || (r3.proxy ? (p2 = "clone" == r3.proxy ? t3(i3.data.target).clone().insertAfter(i3.data.target) : r3.proxy.call(i3.data.target, i3.data.target), o3.proxy = p2) : p2 = t3(i3.data.target)), p2.css("position", "absolute"), e3(i3), n2(i3), r3.onStartDrag.call(i3.data.target, i3), false;
      }
      function createVerLine(op, cp, t4, tt2, h2, pc) {
        if (Math.abs(op[t4] - cp[tt2]) <= HIPRINT_CONFIG.adsorbLineMin) {
          if (op.v.length) {
            op.v.css("left", op[t4] + "pt");
          } else {
            op.v = hiprintJQuery("<div class='verLine id-" + op.id + "'></div>");
            op.v.css("height", h2 + "pt");
            op.v.css("left", op[t4] + "pt");
            pc.append(op.v);
          }
        } else {
          op.v && op.v.remove();
        }
      }
      function removeVerLine(op) {
        if (op) op.v && op.v.remove();
        hiprintJQuery(".verLine").remove();
      }
      function createHorLine(op, cp, t4, tt2, w2, pc) {
        if (Math.abs(op[t4] - cp[tt2]) <= HIPRINT_CONFIG.adsorbLineMin) {
          if (op.h.length) {
            op.h.css("top", op[t4] + "pt");
          } else {
            op.h = hiprintJQuery("<div class='horLine id-" + op.id + "'></div>");
            op.h.css("width", w2 + "pt");
            op.h.css("top", op[t4] + "pt");
            pc.append(op.h);
          }
        } else {
          op.h && op.h.remove();
        }
      }
      function removeHorLine(op) {
        if (op) op.h && op.h.remove();
        hiprintJQuery(".horLine").remove();
      }
      function o2(i3) {
        var o3 = t3.data(i3.data.target, "hidraggable");
        e3(i3);
        if (!(i3.ctrlKey || i3.metaKey) && (i3.data.target.className.startsWith("resize-panel") || "2" == i3.data.target.style.zIndex || i3.data.target.className.startsWith("hiprint-printElement"))) {
          var data = i3.data;
          if (t3(".mouseRect").length == 0 && o3.options.designTarget && o3.options.designTarget.panel.printElements.filter(function(el) {
            return "block" == el.designTarget.children().last().css("display") && !el.printElementType.type.includes("table");
          }).length <= 1) {
            let left = window.hinnn.px.toPt(data.left);
            let top = window.hinnn.px.toPt(data.top);
            let cPosition = o3.options.designTarget.options;
            cPosition.left = left;
            cPosition.top = top;
            cPosition.right = left + cPosition.width;
            cPosition.bottom = top + cPosition.height;
            cPosition.vCenter = left + cPosition.width / 2;
            cPosition.hCenter = top + cPosition.height / 2;
            (() => {
              let oPositions = o3.options.designTarget.panel.printElements.filter((el) => el.id != o3.options.designTarget.id).map((el) => {
                let { left: left2, top: top2, width: width2, height } = el.options;
                let right = left2 + width2, vCenter = left2 + width2 / 2, hCenter = top2 + height / 2;
                let cVCenter = cPosition.left + cPosition.width / 2, cHCenter = cPosition.top + cPosition.height / 2, cRight = cPosition.left + cPosition.width;
                let distance, d1, d2, d3;
                d1 = Math.sqrt(Math.pow(left2 - cPosition.left, 2) + Math.pow(hCenter - cHCenter, 2));
                d2 = Math.sqrt(Math.pow(vCenter - cVCenter, 2) + Math.pow(hCenter - cHCenter, 2));
                d3 = Math.sqrt(Math.pow(right - cRight, 2) + Math.pow(hCenter - cHCenter, 2));
                distance = Math.min(d1, d2, d3);
                return {
                  ...el.options,
                  distance,
                  h: hiprintJQuery(".horLine.id-" + el.id),
                  v: hiprintJQuery(".verLine.id-" + el.id),
                  bottom: top2 + height,
                  right: left2 + width2,
                  vCenter,
                  hCenter
                };
              }).sort((a2, b2) => a2.distance - b2.distance).slice(0, 1);
              let paper = o3.options.designTarget.designPaper;
              let paperContent = paper.target.find(".hiprint-printPaper-content");
              let paperW2 = paper.width, paperH2 = paper.height;
              let showAline = HIPRINT_CONFIG.showAdsorbLine, aMin = HIPRINT_CONFIG.adsorbMin, aLMin = HIPRINT_CONFIG.adsorbLineMin;
              oPositions.forEach((item, idx) => {
                if (Math.abs(oPositions[idx].left - cPosition.left) <= aMin) {
                  cPosition.left = oPositions[idx].left;
                  removeVerLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].vCenter - cPosition.left) <= aMin) {
                  cPosition.left = oPositions[idx].vCenter;
                  removeVerLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].right - cPosition.left) <= aMin) {
                  cPosition.left = oPositions[idx].right;
                  removeVerLine(oPositions[idx]);
                }
                if (Math.abs(oPositions[idx].left - cPosition.vCenter) <= aMin) {
                  cPosition.left = oPositions[idx].left - cPosition.width / 2;
                  removeVerLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].vCenter - cPosition.vCenter) <= aMin) {
                  cPosition.left = oPositions[idx].vCenter - cPosition.width / 2;
                  removeVerLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].right - cPosition.vCenter) <= aMin) {
                  cPosition.left = oPositions[idx].right - cPosition.width / 2;
                  removeVerLine(oPositions[idx]);
                }
                if (Math.abs(oPositions[idx].left - cPosition.right) <= aMin) {
                  cPosition.left = oPositions[idx].left - cPosition.width;
                  removeVerLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].vCenter - cPosition.right) <= aMin) {
                  cPosition.left = oPositions[idx].vCenter - cPosition.width;
                  removeVerLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].right - cPosition.right) <= aMin) {
                  cPosition.left = oPositions[idx].right - cPosition.width;
                  removeVerLine(oPositions[idx]);
                }
                if (Math.abs(oPositions[idx].top - cPosition.top) <= aMin) {
                  cPosition.top = oPositions[idx].top;
                  removeHorLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].hCenter - cPosition.top) <= aMin) {
                  cPosition.top = oPositions[idx].hCenter;
                  removeHorLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].bottom - cPosition.top) <= aMin) {
                  cPosition.top = oPositions[idx].bottom;
                  removeHorLine(oPositions[idx]);
                }
                if (Math.abs(oPositions[idx].top - cPosition.hCenter) <= aMin) {
                  cPosition.top = oPositions[idx].top - cPosition.height / 2;
                  removeHorLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].hCenter - cPosition.hCenter) <= aMin) {
                  cPosition.top = oPositions[idx].hCenter - cPosition.height / 2;
                  removeHorLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].bottom - cPosition.hCenter) <= aMin) {
                  cPosition.top = oPositions[idx].bottom - cPosition.height / 2;
                  removeHorLine(oPositions[idx]);
                }
                if (Math.abs(oPositions[idx].top - cPosition.bottom) <= aMin) {
                  cPosition.top = oPositions[idx].top - cPosition.height;
                  removeHorLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].hCenter - cPosition.bottom) <= aMin) {
                  cPosition.top = oPositions[idx].hCenter - cPosition.height;
                  removeHorLine(oPositions[idx]);
                } else if (Math.abs(oPositions[idx].bottom - cPosition.bottom) <= aMin) {
                  cPosition.top = oPositions[idx].bottom - cPosition.height;
                  removeHorLine(oPositions[idx]);
                }
                if (showAline) {
                  if (Math.abs(oPositions[idx].left - cPosition.left) > aMin && Math.abs(oPositions[idx].left - cPosition.left) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "left", "left", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].vCenter - cPosition.left) > aMin && Math.abs(oPositions[idx].vCenter - cPosition.left) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "vCenter", "left", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].right - cPosition.left) > aMin && Math.abs(oPositions[idx].right - cPosition.left) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "right", "left", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].left - cPosition.vCenter) > aMin && Math.abs(oPositions[idx].left - cPosition.vCenter) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "left", "vCenter", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].vCenter - cPosition.vCenter) > aMin && Math.abs(oPositions[idx].vCenter - cPosition.vCenter) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "vCenter", "vCenter", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].right - cPosition.vCenter) > aMin && Math.abs(oPositions[idx].right - cPosition.vCenter) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "right", "vCenter", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].left - cPosition.right) > aMin && Math.abs(oPositions[idx].left - cPosition.right) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "left", "right", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].vCenter - cPosition.right) > aMin && Math.abs(oPositions[idx].vCenter - cPosition.right) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "vCenter", "right", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].right - cPosition.right) > aMin && Math.abs(oPositions[idx].right - cPosition.right) <= aLMin) {
                    createVerLine(oPositions[idx], cPosition, "right", "right", paperH2, paperContent);
                  } else if (Math.abs(oPositions[idx].top - cPosition.top) > aMin && Math.abs(oPositions[idx].top - cPosition.top) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "top", "top", paperW2, paperContent);
                  } else if (Math.abs(oPositions[idx].hCenter - cPosition.top) > aMin && Math.abs(oPositions[idx].hCenter - cPosition.top) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "hCenter", "top", paperW2, paperContent);
                  } else if (Math.abs(oPositions[idx].bottom - cPosition.top) > aMin && Math.abs(oPositions[idx].bottom - cPosition.top) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "bottom", "top", paperW2, paperContent);
                  } else if (Math.abs(oPositions[idx].top - cPosition.hCenter) > aMin && Math.abs(oPositions[idx].top - cPosition.hCenter) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "top", "hCenter", paperW2, paperContent);
                  } else if (Math.abs(oPositions[idx].hCenter - cPosition.hCenter) > aMin && Math.abs(oPositions[idx].hCenter - cPosition.hCenter) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "hCenter", "hCenter", paperW2, paperContent);
                  } else if (Math.abs(oPositions[idx].bottom - cPosition.hCenter) > aMin && Math.abs(oPositions[idx].bottom - cPosition.hCenter) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "bottom", "hCenter", paperW2, paperContent);
                  } else if (Math.abs(oPositions[idx].top - cPosition.bottom) > aMin && Math.abs(oPositions[idx].top - cPosition.bottom) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "top", "bottom", paperW2, paperContent);
                  } else if (Math.abs(oPositions[idx].hCenter - cPosition.bottom) > aMin && Math.abs(oPositions[idx].hCenter - cPosition.bottom) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "hCenter", "bottom", paperW2, paperContent);
                  } else if (Math.abs(oPositions[idx].bottom - cPosition.bottom) > aMin && Math.abs(oPositions[idx].bottom - cPosition.bottom) <= aLMin) {
                    createHorLine(oPositions[idx], cPosition, "bottom", "bottom", paperW2, paperContent);
                  } else {
                    removeVerLine(oPositions[idx]);
                    removeHorLine(oPositions[idx]);
                  }
                }
              });
            })();
            i3.data.left = window.hinnn.pt.toPx(cPosition.left);
            i3.data.top = window.hinnn.pt.toPx(cPosition.top);
          }
          var parent = data.parent.className.endsWith("design") ? data.parent : data.parent.offsetParent;
          var paperW = parent.clientWidth, paperH = parent.clientHeight;
          var elementW = data.target.clientWidth, elementH = data.target.clientHeight, diffLeft = 0, diffTop = 0;
          if (o3.options.designTarget && o3.options.designTarget.options.transform) {
            var info = o3.options.designTarget.options.getRectInfo();
            diffLeft = window.hinnn.pt.toPx(info.diffW), diffTop = window.hinnn.pt.toPx(info.diffH);
          }
          if (data.left < 0 - diffLeft) {
            data.left = 0 - diffLeft;
          } else if (data.left >= paperW - elementW + diffLeft) {
            data.left = paperW - elementW + diffLeft;
          }
          if (data.top < 0 - diffTop) {
            data.top = 0 - diffTop;
          } else if (data.top >= paperH - elementH + diffTop) {
            data.top = paperH - elementH + diffTop;
          }
          i3.data = data;
        }
        0 != o3.options.onDrag.call(i3.data.target, i3, t3.fn.dragLengthCNum(i3.data.left, o3.options), t3.fn.dragLengthCNum(i3.data.top, o3.options)) && n2(i3);
        var r3 = i3.data.target;
        return o3.hidroppables.each(function() {
          var e4 = t3(this);
          if (!e4.hidroppable("options").disabled) {
            var n3 = e4.offset();
            i3.pageX > n3.left && i3.pageX < n3.left + e4.outerWidth() && i3.pageY > n3.top && i3.pageY < n3.top + e4.outerHeight() ? (this.entered || (t3(this).trigger("_dragenter", [r3]), this.entered = true), t3(this).trigger("_dragover", [r3])) : this.entered && (t3(this).trigger("_dragleave", [r3]), this.entered = false);
          }
        }), false;
      }
      function r2(e4) {
        t3.fn.hidraggable.isDragging = false;
        removeVerLine(), removeHorLine();
        var n3, i3, r3 = t3.data(e4.data.target, "hidraggable"), a2 = r3.proxy, p2 = r3.options;
        p2.revert ? 1 == l2() ? t3(e4.data.target).css({
          position: e4.data.startPosition,
          left: e4.data.startLeft,
          top: e4.data.startTop
        }) : a2 ? (a2.parent()[0] == document.body ? (n3 = e4.data.startX - e4.data.offsetWidth, i3 = e4.data.startY - e4.data.offsetHeight) : (n3 = e4.data.startLeft, i3 = e4.data.startTop), a2.animate(
          {
            left: n3,
            top: i3
          },
          function() {
            s2();
          }
        )) : t3(e4.data.target).animate(
          {
            left: e4.data.startLeft,
            top: e4.data.startTop
          },
          function() {
            t3(e4.data.target).css("position", e4.data.startPosition);
          }
        ) : (t3(e4.data.target).css({
          position: "absolute",
          left: t3.fn.dragLengthC(e4.data.left, p2),
          top: t3.fn.dragLengthC(e4.data.top, p2)
        }), l2());
        function s2() {
          a2 && a2.remove(), r3.proxy = null;
        }
        function l2() {
          var n4 = false;
          return r3.hidroppables.each(function() {
            var i4 = t3(this);
            if (!i4.hidroppable("options").disabled) {
              var o3 = i4.offset();
              var ptr = this.style.transform && parseFloat(this.style.transform.slice(6, -1)) || 1;
              return e4.pageX > o3.left && e4.pageX < o3.left + i4.outerWidth() * ptr && e4.pageY > o3.top && e4.pageY < o3.top + i4.outerHeight() * ptr ? (p2.revert && t3(e4.data.target).css({
                position: e4.data.startPosition,
                left: e4.data.startLeft,
                top: e4.data.startTop
              }), t3(this).trigger("_drop", [e4.data.target]), s2(), n4 = true, this.entered = false, false) : void 0;
            }
          }), n4 || p2.revert || s2(), n4;
        }
        return p2.onStopDrag.call(e4.data.target, e4), t3(document).unbind(".hidraggable"), setTimeout(function() {
          t3("body").css("cursor", "");
        }, 100), false;
      }
      t3.fn.hidraggable = function(e4, n3) {
        return "string" == typeof e4 ? t3.fn.hidraggable.methods[e4](this, n3) : this.each(function() {
          var n4, a2 = t3.data(this, "hidraggable");
          a2 ? (a2.handle.unbind(".hidraggable"), n4 = t3.extend(a2.options, e4)) : n4 = t3.extend({}, t3.fn.hidraggable.defaults, t3.fn.hidraggable.parseOptions(this), e4 || {});
          var p2 = n4.handle ? "string" == typeof n4.handle ? t3(n4.handle, this) : n4.handle : t3(this);
          function s2(e5) {
            var n5 = t3.data(e5.data.target, "hidraggable"), i3 = n5.handle, o3 = t3(i3).offset(), tr = t3(i3)[0].style.transform && parseInt(t3(i3)[0].style.transform.slice(7, -1)), ptr = n5.options.getScale(), r3 = t3(i3).outerWidth();
            var a3 = t3(i3).outerHeight();
            if (tr) {
              var rad = tr * Math.PI / 180, width2 = t3(i3).outerWidth(), height = t3(i3).outerHeight(), sin = Math.sin(rad), cos = Math.cos(rad);
              r3 = Math.abs(width2 * cos) + Math.abs(height * sin), a3 = Math.abs(width2 * sin) + Math.abs(height * cos);
            }
            if (ptr) {
              r3 *= ptr, a3 *= ptr;
            }
            var p3 = e5.pageY - o3.top, s3 = o3.left + r3 - e5.pageX, l2 = o3.top + a3 - e5.pageY, u2 = e5.pageX - o3.left;
            return Math.min(p3, s3, l2, u2) > n5.options.edge;
          }
          t3.data(this, "hidraggable", {
            options: n4,
            handle: p2
          }), n4.disabled ? t3(this).css("cursor", "") : p2.unbind(".hidraggable").bind(
            "mousemove.hidraggable",
            {
              target: this
            },
            function(e5) {
              if (!t3.fn.hidraggable.isDragging) {
                var n5 = t3.data(e5.data.target, "hidraggable").options;
                s2(e5) ? t3(this).css("cursor", n5.cursor) : t3(this).css("cursor", "");
              }
            }
          ).bind(
            "mouseleave.hidraggable",
            {
              target: this
            },
            function(e5) {
              t3(this).css("cursor", "");
            }
          ).bind(
            "mousedown.hidraggable",
            {
              target: this
            },
            function(e5) {
              if (0 != s2(e5)) {
                t3(this).css("cursor", "");
                var n5 = t3(e5.data.target).position(), a3 = t3(e5.data.target).offset(), p3 = {
                  startPosition: t3(e5.data.target).css("position"),
                  startLeft: n5.left,
                  startTop: n5.top,
                  left: n5.left,
                  top: n5.top,
                  startX: e5.pageX,
                  startY: e5.pageY,
                  offsetWidth: e5.pageX - a3.left,
                  offsetHeight: e5.pageY - a3.top,
                  target: e5.data.target,
                  parent: t3(e5.data.target).parent()[0]
                };
                var ops = t3.data(e5.data.target, "hidraggable");
                if (ops.options.draggable === false) {
                  return;
                }
                if ("r resizebtn" == e5.target.className) {
                  return;
                }
                var ptr = ops.options.getScale();
                if (ptr) {
                  p3.left /= ptr, p3.top /= ptr, p3.startLeft /= ptr, p3.startTop /= ptr;
                }
                var tr = p3.target.style.transform && parseInt(p3.target.style.transform.slice(7, -1));
                if (tr) {
                  var rad = tr * Math.PI / 180, width2 = t3(e5.data.target).outerWidth(), height = t3(e5.data.target).outerHeight(), sin = Math.sin(rad), cos = Math.cos(rad);
                  var w2 = Math.abs(width2 * cos) + Math.abs(height * sin), h2 = Math.abs(width2 * sin) + Math.abs(height * cos);
                  var diffW = (w2 - width2) / 2, diffH = (h2 - height) / 2;
                  p3.left += diffW, p3.top += diffH, p3.startLeft += diffW, p3.startTop += diffH;
                }
                t3.extend(e5.data, p3);
                0 != t3.data(e5.data.target, "hidraggable").options.onBeforeDrag.call(e5.data.target, e5) && (t3(document).bind("mousedown.hidraggable", e5.data, i2), t3(document).bind("mousemove.hidraggable", e5.data, o2), t3(document).bind("mouseup.hidraggable", e5.data, r2));
              }
            }
          );
        });
      }, t3.fn.hidraggable.methods = {
        options: function options2(e4) {
          return t3.data(e4[0], "hidraggable").options;
        },
        update: function update(e4, n3) {
          if (n3 && "object" == typeof n3) {
            t3.data(e4[0], "hidraggable") && Object.keys(n3).forEach(function(k2) {
              t3.data(e4[0], "hidraggable").options[k2] = n3[k2];
            });
          }
        },
        proxy: function proxy(e4) {
          return t3.data(e4[0], "hidraggable").proxy;
        },
        enable: function enable(e4) {
          return e4.each(function() {
            t3(this).hidraggable({
              disabled: false
            });
          });
        },
        disable: function disable(e4) {
          return e4.each(function() {
            t3(this).hidraggable({
              disabled: true
            });
          });
        }
      }, t3.fn.hidraggable.parseOptions = function(e4) {
        var n3 = t3(e4);
        return t3.extend(
          {},
          t3.hiprintparser.parseOptions(e4, [
            "cursor",
            "handle",
            "axis",
            {
              revert: "boolean",
              deltaX: "number",
              deltaY: "number",
              edge: "number"
            }
          ]),
          {
            disabled: !!n3.attr("disabled") || void 0
          }
        );
      }, t3.fn.hidraggable.defaults = {
        proxy: null,
        revert: false,
        cursor: "move",
        deltaX: null,
        deltaY: null,
        handle: null,
        disabled: false,
        edge: 0,
        axis: null,
        getScale: function getScale(t4) {
        },
        onBeforeDrag: function onBeforeDrag(t4) {
        },
        onStartDrag: function onStartDrag(t4) {
        },
        onDrag: function onDrag(t4) {
        },
        onStopDrag: function onStopDrag(t4) {
        }
      }, t3.fn.hidraggable.isDragging = false;
    }(hiprintJQuery);
  },
  function(t2, e2) {
    !function(t3) {
      t3.fn.hidroppable = function(e3, n2) {
        return "string" == typeof e3 ? t3.fn.hidroppable.methods[e3](this, n2) : (e3 = e3 || {}, this.each(function() {
          var n3, i2 = t3.data(this, "hidroppable");
          i2 ? t3.extend(i2.options, e3) : (t3(n3 = this).addClass("hidroppable"), t3(n3).bind("_dragenter", function(e4, i3) {
            t3.data(n3, "hidroppable").options.onDragEnter.apply(n3, [e4, i3]);
          }), t3(n3).bind("_dragleave", function(e4, i3) {
            t3.data(n3, "hidroppable").options.onDragLeave.apply(n3, [e4, i3]);
          }), t3(n3).bind("_dragover", function(e4, i3) {
            t3.data(n3, "hidroppable").options.onDragOver.apply(n3, [e4, i3]);
          }), t3(n3).bind("_drop", function(e4, i3) {
            t3.data(n3, "hidroppable").options.onDrop.apply(n3, [e4, i3]);
          }), t3.data(this, "hidroppable", {
            options: t3.extend({}, t3.fn.hidroppable.defaults, t3.fn.hidroppable.parseOptions(this), e3)
          }));
        }));
      }, t3.fn.hidroppable.methods = {
        options: function options2(e3) {
          return t3.data(e3[0], "hidroppable").options;
        },
        enable: function enable(e3) {
          return e3.each(function() {
            t3(this).hidroppable({
              disabled: false
            });
          });
        },
        disable: function disable(e3) {
          return e3.each(function() {
            t3(this).hidroppable({
              disabled: true
            });
          });
        }
      }, t3.fn.hidroppable.parseOptions = function(e3) {
        var n2 = t3(e3);
        return t3.extend({}, t3.hiprintparser.parseOptions(e3, ["accept"]), {
          disabled: !!n2.attr("disabled") || void 0
        });
      }, t3.fn.hidroppable.defaults = {
        accept: null,
        disabled: false,
        onDragEnter: function onDragEnter(t4, e3) {
        },
        onDragOver: function onDragOver(t4, e3) {
        },
        onDragLeave: function onDragLeave(t4, e3) {
        },
        onDrop: function onDrop(t4, e3) {
        }
      };
    }(hiprintJQuery);
  },
  function(t2, e2) {
    var n2;
    (n2 = hiprintJQuery).hiprintparser = {
      parseOptions: function parseOptions(t3, e3) {
        var i2 = n2(t3), o2 = {}, r2 = n2.trim(i2.attr("data-options"));
        if (r2 && ("{" != r2.substring(0, 1) && (r2 = "{" + r2 + "}"), o2 = new Function("return " + r2)()), e3) {
          for (var a2 = {}, p2 = 0; p2 < e3.length; p2++) {
            var s2 = e3[p2];
            if ("string" == typeof s2) a2[s2] = "width" == s2 || "height" == s2 || "left" == s2 || "top" == s2 ? parseInt(t3.style[s2]) || void 0 : i2.attr(s2);
            else
              for (var l2 in s2) {
                var u2 = s2[l2];
                "boolean" == u2 ? a2[l2] = i2.attr(l2) ? "true" == i2.attr(l2) : void 0 : "number" == u2 && (a2[l2] = "0" == i2.attr(l2) ? 0 : parseFloat(i2.attr(l2)) || void 0);
              }
          }
          n2.extend(o2, a2);
        }
        return o2;
      }
    }, n2.fn.dragLengthC = function(t3, e3) {
      return "pt" == e3.moveUnit ? n2.fn.dragLengthCNum(t3, e3) + "pt" : n2.fn.dragLengthCNum(t3, e3);
    }, n2.fn.dragLengthCNum = function(t3, e3) {
      var n3 = 3;
      if ("pt" == e3.moveUnit) {
        var i2 = 0.75 * t3;
        return e3.minMove && (n3 = e3.minMove), Math.round(i2 / n3) * n3;
      }
      return Math.round(i2 / n3) * n3;
    };
  },
  function(t2, e2) {
    var n2, i2, o2;
    n2 = hiprintJQuery, i2 = {
      maxPanelIndex: 0
    }, (o2 = function o3(t3) {
      this.options = n2.data(t3.target, "hireizeable").options, this.init(t3.target);
    }).prototype = {
      numHandlerText: function numHandlerText(t3) {
        return this.numHandler(t3) + "pt";
      },
      numHandler: function numHandler(t3) {
        var e3 = 1.5, n3 = 0.75 * t3;
        return this.options.minResize && (e3 = this.options.minResize), Math.round(n3 / e3) * e3;
      },
      init: function init(t3) {
        this.initResizeBox(t3);
      },
      initResizeBox: function initResizeBox(t3) {
        var e3 = this;
        n2(t3).each(function() {
          var o3;
          i2.maxPanelIndex += 1, e3.options.noContainer ? o3 = n2(t3) : (o3 = n2("<div panelIndex=" + i2.maxPanelIndex + ' class="resize-panel"></div>')).css({
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            position: "absolute",
            "background-color": "rgba(0,0,0,0.5)",
            cursor: "move",
            display: "none"
          }), e3.appendHandler(o3, n2(this));
          var r2 = {
            name: "n",
            target: n2('<div class="n resizebtn" style="cursor: n-resize;top: -12px;margin-left: -4px;left: 50%;"></div>')
          }, a2 = {
            name: "s",
            target: n2('<div class="s resizebtn" style="cursor: s-resize;bottom: -12px;margin-left: -4px;left: 50%;"></div>')
          }, p2 = {
            name: "w",
            target: n2('<div class="w resizebtn" style="cursor: w-resize;left: -12px;margin-top: -4px;top: 50%;"></div>')
          }, s2 = {
            name: "e",
            target: n2('<div class="e resizebtn" style="cursor: e-resize; top: 50%; margin-top:-4px;right: -12px;"></div>')
          }, l2 = {
            name: "ne",
            target: n2('<div class="ne resizebtn" style="cursor: ne-resize;top: -12px;right: -12px;"></div>')
          }, u2 = {
            name: "nw",
            target: n2('<div class="nw resizebtn" style=" cursor: nw-resize;top: -12px;left:-12px;"></div>')
          }, d2 = {
            name: "se",
            target: n2('<div class="se resizebtn" style="cursor: se-resize;bottom:-12px;right: -12px;"></div>')
          }, c2 = {
            name: "sw",
            target: n2('<div class="sw resizebtn" style="cursor: sw-resize;bottom: -12px;left: -12px;"></div>')
          }, r2 = {
            name: "r",
            target: n2(`<div class="r resizebtn" style="cursor:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABvUExURUdwTP///9XV1R0dHf///3Nzc////////////////1ZWVq+vr/T09PX19QQEBP///////8XFxf///////////wYGBv///+jo6P///4aGhqioqMzMzP///2BgYP///////////zExMf///wAAAP///xLps0AAAAAjdFJOUwCxxOdixRDmzSDMv8/Z+tz5wWpXWPk3zALCv8KnyXZVMNuNPnv3CwAAAJ1JREFUKM/NkckOwyAMRFkDBMhC9qWr+//fWCIV1WlzrjoXS36yxmMT8hdqqKoUvRAjMtw22kvecem1GjTuK1vApmI+wQMBbQFy5li+QQRaX4AtRX+vbntAJeRl9HTTx4TiwESs61DXNUPmVQeujzVrQwh43TTxpeRBslVfMUhbiXKWyiAwvnIsMcdyJkfJYdpNvG/ltDm+bjP+8KFP8ggL+zQLGxwAAAAASUVORK5CYII=') 14 14,alias;top: -16px;margin-left: -4px;left: 50%;"></div>`)
          }, sizeBox = n2('<div class="size-box" style="position: absolute;left:-2px;"></div>'), deleteBtn = n2('<div class="del-btn">\u2715</div>'), h2 = function h3() {
            var t4 = [], i3 = e3.options.showPoints;
            return n2.each([r2, a2, p2, s2, l2, u2, d2, c2], function(e4, o4) {
              n2.inArray(o4.name, i3) > -1 && t4.push(o4.target);
            }), t4;
          };
          e3.refreshSizeBox(void 0, sizeBox, o3);
          if (e3.options.draggable != false) {
            o3.append(deleteBtn);
            o3.on("mousedown", ".del-btn", () => {
              var keyboardEvent = new KeyboardEvent("keydown", { bubbles: true, keyCode: 46 });
              t3.dispatchEvent(keyboardEvent);
            });
          }
          e3.addHandlerCss(h2()), e3.appendHandler(h2(), o3), e3.bindResizeEvent(o3, n2(this));
          var f2 = n2(this);
          n2(o3).on("mousedown", ".resizebtn", function() {
            f2.addClass("resizeing");
          }), n2(".easyui-droppable").on("mouseup", function() {
            f2.removeClass("resizeing");
          }), e3.bindTrigger(n2(this));
        }), e3.bindHidePanel();
      },
      addHandlerCss: function addHandlerCss(t3) {
        for (var e3 = 0; e3 < t3.length; e3++) {
          t3[e3].css({
            position: "absolute",
            width: "8px",
            height: "8px",
            background: "#ff6600",
            "border-radius": "50%"
          });
        }
      },
      appendHandler: function appendHandler(t3, e3) {
        e3.find(".resize-panel").remove();
        for (var n3 = 0; n3 < t3.length; n3++) {
          e3.append(t3[n3]);
        }
      },
      refreshSizeBox: function refreshSizeBox(t3, box, o3) {
        if (!this.options.showSizeBox) return;
        if (box) {
          o3.append(box);
        }
        var style, sizeBox;
        if (t3 && t3.length) {
          style = t3[0].style;
          sizeBox = t3.children("div[panelindex]").find(".size-box");
        } else if (o3 && o3.parent()) {
          var t3 = o3.parent();
          if (t3.hasClass("hiprint-printPaper-content")) return;
          style = t3[0].style;
          if (!style.width) {
            style.width = hinnn.px.toPt(t3[0].offsetWidth) + "pt";
          }
          if (!style.height) {
            style.height = hinnn.px.toPt(t3[0].offsetHeight) + "pt";
          }
          sizeBox = t3.children("div[panelindex]").find(".size-box");
        }
        if (sizeBox) {
          sizeBox.text(style.width + " x " + style.height);
          sizeBox.css("top", -(sizeBox.outerHeight() || 20));
        }
      },
      triggerResize: function triggerResize(t3, n3) {
        if (!(n3.ctrlKey || n3.metaKey)) {
          t3.siblings().children("div[panelindex]").removeClass("selected");
          t3.siblings().children("div[panelindex]").css({
            display: "none"
          });
        }
        t3.children("div[panelindex]").addClass("selected");
        t3.children("div[panelindex]").css({
          display: "block"
        });
        this.refreshSizeBox(t3);
      },
      bindResizeEvent: function bindResizeEvent(t3, e3) {
        var i3 = this, o3 = 0, r2 = 0, a2 = t3.width(), p2 = t3.height(), s2 = t3.offset().left, l2 = t3.offset().top, u2 = i3.options.noContainer ? n2(e3) : t3.parent(), d2 = false;
        t3.on("mousedown", ".e", function(e4) {
          o3 = e4.pageX, a2 = t3.width(), d2 = true;
        });
        var c2 = false;
        t3.on("mousedown", ".s", function(e4) {
          r2 = e4.pageY, p2 = t3.height(), c2 = true;
        });
        var h2 = false;
        t3.on("mousedown", ".w", function(e4) {
          o3 = e4.pageX, a2 = t3.width(), h2 = true, s2 = u2.offset().left;
        });
        var f2 = false;
        t3.on("mousedown", ".n", function(e4) {
          r2 = e4.pageY, p2 = t3.height(), f2 = true, l2 = u2.offset().top;
        });
        var g2 = false;
        t3.on("mousedown", ".ne", function(e4) {
          o3 = e4.pageX, r2 = e4.pageY, a2 = t3.width(), p2 = t3.height(), g2 = true, l2 = u2.offset().top;
        });
        var m2 = false;
        t3.on("mousedown", ".nw", function(e4) {
          o3 = e4.pageX, r2 = e4.pageY, a2 = t3.width(), p2 = t3.height(), l2 = u2.offset().top, s2 = u2.offset().left, m2 = true;
        });
        var v2 = false;
        t3.on("mousedown", ".se", function(e4) {
          o3 = e4.pageX, r2 = e4.pageY, a2 = t3.width(), p2 = t3.height(), v2 = true;
        });
        var y2 = false;
        t3.on("mousedown", ".sw", function(e4) {
          o3 = e4.pageX, r2 = e4.pageY, a2 = t3.width(), p2 = t3.height(), y2 = true, s2 = u2.offset().left;
        });
        var rt2 = false;
        t3.on("mousedown", ".r", function(e4) {
          o3 = e4.pageX, r2 = e4.pageY, a2 = t3.width(), p2 = t3.height(), rt2 = true, s2 = a2 / 2 + u2.offset().left, l2 = p2 / 2 + u2.offset().top;
        });
        t3.on("dblclick", ".r", function(e4) {
          u2.css({ transform: "rotate(0deg)" });
          i3.options.onResize(e4, void 0, void 0, void 0, void 0, 0);
        });
        var b2 = false;
        t3.on("mousedown", function(t4) {
          i3.options.onBeforeResize(), o3 = t4.pageX, r2 = t4.pageY, l2 = u2.offset().top, s2 = u2.offset().left, b2 = false;
        }), n2(i3.options.stage).on("mousemove", function(e4) {
          if (d2) {
            var n3 = (e4.pageX - o3) / i3.options.getScale();
            t3.css({
              width: "100%"
            }), u2.css({
              width: i3.numHandlerText(a2 + n3)
            }), i3.options.onResize(e4, void 0, i3.numHandler(a2 + n3), void 0, void 0);
          } else if (c2) {
            var E2 = (e4.pageY - r2) / i3.options.getScale();
            t3.css({
              height: "100%"
            }), u2.css({
              height: i3.numHandlerText(p2 + E2)
            }), i3.options.onResize(e4, i3.numHandler(p2 + E2), void 0, void 0, void 0);
          } else if (rt2) {
            t3.css({ height: "100%" });
            var eo = e4.pageX, er = e4.pageY;
            var direct = (eo - o3) * 360 / 100;
            o3 = e4.pageX;
            var lastAngle = u2[0].style.transform && parseInt(u2[0].style.transform.slice(7, -1)) || 0;
            var R2 = lastAngle + direct;
            if (Math.abs(R2) > 360) {
              R2 = R2 % 360;
            }
            u2.css({ transform: "rotate(" + R2 + "deg)" });
            i3.options.onResize(e4, void 0, void 0, void 0, void 0, R2);
          } else if (h2) {
            n3 = (e4.pageX - o3) / i3.options.getScale(), t3.css({
              width: "100%"
            }), u2.css({
              width: i3.numHandlerText(a2 - n3),
              left: i3.numHandlerText(i3.options.noDrag ? void 0 : i3.numHandler(s2 + n3))
            }), i3.options.onResize(e4, void 0, i3.numHandler(a2 - n3), void 0, i3.options.noDrag ? void 0 : i3.numHandler(s2 + n3));
          } else if (f2) {
            E2 = (e4.pageY - r2) / i3.options.getScale(), t3.css({
              height: "100%"
            }), u2.css({
              height: i3.numHandlerText(p2 - E2),
              top: i3.numHandlerText(i3.options.noDrag ? void 0 : l2 + E2)
            }), i3.options.onResize(e4, i3.numHandler(p2 - E2), void 0, i3.options.noDrag ? void 0 : i3.numHandler(l2 + E2), void 0);
          } else if (g2) {
            n3 = (e4.pageX - o3) / i3.options.getScale(), E2 = (e4.pageY - r2) / i3.options.getScale(), t3.css({
              height: "100%",
              width: "100%"
            }), u2.css({
              height: i3.numHandlerText(p2 - E2),
              top: i3.numHandlerText(i3.options.noDrag ? void 0 : l2 + E2),
              width: i3.numHandlerText(a2 + n3)
            }), i3.options.onResize(e4, i3.numHandler(p2 - E2), i3.numHandler(a2 + n3), i3.options.noDrag ? void 0 : i3.numHandler(l2 + E2), void 0);
          } else if (m2) {
            n3 = (e4.pageX - o3) / i3.options.getScale(), E2 = (e4.pageY - r2) / i3.options.getScale(), t3.css({
              height: "100%",
              width: "100%"
            }), u2.css({
              height: i3.numHandlerText(p2 - E2),
              top: i3.numHandlerText(i3.options.noDrag ? void 0 : l2 + E2),
              width: i3.numHandlerText(a2 - n3),
              left: i3.numHandlerText(i3.options.noDrag ? void 0 : s2 + n3)
            }), i3.options.onResize(e4, i3.numHandler(p2 - E2), i3.numHandler(a2 - n3), i3.options.noDrag ? void 0 : i3.numHandler(l2 + E2), i3.options.noDrag ? void 0 : i3.numHandler(s2 + n3));
          } else if (v2) {
            n3 = (e4.pageX - o3) / i3.options.getScale(), E2 = (e4.pageY - r2) / i3.options.getScale(), t3.css({ width: "100%", height: "100%" });
            if (e4.shiftKey) {
              u2.css({ width: i3.numHandlerText(a2 + n3), height: i3.numHandlerText(p2 + E2) });
              i3.options.onResize(e4, i3.numHandler(p2 + E2), i3.numHandler(a2 + n3), void 0, void 0);
            } else {
              var ratio = p2 / a2;
              var width2 = a2 + n3, height = p2 + E2;
              height = width2 * ratio;
              u2.css({ width: i3.numHandlerText(width2), height: i3.numHandlerText(height) });
              i3.options.onResize(e4, i3.numHandler(height), i3.numHandler(width2), void 0, void 0);
            }
          } else if (y2) {
            n3 = (e4.pageX - o3) / i3.options.getScale(), E2 = (e4.pageY - r2) / i3.options.getScale(), t3.css({
              width: "100%",
              height: "100%"
            }), u2.css({
              width: i3.numHandlerText(a2 - n3),
              left: i3.numHandlerText(i3.options.noDrag ? void 0 : s2 + n3),
              height: i3.numHandlerText(p2 + E2)
            }), i3.options.onResize(e4, i3.numHandler(p2 + E2), i3.numHandler(a2 - n3), i3.numHandler(otundefinedop), i3.options.noDrag ? void 0 : i3.numHandler(s2 + n3));
          } else {
            b2 && (n3 = (e4.pageX - o3) / i3.options.getScale(), E2 = (e4.pageY - r2) / i3.options.getScale(), u2.css({
              left: i3.numHandlerText(i3.options.noDrag ? void 0 : s2 + n3),
              top: i3.numHandlerText(i3.options.noDrag ? void 0 : l2 + E2)
            }), i3.options.onResize(e4, void 0, void 0, i3.options.noDrag ? void 0 : i3.numHandler(l2 + E2), i3.options.noDrag ? void 0 : i3.numHandler(s2 + n3)));
          }
        }).on("mouseup", function(t4) {
          if (d2 || c2 || h2 || f2 || g2 || m2 || y2 || v2 || b2 || rt2) {
            i3.options.onStopResize(rt2);
          }
          d2 = false, c2 = false, h2 = false, f2 = false, g2 = false, m2 = false, y2 = false, v2 = false, b2 = false, rt2 = false;
        });
      },
      bindTrigger: function bindTrigger(t3) {
        var e3 = this;
        t3.on("click", function(_n) {
          _n.stopPropagation(), e3.triggerResize(t3, _n), n2(".mouseRect").remove();
        });
      },
      bindHidePanel: function bindHidePanel(t3) {
        if (i2.maxPanelIndex < 2) {
          var e3 = this.options.stage;
          n2(e3).bind("click", function(t4) {
            if (t4.target.className && _typeof(t4.target.className) == "string" && t4.target.className.includes("design")) {
              t4.stopPropagation(), n2("div[panelindex]").css({
                display: "none"
              });
              n2("div[panelindex]").removeClass("selected");
            }
          });
        }
      }
    }, n2.fn.extend({
      hireizeable: function hireizeable(t3) {
        return this.each(function() {
          var e3, i3 = n2.data(this, "hireizeable");
          e3 = i3 ? n2.extend({}, i3.options, t3 || {}) : n2.extend({}, n2.fn.hireizeable.defaults, t3 || {});
          n2.data(this, "hireizeable", {
            options: e3
          }), new o2({
            target: this,
            onResize: function onResize(t4, e4, n3, i4, o3) {
            },
            onStopResize: function onStopResize(t4, e4, n3, i4, o3) {
            }
          });
        });
      }
    }), n2.fn.hireizeable.defaults = {
      stage: document,
      reizeUnit: "pt",
      minResize: 1.5,
      showSizeBox: true,
      showPoints: ["s", "e"],
      noContainer: false,
      onBeforeResize: function onBeforeResize(t3, e3, n3, i3, o3) {
      },
      onResize: function onResize(t3, e3, n3, i3, o3) {
      },
      onStopResize: function onStopResize(t3, e3, n3, i3, o3) {
      },
      noDrag: false
    };
  },
  function(t2, e2) {
    var n2, i2;
    hiprintJQuery, n2 = "connected", i2 = "reconnecting", window.hiwebSocket = {
      opened: false,
      name: "webSockets",
      host: "http://localhost:17521",
      token: "vue-plugin-hiprint",
      reconnectTimeout: 6e4,
      reconnectWindowSetTimeout: null,
      reconnectDelay: 2e3,
      supportsKeepAlive: function supportsKeepAlive() {
        return true;
      },
      hasIo: function hasIo(t3) {
        return false;
      },
      send: function send(t3) {
        try {
          this.socket.emit("news", t3);
        } catch (e3) {
          /* @__PURE__ */ console.log("send data error:" + (t3 || "") + JSON.stringify(e3));
        }
      },
      getPrinterList: function getPrinterList() {
        return this.printerList;
      },
      refreshPrinterList: function refreshPrinterList() {
        try {
          this.socket.emit("refreshPrinterList");
        } catch (e3) {
          /* @__PURE__ */ console.log("refreshPrinterList error:" + JSON.stringify(e3));
        }
      },
      getAddress: function getAddress(type, ...args) {
        try {
          this.socket.emit("address", type, ...args);
        } catch (e3) {
          /* @__PURE__ */ console.log("getAddress error:" + JSON.stringify(e3));
        }
      },
      ippPrint: function ippPrint2(options2) {
        try {
          this.socket.emit("ippPrint", options2);
        } catch (e3) {
          /* @__PURE__ */ console.log("ippPrint error:" + JSON.stringify(e3));
        }
      },
      ippRequest: function ippRequest2(options2) {
        try {
          this.socket.emit("ippRequest", options2);
        } catch (e3) {
          /* @__PURE__ */ console.log("ippRequest error:" + JSON.stringify(e3));
        }
      },
      setHost: function(host, cb) {
        this.host = host;
        this.stop();
        this.start(cb);
      },
      start: function start(cb) {
        var _this = this;
        var t3 = this;
        window.WebSocket ? this.socket || (this.socket = io(this.host, {
          reconnectionAttempts: 5
        }), this.socket.on("connect", function(e3) {
          t3.opened = true, /* @__PURE__ */ console.log("Websocket opened."), _this.socket.on("successs", function(t4) {
            hinnn.event.trigger("printSuccess_" + t4.templateId, t4);
          }), _this.socket.on("error", function(t4) {
            hinnn.event.trigger("printError_" + t4.templateId, t4);
          }), _this.socket.on("printerList", function(e4) {
            t3.printerList = e4;
            hinnn.event.trigger("printerList", e4);
          }), _this.socket.on("address", function(type, addr, e4) {
            hinnn.event.trigger("address_" + type, {
              addr,
              e: e4
            });
          }), _this.socket.on("ippPrinterConnected", function(printer) {
            hinnn.event.trigger("ippPrinterConnected", printer);
          }), _this.socket.on("ippPrinterCallback", function(err, res) {
            hinnn.event.trigger("ippPrinterCallback", {
              err,
              res
            });
          }), _this.socket.on("ippRequestCallback", function(err, res) {
            hinnn.event.trigger("ippRequestCallback", {
              err,
              res
            });
          }), t3.state = n2;
          cb && cb(true, e3);
        }), this.socket.on("disconnect", function() {
          t3.opened = false;
          cb && cb(false);
        })) : /* @__PURE__ */ console.log("WebSocket start fail"), cb && cb(false);
      },
      reconnect: function reconnect() {
        this.state !== n2 && this.state !== i2 || (this.stop(), this.ensureReconnectingState() && (/* @__PURE__ */ console.log("Websocket reconnecting."), this.start()));
      },
      stop: function stop() {
        this.socket && (/* @__PURE__ */ console.log("Closing the Websocket."), this.socket.close(), this.socket = null, this.printerList = []);
      },
      ensureReconnectingState: function ensureReconnectingState() {
        return this.state = i2, this.state === i2;
      }
    };
  },
  function(t2, e2, n2) {
    var i2 = n2(28);
    "string" == typeof i2 && (i2 = [[t2.i, i2, ""]]);
    var o2 = {
      hmr: true,
      transform: void 0,
      insertInto: void 0
    };
    n2(30)(i2, o2);
    i2.locals && (t2.exports = i2.locals);
  },
  function(t2, e2, n2) {
    (t2.exports = n2(29)(false)).push([t2.i, ".hicontextmenu {\r\n	position: absolute;\r\n	display: inline-block;\r\n	width: 215px;\r\n	padding: 0 0;\r\n	margin: 0;\r\n	font-family: inherit;\r\n	font-size: inherit;\r\n	list-style-type: none;\r\n	list-style: none;\r\n	background: #fff;\r\n	border: 1px solid #bebebe;\r\n	border-radius: 2px;\r\n	font-size: 13px;\r\n}\r\n\r\n.hicontextmenuroot .hicontextmenuitem {\r\n	position: relative;\r\n	-webkit-box-sizing: content-box;\r\n	-moz-box-sizing: content-box;\r\n	box-sizing: content-box;\r\n	padding: .2em 12px;\r\n	color: #2f2f2f;\r\n	-webkit-user-select: none;\r\n	-moz-user-select: none;\r\n	-ms-user-select: none;\r\n	text-decoration: none;\r\n\r\n	user-select: none;\r\n	background-color: #fff;\r\n\r\n}\r\n\r\n.hicontextmenuroot>.hicontextmenuitem:hover,\r\n.hicontextmenuroot .hicontextmenuitem > a:hover {\r\n	background-color: #f3f3f3;\r\n}\r\n\r\n.hicontextmenuroot .hicontextmenuitem>a {\r\n	text-decoration: none;\r\n	color: #363636;\r\n	line-height: 22px;\r\n\r\n}\r\n\r\n.hicontextmenuroot .hicontextsubmenu>ul {\r\n	display: none;\r\n	position: absolute;\r\n\r\n}\r\n\r\n.hicontextmenuroot .hicontextsubmenu:hover>ul {\r\n	display: block;\r\n	left: 100%;\r\n	top: -1px;\r\n	margin-left: 0px;\r\n}\r\n\r\n.hicontextmenuroot .borderBottom {\r\n	border-bottom: 1px solid #efe6e6;\r\n}\r\n\r\n.hicontextmenuroot .disable> a {\r\n  \r\n    color: #ccc;\r\n   \r\n}\r\n.hicontextmenuroot>.disable:hover,\r\n.hicontextmenuroot .disable> a:hover {\r\n	background-color:#fff;\r\n}", ""]);
  },
  function(t2, e2, n2) {
    "use strict";
    t2.exports = function(t3) {
      var e3 = [];
      return e3.toString = function() {
        return this.map(function(e4) {
          var n3 = function(t4, e5) {
            var n4 = t4[1] || "", i2 = t4[3];
            if (!i2) return n4;
            if (e5 && "function" == typeof btoa) {
              var o2 = (a2 = i2, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a2)))) + " */"), r2 = i2.sources.map(function(t5) {
                return "/*# sourceURL=" + i2.sourceRoot + t5 + " */";
              });
              return [n4].concat(r2).concat([o2]).join("\n");
            }
            var a2;
            return [n4].join("\n");
          }(e4, t3);
          return e4[2] ? "@media " + e4[2] + "{" + n3 + "}" : n3;
        }).join("");
      }, e3.i = function(t4, n3) {
        "string" == typeof t4 && (t4 = [[null, t4, ""]]);
        for (var i2 = {}, o2 = 0; o2 < this.length; o2++) {
          var r2 = this[o2][0];
          null != r2 && (i2[r2] = true);
        }
        for (o2 = 0; o2 < t4.length; o2++) {
          var a2 = t4[o2];
          null != a2[0] && i2[a2[0]] || (n3 && !a2[2] ? a2[2] = n3 : n3 && (a2[2] = "(" + a2[2] + ") and (" + n3 + ")"), e3.push(a2));
        }
      }, e3;
    };
  },
  function(t2, e2, n2) {
    var i2, o2, r2 = {}, a2 = (i2 = function i3() {
      return window && document && document.all && !window.atob;
    }, function() {
      return void 0 === o2 && (o2 = i2.apply(this, arguments)), o2;
    }), p2 = /* @__PURE__ */ function(t3) {
      var e3 = {};
      return function(t4, n3) {
        if ("function" == typeof t4) return t4();
        if (void 0 === e3[t4]) {
          var i3 = function(t5, e4) {
            return e4 ? e4.querySelector(t5) : document.querySelector(t5);
          }.call(this, t4, n3);
          if (window.HTMLIFrameElement && _instanceof(i3, window.HTMLIFrameElement))
            try {
              i3 = i3.contentDocument.head;
            } catch (t5) {
              i3 = null;
            }
          e3[t4] = i3;
        }
        return e3[t4];
      };
    }(), s2 = null, l2 = 0, u2 = [], d2 = n2(31);
    function c2(t3, e3) {
      for (var n3 = 0; n3 < t3.length; n3++) {
        var i3 = t3[n3], o3 = r2[i3.id];
        if (o3) {
          o3.refs++;
          for (var a3 = 0; a3 < o3.parts.length; a3++) {
            o3.parts[a3](i3.parts[a3]);
          }
          for (; a3 < i3.parts.length; a3++) {
            o3.parts.push(y2(i3.parts[a3], e3));
          }
        } else {
          var p3 = [];
          for (a3 = 0; a3 < i3.parts.length; a3++) {
            p3.push(y2(i3.parts[a3], e3));
          }
          r2[i3.id] = {
            id: i3.id,
            refs: 1,
            parts: p3
          };
        }
      }
    }
    function h2(t3, e3) {
      for (var n3 = [], i3 = {}, o3 = 0; o3 < t3.length; o3++) {
        var r3 = t3[o3], a3 = e3.base ? r3[0] + e3.base : r3[0], p3 = {
          css: r3[1],
          media: r3[2],
          sourceMap: r3[3]
        };
        i3[a3] ? i3[a3].parts.push(p3) : n3.push(
          i3[a3] = {
            id: a3,
            parts: [p3]
          }
        );
      }
      return n3;
    }
    function f2(t3, e3) {
      var n3 = p2(t3.insertInto);
      if (!n3) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var i3 = u2[u2.length - 1];
      if ("top" === t3.insertAt) i3 ? i3.nextSibling ? n3.insertBefore(e3, i3.nextSibling) : n3.appendChild(e3) : n3.insertBefore(e3, n3.firstChild), u2.push(e3);
      else if ("bottom" === t3.insertAt) n3.appendChild(e3);
      else {
        if ("object" != _typeof(t3.insertAt) || !t3.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o3 = p2(t3.insertAt.before, n3);
        n3.insertBefore(e3, o3);
      }
    }
    function g2(t3) {
      if (null === t3.parentNode) return false;
      t3.parentNode.removeChild(t3);
      var e3 = u2.indexOf(t3);
      e3 >= 0 && u2.splice(e3, 1);
    }
    function m2(t3) {
      var e3 = document.createElement("style");
      if (void 0 === t3.attrs.type && (t3.attrs.type = "text/css"), void 0 === t3.attrs.nonce) {
        var i3 = function() {
          0;
          return n2.nc;
        }();
        i3 && (t3.attrs.nonce = i3);
      }
      return v2(e3, t3.attrs), f2(t3, e3), e3;
    }
    function v2(t3, e3) {
      Object.keys(e3).forEach(function(n3) {
        t3.setAttribute(n3, e3[n3]);
      });
    }
    function y2(t3, e3) {
      var n3, i3, o3, r3;
      if (e3.transform && t3.css) {
        if (!(r3 = "function" == typeof e3.transform ? e3.transform(t3.css) : e3.transform.default(t3.css))) return function() {
        };
        t3.css = r3;
      }
      if (e3.singleton) {
        var a3 = l2++;
        n3 = s2 || (s2 = m2(e3)), i3 = T2.bind(null, n3, a3, false), o3 = T2.bind(null, n3, a3, true);
      } else
        t3.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n3 = function(t4) {
          var e4 = document.createElement("link");
          return void 0 === t4.attrs.type && (t4.attrs.type = "text/css"), t4.attrs.rel = "stylesheet", v2(e4, t4.attrs), f2(t4, e4), e4;
        }(e3), i3 = function(t4, e4, n4) {
          var i4 = n4.css, o4 = n4.sourceMap, r4 = void 0 === e4.convertToAbsoluteUrls && o4;
          (e4.convertToAbsoluteUrls || r4) && (i4 = d2(i4));
          o4 && (i4 += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o4)))) + " */");
          var a4 = new Blob([i4], {
            type: "text/css"
          }), p3 = t4.href;
          t4.href = URL.createObjectURL(a4), p3 && URL.revokeObjectURL(p3);
        }.bind(null, n3, e3), o3 = function o4() {
          g2(n3), n3.href && URL.revokeObjectURL(n3.href);
        }) : (n3 = m2(e3), i3 = function(t4, e4) {
          var n4 = e4.css, i4 = e4.media;
          i4 && t4.setAttribute("media", i4);
          if (t4.styleSheet) t4.styleSheet.cssText = n4;
          else {
            for (; t4.firstChild; ) {
              t4.removeChild(t4.firstChild);
            }
            t4.appendChild(document.createTextNode(n4));
          }
        }.bind(null, n3), o3 = function o4() {
          g2(n3);
        });
      return i3(t3), function(e4) {
        if (e4) {
          if (e4.css === t3.css && e4.media === t3.media && e4.sourceMap === t3.sourceMap) return;
          i3(t3 = e4);
        } else o3();
      };
    }
    t2.exports = function(t3, e3) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e3 = e3 || {}).attrs = "object" == _typeof(e3.attrs) ? e3.attrs : {}, e3.singleton || "boolean" == typeof e3.singleton || (e3.singleton = a2()), e3.insertInto || (e3.insertInto = "head"), e3.insertAt || (e3.insertAt = "bottom");
      var n3 = h2(t3, e3);
      return c2(n3, e3), function(t4) {
        for (var i3 = [], o3 = 0; o3 < n3.length; o3++) {
          var a3 = n3[o3];
          (p3 = r2[a3.id]).refs--, i3.push(p3);
        }
        t4 && c2(h2(t4, e3), e3);
        for (o3 = 0; o3 < i3.length; o3++) {
          var p3;
          if (0 === (p3 = i3[o3]).refs) {
            for (var s3 = 0; s3 < p3.parts.length; s3++) {
              p3.parts[s3]();
            }
            delete r2[p3.id];
          }
        }
      };
    };
    var b2, E2 = (b2 = [], function(t3, e3) {
      return b2[t3] = e3, b2.filter(Boolean).join("\n");
    });
    function T2(t3, e3, n3, i3) {
      var o3 = n3 ? "" : i3.css;
      if (t3.styleSheet) t3.styleSheet.cssText = E2(e3, o3);
      else {
        var r3 = document.createTextNode(o3), a3 = t3.childNodes;
        a3[e3] && t3.removeChild(a3[e3]), a3.length ? t3.insertBefore(r3, a3[e3]) : t3.appendChild(r3);
      }
    }
  },
  function(t2, e2) {
    t2.exports = function(t3) {
      var e3 = "undefined" != typeof window && window.location;
      if (!e3) throw new Error("fixUrls requires window.location");
      if (!t3 || "string" != typeof t3) return t3;
      var n2 = e3.protocol + "//" + e3.host, i2 = n2 + e3.pathname.replace(/\/[^\/]*$/, "/");
      return t3.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(t4, e4) {
        var o2, r2 = e4.trim().replace(/^"(.*)"$/, function(t5, e5) {
          return e5;
        }).replace(/^'(.*)'$/, function(t5, e5) {
          return e5;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r2) ? t4 : (o2 = 0 === r2.indexOf("//") ? r2 : 0 === r2.indexOf("/") ? n2 + r2 : i2 + r2.replace(/^\.\//, ""), "url(" + JSON.stringify(o2) + ")");
      });
    };
  },
  function(t2, e2) {
    var n2, i2;
    window, document, n2 = hiprintJQuery, (i2 = function i3(t3, e3) {
      this.init(t3, e3);
    }).prototype = {
      init: function init(t3, e3) {
        this.ele = t3, this.defaults = {
          menu: [
            {
              text: "text",
              menus: [{}, {}],
              callback: function callback() {
              }
            }
          ],
          target: function target(t4) {
          },
          width: 100,
          itemHeight: 28,
          bgColor: "#fff",
          color: "#333",
          fontSize: 14,
          hoverBgColor: "#f5f5f5"
        }, this.opts = n2.extend(true, {}, this.defaults, e3), this.random = (/* @__PURE__ */ new Date()).getTime() + parseInt(1e3 * Math.random()), this.eventBind();
      },
      renderMenu: function renderMenu(t3, e3) {
        var n3 = this, i3 = e3;
        if (t3 && t3.length) {
          var o2 = hiprintJQuery('<ul class="hicontextmenu" style="z-index: 9999;"></ul>');
          i3 || (i3 = o2).addClass("hicontextmenuroot"), hiprintJQuery.each(t3, function(t4, e4) {
            var i4 = !!e4.disable && e4.disable(), r2 = hiprintJQuery('<li class="hicontextmenuitem"><a href="javascript:void(0);"><span>' + (e4.text || "") + "</span></a></li>");
            i4 && r2.addClass("disable"), e4.borderBottom && r2.addClass("borderBottom"), e4.menus && (r2.addClass("hicontextsubmenu"), n3.renderMenu(e4.menus, r2)), e4.callback && r2.click(function(t5) {
              hiprintJQuery(this).hasClass("disable") ? t5.stopPropagation() : (hiprintJQuery(".hicontextmenuroot").remove(), e4.callback(), t5.stopPropagation());
            }), o2.append(r2);
          }), e3 && e3.append(o2);
        }
        e3 || hiprintJQuery("body").append(i3).find(".hicontextmenuroot").hide();
      },
      setPosition: function setPosition(t3) {
        hiprintJQuery(".hicontextmenuroot").css({
          left: t3.pageX + 2,
          top: t3.pageY + 2
        }).show();
      },
      eventBind: function eventBind() {
        var t3 = this;
        this.ele.on("contextmenu", function(e3) {
          hiprintJQuery(".hicontextmenuroot").remove(), e3.preventDefault(), t3.renderMenu(t3.opts.menus), t3.setPosition(e3), t3.opts.target && "function" == typeof t3.opts.target && t3.opts.target(n2(this));
        }), n2("body").on("click", function() {
          n2(".hicontextmenuroot").remove();
        });
      }
    }, n2.fn.hicontextMenu = function(t3) {
      return new i2(this, t3), this;
    };
  },
  function(t, e, n) {
    "use strict";
    n.r(e);
    n(22), n(23), n(24), n(25);
    var i, o = n(0);
    n(26);
    window.hiLocalStorage = (i = window.localStorage || null, {
      saveLocalData: function saveLocalData(t2, e2) {
        return !(!i || !e2 || (i.setItem(t2, e2), 0));
      },
      getLocalData: function getLocalData(t2) {
        return i ? i.getItem(t2) : null;
      },
      removeItem: function removeItem(t2) {
        i && i.removeItem(t2);
      }
    });
    n(27), n(32);
    var _r, a = function() {
      function t2() {
        this.allElementTypes = [];
      }
      return Object.defineProperty(t2, "instance", {
        get: function get() {
          return t2._instance || (t2._instance = new t2()), t2._instance;
        },
        enumerable: true,
        configurable: true
      }), t2.prototype.addPrintElementTypes = function(t3, e2) {
        var n2 = this;
        this[t3] ? this[t3] = this[t3].concat(e2) : this[t3] = e2, e2.forEach(function(t4) {
          n2.allElementTypes = n2.allElementTypes.concat(t4.printElementTypes);
        });
      }, t2.prototype.removePrintElementTypes = function(t3) {
        var n2 = this;
        delete n2[t3], n2.allElementTypes = n2.allElementTypes.filter(function(e2) {
          return !e2.tid.startsWith(t3);
        });
      }, t2.prototype.getElementTypeGroups = function(t3) {
        return this[this.formatterModule(t3)] || [];
      }, t2.prototype.getElementType = function(t3) {
        var e2 = this.allElementTypes.filter(function(e3) {
          return e3.tid == t3;
        });
        if (e2.length > 0) return e2[0];
      }, t2.prototype.updateElementType = function(t3, c2) {
        var type = this.getElementType(t3);
        if (c2) {
          var newType = c2(type);
          var idx = this.allElementTypes.findIndex(function(e2) {
            return e2.tid == t3;
          });
          if (idx >= 0) {
            this.allElementTypes.splice(idx, 1, newType);
            return newType;
          }
        }
        return type;
      }, t2.prototype.formatterModule = function(t3) {
        return t3 || "_default";
      }, t2;
    }(), p = n(1), s = n(2), l = function() {
      function t2() {
      }
      return t2.prototype.createPrintElementTypeHtml = function(t3, e2) {
        var n2 = hiprintJQuery('<ul class="hiprint-printElement-type"></ul>');
        return e2.forEach(function(t4) {
          var e3 = hiprintJQuery("<li></li>");
          e3.append('<span class="title">' + t4.name + "</span>");
          var i2 = hiprintJQuery("<ul></ul>");
          e3.append(i2), t4.printElementTypes.forEach(function(t5) {
            i2.append('<li><a class="ep-draggable-item" tid="' + t5.tid + '">  ' + t5.getText() + " </a></li>");
          }), n2.append(e3);
        }), hiprintJQuery(t3).append(n2), n2.find(".ep-draggable-item");
      }, t2;
    }(), u = n(5), d = n(15), c = /* @__PURE__ */ function() {
      return function(t2) {
        this.title = t2.title, this.type = t2.type;
      };
    }(), ctable = /* @__PURE__ */ function() {
      return function(t2) {
        this.title = t2.title, this.type = t2.type, this.editable = t2.editable, this.columnDisplayEditable = t2.columnDisplayEditable, this.columnDisplayIndexEditable = t2.columnDisplayIndexEditable, this.columnTitleEditable = t2.columnTitleEditable, this.columnResizable = t2.columnResizable, this.columnAlignEditable = t2.columnAlignEditable, this.isEnableEditField = t2.isEnableEditField, this.isEnableContextMenu = t2.isEnableContextMenu, this.isEnableInsertRow = t2.isEnableInsertRow, this.isEnableDeleteRow = t2.isEnableDeleteRow, this.isEnableInsertColumn = t2.isEnableInsertColumn, this.isEnableDeleteColumn = t2.isEnableDeleteColumn, this.isEnableMergeCell = t2.isEnableMergeCell;
      };
    }(), h = function() {
      function t2(t3) {
        var e2 = this;
        this.text = t3.text, this.field = t3.field, this.fields = t3.fields, this.title = t3.title, this.tid = t3.tid, this.data = t3.data, this.styler = t3.styler, this.formatter = t3.formatter, this.type = t3.type, this.options = t3.options, this.editable = t3.editable != void 0 ? t3.editable : true, this.columnDisplayEditable = t3.columnDisplayEditable != void 0 ? t3.columnDisplayEditable : true, this.columnDisplayIndexEditable = t3.columnDisplayIndexEditable != void 0 ? t3.columnDisplayIndexEditable : true, this.columnTitleEditable = t3.columnTitleEditable != void 0 ? t3.columnTitleEditable : true, this.columnResizable = t3.columnResizable != void 0 ? t3.columnResizable : true, this.columnAlignEditable = t3.columnAlignEditable != void 0 ? t3.columnAlignEditable : true, this.columns = [], (t3.columns || []).forEach(function(t4, n2) {
          e2.columns.push(e2.createTableColumnArray(t4));
        }), this.rowStyler = t3.rowStyler, this.striped = t3.striped, this.groupFields = t3.groupFields || [], this.groupFormatter = t3.groupFormatter, this.groupFooterFormatter = t3.groupFooterFormatter, this.footerFormatter = t3.footerFormatter, this.rowsColumnsMerge = t3.rowsColumnsMerge, this.rowsColumnsMergeClean = t3.rowsColumnsMergeClean, this.groupSequenceContinue = t3.groupSequenceContinue, this.gridColumnsFooterFormatter = t3.gridColumnsFooterFormatter, this.isEnableEditField = t3.isEnableEditField != void 0 ? t3.isEnableEditField : true, this.isEnableContextMenu = t3.isEnableContextMenu != void 0 ? t3.isEnableContextMenu : true, this.isEnableInsertRow = t3.isEnableInsertRow != void 0 ? t3.isEnableInsertRow : true, this.isEnableDeleteRow = t3.isEnableDeleteRow != void 0 ? t3.isEnableDeleteRow : true, this.isEnableInsertColumn = t3.isEnableInsertColumn != void 0 ? t3.isEnableInsertColumn : true, this.isEnableDeleteColumn = t3.isEnableDeleteColumn != void 0 ? t3.isEnableDeleteColumn : true, this.isEnableMergeCell = t3.isEnableMergeCell != void 0 ? t3.isEnableMergeCell : true, this.columnObj = this.makeColumnObj();
      }
      return t2.prototype.getText = function() {
        return this.text || this.title || "";
      }, t2.prototype.createPrintElement = function(t3) {
        var e2 = this;
        return this.columns && 0 == this.columns.length && (t3.columns || []).forEach(function(t4, n2) {
          e2.columns.push(e2.createTableColumnArray(t4));
        }), new d.a(this, t3);
      }, t2.prototype.getData = function() {
        return [{}];
      }, t2.prototype.createTableColumnArray = function(t3) {
        var e2 = [];
        return t3.forEach(function(t4, n2) {
          e2.push(new u.a(t4));
        }), e2;
      }, t2.prototype.getPrintElementTypeEntity = function() {
        if ("table" == this.type) {
          return new ctable({
            title: this.title,
            type: this.type,
            editable: this.editable,
            columnDisplayEditable: this.columnDisplayEditable,
            columnDisplayIndexEditable: this.columnDisplayIndexEditable,
            columnResizable: this.columnResizable,
            columnAlignEditable: this.columnAlignEditable,
            columnTitleEditable: this.columnTitleEditable,
            isEnableEditField: this.isEnableEditField,
            isEnableContextMenu: this.isEnableContextMenu,
            isEnableInsertRow: this.isEnableInsertRow,
            isEnableDeleteRow: this.isEnableDeleteRow,
            isEnableInsertColumn: this.isEnableInsertColumn,
            isEnableDeleteColumn: this.isEnableDeleteColumn,
            isEnableMergeCell: this.isEnableMergeCell
          });
        }
        return new c({
          title: this.title,
          type: this.type
        });
      }, t2.prototype.getFields = function() {
        return this.fields;
      }, t2.prototype.getOptions = function() {
        return this.options || {};
      }, t2.prototype.getColumnByColumnId = function(t3) {
        return this.columnObj[t3];
      }, t2.prototype.makeColumnObj = function(columns2) {
        var t3 = {};
        return columns2 ? columns2.forEach(function(e2) {
          (e2.id || e2.columnId) && (t3[e2.id || e2.columnId] = e2);
        }) : this.columns && this.columns.forEach(function(e2) {
          e2.forEach(function(e3) {
            (e3.id || e3.columnId) && (t3[e3.id || e3.columnId] = e3);
          });
        }), this.columnObj = t3, t3;
      }, t2;
    }(), f = n(4), g = n(3), m = (_r = function r2(t2, e2) {
      return (_r = Object.setPrototypeOf || _instanceof(
        {
          __proto__: []
        },
        Array
      ) && function(t3, e3) {
        t3.__proto__ = e3;
      } || function(t3, e3) {
        for (var n2 in e3) {
          e3.hasOwnProperty(n2) && (t3[n2] = e3[n2]);
        }
      })(t2, e2);
    }, function(t2, e2) {
      function n2() {
        this.constructor = t2;
      }
      _r(t2, e2), t2.prototype = null === e2 ? Object.create(e2) : (n2.prototype = e2.prototype, new n2());
    }), v = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new g.a(n2), i2.options.setDefault(new g.a(p.a.instance.image.default).getPrintElementOptionEntity()), i2;
      }
      return m(e2, t2), e2.prototype.getReizeableShowPoints = function() {
        return ["s", "e", "se", "r"];
      }, e2.prototype.getData = function(t3) {
        var e3 = "", f2 = this.getField();
        t3 ? e3 = f2 ? f2.split(".").reduce((a2, c2) => a2 ? a2[c2] : t3[c2], false) || "" : this.options.src || this.printElementType.getData() : e3 = this.options.src || this.printElementType.getData();
        var n2 = this.getFormatter();
        return n2 && (e3 = n2(e3, this.options, this._currenttemplateData)), e3 || "";
      }, e2.prototype.createTarget = function(t3, e3) {
        var n2 = hiprintJQuery('<div  class="hiprint-printElement hiprint-printElement-image" style="position: absolute;"><div class="hiprint-printElement-image-content" style="height:100%;width:100%"></div></div>');
        return this.updateTargetImage(n2, t3, e3), n2;
      }, e2.prototype.initSizeByHtml = function(e3) {
        t2.prototype.initSizeByHtml.call(this, e3), this.css(e3, this.getData());
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.image;
      }, e2.prototype.updateDesignViewFromOptions = function() {
        this.designTarget && (this.css(this.designTarget, this.getData()), this.updateTargetImage(this.designTarget, this.getTitle(), this.getData()));
      }, e2.prototype.updateTargetImage = function(t3, e3, n2) {
        var i2 = t3.find(".hiprint-printElement-image-content");
        i2.find("img").length ? i2.find("img").attr("src", n2) : i2.html('<img style="width:100%;height:100%;" src="' + n2 + '">');
        if (n2.length) i2.find("img").css("cssText", `width:100%;height:100%;content:url("${n2}")!important`);
        else i2.find("img").css("cssText", "width:100%;height:100%;");
        if (this.options.fit) i2.find("img").css("object-fit", this.options.fit);
        if (this.options.borderRadius) i2.find("img").css("border-radius", this.options.borderRadius);
      }, e2.prototype.getHtml = function(t3, e3, n2) {
        return this.getHtml2(t3, e3, n2);
      }, e2;
    }(f.a), y = /* @__PURE__ */ function() {
      var _t4 = function t2(e2, n2) {
        return (_t4 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t4(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), b = function(t2) {
      function e2(e3) {
        var n2 = this;
        return e3 = e3 || {}, (n2 = t2.call(this, e3) || this).leftSpaceRemoved = e3.leftSpaceRemoved, n2;
      }
      return y(e2, t2), e2.prototype.getHideTitle = function() {
        return null == this.hideTitle ? this.defaultOptions.hideTitle : this.hideTitle;
      }, e2;
    }(g.a), E = n(8), T = function() {
      function t(t2, idx, watermarkOptions, pr, scl, e2, n2, i2, r2, a2, p2, s2, s1, l2, u2, d2) {
        this.panelPageRule = pr, this.scale = scl, this.watermarkOptions = watermarkOptions, this.defaultPaperNumberFormat = "${paperNo}-${paperCount}", this.printLine = 0, this.templateId = t2, this.panelIdx = idx, this.width = o.a.mm.toPt(e2), this.height = o.a.mm.toPt(n2), this.mmwidth = e2, this.mmheight = n2, this.paperHeader = i2 >= 0 ? i2 : 0, this.paperFooter = r2, this.contentHeight = r2 - i2, this.createTarget(), this.index = u2, this.paperNumberLeft = a2 || parseInt((this.width - 30).toString()), this.paperNumberTop = p2 || parseInt((this.height - 22).toString()), this.paperNumberDisabled = s2, this.paperNumberContinue = s1, this.paperNumberFormat = l2, this.referenceElement = d2 ? hiprintJQuery.extend({}, d2) : new E.a({
          top: 0,
          left: 0,
          height: 0,
          width: 0,
          bottomInLastPaper: 0,
          beginPrintPaperIndex: 0,
          printTopInPaper: 0,
          endPrintPaperIndex: 0
        });
      }
      return t.prototype.subscribePaperBaseInfoChanged = function(t2) {
        this.onPaperBaseInfoChanged = t2;
      }, t.prototype.triggerOnPaperBaseInfoChanged = function(t2) {
        this.onPaperBaseInfoChanged && this.onPaperBaseInfoChanged({
          panelPageRule: this.panelPageRule,
          scale: this.scale,
          paperHeader: this.paperHeader,
          paperFooter: this.paperFooter,
          paperNumberLeft: this.paperNumberLeft,
          paperNumberTop: this.paperNumberTop,
          paperNumberDisabled: this.paperNumberDisabled,
          paperNumberContinue: this.paperNumberContinue,
          paperNumberFormat: this.paperNumberFormat
        });
        o.a.event.trigger("hiprintTemplateDataChanged_" + this.templateId, t2 || "\u6A21\u677F\u8C03\u6574");
      }, t.prototype.setFooter = function(t2, e2, n2, i2) {
        this.firstPaperFooter = t2, this.evenPaperFooter = e2, this.oddPaperFooter = n2, this.lastPaperFooter = i2;
      }, t.prototype.setOffset = function(t2, e2) {
        this.setLeftOffset(t2), this.setTopOffset(e2);
      }, t.prototype.setLeftOffset = function(t2) {
        t2 ? this.paperContentTarget.css("left", t2 + "pt") : this.paperContentTarget[0].style.left = "";
      }, t.prototype.setTopOffset = function(t2) {
        t2 ? this.paperContentTarget.css("top", t2 + "pt") : this.paperContentTarget[0].style.top = "";
      }, t.prototype.createTarget = function() {
        this.target = hiprintJQuery('<div class="hiprint-printPaper"><div class="hiprint-printPaper-content"></div></div>'), this.paperContentTarget = this.target.find(".hiprint-printPaper-content"), this.target.css("width", this.mmwidth + "mm"), this.target.css("height", this.mmheight - p.a.instance.paperHeightTrim + "mm"), this.target.attr("original-height", this.mmheight), this.zoom(this.scale);
      }, t.prototype.createHeaderLine = function() {
        var t2 = this;
        this.headerLinetarget = hiprintJQuery('<div class="hiprint-headerLine"  style="position: absolute;width: 100%;border-top: 1px dashed #c9bebe;height: 7pt;"></div>'), this.headerLinetarget.css("top", (this.paperHeader || -1) + "pt"), 0 == this.paperHeader && this.headerLinetarget.addClass("hideheaderLinetarget"), this.paperContentTarget.append(this.headerLinetarget), this.dragHeadLineOrFootLine(this.headerLinetarget, function(e2, n2) {
          if (n2 >= t2.paperFooter) {
            n2 = t2.paperFooter - 10;
          }
          t2.paperHeader = n2 >= 0 ? n2 : 0, t2.triggerOnPaperBaseInfoChanged();
        });
      }, t.prototype.createFooterLine = function() {
        var t2 = this;
        this.footerLinetarget = hiprintJQuery('<div class="hiprint-footerLine"  style="position: absolute;width: 100%;border-top: 1px dashed #c9bebe;height: 7pt;"></div>'), this.footerLinetarget.css("top", parseInt(this.paperFooter.toString()) + "pt"), this.paperFooter == this.height && (this.footerLinetarget.css("top", this.mmheight - p.a.instance.paperHeightTrim + "mm"), this.footerLinetarget.addClass("hidefooterLinetarget")), this.paperContentTarget.append(this.footerLinetarget), this.dragHeadLineOrFootLine(this.footerLinetarget, function(e2, n2) {
          if (n2 <= t2.paperHeader) {
            n2 = t2.paperHeader + 10;
          }
          t2.paperFooter = n2, t2.triggerOnPaperBaseInfoChanged();
        });
      }, t.prototype.createPaperNumber = function(t2, d2) {
        var e2 = this, n2 = this.target.find(".hiprint-paperNumber");
        if (n2.length) return n2.html(t2), n2;
        var i2 = hiprintJQuery('<span class="hiprint-paperNumber"  style="position: absolute">' + t2 + "</span>");
        return i2.css("top", this.paperNumberTop + "pt"), i2.css("left", this.paperNumberLeft + "pt"), this.paperContentTarget.append(i2), d2 && this.dragHeadLineOrFootLine(
          i2,
          function(t3, n3) {
            e2.paperNumberTop = n3, e2.paperNumberLeft = t3, e2.triggerOnPaperBaseInfoChanged();
          },
          true
        ), i2;
      }, t.prototype.getTarget = function() {
        return this.target;
      }, t.prototype.append = function(t2) {
        this.paperContentTarget.append(t2);
      }, t.prototype.updateReferenceElement = function(t2) {
        t2 && (this.referenceElement = t2);
      }, t.prototype.updatePrintLine = function(t2) {
        t2 >= this.printLine && (this.printLine = t2);
      }, t.prototype.design = function(t2) {
        var e2 = this;
        this.createHeaderLine(), this.createFooterLine(), this.target.addClass("design"), t2 && t2.grid && this.target.addClass("grid"), this.paperNumberTarget = this.createPaperNumber(this.formatPaperNumber(1, 1), true), this.createRuler(), this.createWaterMark(true, this.panelIdx, this.watermarkOptions), this.resetPaperNumber(this.paperNumberTarget), hiprintJQuery(this.paperNumberTarget).bind("dblclick.hiprint", function() {
          null == e2.paperNumberDisabled && (e2.paperNumberDisabled = false), e2.paperNumberDisabled = !e2.paperNumberDisabled, e2.resetPaperNumber(e2.paperNumberTarget), e2.triggerOnPaperBaseInfoChanged("\u521D\u59CB");
        }), hiprintJQuery(this.paperNumberTarget).bind("click.hiprint", function() {
          o.a.event.trigger("BuildCustomOptionSettingEventKey_" + e2.templateId, {
            options: {
              paperNumberFormat: e2.paperNumberFormat,
              paperNumberDisabled: e2.paperNumberDisabled,
              paperNumberContinue: e2.paperNumberContinue
            },
            callback: function callback(t3) {
              e2.paperNumberDisabled = !!t3.paperNumberDisabled || void 0, e2.paperNumberContinue = t3.paperNumberContinue, e2.paperNumberFormat = t3.paperNumberFormat ? t3.paperNumberFormat : void 0, e2.createPaperNumber(e2.formatPaperNumber(1, 1), true), e2.resetPaperNumber(e2.paperNumberTarget), e2.triggerOnPaperBaseInfoChanged();
            }
          });
        });
      }, t.prototype.resetPaperNumber = function(t2) {
        this.paperNumberDisabled ? t2.addClass("hiprint-paperNumber-disabled") : t2.removeClass("hiprint-paperNumber-disabled");
      }, t.prototype.updatePaperNumber = function(t2, e2, n2) {
        var i2 = this.createPaperNumber(this.formatPaperNumber(t2, e2));
        this.paperNumberDisabled ? i2.hide() : n2 && this.index % 2 == 1 && (i2[0].style.left = "", i2.css("right", this.paperNumberLeft + "pt"));
      }, t.prototype.formatPaperNumber = function(t, e) {
        this.createWaterMark(false, t, this.watermarkOptions);
        return eval("`" + (this.paperNumberFormat ? this.paperNumberFormat : this.defaultPaperNumberFormat).replace("paperNo", t).replace("paperCount", e) + "`");
      }, t.prototype.dragHeadLineOrFootLine = function(t2, e2, n2) {
        var i2 = this;
        t2.hidraggable({
          axis: n2 ? void 0 : "v",
          onDrag: function onDrag(t3, n3, i3) {
            e2(n3, i3);
          },
          moveUnit: "pt",
          minMove: p.a.instance.movingDistance,
          onBeforeDrag: function onBeforeDrag(t3) {
            s.a.instance.draging = true;
          },
          getScale: function getScale() {
            return i2.scale || 1;
          },
          onStopDrag: function onStopDrag(t3) {
            i2.headerLinetarget.css("top", i2.paperHeader + "pt");
            i2.footerLinetarget.css("top", i2.paperFooter + "pt");
            s.a.instance.draging = false, i2.footerLinetarget.removeClass("hidefooterLinetarget"), i2.headerLinetarget.removeClass("hideheaderLinetarget");
          }
        });
      }, t.prototype.resize = function(t2, e2) {
        var parperFooterRatio = this.paperFooter / this.height;
        this.width = o.a.mm.toPt(t2), this.height = o.a.mm.toPt(e2), this.mmwidth = t2, this.mmheight = e2, this.target.css("width", t2 + "mm"), this.target.css("height", e2 - p.a.instance.paperHeightTrim + "mm"), this.target.attr("original-height", this.mmheight);
        var paperFooter = this.height * parperFooterRatio;
        this.paperFooter = paperFooter || this.height, this.footerLinetarget.css("top", paperFooter + "pt"), this.contentHeight = this.paperFooter - this.paperHeader, // 设置纸张后, 页码位置重置问题
        this.paperNumberLeft = this.paperNumberLeft > this.width ? parseInt((this.width - 30).toString()) : this.paperNumberLeft;
        this.paperNumberTop = this.paperNumberTop > this.height ? this.paperNumberTop = parseInt((this.height - 22).toString()) : this.paperNumberTop;
        this.paperNumberTarget.css("top", this.paperNumberTop + "pt"), this.paperNumberTarget.css("left", this.paperNumberLeft + "pt"), this.triggerOnPaperBaseInfoChanged("\u8C03\u6574\u5927\u5C0F");
      }, t.prototype.zoom = function(s2) {
        if (s2) {
          this.scale = s2, this.target.css("transform", "scale(" + s2 + ")");
          if (s2 > 1) {
            this.target.css("transform-origin", "-" + s2 + "% -" + s2 + "%");
          } else {
            this.target.css("transform-origin", "0 0");
          }
          this.triggerOnPaperBaseInfoChanged("\u7F29\u653E");
        }
      }, t.prototype.getPaperFooter = function(t2) {
        var e2 = this.index + t2;
        return 0 == e2 ? this.firstPaperFooter ? this.firstPaperFooter : this.oddPaperFooter ? this.oddPaperFooter : this.paperFooter : e2 % 2 == 0 ? this.oddPaperFooter ? this.oddPaperFooter : this.paperFooter : e2 % 2 == 1 ? this.evenPaperFooter ? this.evenPaperFooter : this.paperFooter : void 0;
      }, t.prototype.getContentHeight = function(t2) {
        return this.getPaperFooter(t2) - this.paperHeader;
      }, t.prototype.createRuler = function() {
        this.target.append('<div class="hiprint_rul_wrapper">\n                     <img class="h_img" src="' + lImg + '" />\n                     <img class="v_img" src="' + vImg + '" />\n                    </div>');
      }, t.prototype.createWaterMark = function(watch, idx, opts) {
        var e2 = this;
        var options2 = Object.assign({}, opts || {}, {
          id: `${e2.templateId}_${e2.panelIdx}_${idx || 1}_${watch ? "design" : e2.index}`,
          watch,
          container: e2.target[0]
        });
        if (!options2.container) return;
        if (options2.content) {
          if (watch) {
            watermark.destroyWatermark(
              Object.assign({}, options2, {
                id: `${e2.templateId}_${e2.panelIdx}_${idx || 1}_${e2.index}`
              })
            );
          }
          watermark.createWatermark(options2);
        } else {
          watermark.destroyWatermark(options2);
        }
      }, t.prototype.displayHeight = function() {
        return this.mmheight - p.a.instance.paperHeightTrim + "mm";
      }, t.prototype.displayWidth = function() {
        return this.mmwidth + "mm";
      }, t.prototype.getPanelTarget = function() {
        return this.target.parent(".hiprint-printPanel ");
      }, t;
    }(), P = n(6), _ = /* @__PURE__ */ function() {
      var _t5 = function t2(e2, n2) {
        return (_t5 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t5(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), w = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new b(n2), i2.options.setDefault(new b(p.a.instance.longText.default).getPrintElementOptionEntity()), i2;
      }
      return _(e2, t2), e2.prototype.getDesignTarget = function(e3) {
        var n2 = t2.prototype.getDesignTarget.call(this, e3);
        return n2.find(".hiprint-printElement-longText-content").css("border", "1px dashed #cebcbc"), n2;
      }, e2.prototype.getProxyTarget = function(t3) {
        t3 && this.SetProxyTargetOption(t3);
        var e3 = this.getData(), n2 = this.createTarget(this.printElementType.getText(true), e3);
        return this.updateTargetSize(n2), this.css(n2, e3), n2;
      }, e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData(), e3 = this.getHtml(this.designPaper)[0].target;
          this.designTarget.find(".hiprint-printElement-longText-content").html(e3.find(".hiprint-printElement-longText-content").html()), this.css(this.designTarget, t3);
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.longText;
      }, e2.prototype.getTitle = function() {
        return this.options.title || this.printElementType.title;
      }, e2.prototype.getData = function(t3) {
        var f2 = this.getField();
        var e3 = f2 ? f2.split(".").reduce((a2, c2) => a2 ? a2[c2] : t3 ? t3[c2] : "", false) || "" : "";
        return t3 ? e3 || "" : this.options.testData || this.printElementType.getData() || "";
      }, e2.prototype.updateTargetText = function(t3, e3, n2) {
        var i2 = t3.find(".hiprint-printElement-longText-content"), o2 = this.getText(e3, n2);
        i2.html(o2);
      }, e2.prototype.createTarget = function(t3, e3) {
        var n2 = hiprintJQuery('<div  class="hiprint-printElement hiprint-printElement-longText" style="position: absolute;"><div class="hiprint-printElement-longText-content hiprint-printElement-content" style="height:100%;width:100%"></div></div>');
        return this.updateTargetText(n2, t3, e3), n2;
      }, e2.prototype.getText = function(t3, e3) {
        var n2 = this.getFormatter();
        e3 && (e3 = 0 != this.options.leftSpaceRemoved ? e3.toString().replace(/^\s*/, "") : e3);
        return (this.getField() ? (this.options.getHideTitle() ? "" : t3 ? t3 + "\uFF1A" : "") + (n2 ? n2(t3, e3, this.options, this._currenttemplateData) : e3) : n2 ? n2(t3, t3, this.options, this._currenttemplateData) : t3 || "") || "";
      }, e2.prototype.getHtml = function(t3, e3) {
        this.setCurrenttemplateData(e3), this.createTempContainer();
        var n2 = this.getPaperHtmlResult(t3, e3);
        return this.removeTempContainer(), n2;
      }, e2.prototype.getHeightByData = function(t3) {
        this.createTempContainer();
        var e3 = this.getPaperHtmlResult(new T("", "", void 0, 1e3, 1e3, 0, 25e3, 0, 0, true, true, void 0, 0, void 0), {}, t3);
        return this.removeTempContainer(), e3[0].referenceElement.bottomInLastPaper - e3[0].referenceElement.printTopInPaper;
      }, e2.prototype.getLongTextIndent = function() {
        return this.options.longTextIndent ? '<span class="long-text-indent" style="margin-left:' + this.options.longTextIndent + 'pt"></span>' : '<span class="long-text-indent"></span>';
      }, e2.prototype.getPaperHtmlResult = function(t3, e3, n2) {
        var i2 = this, o2 = [], r2 = 0, a2 = n2 || this.getData(e3), p2 = this.getText(this.getTitle(), a2), s2 = this.createTarget(this.getTitle(), this.options.testData || "");
        this.css(s2, a2), e3 ? this.updateTargetWidth(s2) : this.updateTargetSize(s2), this.getTempContainer().html(""), this.getTempContainer().append(s2);
        var l2 = [this.getLongTextIndent()], u2 = p2.split(new RegExp("\r|\n", "g"));
        if (u2.forEach(function(t4, e4) {
          var n3 = 0 != i2.options.leftSpaceRemoved ? (t4 || "").toString().replace(/^\s*/, "") : t4;
          l2 = l2.concat(n3.split("")), e4 < u2.length - 1 && l2.push("<br/>" + i2.getLongTextIndent());
        }), 0 == l2.length && (l2 = [""]), this.isHeaderOrFooter() || this.isFixed() || !e3)
          return (f2 = this.getStringBySpecificHeight(l2, 25e3, s2)).target.css("left", this.options.displayLeft()), f2.target.css("top", this.options.displayTop()), f2.target[0].height = "", o2.push(
            new P.a({
              target: f2.target,
              printLine: this.options.displayTop() + f2.height,
              referenceElement: new E.a({
                top: this.options.getTop(),
                left: this.options.getLeft(),
                height: this.options.getHeight(),
                width: this.options.getWidth(),
                beginPrintPaperIndex: t3.index,
                bottomInLastPaper: this.options.getTop() + f2.height,
                printTopInPaper: this.options.getTop()
              })
            })
          ), o2;
        for (var d2 = this.getBeginPrintTopInPaperByReferenceElement(t3); l2.length > 0; ) {
          var c2 = 0, h2 = t3.getPaperFooter(r2);
          0 == r2 && d2 > h2 && "none" != t3.panelPageRule && (d2 = d2 - h2 + t3.paperHeader, o2.push(
            new P.a({
              target: void 0,
              printLine: void 0
            })
          ), r2++, c2 = t3.getContentHeight(r2) - (d2 - t3.paperHeader), h2 = t3.getPaperFooter(r2));
          var f2 = this.getStringBySpecificHeight(l2, c2 > 0 ? c2 : 0 == r2 ? h2 - d2 : t3.getContentHeight(r2), s2);
          l2.splice(0, f2.length);
          var g2 = void 0, m2 = void 0;
          f2.target.css("left", this.options.displayLeft()), f2.target[0].height = "", 0 == r2 || c2 > 0 ? (m2 = d2, f2.target.css("top", m2 + "pt"), g2 = l2.length > 0 ? d2 + f2.height : null != this.options.lHeight ? d2 + (f2.height > this.options.lHeight ? f2.height : this.options.lHeight) : d2 + f2.height) : (m2 = t3.paperHeader, f2.target.css("top", m2 + "pt"), g2 = m2 + f2.height), o2.push(
            new P.a({
              target: f2.target,
              printLine: g2,
              referenceElement: new E.a({
                top: this.options.getTop(),
                left: this.options.getLeft(),
                height: this.options.getHeight(),
                width: this.options.getWidth(),
                beginPrintPaperIndex: t3.index,
                bottomInLastPaper: g2,
                printTopInPaper: m2
              })
            })
          ), r2++;
          e3 && this.updatePanelHeight(g2 + this.options.getHeight(), t3);
        }
        return o2;
      }, e2.prototype.getStringBySpecificHeight = function(t3, e3, n2) {
        var i2 = o.a.pt.toPx(e3);
        var r2 = void 0;
        var noPaging = "none" == this.panel.panelPageRule;
        if (noPaging) {
          r2 = this.IsPaginationIndex(t3, t3.length, -1, n2);
        } else {
          r2 = this.IsPaginationIndex(t3, t3.length - 1, i2, n2);
        }
        return r2.IsPagination ? r2 : this.BinarySearch(t3, 0, t3.length - 1, i2, n2);
      }, e2.prototype.BinarySearch = function(t3, e3, n2, i2, o2) {
        var r2 = Math.floor((e3 + n2) / 2);
        if (e3 > n2)
          return o2.find(".hiprint-printElement-longText-content").html(""), {
            IsPagination: true,
            height: 0,
            length: 0,
            target: o2.clone()
          };
        var a2 = this.IsPaginationIndex(t3, r2, i2, o2);
        return a2.IsPagination ? a2 : "l" == a2.move ? this.BinarySearch(t3, e3, r2 - 1, i2, o2) : this.BinarySearch(t3, r2 + 1, n2, i2, o2);
      }, e2.prototype.IsPaginationIndex = function(t3, e3, n2, i2) {
        if (-1 == n2) {
          i2.find(".hiprint-printElement-longText-content").html(t3.slice(0, e3).join(""));
          var a2 = i2.height();
          return {
            IsPagination: true,
            height: o.a.px.toPt(a2),
            length: t3.length,
            target: i2.clone()
          };
        }
        i2.find(".hiprint-printElement-longText-content").html(t3.slice(0, e3 + 2).join(""));
        var r2 = i2.height();
        i2.find(".hiprint-printElement-longText-content").html(t3.slice(0, e3 + 1).join(""));
        var a2 = i2.height();
        return e3 >= t3.length - 1 && a2 < n2 ? {
          IsPagination: true,
          height: o.a.px.toPt(a2),
          length: t3.length,
          target: i2.clone()
        } : a2 <= n2 && r2 >= n2 ? {
          IsPagination: true,
          height: a2,
          length: e3 + 1,
          target: i2.clone()
        } : a2 >= n2 ? {
          IsPagination: false,
          move: "l"
        } : r2 <= n2 ? {
          IsPagination: false,
          move: "r"
        } : {
          IsPagination: true,
          result: 1
        };
      }, e2;
    }(f.a), x = function() {
      function t2() {
      }
      return t2.replaceEnterAndNewline = function(t3, e2) {
        return t3.replace(new RegExp("\r|\n|/g", "g"), e2);
      }, t2.replaceTab = function(t3, e2) {
        return t3.replace(new RegExp("	/g", "g"), e2);
      }, t2.replaceEnterAndNewlineAndTab = function(t3, e2) {
        return t3.replace(new RegExp("\r|\n|	|/g", "g"), e2);
      }, t2;
    }(), C = /* @__PURE__ */ function() {
      var _t6 = function t2(e2, n2) {
        return (_t6 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t6(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), O = function(t2) {
      function e2(e3) {
        var n2 = t2.call(this, e3) || this;
        return n2.title && (n2.title = x.replaceEnterAndNewlineAndTab(n2.title, "")), n2;
      }
      return C(e2, t2), e2.prototype.getHideTitle = function() {
        return null == this.hideTitle ? this.defaultOptions.hideTitle : this.hideTitle;
      }, e2.prototype.getTextType = function() {
        return (null == this.textType ? this.defaultOptions.textType : this.textType) || "text";
      }, e2.prototype.getFontSize = function() {
        return (null == this.fontSize ? this.defaultOptions.fontSize : this.fontSize) || 9;
      }, e2.prototype.getbarcodeMode = function() {
        return (null == this.barcodeMode ? this.defaultOptions.barcodeMode : this.barcodeMode) || "CODE128";
      }, e2.prototype.getBarTextMode = function() {
        return (null == this.barTextMode ? this.defaultOptions.barTextMode : this.barTextMode) || "text";
      }, e2.prototype.getBarWidth = function() {
        return (null == this.barWidth ? this.defaultOptions.barWidth : this.barWidth) || 1;
      }, e2.prototype.getBarAutoWidth = function() {
        var _a;
        return (_a = null == this.barAutoWidth ? this.defaultOptions.barAutoWidth === "true" : this.barAutoWidth === "true") != null ? _a : true;
      }, e2.prototype.getQRcodeLevel = function() {
        let levelMap = {
          1: "L",
          0: "M",
          3: "Q",
          2: "H"
        };
        return (null == this.qrCodeLevel ? "L" : levelMap[this.qrCodeLevel]) || "L";
      }, e2;
    }(g.a), H = /* @__PURE__ */ function() {
      var _t7 = function t2(e2, n2) {
        return (_t7 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t7(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), D = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new O(n2), i2.options.setDefault(new O(p.a.instance.text.default).getPrintElementOptionEntity()), i2;
      }
      return H(e2, t2), e2.prototype.getDesignTarget = function(e3) {
        return t2.prototype.getDesignTarget.call(this, e3);
      }, e2.prototype.getProxyTarget = function(t3) {
        t3 && this.SetProxyTargetOption(t3);
        var e3 = this.getData(), n2 = this.createTarget(this.printElementType.getText(true), e3);
        return this.updateTargetSize(n2), this.css(n2, e3), n2;
      }, e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData();
          this.css(this.designTarget, t3), this.updateTargetText(this.designTarget, this.getTitle(), t3);
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.text;
      }, e2.prototype.getTitle = function() {
        var t3 = this.options.title || this.printElementType.title || "";
        return t3 && (t3 = x.replaceEnterAndNewlineAndTab(t3, "")), t3;
      }, e2.prototype.getData = function(t3) {
        var e3 = void 0;
        var f2 = this.getField();
        if (e3 = t3 ? f2 ? f2.split(".").reduce((a2, c2) => a2 ? a2[c2] : t3 ? t3[c2] : "", false) || "" : "" : this.options.testData || this.printElementType.getData() || "", this.options.format) {
          if ("datetime" == this.options.dataType) return o.a.dateFormat(e3, this.options.format);
          if ("boolean" == this.options.dataType) {
            var n2 = this.options.format.split(":");
            if (n2.length > 0) return true === e3 || "true" === e3 ? n2[0] : n2[1];
          }
        }
        return e3;
      }, e2.prototype.updateTargetText = function(t3, e3, n2, i2, rowIndex2) {
        var _a, _b;
        var r2 = this.getFormatter(), a2 = t3.find(".hiprint-printElement-text-content"), p2 = "";
        p2 = this.getField() ? (this.options.getHideTitle() ? "" : e3 ? e3 + "\uFF1A" : "") + hinnn.toUpperCase(this.options.upperCase, r2 ? r2(e3, n2, this.options, this._currenttemplateData, t3) : n2) : n2 = hinnn.toUpperCase(this.options.upperCase, r2 ? r2(e3, e3, this.options, this._currenttemplateData, t3) : e3);
        var s2 = this.options.getTextType();
        if ("text" == s2) a2.html(p2);
        else {
          if ("barcode" == s2) {
            a2.css({
              display: "flex",
              "flex-direction": "column"
            });
            var divMode = this.options.getBarTextMode() == "text";
            a2.html('<svg width="100%" display="block" height="100%" class="hibarcode_imgcode" preserveAspectRatio="none slice"></svg>');
            if (divMode) {
              a2.append(`<div class="hibarcode_displayValue" style="white-space:nowrap">`);
            }
            try {
              n2 ? (JsBarcode(a2.find(".hibarcode_imgcode")[0], n2, {
                format: this.options.getbarcodeMode(),
                width: this.options.getBarWidth(),
                textMargin: -1,
                lineColor: this.options.color || "#000000",
                margin: 0,
                height: parseInt(o.a.pt.toPx(this.options.getHeight() || 10).toString()),
                displayValue: divMode ? false : !this.options.hideTitle
              }), a2.find(".hibarcode_imgcode").attr("height", "100%"), a2.find(".hibarcode_imgcode").attr("width", "100%"), divMode && (this.options.hideTitle || a2.find(".hibarcode_displayValue").html(n2))) : a2.html("");
              let svgWidth = a2.find(".hibarcode_imgcode rect")[0].attributes.width.value;
              svgWidth = Math.ceil(hinnn.px.toPt(svgWidth * 1.05));
              if (this.options.getBarAutoWidth() && svgWidth > this.options.width) {
                a2.parent().css("width", svgWidth + "pt");
                this.options.width = svgWidth;
              }
            } catch (t4) {
              /* @__PURE__ */ console.log(t4), a2.html(`\u6B64\u683C\u5F0F\u4E0D\u652F\u6301\u8BE5\u6587\u672C`);
            }
          }
          if ("qrcode" == s2) {
            a2.html("");
            try {
              if (n2) {
                a2.css({
                  display: "flex",
                  "flex-direction": "column"
                });
                var width2 = this.options.width;
                var height = this.options.height - (!this.options.hideTitle ? (_b = this.options.lineHeight) != null ? _b : ((_a = this.options.fontSize) != null ? _a : 10.5) * 1.5 : 0);
                var box = hiprintJQuery('<div class="hiqrcode_imgcode"></div>').css({
                  width: Math.min(width2, height) + "pt",
                  height: Math.min(width2, height) + "pt",
                  margin: "auto"
                });
                new QRCode(box[0], {
                  width: "100%",
                  height: "100%",
                  colorDark: this.options.color || "#000000",
                  useSVG: true,
                  correctLevel: this.options.getQRcodeLevel(),
                  mode: 4
                }).makeCode(n2);
                a2.html(box), !this.options.hideTitle && a2.append(`<div class="hiqrcode_displayValue" style="white-space:nowrap">${n2}</div>`);
              }
            } catch (t4) {
              /* @__PURE__ */ console.log(t4), a2.html(`\u4E8C\u7EF4\u7801\u751F\u6210\u5931\u8D25`);
            }
          }
        }
      }, e2.prototype.onResize = function(e3, n2, i2, o2, r2) {
        t2.prototype.onResize.call(this, e3, n2, i2, o2, r2);
        "barcode" != this.options.getTextType() && "qrcode" != this.options.getTextType() || this.updateTargetText(this.designTarget, this.getTitle(), this.getData());
      }, e2.prototype.createTarget = function(t3, e3, n2) {
        var i2 = hiprintJQuery('<div tabindex="1" class="hiprint-printElement hiprint-printElement-text" style="position: absolute;"><div class="hiprint-printElement-text-content hiprint-printElement-content" style="height:100%;width:100%"></div></div>');
        return this.updateTargetText(i2, t3, e3, n2), i2;
      }, e2.prototype.getHtml = function(t3, e3, n2) {
        return this.getHtml2(t3, e3, n2);
      }, e2;
    }(f.a), I = /* @__PURE__ */ function() {
      var _t8 = function t2(e2, n2) {
        return (_t8 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t8(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), R = function(t2) {
      function e2(e3) {
        return t2.call(this, e3) || this;
      }
      return I(e2, t2), e2;
    }(g.a), M = /* @__PURE__ */ function() {
      var _t9 = function t2(e2, n2) {
        return (_t9 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t9(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), S = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new R(n2), i2.options.setDefault(new R(p.a.instance.html.default).getPrintElementOptionEntity()), i2;
      }
      return M(e2, t2), e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData();
          this.css(this.designTarget, t3), this.updateTargetHtml();
        }
      }, e2.prototype.updateTargetHtml = function() {
        var t3 = this.getFormatter();
        if (t3) {
          var e3 = t3(this.getData(), this.options, this._currenttemplateData);
          this.designTarget.find(".hiprint-printElement-html-content").html(e3);
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.html;
      }, e2.prototype.createTarget = function(t3, e3) {
        var n2 = hiprintJQuery('<div  class="hiprint-printElement hiprint-printElement-html" style="position: absolute;"><div class="hiprint-printElement-html-content" style="height:100%;width:100%"></div></div>'), i2 = this.getFormatter();
        if (i2) {
          var o2 = i2(this.getData(), this.options, this._currenttemplateData);
          n2.find(".hiprint-printElement-html-content").append(o2);
        } else this.options.content && n2.find(".hiprint-printElement-html-content").append(this.options.content);
        return n2;
      }, e2.prototype.getHtml = function(t3, e3, n2) {
        return this.getHtml2(t3, e3, n2);
      }, e2;
    }(f.a), B = /* @__PURE__ */ function() {
      var _t10 = function t2(e2, n2) {
        return (_t10 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t10(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), F = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new g.a(n2), i2.options.setDefault(new g.a(p.a.instance.vline.default).getPrintElementOptionEntity()), i2;
      }
      return B(e2, t2), e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData();
          this.css(this.designTarget, t3);
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.vline;
      }, e2.prototype.createTarget = function(t3, e3) {
        return hiprintJQuery('<div class="hiprint-printElement hiprint-printElement-vline" style="border-left:1px solid;position: absolute;"></div>');
      }, e2.prototype.getReizeableShowPoints = function() {
        return ["s", "r"];
      }, e2.prototype.getHtml = function(t3, e3, n2) {
        return this.getHtml2(t3, e3, n2);
      }, e2;
    }(f.a), L = /* @__PURE__ */ function() {
      var _t11 = function t2(e2, n2) {
        return (_t11 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t11(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), A = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new g.a(n2), i2.options.setDefault(new g.a(p.a.instance.hline.default).getPrintElementOptionEntity()), i2;
      }
      return L(e2, t2), e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData();
          this.css(this.designTarget, t3);
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.hline;
      }, e2.prototype.createTarget = function(t3, e3) {
        return hiprintJQuery('<div class="hiprint-printElement hiprint-printElement-hline" style="border-top:1px solid;position: absolute;"></div>');
      }, e2.prototype.getReizeableShowPoints = function() {
        return ["e", "r"];
      }, e2;
    }(f.a), z = /* @__PURE__ */ function() {
      var _t12 = function t2(e2, n2) {
        return (_t12 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t12(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), k = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new g.a(n2), i2.options.setDefault(new g.a(p.a.instance.rect.default).getPrintElementOptionEntity()), i2;
      }
      return z(e2, t2), e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData();
          this.css(this.designTarget, t3);
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.rect;
      }, e2.prototype.createTarget = function(t3, e3) {
        return hiprintJQuery('<div class="hiprint-printElement hiprint-printElement-rect" style="border:1px solid;position: absolute;"></div>');
      }, e2.prototype.getHtml = function(t3, e3, n2) {
        return this.getHtml2(t3, e3, n2);
      }, e2;
    }(f.a), N = /* @__PURE__ */ function() {
      var _t13 = function t2(e2, n2) {
        return (_t13 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t13(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), V = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new g.a(n2), i2.options.setDefault(new g.a(p.a.instance.oval.default).getPrintElementOptionEntity()), i2;
      }
      return N(e2, t2), e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData();
          this.css(this.designTarget, t3);
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.oval;
      }, e2.prototype.createTarget = function(t3, e3) {
        return hiprintJQuery('<div class="hiprint-printElement hiprint-printElement-oval" style="border:1px solid;position: absolute;border-radius: 50%;"></div>');
      }, e2.prototype.getHtml = function(t3, e3, n2) {
        return this.getHtml2(t3, e3, n2);
      }, e2;
    }(f.a), barcode = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new g.a(n2), i2.options.setDefault(new g.a(p.a.instance.barcode.default).getPrintElementOptionEntity()), i2;
      }
      return N(e2, t2), e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData();
          this.css(this.designTarget, t3), this.initBarcode(this.designTarget, this.getTitle(), this.getData());
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.barcode;
      }, e2.prototype.getBarAutoWidth = function() {
        var _a;
        return (_a = null == this.options.barAutoWidth ? this.options.defaultOptions.barAutoWidth === "true" : this.options.barAutoWidth === "true") != null ? _a : true;
      }, e2.prototype.onResize = function(e3, n2, i2, o2, r2) {
        t2.prototype.onResize.call(this, e3, n2, i2, o2, r2);
        this.initBarcode(this.designTarget, this.getTitle(), this.getData());
      }, e2.prototype.getTitle = function() {
        return this.options.title || this.printElementType.title;
      }, e2.prototype.getData = function(t3) {
        var e3 = void 0;
        var f2 = this.getField();
        e3 = t3 ? f2 ? f2.split(".").reduce((a2, c2) => a2 ? a2[c2] : t3 ? t3[c2] : "", false) || "" : "" : this.options.testData || this.printElementType.getData() || "";
        return e3;
      }, e2.prototype.initBarcode = function(designTarget, title, text) {
        var _a, _b;
        designTarget = designTarget || this.designTarget;
        var content = designTarget.find(".hiprint-printElement-barcode-content");
        try {
          const height = o.a.pt.toMm(this.options.height - (!this.options.hideTitle ? (_b = this.options.lineHeight) != null ? _b : ((_a = this.options.fontSize) != null ? _a : 10.5) * 1.5 : 0));
          var barcode2 = bwipjs.toSVG({
            bcid: this.options.barcodeType || "code128",
            text: text || this.options.testData || this.options.title,
            scale: this.options.barWidth || 1,
            width: !this.getBarAutoWidth() ? parseInt(o.a.pt.toMm(this.options.getWidth())) : "",
            height: parseInt(height),
            includetext: !this.options.hideTitle,
            barcolor: this.options.barColor || "#000"
          });
          barcode2 = hiprintJQuery(barcode2);
          barcode2.attr("preserveAspectRatio", "none slice");
          let svgWidth = barcode2[0].attributes.viewBox.value.split(" ")[2];
          svgWidth = Math.ceil(hinnn.px.toPt(svgWidth * 1.05));
          if (this.getBarAutoWidth() && svgWidth > this.options.width) {
            content.parent().css("width", svgWidth + "pt");
            barcode2.css("height", "100%");
            this.options.width = svgWidth;
          }
          content.html(barcode2);
        } catch (error) {
          console.error(error);
          content.html(hiprintJQuery(`<div>\u6761\u5F62\u7801\u751F\u6210\u5931\u8D25</div>`));
        }
      }, // 设置 barcode 元素 resize 控制点
      e2.prototype.getReizeableShowPoints = function() {
        return ["s", "e", "se", "r"];
      }, e2.prototype.createTarget = function(title, data) {
        var designTarget = hiprintJQuery('<div class="hiprint-printElement hiprint-printElement-barcode" style="position: absolute;"><div class="hiprint-printElement-barcode-content" style="height:100%;width:100%;display:flex;flex-direction:column"></div></div>');
        this.initBarcode(designTarget, title, data);
        return designTarget;
      }, e2.prototype.getHtml = function(t3, e3, n2) {
        return this.getHtml2(t3, e3, n2);
      }, e2;
    }(f.a), qrcode = function(t2) {
      function e2(e3, n2) {
        var i2 = t2.call(this, e3) || this;
        return i2.options = new g.a(n2), i2.options.setDefault(new g.a(p.a.instance.qrcode.default).getPrintElementOptionEntity()), i2;
      }
      return N(e2, t2), e2.prototype.updateDesignViewFromOptions = function() {
        if (this.designTarget) {
          var t3 = this.getData();
          this.css(this.designTarget, t3), this.initQrcode(this.designTarget, this.getTitle(), this.getData());
        }
      }, e2.prototype.getConfigOptions = function() {
        return p.a.instance.qrcode;
      }, e2.prototype.onResize = function(e3, n2, i2, o2, r2) {
        t2.prototype.onResize.call(this, e3, n2, i2, o2, r2);
        this.initQrcode(this.designTarget, this.getTitle(), this.getData());
      }, e2.prototype.getTitle = function() {
        return this.options.title || this.printElementType.title;
      }, e2.prototype.getData = function(t3) {
        var e3 = void 0;
        var f2 = this.getField();
        e3 = t3 ? f2 ? f2.split(".").reduce((a2, c2) => a2 ? a2[c2] : t3 ? t3[c2] : "", false) || "" : "" : this.options.testData || this.printElementType.getData() || "";
        return e3;
      }, e2.prototype.initQrcode = function(designTarget, title, text) {
        var _a, _b, _c;
        designTarget = designTarget || this.designTarget;
        var content = designTarget.find(".hiprint-printElement-qrcode-content");
        try {
          const width2 = o.a.pt.toPx(this.options.getWidth());
          const height = o.a.pt.toPx(this.options.height - (!this.options.hideTitle ? (_b = this.options.lineHeight) != null ? _b : ((_a = this.options.fontSize) != null ? _a : 10.5) * 1.5 : 0));
          const paddingwidth = width2 >= height ? Math.abs(parseInt((width2 - height) / 2)) : 0;
          const paddingheight = width2 >= height ? 0 : Math.abs(parseInt((height - width2) / 2));
          var qrcode2 = bwipjs.toSVG({
            bcid: this.options.qrcodeType || "qrcode",
            text: text || this.options.testData || this.options.title,
            scale: 1,
            paddingwidth,
            paddingheight,
            // 保持 qrcode 始终为正方形
            width: Math.min(parseInt(width2 / 2.835), parseInt(height / 2.835)),
            height: Math.min(parseInt(width2 / 2.835), parseInt(height / 2.835)),
            includetext: false,
            eclevel: ["M", "L", "H", "Q"][(_c = this.options.qrCodeLevel) != null ? _c : 0],
            barcolor: this.options.barColor || "#000"
          });
          content.html(hiprintJQuery(qrcode2));
          if (!this.options.hideTitle) {
            const titleText = title ? title + (text ? ":" : "") : "";
            const textAlign = this.options.textAlign || "center";
            const textStyle = textAlign === "justify" ? "text-align-last: justify;text-justify: distribute-all-lines;" : `text-align: ${textAlign};`;
            content.append(hiprintJQuery(`<div class="hiprint-printElement-qrcode-content-title" style="${textStyle}">${titleText}${text}</div>`));
          }
        } catch (error) {
          console.error(error);
          content.html(hiprintJQuery(`<div>\u4E8C\u7EF4\u7801\u751F\u6210\u5931\u8D25</div>`));
        }
      }, // 设置 qrcode 元素 resize 控制点
      e2.prototype.getReizeableShowPoints = function() {
        return ["s", "e", "se", "r"];
      }, e2.prototype.createTarget = function(title, data) {
        var designTarget = hiprintJQuery('<div class="hiprint-printElement hiprint-printElement-qrcode" style="position: absolute;"><div class="hiprint-printElement-qrcode-content" style="height:100%;width:100%;display:flex;flex-direction:column"></div></div>');
        this.initQrcode(designTarget, title, data);
        return designTarget;
      }, e2.prototype.getHtml = function(t3, e3, n2) {
        return this.getHtml2(t3, e3, n2);
      }, e2;
    }(f.a), W = function() {
      function t2() {
      }
      return t2.createPrintElement = function(t3, e2) {
        return "text" == t3.type ? new D(t3, e2) : "image" == t3.type ? new v(t3, e2) : "longText" == t3.type ? new w(t3, e2) : "table" == t3.type ? new d.a(t3, e2) : "html" == t3.type ? new S(t3, e2) : "vline" == t3.type ? new F(t3, e2) : "hline" == t3.type ? new A(t3, e2) : "rect" == t3.type ? new k(t3, e2) : "oval" == t3.type ? new V(t3, e2) : "barcode" == t3.type ? new barcode(t3, e2) : "qrcode" == t3.type ? new qrcode(t3, e2) : void 0;
      }, t2;
    }(), j = function() {
      function t2(t3) {
        this.field = t3.field, this.fields = t3.fields, this.title = t3.title, this.text = t3.text, this.tid = t3.tid, this.data = t3.data, this.styler = t3.styler, this.formatter = t3.formatter, this.type = t3.type, this.onRendered = t3.onRendered, this.options = t3.options;
      }
      return t2.prototype.getText = function(t3) {
        return t3 ? this.title || this.text || "" : this.text || this.title || "";
      }, t2.prototype.getData = function() {
        return this.data;
      }, t2.prototype.createPrintElement = function(t3) {
        var e2 = {};
        return hiprintJQuery.extend(e2, t3 || {}), W.createPrintElement(this, e2);
      }, t2.prototype.getPrintElementTypeEntity = function() {
        return new c({
          title: this.title,
          type: this.type
        });
      }, t2.prototype.getFields = function() {
        return this.fields;
      }, t2.prototype.getOptions = function() {
        return this.options || {};
      }, t2;
    }(), U = n(16), K = n(12), G = /* @__PURE__ */ function() {
      var _t14 = function t2(e2, n2) {
        return (_t14 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t14(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), q = function(t2) {
      function e2(e3) {
        var n2 = t2.call(this, e3) || this;
        (e3 = e3 || {}).columns ? (n2.columns = [], e3.columns.forEach(function(t3) {
          n2.columns.push(new K.a(t3));
        })) : n2.columns = [
          new K.a({
            columns: [
              new u.a({
                width: 100
              }),
              new u.a({
                width: 100
              })
            ]
          })
        ];
        return n2.lHeight = e3.lHeight, n2.autoCompletion = e3.autoCompletion, n2.tableFooterRepeat = e3.tableFooterRepeat, n2;
      }
      return G(e2, t2), e2.prototype.getPrintElementOptionEntity = function() {
        var e3 = t2.prototype.getPrintElementOptionEntity.call(this);
        e3.fields = this.fields;
        return e3.columns = [], this.columns.forEach(function(t3) {
          e3.columns.push(t3.getPrintElementOptionEntity());
        }), e3;
      }, e2;
    }(g.a), Q = /* @__PURE__ */ function() {
      var _t16 = function t2(e2, n2) {
        return (_t16 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t16(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), tt = /* @__PURE__ */ function() {
      var _t17 = function t2(e2, n2) {
        return (_t17 = Object.setPrototypeOf || _instanceof(
          {
            __proto__: []
          },
          Array
        ) && function(t3, e3) {
          t3.__proto__ = e3;
        } || function(t3, e3) {
          for (var n3 in e3) {
            e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
          }
        })(e2, n2);
      };
      return function(e2, n2) {
        function i2() {
          this.constructor = e2;
        }
        _t17(e2, n2), e2.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
      };
    }(), et = function(t2) {
      function e2(e3) {
        return t2.call(this, e3) || this;
      }
      return tt(e2, t2), e2.prototype.createPrintElement = function(t3) {
        var e3 = {};
        return hiprintJQuery.extend(e3, t3 || {}), W.createPrintElement(this, e3);
      }, e2.prototype.getPrintElementTypeEntity = function() {
        return new c({
          title: this.title,
          type: this.type
        });
      }, e2;
    }(j), nt = function() {
      function t2() {
      }
      return t2.createPrintElementType = function(t3) {
        return t3.type = t3.type || "text", "text" == t3.type ? new et(t3) : "table" == t3.type ? new h(t3) : new j(t3);
      }, t2;
    }(), it = function() {
      function t2() {
      }
      return t2.getElementTypeGroups = function(e2) {
        var n2 = t2.formatterModule(e2);
        return a.instance[n2] || [];
      }, t2.getElementType = function(t3, e2) {
        if (t3) return a.instance.getElementType(t3);
        nt.createPrintElementType({
          type: e2
        });
      }, t2.build = function(e2, n2) {
        var i2 = t2.formatterModule(n2), o2 = new l().createPrintElementTypeHtml(e2, this.getElementTypeGroups(i2));
        this.enableDrag(o2);
      }, t2.buildByHtml = function(t3) {
        this.enableDrag(t3);
      }, t2.enableDrag = function(e2) {
        e2.hidraggable({
          revert: true,
          proxy: function proxy(t3) {
            var e3 = s.a.instance.getDragingPrintElement(), n2 = e3.printElement.getProxyTarget(e3.printElement.printElementType.getOptions());
            return n2.appendTo("body"), n2.css("z-index", "9999"), n2;
          },
          moveUnit: "pt",
          minMove: 4,
          onBeforeDrag: function onBeforeDrag(e3) {
            s.a.instance.draging = true;
            var tid = hiprintJQuery(e3.data.target).attr("tid");
            var n2 = t2.getElementType(tid, hiprintJQuery(e3.data.target).attr("ptype"));
            if (!n2) {
              throw new Error(`\u8BF7\u68C0\u67E5 hiprint.init \u7684 provider \u662F\u5426\u914D\u7F6E\u4E86 [${tid}]`);
              return false;
            }
            var ele = n2.createPrintElement();
            if (!ele) {
              if (n2.type == "tableCustom") {
                throw new Error(`\u5DF2\u79FB\u9664"tableCustom",\u8BF7\u66FF\u6362\u4F7F\u7528"table".\u8BE6\u60C5\u89C1\u66F4\u65B0\u8BB0\u5F55`);
                return false;
              }
            }
            return s.a.instance.setDragingPrintElement(ele), true;
          },
          onDrag: function onDrag(t3, e3, n2) {
            s.a.instance.getDragingPrintElement().updatePosition(e3, n2);
          },
          onStopDrag: function onStopDrag(t3) {
            s.a.instance.draging = false;
          }
        });
      }, t2.formatterModule = function(t3) {
        return t3 || "_default";
      }, t2;
    }(), ot = /* @__PURE__ */ function() {
      return function(t2, e2) {
        var n2 = this;
        this.name = t2, this.printElementTypes = [], e2.forEach(function(t3) {
          n2.printElementTypes.push(nt.createPrintElementType(t3));
        });
      };
    }(), rt = /* @__PURE__ */ function() {
      return function(t2) {
        if (this.index = t2.index, this.name = t2.name, this.paperType = t2.paperType, this.paperType) {
          var e2 = s.a.instance[this.paperType];
          t2.height ? (this.height = t2.height, this.width = t2.width) : (this.height = e2.height, this.width = e2.width);
        } else this.height = t2.height, this.width = t2.width;
        this.paperHeader = t2.paperHeader || 0, this.paperFooter = t2.paperFooter || o.a.mm.toPt(this.height), this.printElements = t2.printElements || [], this.paperNumberLeft = t2.paperNumberLeft, this.paperNumberTop = t2.paperNumberTop, this.paperNumberDisabled = t2.paperNumberDisabled, this.paperNumberContinue = t2.paperNumberContinue, this.paperNumberFormat = t2.paperNumberFormat, this.panelPaperRule = t2.panelPaperRule, this.panelPageRule = t2.panelPageRule, this.rotate = t2.rotate || void 0, this.firstPaperFooter = t2.firstPaperFooter, this.evenPaperFooter = t2.evenPaperFooter, this.oddPaperFooter = t2.oddPaperFooter, this.lastPaperFooter = t2.lastPaperFooter, this.topOffset = t2.topOffset, this.fontFamily = t2.fontFamily, this.leftOffset = t2.leftOffset, this.orient = t2.orient, this.scale = t2.scale, this.watermarkOptions = t2.watermarkOptions, this.panelLayoutOptions = t2.panelLayoutOptions;
      };
    }(), at = function() {
      function t2(t3, e2, n2, i2) {
        this.bx = t3, this.by = e2, this.ex = t3, this.ey = e2, this.startX = this.minX = t3, this.startY = this.minY = e2, this.maxX = t3, this.maxY = e2, this.lastLeft = n2, this.lastTop = i2;
      }
      return t2.prototype.updateRect = function(t3, e2, i2) {
        var scale = i2.designPaper.scale || 1;
        this.ex = t3;
        this.ey = e2;
        this.minX = this.startX / scale < t3 / scale ? this.startX / scale : t3 / scale, this.minY = this.startY / scale < e2 / scale ? this.startY / scale : e2 / scale, this.maxX = this.startX / scale < t3 / scale ? t3 / scale : this.startX / scale, this.maxY = this.startY / scale < e2 / scale ? e2 / scale : this.startY / scale;
      }, t2.prototype.updatePositionByMultipleSelect = function(t3, e2) {
        null != t3 && (this.lastLeft = this.lastLeft + t3), null != e2 && (this.lastTop = this.lastTop + e2), this.target.css({
          left: this.lastLeft + "pt",
          top: this.lastTop + "pt"
        });
      }, t2;
    }(), pt = function() {
      function t2(t3, e2) {
        this.templateId = e2, this.index = t3.index, this.name = t3.name, this.width = t3.width, this.height = t3.height, this.paperType = t3.paperType, this.paperHeader = t3.paperHeader, this.paperFooter = t3.paperFooter, this.initPrintElements(t3.printElements), this.paperNumberLeft = t3.paperNumberLeft, this.paperNumberTop = t3.paperNumberTop, this.paperNumberDisabled = t3.paperNumberDisabled, this.paperNumberContinue = t3.paperNumberContinue == void 0 ? true : t3.paperNumberContinue, this.paperNumberFormat = t3.paperNumberFormat, this.panelPaperRule = t3.panelPaperRule, this.panelPageRule = t3.panelPageRule, this.firstPaperFooter = t3.firstPaperFooter, this.evenPaperFooter = t3.evenPaperFooter, this.oddPaperFooter = t3.oddPaperFooter, this.lastPaperFooter = t3.lastPaperFooter, this.topOffset = t3.topOffset, this.leftOffset = t3.leftOffset, this.fontFamily = t3.fontFamily, this.orient = t3.orient, this.target = this.createTarget(), this.rotate = t3.rotate, this.scale = t3.scale, this.watermarkOptions = t3.watermarkOptions || {}, this.panelLayoutOptions = t3.panelLayoutOptions || {};
      }
      return t2.prototype.design = function(t3) {
        var e2 = this;
        this.orderPrintElements(), this.designPaper = this.createNewPage(0), this.target.html(""), this.target.append(this.designPaper.getTarget()), this.droppablePaper(this.designPaper), this.designPaper.design(t3), this.designPaper.subscribePaperBaseInfoChanged(function(t4) {
          e2.paperHeader = t4.paperHeader, e2.paperFooter = t4.paperFooter, e2.paperNumberLeft = t4.paperNumberLeft, e2.paperNumberTop = t4.paperNumberTop, e2.paperNumberDisabled = t4.paperNumberDisabled, e2.paperNumberFormat = t4.paperNumberFormat;
        }), this.printElements.forEach(function(n2) {
          e2.appendDesignPrintElement(e2.designPaper, n2), n2.design(t3, e2.designPaper);
        }), this.target.bind("click.hiprint", function(t4) {
          let panelOptions = {
            panelPaperRule: e2.panelPaperRule,
            panelPageRule: e2.panelPageRule,
            firstPaperFooter: e2.firstPaperFooter,
            evenPaperFooter: e2.evenPaperFooter,
            oddPaperFooter: e2.oddPaperFooter,
            lastPaperFooter: e2.lastPaperFooter,
            leftOffset: e2.leftOffset,
            topOffset: e2.topOffset,
            panelLayoutOptions: e2.panelLayoutOptions || {},
            fontFamily: e2.fontFamily,
            orient: e2.orient,
            paperNumberDisabled: e2.paperNumberDisabled,
            paperNumberContinue: e2.paperNumberContinue,
            paperNumberFormat: e2.paperNumberFormat,
            watermarkOptions: e2.watermarkOptions || {}
          };
          if (!p.a.instance.paperNumberContinue) {
            delete panelOptions["paperNumberContinue"];
          }
          o.a.event.trigger("BuildCustomOptionSettingEventKey_" + e2.templateId, {
            options: panelOptions,
            callback: function callback(t5) {
              e2.panelLayoutOptions = t5.panelLayoutOptions || {}, e2.watermarkOptions = t5.watermarkOptions || void 0, t5.watermarkOptions && e2.designPaper.createWaterMark(true, 1, t5.watermarkOptions);
              e2.panelPaperRule = t5.panelPaperRule, e2.panelPageRule = t5.panelPageRule, e2.firstPaperFooter = t5.firstPaperFooter, e2.evenPaperFooter = t5.evenPaperFooter, e2.oddPaperFooter = t5.oddPaperFooter, e2.lastPaperFooter = t5.lastPaperFooter, e2.leftOffset = t5.leftOffset, e2.topOffset = t5.topOffset, e2.fontFamily = t5.fontFamily, e2.orient = t5.orient, e2.paperNumberDisabled = e2.designPaper.paperNumberDisabled = !!t5.paperNumberDisabled || void 0, e2.paperNumberContinue = e2.designPaper.paperNumberContinue = t5.paperNumberContinue, e2.paperNumberFormat = t5.paperNumberFormat, e2.designPaper.paperNumberFormat = t5.paperNumberFormat, t5.paperNumberFormat && (e2.designPaper.paperNumberTarget = e2.designPaper.createPaperNumber(e2.designPaper.formatPaperNumber(1, 1), true)), e2.designPaper.setOffset(e2.leftOffset, e2.topOffset), e2.css(e2.target), e2.designPaper.resetPaperNumber(e2.designPaper.paperNumberTarget), e2.designPaper.triggerOnPaperBaseInfoChanged();
            }
          });
        }), this.bindShortcutKeyEvent();
        this.bingPasteEvent();
        this.bindBatchMoveElement();
      }, t2.prototype.update = function(t3) {
        try {
          var start = Date.now();
          /* @__PURE__ */ console.log("start", start);
          var e2 = this;
          this.index = t3.index, this.name = t3.name, this.width = t3.width, this.height = t3.height, this.paperType = t3.paperType, this.paperHeader = t3.paperHeader, this.paperFooter = t3.paperFooter;
          this.designPaper.width = o.a.mm.toPt(t3.width), this.designPaper.height = o.a.mm.toPt(this.height), this.designPaper.paperType = this.paperType, this.designPaper.paperHeader = this.paperHeader, this.designPaper.paperFooter = this.paperFooter;
          this.designPaper.mmheight = t3.height, this.designPaper.mmwidth = t3.width;
          this.designPaper.headerLinetarget.css("top", (this.paperHeader || -1) + "pt"), 0 == this.paperHeader && this.designPaper.headerLinetarget.addClass("hideheaderLinetarget");
          this.designPaper.footerLinetarget.css("top", parseInt(this.paperFooter.toString()) + "pt"), this.paperFooter == this.height && this.designPaper.footerLinetarget.css("top", t3.height - p.a.instance.paperHeightTrim + "mm");
          this.watermarkOptions = t3.watermarkOptions || {};
          this.designPaper.createWaterMark(true, this.index, this.watermarkOptions);
          this.paperNumberLeft = t3.paperNumberLeft, this.paperNumberTop = t3.paperNumberTop, this.paperNumberDisabled = t3.paperNumberDisabled, this.paperNumberContinue = t3.paperNumberContinue, this.paperNumberFormat = t3.paperNumberFormat;
          this.designPaper.paperNumberLeft = this.paperNumberLeft, this.designPaper.paperNumberTop = this.paperNumberTop, this.designPaper.paperNumberDisabled = this.paperNumberDisabled, this.designPaper.paperNumberContinue = this.paperNumberContinue, this.designPaper.paperNumberFormat = this.paperNumberFormat;
          this.designPaper.paperNumberTarget.css("top", this.paperNumberTop + "pt").css("left", this.paperNumberLeft + "pt"), this.designPaper.resetPaperNumber(this.designPaper.paperNumberTarget);
          this.fontFamily = t3.fontFamily, this.orient = t3.orient, this.rotate = t3.rotate, this.scale = t3.scale;
          this.designPaper.fontFamily = this.fontFamily, this.designPaper.orient = this.orient, this.designPaper.scale = e2.designPaper.scale || this.scale;
          this.panelLayoutOptions = t3.panelLayoutOptions, this.panelPaperRule = t3.panelPaperRule, this.panelPageRule = t3.panelPageRule, this.firstPaperFooter = t3.firstPaperFooter, this.evenPaperFooter = t3.evenPaperFooter, this.oddPaperFooter = t3.oddPaperFooter, this.lastPaperFooter = t3.lastPaperFooter, this.topOffset = t3.topOffset, this.leftOffset = t3.leftOffset;
          this.designPaper.setFooter(this.firstPaperFooter, this.evenPaperFooter, this.oddPaperFooter, this.lastPaperFooter), this.designPaper.setOffset(this.leftOffset, this.topOffset);
          this.target.css("width", t3.width + "mm"), this.target.css("height", t3.height - p.a.instance.paperHeightTrim + "mm"), this.target.attr("original-height", t3.height), this.target.parent().css("width", t3.width + "mm"), this.target.parent().css("height", t3.height - p.a.instance.paperHeightTrim + "mm"), this.designPaper.target.css("width", t3.width + "mm"), this.designPaper.target.css("height", t3.height - p.a.instance.paperHeightTrim + "mm");
          var end = Date.now();
          /* @__PURE__ */ console.log("\u66F4\u65B0\u53C2\u6570 end", end);
          /* @__PURE__ */ console.log("\u66F4\u65B0\u53C2\u6570 time:", end - start);
          this.printElements.forEach(function(t4) {
            t4.designTarget && t4.designTarget.length && t4.designTarget.remove();
          }), this.printElements = [];
          var end = Date.now();
          /* @__PURE__ */ console.log("\u6E05\u7A7A\u9762\u677F end", end);
          /* @__PURE__ */ console.log("\u6E05\u7A7A\u9762\u677F time:", end - start);
          this.initPrintElements(t3.printElements);
          var end = Date.now();
          /* @__PURE__ */ console.log("\u521D\u59CB\u5316\u5143\u7D20 end", end);
          /* @__PURE__ */ console.log("\u521D\u59CB\u5316\u5143\u7D20 time:", end - start);
          this.printElements.forEach(function(n2) {
            e2.appendDesignPrintElement(e2.designPaper, n2), n2.design(t3, e2.designPaper);
          });
          var end = Date.now();
          /* @__PURE__ */ console.log("\u63D2\u5165\u9762\u677F end", end);
          /* @__PURE__ */ console.log("\u63D2\u5165\u9762\u677F time:", end - start);
        } catch (e3) {
          /* @__PURE__ */ console.log("???????");
          /* @__PURE__ */ console.log(e3);
        }
      }, t2.prototype.bindShortcutKeyEvent = function() {
        var n2 = this;
        hiprintJQuery(document).keydown(function(e2) {
          if ("INPUT" == e2.target.tagName) return;
          if ((e2.ctrlKey || e2.metaKey) && 90 == e2.keyCode) {
            if (e2.shiftKey) {
              o.a.event.trigger("hiprintTemplateDataShortcutKey_" + n2.templateId, "redo");
            } else {
              o.a.event.trigger("hiprintTemplateDataShortcutKey_" + n2.templateId, "undo");
            }
            e2.preventDefault();
          }
        });
      }, t2.prototype.bingPasteEvent = function() {
        var n2 = this;
        n2.designPaper.target.attr("tabindex", "1");
        n2.designPaper.target.keydown(function(e2) {
          if ("INPUT" == e2.target.tagName) return;
          if ((e2.ctrlKey || e2.metaKey) && 86 == e2.keyCode) {
            n2.pasteJson(e2);
            e2.preventDefault();
          }
        });
      }, t2.prototype.pasteJson = function(e2) {
        var copyArea = hiprintJQuery("#copyArea");
        if (!copyArea.length) return;
        try {
          var json = copyArea.text();
          var objList = JSON.parse(json);
          let operationPasterPosition = null;
          let replacePosition = null;
          var left = null;
          var top = null;
          objList.forEach((obj, index) => {
            if (!obj.printElementType && !obj.templateId) return;
            var n2 = this, r2 = obj.options, ele = n2.getElementById(obj.id);
            if (!ele) return;
            var a2 = ele.clone(obj);
            if (!a2) return;
            if (index === 0) {
              operationPasterPosition = {
                x: obj.options.left,
                y: obj.options.top
              };
              var useMouse = e2.currentTarget.className != e2.target.className;
              left = !useMouse && n2.mouseOffsetX && o.a.px.toPt(n2.mouseOffsetX) || (r2.left += 10);
              top = !useMouse && n2.mouseOffsetY && o.a.px.toPt(n2.mouseOffsetY) || (r2.top += 10);
              replacePosition = {
                x: left,
                y: top
              };
            } else {
              const position = {
                x: obj.options.left,
                y: obj.options.top
              };
              const incrementPosition = {
                x: position.x - operationPasterPosition.x,
                y: position.y - operationPasterPosition.y
              };
              left = replacePosition.x + incrementPosition.x;
              top = replacePosition.y + incrementPosition.y;
            }
            a2.options.setLeft(left);
            a2.options.setTop(top);
            a2.setTemplateId(n2.templateId), a2.setPanel(n2);
            n2.appendDesignPrintElement(n2.designPaper, a2, false);
            const template = s.a.instance.getPrintTemplateById(n2.templateId);
            if (a2.options.field && template.qtDesigner) {
              a2.options.qid = template.qtDesignderFunction(a2.options.field);
            }
            n2.printElements.push(a2), a2.design(void 0, n2.designPaper);
            /* @__PURE__ */ console.log("pasteJson success");
            o.a.event.trigger("hiprintTemplateDataChanged_" + n2.templateId, "\u590D\u5236");
            ele.designTarget.trigger(hiprintJQuery.Event("blur"));
            a2.designTarget.children(".resize-panel").trigger(hiprintJQuery.Event("click"));
            a2.designTarget.trigger(hiprintJQuery.Event("focus"));
          });
        } catch (e3) {
          console.error("pasteJson error", e3);
        }
      }, t2.prototype.css = function(t3) {
        if (this.fontFamily) t3.css("fontFamily", this.fontFamily);
        else t3[0].style.fontFamily = "";
      }, t2.prototype.getConfig = function() {
        return p.a.instance;
      }, t2.prototype.getHtml = function(t3, e2, n2, i2, o2) {
        var r2 = this;
        this.orderPrintElements();
        let config = r2.getConfig();
        var a2, p2 = n2 || [], s2 = i2 || this, l2 = void 0;
        if (i2) {
          l2 = p2[p2.length - 1];
          a2 = l2.getPanelTarget();
          l2.updateReferenceElement(
            new E.a({
              top: this.paperHeader,
              left: 0,
              height: 0,
              width: 0,
              bottomInLastPaper: l2.referenceElement.bottomInLastPaper,
              beginPrintPaperIndex: p2.length - 1,
              printTopInPaper: l2.referenceElement.bottomInLastPaper,
              endPrintPaperIndex: p2.length - 1
            })
          );
        } else {
          a2 = s2.createTarget();
          l2 = s2.createNewPage(p2.length);
          p2.push(l2);
          a2.append(l2.getTarget());
        }
        this.printElements.filter(function(t4) {
          return !t4.isFixed() && !t4.isHeaderOrFooter();
        }).forEach(function(e3) {
          var n3 = [], i3 = p2[p2.length - 1];
          if (i3.referenceElement.isPositionLeftOrRight(e3.options.getTop())) {
            l2 = p2[i3.referenceElement.beginPrintPaperIndex];
          } else {
            l2 = p2[i3.referenceElement.endPrintPaperIndex];
          }
          n3 = e3.getHtml(l2, t3);
          n3.forEach(function(t4, i4) {
            t4.referenceElement && (t4.referenceElement.endPrintPaperIndex = t4.referenceElement.beginPrintPaperIndex + n3.length - 1);
            if (i4 > 0) {
              if (l2.index < p2.length - 1) {
                l2 = p2[l2.index + 1];
              } else {
                l2 = s2.createNewPage(p2.length, l2.referenceElement);
                p2.push(l2);
              }
              a2.append(l2.getTarget());
            }
            t4.target && ("none" != e3.options.showInPage && l2.append(t4.target), l2.updatePrintLine(t4.printLine), e3.onRendered(l2, t4.target));
            i4 == n3.length - 1 && t4.referenceElement && l2.updateReferenceElement(t4.referenceElement);
          });
        });
        o2 && o2.templates.forEach(function(t4, e3) {
          var i3 = t4.data || {}, o3 = t4.options || {};
          t4.template.printPanels.forEach(function(t5) {
            t5.getHtml(i3, o3, n2, r2);
          });
        });
        if (config.paperNumberContinue) {
          if (r2.paperNumberContinue) {
            hinnn._paperList = [...hinnn._paperList || [], ...p2];
          } else {
            hinnn._paperList = [...p2];
          }
        }
        if (!i2) {
          if (this.lastPaperFooter) p2[p2.length - 1].printLine > this.lastPaperFooter && (l2 = s2.createNewPage(p2.length, l2.referenceElement), p2.push(l2), a2.append(l2.getTarget()));
          this.panelPaperRule && ("odd" == this.panelPaperRule && p2.length % 2 == 0 && (l2 = s2.createNewPage(p2.length, l2.referenceElement), p2.push(l2), a2.append(l2.getTarget())), "even" == this.panelPaperRule && p2.length % 2 == 1 && (l2 = s2.createNewPage(p2.length, l2.referenceElement), p2.push(l2), a2.append(l2.getTarget())));
          p2.forEach(function(n3) {
            n3.updatePaperNumber(n3.index + 1, p2.length, e2.paperNumberToggleInEven), r2.fillPaperHeaderAndFooter(n3, t3, p2.length), e2 && (null != e2.leftOffset && n3.setLeftOffset(e2.leftOffset), null != e2.topOffset && n3.setTopOffset(e2.topOffset));
          });
          a2.prepend(this.getPrintStyle());
          if (config.paperNumberContinue) {
            hinnn._paperList.forEach(function(n3, index) {
              n3.updatePaperNumber(index + 1, hinnn._paperList.length);
            });
          }
        }
        return a2;
      }, t2.prototype.resize = function(t3, e2, n2, i2) {
        this.width = e2, this.height = n2, this.paperType = t3, this.rotate = i2, this.designPaper.resize(e2, n2);
      }, t2.prototype.rotatePaper = function() {
        null == this.rotate && (this.rotate = false), this.rotate = !this.rotate, this.resize(this.paperType, this.height, this.width, this.rotate);
      }, t2.prototype.zoom = function(s2, p2) {
        if (p2) {
          this.scale = s2;
        } else {
          this.scale = void 0;
        }
        this.designPaper.zoom(s2);
      }, t2.prototype.getTarget = function() {
        return this.target;
      }, t2.prototype.enable = function() {
        this.target.removeClass("hipanel-disable");
      }, t2.prototype.disable = function() {
        this.target.addClass("hipanel-disable");
      }, t2.prototype.getPanelEntity = function(t3) {
        var e2 = [];
        return this.printElements.forEach(function(n2) {
          e2.push(n2.getPrintElementEntity(t3));
        }), new rt({
          index: this.index,
          name: this.name || this.index + 1,
          width: this.width,
          height: this.height,
          paperType: this.paperType,
          paperHeader: this.paperHeader,
          paperFooter: this.paperFooter,
          paperNumberDisabled: !!this.paperNumberDisabled || void 0,
          paperNumberContinue: this.paperNumberContinue == void 0 ? true : this.paperNumberContinue,
          paperNumberFormat: this.paperNumberFormat ? this.paperNumberFormat : void 0,
          panelPaperRule: this.panelPaperRule ? this.panelPaperRule : void 0,
          panelPageRule: this.panelPageRule ? this.panelPageRule : void 0,
          paperNumberLeft: this.paperNumberLeft,
          paperNumberTop: this.paperNumberTop,
          printElements: e2,
          rotate: this.rotate,
          firstPaperFooter: this.firstPaperFooter,
          evenPaperFooter: this.evenPaperFooter,
          oddPaperFooter: this.oddPaperFooter,
          lastPaperFooter: this.lastPaperFooter,
          topOffset: this.topOffset,
          fontFamily: this.fontFamily,
          orient: this.orient,
          scale: this.scale,
          watermarkOptions: this.watermarkOptions ? this.watermarkOptions : void 0,
          leftOffset: this.leftOffset,
          panelLayoutOptions: this.panelLayoutOptions || {}
        });
      }, t2.prototype.createTarget = function() {
        var t3 = hiprintJQuery('<div class="hiprint-printPanel panel-index-' + this.index + '"></div>');
        return this.css(t3), t3;
      }, t2.prototype.droppablePaper = function(t3) {
        var e2 = this;
        t3.getTarget().hidroppable({
          accept: ".ep-draggable-item",
          onDrop: function onDrop(n2, i2) {
            const template = s.a.instance.getPrintTemplateById(e2.templateId);
            var r2 = s.a.instance.getDragingPrintElement(), a2 = r2.printElement;
            var ptr = e2.designPaper.scale || 1;
            var left = (r2.left - o.a.px.toPt(e2.target.children(".hiprint-printPaper").offset().left)) / ptr, top = (r2.top - o.a.px.toPt(e2.target.children(".hiprint-printPaper").offset().top)) / ptr;
            a2.updateSizeAndPositionOptions(e2.mathroundToporleft(left), e2.mathroundToporleft(top));
            a2.setTemplateId(e2.templateId), a2.setPanel(e2), e2.appendDesignPrintElement(e2.designPaper, a2, true);
            if (a2.options.field && template.qtDesigner) {
              a2.options.qid = template.qtDesignderFunction(a2.options.field);
            }
            e2.printElements.push(a2), a2.design(void 0, t3);
            o.a.event.trigger("hiprintTemplateDataChanged_" + e2.templateId, "\u65B0\u589E");
          }
        });
      }, t2.prototype.initPrintElements = function(t3) {
        var e2 = this;
        this.printElements = [], t3 && t3.forEach(function(n2) {
          var i2;
          if (i2 = n2.printElementType ? nt.createPrintElementType(n2.printElementType) : a.instance.getElementType(n2.tid)) {
            var o2 = i2.createPrintElement(n2.options);
            o2.setTemplateId(e2.templateId), o2.setPanel(e2), e2.printElements.push(o2);
          } else /* @__PURE__ */ console.log("miss " + JSON.stringify(t3));
        });
      }, t2.prototype.mathroundToporleft = function(t3) {
        var e2 = p.a.instance.movingDistance;
        return Math.round(t3 / e2) * e2;
      }, t2.prototype.appendDesignPrintElement = function(t3, e2, n2) {
        e2.setCurrenttemplateData(void 0);
        var i2 = e2.getDesignTarget(t3);
        i2.addClass("design"), n2 && e2.initSizeByHtml(i2), t3.append(i2);
      }, t2.prototype.createNewPage = function(t3, e2) {
        var n2 = new T(this.templateId, this.index, this.watermarkOptions, this.panelPageRule, this.scale, this.width, this.height, this.paperHeader, this.paperFooter, this.paperNumberLeft, this.paperNumberTop, this.paperNumberDisabled, this.paperNumberContinue, this.paperNumberFormat, t3, e2);
        return n2.setFooter(this.firstPaperFooter, this.evenPaperFooter, this.oddPaperFooter, this.lastPaperFooter), n2.setOffset(this.leftOffset, this.topOffset), n2;
      }, t2.prototype.orderPrintElements = function() {
        this.printElements = o.a.orderBy(this.printElements, function(t3) {
          return t3.options.getLeft();
        }), this.printElements = o.a.orderBy(this.printElements, function(t3) {
          return t3.options.getTop();
        });
      }, t2.prototype.fillPaperHeaderAndFooter = function(t3, e2, n2) {
        this.printElements.filter(function(t4) {
          return t4.isFixed() || t4.isHeaderOrFooter();
        }).forEach(function(i2) {
          if (i2.isFixed(), i2.showInPage(t3.index, n2)) {
            var o2 = i2.getHtml(t3, e2);
            o2.length && t3.append(o2[0].target);
          }
        });
      }, t2.prototype.clear = function() {
        this.printElements.forEach(function(t3) {
          t3.designTarget && t3.designTarget.length && t3.designTarget.remove();
        }), this.printElements = [];
        o.a.event.trigger("hiprintTemplateDataChanged_" + this.templateId, "\u6E05\u7A7A");
      }, t2.prototype.insertPrintElementToPanel = function(t3) {
        var e2 = this.getPrintElementTypeByEntity(t3);
        if (e2) {
          var n2 = e2.createPrintElement(t3.options);
          n2.setTemplateId(this.templateId), n2.setPanel(this), this.printElements.push(n2);
        }
      }, t2.prototype.addPrintText = function(t3) {
        t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "text", this.insertPrintElementToPanel(t3);
      }, t2.prototype.addPrintHtml = function(t3) {
        t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "html", this.insertPrintElementToPanel(t3);
      }, t2.prototype.addPrintTable = function(t3) {
        if (t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "table", t3.options && t3.options.columns) {
          var e2 = hiprintJQuery.extend({}, t3.options.columns);
          t3.printElementType.columns = e2.columns, e2.columns = void 0;
        }
        this.insertPrintElementToPanel(t3);
      }, t2.prototype.addPrintImage = function(t3) {
        t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "image", this.insertPrintElementToPanel(t3);
      }, t2.prototype.addPrintLongText = function(t3) {
        t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "longText", this.insertPrintElementToPanel(t3);
      }, t2.prototype.addPrintVline = function(t3) {
        t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "vline", this.insertPrintElementToPanel(t3);
      }, t2.prototype.addPrintHline = function(t3) {
        t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "hline", this.insertPrintElementToPanel(t3);
      }, t2.prototype.addPrintRect = function(t3) {
        t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "rect", this.insertPrintElementToPanel(t3);
      }, t2.prototype.addPrintOval = function(t3) {
        t3.printElementType = t3.printElementType || {}, t3.printElementType.type = "oval", this.insertPrintElementToPanel(t3);
      }, t2.prototype.getPrintElementTypeByEntity = function(t3) {
        var e2;
        return (e2 = t3.tid ? a.instance.getElementType(t3.tid) : nt.createPrintElementType(t3.printElementType)) || /* @__PURE__ */ console.log("miss " + JSON.stringify(t3)), e2;
      }, t2.prototype.getPrintStyle = function() {
        return " <style printStyle>\n        @page\n        {\n             border:0;\n             padding:0cm;\n             margin:0cm;\n             " + this.getPrintSizeStyle() + "\n        }\n        </style>\n";
      }, t2.prototype.getPrintSizeStyle = function() {
        return this.paperType ? "size:" + this.paperType + " " + (this.height > this.width ? "portrait" : "landscape") + ";" : "size: " + this.width + "mm " + this.height + "mm " + (this.orient ? 1 == this.orient ? "portrait" : "landscape" : "") + ";";
      }, t2.prototype.deletePrintElement = function(t3) {
        var e2 = this;
        this.printElements.filter(function(n2, i2) {
          n2.id == t3.id && (t3.delete(), e2.printElements.splice(i2, 1));
        });
      }, t2.prototype.getElementByTid = function(t3) {
        return this.printElements.filter(function(e2) {
          return e2.printElementType.tid === t3;
        }).map(function(t4, e2) {
          return t4;
        });
      }, t2.prototype.getElementByName = function(t3) {
        return this.printElements.filter(function(e2) {
          return e2.options.name === t3;
        }).map(function(t4, e2) {
          return t4;
        });
      }, t2.prototype.getElementById = function(t3) {
        return this.printElements.find(function(e2) {
          return e2.id === t3;
        });
      }, t2.prototype.getFieldsInPanel = function() {
        var t3 = [];
        return this.printElements.forEach(function(e2) {
          e2.options && e2.options.field ? t3.push(e2.options.field) : e2.printElementType.field && t3.push(e2.printElementType.field);
        }), t3;
      }, t2.prototype.getTestData = function() {
        var t3 = {};
        return this.printElements.forEach(function(e2) {
          if ("table" != e2.printElementType.type) {
            e2.options && e2.options.field ? t3[e2.options.field] = e2.options.testData : e2.printElementType.field ? t3[e2.printElementType.field] = e2.printElementType.data || e2.options.testData : void 0;
          }
        }), t3;
      }, t2.prototype.bindBatchMoveElement = function() {
        var t3 = this;
        this.designPaper.getTarget().on("mousemove", function(e2) {
          if (e2.target.className && _typeof(e2.target.className) == "string" && e2.target.className.includes("editing")) {
            return;
          }
          if (e2.currentTarget.className == t3.designPaper.target[0].className) {
            t3.mouseOffsetX = e2.offsetX, t3.mouseOffsetY = e2.offsetY;
          } else {
            t3.mouseOffsetX = t3.mouseOffsetY = void 0;
          }
          s.a.instance.draging || 1 === e2.buttons && s.a.instance.rectDraging && t3.mouseRect && (t3.mouseRect.updateRect(e2.pageX, e2.pageY, t3), t3.updateRectPanel(t3.mouseRect));
        }).on("mousedown", function(e2) {
          s.a.instance.rectDraging = true;
          if (e2.target.className && _typeof(e2.target.className) == "string" && e2.target.className.includes("editing")) {
            return;
          }
          s.a.instance.draging || (t3.mouseRect && t3.mouseRect.target && t3.mouseRect.target.remove(), 1 === e2.buttons && _typeof(e2.target.className) == "string" && e2.target.className.includes("hiprint-printPaper hidroppable design") && (t3.mouseRect = new at(e2.pageX, e2.pageY, s.a.instance.dragLengthCNum(e2.pageX - t3.designPaper.getTarget().offset().left, p.a.instance.movingDistance), s.a.instance.dragLengthCNum(e2.pageY - t3.designPaper.getTarget().offset().top, p.a.instance.movingDistance))));
        }).on("mouseup", function(e2) {
          s.a.instance.rectDraging = false;
        });
      }, t2.prototype.getElementInRect = function(t3) {
        var e2 = [];
        return this.printElements.filter(function(n2) {
          return n2.options.draggable !== false;
        }).forEach(function(n2) {
          n2.inRect(t3) && e2.push(n2);
        }), e2;
      }, t2.prototype.updateRectPanel = function(t3) {
        var e2 = this, n2 = this.designPaper.getTarget();
        var ptr = this.designPaper.scale || 1;
        this.mouseRect.target || (this.mouseRect.target = hiprintJQuery('<div tabindex="1" class="mouseRect" style="z-index:2;position: absolute;opacity:0.2;border: 1px dashed #000;background-color:#31676f;"><span></span></div>'), n2.find(".hiprint-printPaper-content").append(this.mouseRect.target), this.bingKeyboardMoveEvent(this.mouseRect.target), this.mouseRect.target.hidraggable({
          onDrag: function onDrag(t4, n3, i2) {
            e2.mouseRect.lastLeft = e2.mouseRect.lastLeft ? o.a.px.toPt(e2.mouseRect.target[0].offsetLeft) : n3 / ptr, e2.mouseRect.lastTop = e2.mouseRect.lastTop ? o.a.px.toPt(e2.mouseRect.target[0].offsetTop) : i2 / ptr, (e2.mouseRect.mouseRectSelectedElement || []).forEach(function(t5) {
              t5.updatePositionByMultipleSelect(n3 - e2.mouseRect.lastLeft, i2 - e2.mouseRect.lastTop);
            }), e2.mouseRect.lastLeft = n3 / ptr, e2.mouseRect.lastTop = i2 / ptr, s.a.instance.changed = true;
          },
          moveUnit: "pt",
          minMove: p.a.instance.movingDistance,
          onBeforeDrag: function onBeforeDrag(t4) {
            e2.mouseRect.target.focus(), s.a.instance.draging = true, e2.mouseRect.mouseRectSelectedElement || (e2.mouseRect.mouseRectSelectedElement = e2.getElementInRect(e2.mouseRect));
            e2.mouseRect.target.css({
              transform: "unset"
            });
          },
          getScale: function getScale() {
            return e2.designPaper.scale || 1;
          },
          onStopDrag: function onStopDrag(t4) {
            if (s.a.instance.changed) o.a.event.trigger("hiprintTemplateDataChanged_" + n2.templateId, "\u6846\u9009\u79FB\u52A8");
            s.a.instance.draging = false;
            s.a.instance.changed = false;
          }
        }));
        if (t3.ex >= t3.bx && t3.ey >= t3.by) {
          this.mouseRect.target.css({
            height: t3.maxY - t3.minY + "px",
            width: t3.maxX - t3.minX + "px",
            left: t3.lastLeft / ptr + "pt",
            top: t3.lastTop / ptr + "pt",
            transform: "unset"
          });
        } else if (t3.ex < t3.bx && t3.ey < t3.by) {
          this.mouseRect.target.css({
            height: t3.maxY - t3.minY + "px",
            width: t3.maxX - t3.minX + "px",
            left: t3.lastLeft / ptr + "pt",
            top: t3.lastTop / ptr + "pt",
            transform: "rotate(180deg)",
            "transform-origin": "0 0"
          });
        } else if (t3.ex < t3.bx && t3.ey > t3.by) {
          this.mouseRect.target.css({
            height: t3.maxY - t3.minY + "px",
            width: t3.maxX - t3.minX + "px",
            left: t3.lastLeft / ptr + "pt",
            top: t3.lastTop / ptr + "pt",
            transform: "rotateY(180deg)",
            "transform-origin": "0 0"
          });
        } else if (t3.ex > t3.bx && t3.ey < t3.by) {
          this.mouseRect.target.css({
            height: t3.maxY - t3.minY + "px",
            width: t3.maxX - t3.minX + "px",
            left: t3.lastLeft / ptr + "pt",
            top: t3.lastTop / ptr + "pt",
            transform: "rotateX(180deg)",
            "transform-origin": "0 0"
          });
        }
        t3.target.focus();
      }, t2.prototype.bingKeyboardMoveEvent = function(t3) {
        var e2 = this;
        t3.attr("tabindex", "1"), t3.keydown(function(t4) {
          e2.mouseRect.mouseRectSelectedElement || (e2.mouseRect.mouseRectSelectedElement = e2.getElementInRect(e2.mouseRect));
          var n2 = e2.mouseRect.mouseRectSelectedElement || [];
          switch (t4.keyCode) {
            case 37:
              e2.mouseRect.updatePositionByMultipleSelect(0 - p.a.instance.movingDistance, 0), n2.forEach(function(t5) {
                t5.updatePositionByMultipleSelect(0 - p.a.instance.movingDistance, 0);
              }), t4.preventDefault();
              break;
            case 38:
              e2.mouseRect.updatePositionByMultipleSelect(0, 0 - p.a.instance.movingDistance), n2.forEach(function(t5) {
                t5.updatePositionByMultipleSelect(0, 0 - p.a.instance.movingDistance);
              }), t4.preventDefault();
              break;
            case 39:
              e2.mouseRect.updatePositionByMultipleSelect(p.a.instance.movingDistance, 0), n2.forEach(function(t5) {
                t5.updatePositionByMultipleSelect(p.a.instance.movingDistance, 0);
              }), t4.preventDefault();
              break;
            case 40:
              e2.mouseRect.updatePositionByMultipleSelect(0, p.a.instance.movingDistance), n2.forEach(function(t5) {
                t5.updatePositionByMultipleSelect(0, p.a.instance.movingDistance);
              }), t4.preventDefault();
          }
          if ([37, 38, 39, 40].includes(t4.keyCode)) {
            o.a.event.trigger("hiprintTemplateDataChanged_" + e2.templateId, "\u6846\u9009\u79FB\u52A8");
          }
        });
      }, t2;
    }(), st = /* @__PURE__ */ function() {
      return function(t2) {
        if (t2)
          if (t2.panels) {
            this.panels = [];
            for (var e2 = 0; e2 < t2.panels.length; e2++) {
              this.panels.push(new rt(t2.panels[e2]));
            }
          } else this.panels = [];
      };
    }(), lt = n(9), ut = function() {
      function t2(t3, e2) {
        var n2 = this;
        this.printElementOptionSettingPanel = {}, this.printTemplate = t3, this.settingContainer = hiprintJQuery(e2), o.a.event.on(t3.getPrintElementSelectEventKey(), function(t4) {
          n2.buildSetting(t4);
        }), o.a.event.on(t3.getBuildCustomOptionSettingEventKey(), function(t4) {
          n2.buildSettingByCustomOptions(t4);
        }), o.a.event.on("clearSettingContainer", function() {
          n2.clearSettingContainer();
        });
      }
      return t2.prototype.init = function() {
      }, t2.prototype.clearSettingContainer = function() {
        this.clearLastPrintElement(), this.settingContainer.html("");
      }, t2.prototype.clearLastPrintElement = function() {
        if (this.lastPrintElement) {
          if (this.lastPrintElement._editing) {
            this.lastPrintElement.updateByContent(true);
          }
          if (this.lastPrintElement._printElementOptionTabs) {
            this.lastPrintElement._printElementOptionTabs.forEach(function(t3) {
              t3.list && t3.list.forEach(function(e2) {
                if (!e2) return;
                e2.destroy();
              });
            });
          }
          if (this.lastPrintElement._printElementOptionItems) {
            this.lastPrintElement._printElementOptionItems.forEach(function(t3) {
              t3.destroy();
            });
          }
        }
        this.lastPrintElement = void 0;
      }, t2.prototype.buildSetting = function(t3) {
        var e2 = this, n2 = this, i2 = t3.printElement, o2 = t3.customOptionsInput;
        var tabs = i2.getPrintElementOptionTabs();
        e2.clearSettingContainer();
        var r2;
        if (tabs.length) {
          r2 = hiprintJQuery('<div class="prop-tabs"><ul class="prop-tab-items"></ul></div>');
          tabs.filter((e3, idx) => e3.list.length > 0 || idx == 2 && o2 && o2.length).forEach(function(tab) {
            var item = hiprintJQuery('<li class="prop-tab-item"><span class="tab-title">' + tab.name + "</span></li>");
            r2.find(".prop-tab-items").append(item);
            var options2 = hiprintJQuery('<div class="hiprint-option-items" data-title="' + tab.name + '"></div>');
            tab.list.forEach(function(t4) {
              if (!t4) return;
              t4.submit = function(t5) {
                i2.submitOption();
              };
              var n3 = t4.createTarget(i2, i2.options, i2.printElementType);
              e2.printElementOptionSettingPanel[t4.name] = n3, options2.append(n3);
              if (["columns", "dataType"].includes(t4.name)) {
                t4.setValue(i2.options[t4.name], i2.options, i2.printElementType);
              } else {
                if (["coordinate", "widthHeight"].includes(t4.name)) {
                  t4.setValue(i2.options, i2);
                } else {
                  t4.setValue(i2.options[t4.name] || i2.printElementType[t4.name]);
                }
              }
              n3.find("textarea").bind("dblclick.textarea", function(event) {
                if (!hiprintJQuery(this).val()) {
                  var placeholder = event.target.placeholder || "";
                  hiprintJQuery(this).val(placeholder);
                }
              });
            });
            if (tab.list.length == 0 && o2 && o2.length) {
              o2.forEach(function(t4) {
                var n22 = t4.callback;
                t4.callback = function(t5) {
                  n22 && n22(t5);
                };
                var tableColumn = t4.optionItems;
                t4.title && options2.append('<div class="hiprint-option-item hiprint-option-item-row">\n            <div class="hiprint-option-item-label hiprint-option-title">\n              ' + t4.title + "\n            </div>\n        </div>");
                tableColumn.forEach(function(e3) {
                  e3.submit = function(e4) {
                    t4.callback(n2.getValueByOptionItems(tableColumn));
                  }, options2.append(e3.createTarget(n2.printTemplate, t4.options, void 0)), e3.setValue(t4.options[e3.name], t4.options, void 0);
                });
                options2.find(".auto-submit").change(function() {
                  t4.callback(n2.getValueByOptionItems(tableColumn));
                });
                options2.find(".auto-submit:input").bind("keydown.submitOption", function(e3) {
                  13 === e3.keyCode && t4.callback(n2.getValueByOptionItems(tableColumn));
                });
                options2.find("textarea").bind("dblclick.textarea", function(event) {
                  if (!hiprintJQuery(this).val()) {
                    var placeholder = event.target.placeholder || "";
                    hiprintJQuery(this).val(placeholder);
                  }
                });
              });
            }
            r2.append(options2);
          });
        } else {
          r2 = hiprintJQuery('<div class="hiprint-option-items"></div>');
          i2.getPrintElementOptionItems().forEach(function(t4) {
            t4.submit = function(t5) {
              i2.submitOption();
            };
            var n3 = t4.createTarget(i2, i2.options, i2.printElementType);
            e2.printElementOptionSettingPanel[t4.name] = n3, r2.append(n3);
            if (["columns", "dataType"].includes(t4.name)) {
              t4.setValue(i2.options[t4.name], i2.options, i2.printElementType);
            } else {
              if (["coordinate", "widthHeight"].includes(t4.name)) {
                t4.setValue(i2.options, i2);
              } else {
                t4.setValue(i2.options[t4.name] || i2.printElementType[t4.name]);
              }
            }
          });
        }
        var a2 = hiprintJQuery(`<button class="hiprint-option-item-settingBtn hiprint-option-item-submitBtn"
        type="button">\u786E\u5B9A</button>`), p2 = hiprintJQuery(`<button  class="hiprint-option-item-settingBtn hiprint-option-item-deleteBtn"
        type="button">\u5220\u9664</button>`);
        r2.append(a2);
        i2.options.draggable != false && r2.append(p2);
        if (tabs.length) {
          r2.on("click", ".prop-tab-item", function() {
            var $li = hiprintJQuery(this);
            var index = $li.index();
            e2.settingContainer.data("last-index", index);
            $li.addClass("active");
            $li.siblings().removeClass("active");
            var options2 = r2.find(".hiprint-option-items:eq(" + index + ")");
            options2.addClass("active");
            options2.siblings().removeClass("active");
          });
          var lastIndex = +(e2.settingContainer.data("last-index") || 0);
          if (lastIndex >= tabs.length) {
            lastIndex = 0;
          }
          r2.find(".prop-tab-item:eq(" + lastIndex + ")").click();
        }
        a2.bind("click.submitOption", function() {
          i2.submitOption();
        }), p2.bind("click.deleteBtn", function() {
          hinnn.event.trigger("hiprintTemplateDataChanged_" + i2.templateId, "\u5220\u9664");
          n2.printTemplate.deletePrintElement(i2);
          e2.clearSettingContainer();
        }), r2.find(".auto-submit").change(function(t4) {
          i2.submitOption();
        }), r2.find(".auto-submit:input").bind("keydown.submitOption", function(t4) {
          13 == t4.keyCode && i2.submitOption();
        }), this.settingContainer.append(r2), tabs.length < 1 && o2 && o2.forEach(function(t4) {
          var n3 = t4.callback;
          t4.callback = function(t5) {
            n3 && (n3(t5), i2.submitOption());
          }, e2.buildSettingByCustomOptions(t4, e2.settingContainer);
        }), this.lastPrintElement = i2;
      }, t2.prototype.buildSettingByCustomOptions = function(t3, e2) {
        var n2 = this;
        this.clearLastPrintElement();
        var i2 = e2 || this.settingContainer;
        e2 || this.settingContainer.html("");
        var o2 = [], supportOptions = p.a.instance.panel.supportOptions.filter(function(t4) {
          return !t4.hidden;
        }).map(function(e3) {
          return e3.name;
        });
        t3.optionItems ? o2 = t3.optionItems : Object.keys(t3.options).filter(function(t4) {
          return supportOptions.includes(t4);
        }).forEach(function(t4) {
          var e3 = lt.a.getItem(t4);
          e3 && o2.push(e3);
        });
        var r2 = hiprintJQuery('<div class="hiprint-option-items"></div>');
        t3.title && r2.append('<div class="hiprint-option-item hiprint-option-item-row">\n            <div class="hiprint-option-item-label hiprint-option-title">\n              ' + t3.title + "\n            </div>\n        </div>"), o2.forEach(function(e3) {
          e3.submit = function(e4) {
            t3.callback(n2.getValueByOptionItems(o2));
          }, r2.append(e3.createTarget(n2.printTemplate, t3.options, void 0)), e3.setValue(t3.options[e3.name], t3.options, void 0);
        });
        var a2 = hiprintJQuery(`<button class="hiprint-option-item-settingBtn hiprint-option-item-submitBtn"
        type="button">\u786E\u5B9A</button>`);
        r2.append(a2), a2.bind("click.submitOption", function() {
          t3.callback(n2.getValueByOptionItems(o2));
        }), r2.find(".auto-submit").change(function(e3) {
          t3.callback(n2.getValueByOptionItems(o2));
        }), r2.find(".auto-submit:input").bind("keydown.submitOption", function(e3) {
          13 == e3.keyCode && t3.callback(n2.getValueByOptionItems(o2));
        }), i2.append(r2);
      }, t2.prototype.getValueByOptionItems = function(t3) {
        var e2 = {};
        return t3.forEach(function(t4) {
          e2[t4.name] = t4.getValue();
        }), e2;
      }, t2;
    }(), dt = function() {
      function t2(t3, e2) {
        this.paginationContainer = t3, this.jqPaginationContainer = hiprintJQuery(this.paginationContainer), this.template = e2;
      }
      return t2.prototype.buildPagination = function(t3) {
        var e2 = this.template.getPaneltotal(), n2 = this;
        this.jqPaginationContainer.html("");
        for (var i2 = hiprintJQuery('<ul class="hiprint-pagination"></ul>'), o2 = function o3() {
          var t4 = r2, name = n2.template.printPanels[t4].name || t4 + 1, e3 = hiprintJQuery("<li><span>" + name + '</span><a href="javascript:void(0);">x</a></li>');
          e3.find("span").click(function() {
            n2.template.selectPanel(t4), e3.siblings().removeClass("selected"), hiprintJQuery(this).parent("li").addClass("selected");
          }), e3.find("a").click(function() {
            n2.template.deletePanel(t4), n2.buildPagination();
          }), i2.append(e3);
        }, r2 = 0; r2 < e2; r2++) {
          o2();
        }
        var a2 = hiprintJQuery("<li><span>+</span></li>");
        i2.append(a2), this.jqPaginationContainer.append(i2), a2.click(function() {
          var createPanel = function(t4) {
            n2.template.addPrintPanel(t4 || void 0, true), n2.buildPagination();
            hiprintJQuery(".hiprint-pagination li").removeClass("selected");
            hiprintJQuery(".hiprint-pagination li:nth-last-child(2)").addClass("selected");
          };
          if (n2.template.onPanelAddClick) {
            var panel = {
              index: n2.template.printPanels.length,
              paperType: "A4"
            };
            n2.template.onPanelAddClick(panel, createPanel);
          } else {
            createPanel();
          }
        });
      }, t2.prototype.selectPanel = function(idx) {
        var i2 = idx || this.template.editingPanel.index;
        var li = hiprintJQuery(".hiprint-pagination li:nth(" + i2 + ")");
        if (li.length) {
          li.siblings().removeClass("selected");
          li.addClass("selected");
        }
        hinnn.event.trigger("onSelectPanel", this.template.editingPanel, i2, li);
      }, t2;
    }(), ct = function() {
      function t2(t3) {
        var e2 = this;
        this.tempimageBase64 = {}, this.id = s.a.instance.guid(), s.a.instance.setPrintTemplateById(this.id, this);
        var n2 = t3 || {};
        this.printPanels = [];
        this.dataMode = n2.dataMode || 1;
        this.history = n2.history != void 0 ? n2.history : true;
        this.willOutOfBounds = n2.willOutOfBounds != void 0 ? n2.willOutOfBounds : true;
        this.onDataChanged = n2.onDataChanged;
        this.onUpdateError = n2.onUpdateError;
        this.lastJson = n2.template || {};
        this.historyList = [{ id: s.a.instance.guid(), type: "\u521D\u59CB", json: this.lastJson }];
        this.historyPos = 0;
        this.defaultPanelName = n2.defaultPanelName;
        this.designOptions = {};
        this.qtDesigner = n2.qtDesigner != void 0 ? n2.qtDesigner : true;
        this.qtDesignerMap = {};
        this.qtDesignderFunction = function(field) {
          this.qtDesignerMap = {};
          const fieldTitle = field.split("_")[0];
          var printElements = this.editingPanel && this.editingPanel.printElements || [];
          for (const item of printElements) {
            if (item.options.field === void 0) {
              continue;
            }
            const renderKey = item.options.field.split("_")[0];
            if (this.qtDesignerMap[renderKey] === void 0) {
              this.qtDesignerMap[renderKey] = 1;
            } else {
              this.qtDesignerMap[renderKey] += 1;
            }
          }
          if (this.qtDesignerMap[fieldTitle] === 0 || this.qtDesignerMap[fieldTitle] === void 0) {
            return fieldTitle;
          } else {
            return fieldTitle + "_" + this.qtDesignerMap[fieldTitle];
          }
        };
        var i2 = new st(n2.template || []);
        n2.template && i2.panels.forEach(function(t4) {
          e2.printPanels.push(new pt(t4, e2.id));
        }), n2.fontList && (this.fontList = n2.fontList), n2.fields && (this.fields = n2.fields), n2.onImageChooseClick && (this.onImageChooseClick = n2.onImageChooseClick), n2.onPanelAddClick && (this.onPanelAddClick = n2.onPanelAddClick), n2.settingContainer && new ut(this, n2.settingContainer), n2.paginationContainer && (this.printPaginationCreator = new dt(n2.paginationContainer, this), this.printPaginationCreator.buildPagination()), this.initAutoSave();
      }
      return t2.prototype.design = function(t3, e2) {
        var n2 = this;
        if (e2 || (e2 = {}), 0 == this.printPanels.length) {
          var i2 = this.createDefaultPanel();
          this.printPanels.push(i2);
        }
        if (!t3) throw new Error("options.container can not be empty");
        n2.designOptions = e2;
        this.createContainer(t3), this.printPanels.forEach(function(t4, i3) {
          n2.container.append(t4.getTarget()), i3 > 0 && t4.disable(), t4.design(e2);
        }), this.selectPanel(0);
      }, t2.prototype.getSimpleHtml = function(t3, e2) {
        var n2 = this;
        e2 || (e2 = {});
        var i2 = hiprintJQuery('<div class="hiprint-printTemplate"></div>');
        t3 && t3.constructor === Array ? t3.forEach(function(data, dataIndex) {
          data && n2.printPanels.forEach(function(printPanel, o2) {
            i2.append(printPanel.getHtml(data, e2));
            if (dataIndex == t3.length - 1 && o2 == n2.printPanels.length - 1) {
              delete hinnn._paperList;
            }
          });
        }) : this.printPanels.forEach(function(panel, panelIndex) {
          i2.append(panel.getHtml(t3, e2));
          if (panelIndex == n2.printPanels.length - 1) {
            delete hinnn._paperList;
          }
        });
        return e2 && e2.imgToBase64 && this.transformImg(i2.find("img")), i2;
      }, t2.prototype.getSimpleHtmlAsync = function(dataItemOrList, e2) {
        return new Promise((resolve) => {
          var that = this;
          e2 || (e2 = {});
          let rootElement = hiprintJQuery('<div class="hiprint-printTemplate"></div>');
          const dataList = Array.isArray(dataItemOrList) ? dataItemOrList : [dataItemOrList];
          const paramsListToCreateHTML = [];
          dataList.forEach(function(data, dataIndex) {
            data && that.printPanels.forEach(function(panel, o2) {
              paramsListToCreateHTML.push([panel, data, e2]);
            });
          });
          function appendElementByParamsList(paramsListToCreateHTML2, onFinish2) {
            var _a;
            if (!paramsListToCreateHTML2.length) return onFinish2();
            const [panel, data, e3] = paramsListToCreateHTML2.shift();
            rootElement.append(panel.getHtml(data, e3));
            /* @__PURE__ */ console.log("e.generateHTMLInterval", e3.generateHTMLInterval);
            setTimeout(() => appendElementByParamsList(paramsListToCreateHTML2, onFinish2), (_a = e3.generateHTMLInterval) != null ? _a : 10);
          }
          function onFinish() {
            delete hinnn._paperList;
            e2 && e2.imgToBase64 && that.transformImg(rootElement.find("img"));
            resolve(rootElement);
          }
          appendElementByParamsList(paramsListToCreateHTML, onFinish);
        });
      }, t2.prototype.getHtml = function(t3, e2) {
        return t3 || (t3 = {}), this.getSimpleHtml(t3, e2);
      }, t2.prototype.getHtmlAsync = function(t3, e2) {
        return t3 || (t3 = {}), this.getSimpleHtmlAsync(t3, e2);
      }, t2.prototype.getJointHtml = function(t3, e2, n2) {
        var i2 = hiprintJQuery('<div class="hiprint-printTemplate"></div>'), o2 = [];
        return this.printPanels.forEach(function(r2, a2) {
          i2.append(r2.getHtml(t3, e2, o2, void 0, n2));
        }), i2;
      }, t2.prototype.setPaper = function(t3, e2) {
        if (/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(t3)) this.editingPanel.resize(void 0, parseFloat(t3), parseFloat(e2), false);
        else {
          var n2 = s.a.instance[t3];
          if (!n2) throw new Error("not found pagetype:" + (t3 || ""));
          this.editingPanel.resize(t3, n2.width, n2.height, false);
        }
      }, t2.prototype.rotatePaper = function() {
        this.editingPanel.rotatePaper();
      }, t2.prototype.zoom = function(s2, p2) {
        this.editingPanel.zoom(s2, p2);
      }, t2.prototype.addPrintPanel = function(t3, e2) {
        var n2 = t3 ? new pt(new rt(t3), this.id) : this.createDefaultPanel();
        return t3 && (t3.index = this.printPanels.length), e2 && (this.container.append(n2.getTarget()), n2.design(this.designOptions)), this.printPanels.push(n2), e2 && this.selectPanel(n2.index), n2;
      }, t2.prototype.selectPanel = function(t3) {
        var e2 = this;
        if (t3 > e2.printPanels.length - 1) t3 = e2.printPanels.length - 1;
        this.printPanels.forEach(function(n2, i2) {
          t3 == i2 ? (n2.enable(), e2.editingPanel = n2, e2.printPaginationCreator && e2.printPaginationCreator.selectPanel(t3)) : n2.disable();
        });
      }, t2.prototype.deletePanel = function(t3) {
        this.printPanels[t3].clear(), this.printPanels[t3].getTarget().remove(), this.printPanels.splice(t3, 1);
      }, t2.prototype.getPaneltotal = function() {
        return this.printPanels.length;
      }, t2.prototype.createDefaultPanel = function() {
        return new pt(
          new rt({
            index: this.printPanels.length,
            name: this.defaultPanelName,
            paperType: "A4"
          }),
          this.id
        );
      }, t2.prototype.createContainer = function(t3) {
        t3 ? (this.container = hiprintJQuery(t3), this.container.addClass("hiprint-printTemplate")) : this.container = hiprintJQuery('<div class="hiprint-printTemplate"></div>');
      }, t2.prototype.getJsonTid = function() {
        var t3 = [];
        return this.printPanels.forEach(function(e2) {
          e2.getPanelEntity().printElements.length && t3.push(e2.getPanelEntity());
        }), new st({
          panels: t3
        });
      }, t2.prototype.getJson = function() {
        var t3 = [];
        return this.printPanels.forEach(function(e2) {
          t3.push(e2.getPanelEntity(true));
        }), new st({
          panels: t3
        });
      }, t2.prototype.undo = function(t3) {
        o.a.event.trigger("hiprintTemplateDataShortcutKey_" + this.id, "undo");
      }, t2.prototype.redo = function(t3) {
        o.a.event.trigger("hiprintTemplateDataShortcutKey_" + this.id, "redo");
      }, t2.prototype.getPrintElementSelectEventKey = function() {
        return "PrintElementSelectEventKey_" + this.id;
      }, t2.prototype.getBuildCustomOptionSettingEventKey = function() {
        return "BuildCustomOptionSettingEventKey_" + this.id;
      }, t2.prototype.clear = function() {
        this.printPanels.forEach(function(t3) {
          if (t3.clear(), t3.index > 0) {
            var e2 = t3.getTarget();
            e2 && e2.length && e2.remove();
          }
        }), this.printPanels = [this.printPanels[0]], this.printPaginationCreator && this.printPaginationCreator.buildPagination();
      }, t2.prototype.getPaperType = function(t3) {
        return null == t3 && (t3 = 0), this.printPanels[0].paperType;
      }, t2.prototype.getOrient = function(t3) {
        return null == t3 && (t3 = 0), this.printPanels[t3].height > this.printPanels[t3].width ? 1 : 2;
      }, t2.prototype.getPrintStyle = function(t3) {
        return this.printPanels[t3].getPrintStyle();
      }, t2.prototype.print = function(t3, e2, o2) {
        t3 || (t3 = {}), this.getHtml(t3, e2).hiwprint(o2);
      }, t2.prototype.print2 = function(t3, e2) {
        if (t3 || (t3 = {}), e2 || (e2 = {}), this.clientIsOpened()) {
          var css = "", p2 = `<style rel="stylesheet" type="text/css">${printCss}</style>`;
          if (e2.styleHandler) {
            css += e2.styleHandler();
          }
          if (css) p2 = `${css}${p2}`;
          this.sentToClient(p2, t3, e2);
        } else alert("\u8FDE\u63A5\u5BA2\u6237\u7AEF\u5931\u8D25");
      }, t2.prototype.imageToBase64 = function(t3) {
        var e2 = hiprintJQuery(t3).attr("src");
        if (-1 == e2.indexOf("base64"))
          try {
            if (!this.tempimageBase64[e2]) {
              var n2 = document.createElement("canvas"), i2 = new Image();
              i2.src = t3.attr("src"), n2.width = i2.width, n2.height = i2.height, n2.getContext("2d").drawImage(i2, 0, 0), e2 && (this.tempimageBase64[e2] = n2.toDataURL("image/png"));
            }
            t3.attr("src", this.tempimageBase64[e2]);
          } catch (e3) {
            try {
              this.xhrLoadImage(t3);
            } catch (t4) {
              /* @__PURE__ */ console.log(t4);
            }
          }
      }, t2.prototype.xhrLoadImage = function(t3) {
      }, t2.prototype.sentToClient = function(t3, e2, n2) {
        e2 || (e2 = {});
        var i2 = hiprintJQuery.extend({}, n2 || {});
        i2.imgToBase64 = true;
        var o2 = t3 + this.getHtml(e2, i2)[0].outerHTML;
        i2.id = s.a.instance.guid(), i2.html = o2, i2.templateId = this.id, hiwebSocket.send(i2);
      }, t2.prototype.printByHtml = function(t3) {
        hiprintJQuery(t3).hiwprint();
      }, t2.prototype.printByHtml2 = function(t3, e2) {
        if (e2 || (e2 = {}), this.clientIsOpened()) {
          var n2 = this, i2 = 0, o2 = {}, r2 = hiprintJQuery('link[media=print][href*="print-lock.css"]');
          if (r2.length <= 0) {
            throw new Error('\u8BF7\u5728 \u5165\u53E3\u6587\u4EF6(index.html) \u4E2D\u5F15\u5165 print-lock.css. \u6CE8\u610F: link[media="print"]');
            return;
          }
          r2.each(function(a2, p2) {
            var l2 = new XMLHttpRequest();
            l2.open("GET", hiprintJQuery(p2).attr("href")), l2.onreadystatechange = function() {
              if (4 === l2.readyState && 200 === l2.status && (o2[a2 + ""] = '<style rel="stylesheet" type="text/css">' + l2.responseText + "</style>", ++i2 == r2.length)) {
                for (var p3 = "", u2 = 0; u2 < r2.length; u2++) {
                  p3 += o2[u2 + ""];
                }
                var d2 = p3 + hiprintJQuery(t3)[0].outerHTML, c2 = hiprintJQuery.extend({}, e2 || {});
                c2.id = s.a.instance.guid(), c2.html = d2, c2.templateId = n2.id, hiwebSocket.send(c2);
              }
            }, l2.send();
          });
        } else alert("\u8FDE\u63A5\u5BA2\u6237\u7AEF\u5931\u8D25");
      }, t2.prototype.deletePrintElement = function(t3) {
        this.printPanels.forEach(function(e2) {
          e2.deletePrintElement(t3);
        });
      }, t2.prototype.transformImg = function(t3) {
        var e2 = this;
        t3.map(function(t4, n2) {
          e2.imageToBase64(hiprintJQuery(n2));
        });
      }, t2.prototype.toPdf = function(t3, e2, options2) {
        var i2 = this;
        var dtd = hiprintJQuery.Deferred();
        var isDownload = true;
        if (this.printPanels.length) {
          var r2 = o.a.mm.toPt(this.printPanels[0].width), a2 = o.a.mm.toPt(this.printPanels[0].height), p2 = hiprintJQuery.extend(
            {
              scale: 2,
              width: o.a.pt.toPx(r2),
              x: 0,
              y: 0,
              useCORS: true
            },
            options2 || {}
          ), s2 = new jsPDF({
            orientation: 1 == this.getOrient(0) ? "portrait" : "landscape",
            unit: "pt",
            format: this.printPanels[0].paperType ? this.printPanels[0].paperType.toLocaleLowerCase() : [r2, a2]
          }), l2 = this.getHtml(t3, options2);
          if (options2 && void 0 != options2.isDownload) {
            isDownload = options2.isDownload;
          }
          this.createTempContainer();
          var u2 = this.getTempContainer();
          this.svg2canvas(l2), u2.html(l2[0]);
          var d2 = u2.find(".hiprint-printPanel .hiprint-printPaper").length;
          hiprintJQuery(l2).css("position:fixed"), html2canvas(l2[0], p2).then(function(t4) {
            var n2 = t4.getContext("2d");
            n2.mozImageSmoothingEnabled = false, n2.webkitImageSmoothingEnabled = false, n2.msImageSmoothingEnabled = false, n2.imageSmoothingEnabled = false;
            for (var o2 = t4.toDataURL("image/jpeg"), p3 = 0; p3 < d2; p3++) {
              s2.addImage(o2, "JPEG", 0, 0 - p3 * a2, r2, d2 * a2), p3 < d2 - 1 && s2.addPage();
            }
            if (isDownload) {
              i2.removeTempContainer(), e2.indexOf(".pdf") > -1 ? s2.save(e2) : s2.save(e2 + ".pdf");
            } else {
              i2.removeTempContainer();
              let type = options2.type || "blob";
              var pdfFile = s2.output(type);
              dtd.resolve(pdfFile);
            }
          });
        }
        return dtd.promise();
      }, t2.prototype.createTempContainer = function() {
        this.removeTempContainer(), hiprintJQuery("body").prepend(hiprintJQuery('<div class="hiprint_temp_Container" style="overflow:hidden;height: 0px;box-sizing: border-box;"></div>'));
      }, t2.prototype.removeTempContainer = function() {
        hiprintJQuery(".hiprint_temp_Container").remove();
      }, t2.prototype.getTempContainer = function() {
        return hiprintJQuery(".hiprint_temp_Container");
      }, t2.prototype.svg2canvas = function(t3) {
        var that = this;
        t3.find("svg").each(function(t4, e2) {
          var n2 = e2.parentNode, p2 = that.parentWidthHeight(n2), i2 = document.createElement("canvas");
          i2.width = p2.width, i2.height = p2.height;
          var ctx = i2.getContext("2d"), str = new XMLSerializer().serializeToString(e2);
          Canvg.fromString(ctx, str).render(), hiprintJQuery(e2).before(i2), n2.removeChild(e2);
        });
      }, t2.prototype.parentWidthHeight = function(t3) {
        if (t3.style.width.endsWith("%") || t3.style.height.endsWith("%")) {
          if (t3.className != "hiprint-printPaper-content") {
            return this.parentWidthHeight(t3.parentNode);
          }
          return { width: 10, height: 10 };
        } else {
          return { width: o.a.pt.toPx(parseFloat(t3.style.width)), height: o.a.pt.toPx(parseFloat(t3.style.height)) };
        }
      }, t2.prototype.on = function(t3, e2) {
        o.a.event.clear(t3 + "_" + this.id);
        o.a.event.on(t3 + "_" + this.id, e2);
      }, t2.prototype.clientIsOpened = function() {
        return hiwebSocket.opened;
      }, t2.prototype.getPrinterList = function() {
        var t3 = hiwebSocket.getPrinterList();
        return t3 || [];
      }, t2.prototype.getElementByTid = function(t3, e2) {
        return null == e2 && (e2 = 0), this.printPanels[e2].getElementByTid(t3);
      }, t2.prototype.getElementByName = function(t3, e2) {
        return null == e2 && (e2 = 0), this.printPanels[e2].getElementByName(t3);
      }, t2.prototype.getPanel = function(t3) {
        return null == t3 && (t3 = 0), this.printPanels[t3];
      }, t2.prototype.loadAllImages = function(t3, e2, n2) {
        var i2 = this;
        null == n2 && (n2 = 0);
        for (var o2 = t3[0].getElementsByTagName("img"), r2 = true, a2 = 0; a2 < o2.length; a2++) {
          var p2 = o2[a2];
          p2.src && p2.src !== window.location.href && -1 == p2.src.indexOf("base64") && (p2 && void 0 !== p2.naturalWidth && 0 !== p2.naturalWidth && p2.complete || (r2 = false));
        }
        n2++, !r2 && n2 < 10 ? setTimeout(function() {
          i2.loadAllImages(t3, e2, n2);
        }, 500) : e2();
      }, t2.prototype.setFontList = function(t3) {
        this.fontList = t3;
      }, t2.prototype.getFontList = function() {
        return this.fontList;
      }, t2.prototype.setFields = function(t3) {
        this.fields = t3;
      }, t2.prototype.getFields = function() {
        return this.fields;
      }, t2.prototype.setOnImageChooseClick = function(t3) {
        this.onImageChooseClick = t3;
      }, t2.prototype.getOnImageChooseClick = function() {
        return this.onImageChooseClick;
      }, t2.prototype.getFieldsInPanel = function() {
        var t3 = [];
        return this.printPanels.forEach(function(e2) {
          t3 = t3.concat(e2.getFieldsInPanel());
        }), t3;
      }, t2.prototype.getTestData = function() {
        var t3 = {};
        return this.printPanels.forEach(function(e2) {
          t3 = Object.assign(t3, e2.getTestData());
        }), t3;
      }, t2.prototype.update = function(t3, idx) {
        var e2 = this;
        try {
          if (t3 && "object" == _typeof(t3) && t3.panels.length > 0) {
            var curLen = e2.printPanels.length - 1;
            t3.panels.forEach(function(panel, index) {
              if (index > curLen) {
                e2.printPanels.push(new pt(panel, e2.id));
                var t4 = e2.printPanels[index];
                e2.container.append(t4.getTarget()), index > 0 && t4.disable(), t4.design(e2.designOptions);
                e2.printPaginationCreator && e2.printPaginationCreator.buildPagination();
              }
              var temp = new rt(panel);
              e2.editingPanel = e2.printPanels[index];
              e2.editingPanel.update(temp);
            });
            e2.selectPanel(idx || 0);
          }
        } catch (er) {
          /* @__PURE__ */ console.log(er);
          e2.onUpdateError && e2.onUpdateError(er);
        }
      }, t2.prototype.getSelectEls = function() {
        var t3 = this;
        var elements = [];
        if (t3.editingPanel.mouseRect && t3.editingPanel.mouseRect.target && hiprintJQuery(".mouseRect").length) {
          elements = t3.editingPanel.getElementInRect(t3.editingPanel.mouseRect);
        } else {
          elements = t3.editingPanel.printElements.filter(function(el) {
            return "block" == el.designTarget.children().last().css("display") && !el.printElementType.type.includes("table");
          });
        }
        return elements;
      }, t2.prototype.selectElementsByField = function(fieldsArray) {
        var hiPrintEntity = this;
        var t3 = hiprintJQuery;
        hiPrintEntity.editingPanel.printElements.forEach((e2, index) => {
          if (fieldsArray && fieldsArray.includes(e2.options.field)) {
            let designTarget = e2.designTarget;
            designTarget.children("div[panelindex]").addClass("selected");
            designTarget.children().last().css({
              display: "block"
            });
            designTarget = designTarget[0];
            t3.data(designTarget, "hidraggable").options.onBeforeSelectAllDrag.call(designTarget, {});
          }
        });
      }, t2.prototype.selectAllElements = function() {
        var hiPrintEntity = this;
        var t3 = hiprintJQuery;
        hiPrintEntity.editingPanel.printElements.forEach((e2, index) => {
          let designTarget = e2.designTarget;
          designTarget.children("div[panelindex]").addClass("selected");
          designTarget.children().last().css({
            display: "block"
          });
          designTarget = designTarget[0];
          t3.data(designTarget, "hidraggable").options.onBeforeSelectAllDrag.call(designTarget, {});
        });
      }, t2.prototype.updateOption = function(option, v2) {
        var elements = this.getSelectEls();
        if (elements && elements.length) {
          elements.forEach(function(e2) {
            e2.updateOption(option, v2, true);
          });
          o.a.event.trigger("hiprintTemplateDataChanged_" + this.id, "\u6279\u91CF\u4FEE\u6539");
        }
      }, t2.prototype.setElsAlign = function(e2) {
        var t3 = this;
        var elements = this.getSelectEls();
        if (elements.length) {
          var minLeft = Math.min.apply(
            null,
            elements.map(function(el) {
              return el.options.left;
            })
          );
          var maxRight = Math.max.apply(
            null,
            elements.map(function(el) {
              return el.options.left + el.options.width;
            })
          );
          var minTop = Math.min.apply(
            null,
            elements.map(function(el) {
              return el.options.top;
            })
          );
          var maxBottom = Math.max.apply(
            null,
            elements.map(function(el) {
              return el.options.top + el.options.height;
            })
          );
          switch (e2) {
            case "left":
              elements.forEach(function(el) {
                el.updateSizeAndPositionOptions(minLeft);
                el.designTarget.css("left", el.options.displayLeft());
              });
              break;
            case "vertical":
              var vertical = minLeft + (maxRight - minLeft) / 2;
              elements.forEach(function(el) {
                el.updateSizeAndPositionOptions(vertical - el.options.width / 2);
                el.designTarget.css("left", el.options.displayLeft());
              });
              break;
            case "right":
              elements.forEach(function(el) {
                el.updateSizeAndPositionOptions(maxRight - el.options.width);
                el.designTarget.css("left", el.options.displayLeft());
              });
              break;
            case "top":
              elements.forEach(function(el) {
                el.updateSizeAndPositionOptions(void 0, minTop);
                el.designTarget.css("top", el.options.displayTop());
              });
              break;
            case "horizontal":
              var horizontal = minTop + (maxBottom - minTop) / 2;
              elements.forEach(function(el) {
                el.updateSizeAndPositionOptions(void 0, horizontal - el.options.height / 2);
                el.designTarget.css("top", el.options.displayTop());
              });
              break;
            case "bottom":
              elements.forEach(function(el) {
                el.updateSizeAndPositionOptions(void 0, maxBottom - el.options.height);
                el.designTarget.css("top", el.options.displayTop());
              });
              break;
            case "distributeHor":
              var sumWidth = [].reduce.call(
                elements,
                function(total, el) {
                  return total + el.options.width;
                },
                0
              );
              var distributeHor = (maxRight - minLeft - sumWidth) / (elements.length - 1);
              elements.sort(function(prev, curr) {
                return prev.options.left - curr.options.left;
              });
              elements.forEach(function(el, index) {
                if (![0, elements.length - 1].includes(index)) {
                  el.updateSizeAndPositionOptions(elements[index - 1].options.left + elements[index - 1].options.width + distributeHor);
                  el.designTarget.css("left", el.options.displayLeft());
                }
              });
              break;
            case "distributeVer":
              var sumHeight = [].reduce.call(
                elements,
                function(total, el) {
                  return total + el.options.height;
                },
                0
              );
              var distributeVer = (maxBottom - minTop - sumHeight) / (elements.length - 1);
              elements.sort(function(prev, curr) {
                return prev.options.top - curr.options.top;
              });
              elements.forEach(function(el, index) {
                if (![0, elements.length - 1].includes(index)) {
                  el.updateSizeAndPositionOptions(void 0, elements[index - 1].options.top + elements[index - 1].options.height + distributeVer);
                  el.designTarget.css("top", el.options.displayTop());
                }
              });
              break;
          }
        }
      }, t2.prototype.setElsSpace = function(dis, isHor) {
        var t3 = this;
        var elements = this.getSelectEls();
        if (elements.length) {
          if (isHor) {
            elements.sort(function(prev, curr) {
              return prev.options.left - curr.options.left;
            });
            elements.forEach(function(el, index) {
              if (index > 0) {
                el.updateSizeAndPositionOptions(elements[index - 1].options.left + elements[index - 1].options.width + dis);
                el.designTarget.css("left", el.options.displayLeft());
              }
            });
          } else {
            elements.sort(function(prev, curr) {
              return prev.options.top - curr.options.top;
            });
            elements.forEach(function(el, index) {
              if (index > 0) {
                el.updateSizeAndPositionOptions(void 0, elements[index - 1].options.top + elements[index - 1].options.height + dis);
                el.designTarget.css("top", el.options.displayTop());
              }
            });
          }
        }
      }, t2.prototype.initAutoSave = function() {
        var t3 = this;
        o.a.event.on("hiprintTemplateDataShortcutKey_" + this.id, function(key) {
          if (!t3.history) return;
          switch (key) {
            case "undo":
              if (t3.historyPos > 0) {
                t3.historyPos -= 1;
                var cur = t3.historyList[t3.historyPos];
                t3.update(cur.json);
              }
              break;
            case "redo":
              if (t3.historyPos < t3.historyList.length - 1) {
                t3.historyPos += 1;
                var cur = t3.historyList[t3.historyPos];
                t3.update(cur.json);
              }
              break;
          }
        });
        o.a.event.on("hiprintTemplateDataChanged_" + this.id, function(type) {
          if (t3.history) {
            var j2 = 1 == t3.dataMode ? t3.getJson() : t3.getJsonTid();
            t3.lastJson = j2;
            if (t3.historyPos < t3.historyList.length - 1) {
              t3.historyList = t3.historyList.slice(0, t3.historyPos + 1);
            }
            t3.historyList.push({ id: s.a.instance.guid(), type, json: j2 });
            if (t3.historyList.length > 50) {
              t3.historyList = t3.historyList.slice(0, 1).concat(t3.historyList.slice(1, 50));
            } else {
              t3.historyPos += 1;
            }
            t3.onDataChanged && t3.onDataChanged(type, j2);
          }
        });
      }, t2;
    }();
    function ht(t2) {
      this.getHtml(t2).hiwprint();
    }
    function ft(t2, e2, n2) {
      hiprintJQuery.extend({}, t2 || {}).imgToBase64 = true;
      var i2 = new ct({});
      i2.on("printSuccess", e2), i2.on("printError", n2), i2.printByHtml2(this.getHtml(t2), t2.options);
    }
    function gt(t2) {
      var e2 = void 0;
      return t2 && t2.templates.forEach(function(n2, i2) {
        var o2 = hiprintJQuery.extend({}, n2.options || {});
        t2.imgToBase64 && (o2.imgToBase64 = true), e2 ? e2.append(n2.template.getHtml(n2.data, o2).html()) : e2 = n2.template.getHtml(n2.data, o2);
      }), e2;
    }
    function mt(t2) {
      p.a.instance.init(t2), p.a.instance.providers && p.a.instance.providers.forEach(function(t3) {
        t3.addElementTypes(a.instance);
      });
    }
    function cig(t2) {
      if (t2) {
        t2 && Object.keys(t2).forEach(function(i2) {
          if (i2 == "optionItems" && t2.optionItems && t2.optionItems.length) {
            p.a.instance.registerItems(t2.optionItems);
          } else if (t2[i2].tabs && t2[i2].tabs.length) {
            t2[i2].tabs.forEach(function(tab, idx) {
              if (tab.replace) {
                hiprintJQuery.extend(p.a.instance[i2].tabs[idx], tab);
              } else {
                var options3 = tab.options, list2 = p.a.instance[i2].tabs[idx].options;
                options3.forEach(function(o2) {
                  var idx2 = list2.findIndex(function(e2) {
                    return e2.name == o2.name;
                  });
                  if (idx2 > -1) list2[idx2].hidden = o2.hidden;
                  else {
                    if (o2.after) {
                      idx2 = list2.findIndex(function(e2) {
                        return e2.name == o2.after;
                      });
                      if (idx2 > -1) list2.splice(idx2 + 1, 0, o2);
                    } else list2.push(o2);
                  }
                });
                hiprintJQuery.extend(p.a.instance[i2].tabs[idx], {
                  name: tab.name,
                  options: list2
                });
              }
            });
            delete t2[i2].tabs;
          } else if (t2[i2].supportOptions) {
            var options2 = t2[i2].supportOptions, list = p.a.instance[i2].supportOptions;
            options2.forEach(function(o2) {
              var idx = list.findIndex(function(e2) {
                return e2.name == o2.name;
              });
              if (idx > -1) list[idx].hidden = o2.hidden;
              else {
                if (o2.after) {
                  idx = list.findIndex(function(e2) {
                    return e2.name == o2.after;
                  });
                  if (idx > -1) list.splice(idx + 1, 0, o2);
                } else list.push(o2);
              }
            });
            hiprintJQuery.extend(p.a.instance[i2].supportOptions, list);
            delete t2[i2].supportOptions;
          } else {
            var keyMap = {};
            keyMap[i2] = t2[i2];
            hiprintJQuery.extend(p.a.instance, keyMap);
          }
        });
      } else {
        hiprintJQuery.extend(p.a.instance, HIPRINT_CONFIG);
      }
    }
    function uep(t2, c2) {
      return a.instance.updateElementType(t2, c2);
    }
    function rpl(c2) {
      p.a.instance.clear("printerList");
      p.a.instance.on("printerList", c2);
      hiwebSocket.refreshPrinterList();
    }
    function getAddr(type, c2, ...args) {
      p.a.instance.clear("address_" + type);
      p.a.instance.on("address_" + type, c2);
      hiwebSocket.getAddress(type, ...args);
    }
    function ippPrint(options2, callback, connected) {
      p.a.instance.clear("ippPrinterCallback");
      p.a.instance.on("ippPrinterCallback", callback);
      p.a.instance.clear("ippPrinterConnected");
      p.a.instance.on("ippPrinterConnected", connected);
      hiwebSocket.ippPrint(options2);
    }
    function ippRequest(options2, callback) {
      p.a.instance.clear("ippRequestCallback");
      p.a.instance.on("ippRequestCallback", callback);
      hiwebSocket.ippRequest(options2);
    }
    n.d(e, "init", function() {
      return mt;
    }), n.d(e, "setConfig", function() {
      return cig;
    }), n.d(e, "updateElementType", function() {
      return uep;
    }), n.d(e, "hiwebSocket", function() {
      return hiwebSocket;
    }), n.d(e, "refreshPrinterList", function() {
      return rpl;
    }), n.d(e, "getAddress", function() {
      return getAddr;
    }), n.d(e, "ippPrint", function() {
      return ippPrint;
    }), n.d(e, "ippRequest", function() {
      return ippRequest;
    }), n.d(e, "PrintElementTypeManager", function() {
      return it;
    }), n.d(e, "PrintElementTypeGroup", function() {
      return ot;
    }), n.d(e, "PrintTemplate", function() {
      return ct;
    }), n.d(e, "print", function() {
      return ht;
    }), n.d(e, "print2", function() {
      return ft;
    }), n.d(e, "getHtml", function() {
      return gt;
    }), hiprintJQuery(document).ready(function() {
      /* @__PURE__ */ console.log("document ready");
      /* @__PURE__ */ console.log(window.autoConnect);
      if (hiwebSocket.hasIo() && window.autoConnect) {
        hiwebSocket.start();
      }
    });
  }
]);
var defaultElementTypeProvider = defaultTypeProvider(hiprint);
export {
  defaultElementTypeProvider,
  hiprint
};
